import { computed as A, defineComponent as Qe, toRefs as ht, openBlock as z, createElementBlock as ne, normalizeStyle as Di, unref as q, createElementVNode as Q, toDisplayString as Ve, Fragment as Ie, renderList as pt, createCommentVNode as qe, onMounted as qt, nextTick as Jt, onUnmounted as Ou, getCurrentScope as FC, onScopeDispose as Zt, getCurrentInstance as $i, ref as oe, watchEffect as Mr, h as Rn, inject as Ze, shallowRef as Ue, onBeforeMount as Pu, watch as Re, createVNode as T, Text as Lv, reactive as mr, provide as Et, cloneVNode as tu, isVNode as MC, Comment as DC, capitalize as Ov, warn as ns, camelize as Pv, onBeforeUnmount as _r, readonly as Nu, effectScope as Ru, toRaw as bn, TransitionGroup as Fu, Transition as ti, mergeProps as Te, isRef as Pi, toRef as Me, withDirectives as Gn, resolveDirective as Bi, vShow as Vi, onUpdated as $C, resolveDynamicComponent as zn, Teleport as BC, createTextVNode as ni, createStaticVNode as VC, normalizeClass as Mt, pushScopeId as Ui, popScopeId as Wi, createBlock as wt, withCtx as bt, resolveComponent as UC, normalizeProps as WC, withKeys as HC } from "vue";
const MN = {
  cdn: "https://storage.googleapis.com/is-assets-dev/71",
  widgetCdn: "https://storage.googleapis.com/is-cdn-dev/widgets/71",
  globalCdn: "https://storage.googleapis.com/is-assets-dev",
  portalUrl: ""
};
var da = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function GC(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Vo = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Vo.exports;
(function(e, n) {
  (function() {
    var r, a = "4.17.21", o = 200, s = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", l = "Expected a function", c = "Invalid `variable` option passed into `_.template`", f = "__lodash_hash_undefined__", h = 500, v = "__lodash_placeholder__", m = 1, p = 2, y = 4, b = 1, C = 2, S = 1, R = 2, $ = 4, k = 8, L = 16, F = 32, P = 64, E = 128, V = 256, W = 512, me = 30, le = "...", K = 800, ae = 16, ue = 1, Ce = 2, Se = 3, Pe = 1 / 0, ie = 9007199254740991, se = 17976931348623157e292, j = NaN, re = 4294967295, fe = re - 1, ye = re >>> 1, Oe = [
      ["ary", E],
      ["bind", S],
      ["bindKey", R],
      ["curry", k],
      ["curryRight", L],
      ["flip", W],
      ["partial", F],
      ["partialRight", P],
      ["rearg", V]
    ], ge = "[object Arguments]", Je = "[object Array]", $t = "[object AsyncFunction]", xt = "[object Boolean]", at = "[object Date]", Cn = "[object DOMException]", Qt = "[object Error]", cn = "[object Function]", we = "[object GeneratorFunction]", J = "[object Map]", be = "[object Number]", Nt = "[object Null]", At = "[object Object]", Sn = "[object Promise]", er = "[object Proxy]", I = "[object RegExp]", O = "[object Set]", Z = "[object String]", pe = "[object Symbol]", lt = "[object Undefined]", xe = "[object WeakMap]", H = "[object WeakSet]", te = "[object ArrayBuffer]", Xe = "[object DataView]", ft = "[object Float32Array]", En = "[object Float64Array]", wr = "[object Int8Array]", jn = "[object Int16Array]", Xi = "[object Int32Array]", Ba = "[object Uint8Array]", ws = "[object Uint8ClampedArray]", Cs = "[object Uint16Array]", Ss = "[object Uint32Array]", np = /\b__p \+= '';/g, rp = /\b(__p \+=) '' \+/g, ip = /(__e\(.*?\)|\b__t\)) \+\n'';/g, gc = /&(?:amp|lt|gt|quot|#39);/g, pc = /[&<>"']/g, ap = RegExp(gc.source), op = RegExp(pc.source), sp = /<%-([\s\S]+?)%>/g, lp = /<%([\s\S]+?)%>/g, _c = /<%=([\s\S]+?)%>/g, up = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, cp = /^\w*$/, fp = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Es = /[\\^$.*+?()[\]{}|]/g, dp = RegExp(Es.source), xs = /^\s+/, hp = /\s/, vp = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, mp = /\{\n\/\* \[wrapped with (.+)\] \*/, gp = /,? & /, pp = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, _p = /[()=,{}\[\]\/\s]/, yp = /\\(\\)?/g, bp = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, yc = /\w*$/, wp = /^[-+]0x[0-9a-f]+$/i, Cp = /^0b[01]+$/i, Sp = /^\[object .+?Constructor\]$/, Ep = /^0o[0-7]+$/i, xp = /^(?:0|[1-9]\d*)$/, Ap = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Va = /($^)/, kp = /['\n\r\u2028\u2029\\]/g, Ua = "\\ud800-\\udfff", Tp = "\\u0300-\\u036f", Ip = "\\ufe20-\\ufe2f", Lp = "\\u20d0-\\u20ff", bc = Tp + Ip + Lp, wc = "\\u2700-\\u27bf", Cc = "a-z\\xdf-\\xf6\\xf8-\\xff", Op = "\\xac\\xb1\\xd7\\xf7", Pp = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Np = "\\u2000-\\u206f", Rp = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Sc = "A-Z\\xc0-\\xd6\\xd8-\\xde", Ec = "\\ufe0e\\ufe0f", xc = Op + Pp + Np + Rp, As = "['’]", Fp = "[" + Ua + "]", Ac = "[" + xc + "]", Wa = "[" + bc + "]", kc = "\\d+", Mp = "[" + wc + "]", Tc = "[" + Cc + "]", Ic = "[^" + Ua + xc + kc + wc + Cc + Sc + "]", ks = "\\ud83c[\\udffb-\\udfff]", Dp = "(?:" + Wa + "|" + ks + ")", Lc = "[^" + Ua + "]", Ts = "(?:\\ud83c[\\udde6-\\uddff]){2}", Is = "[\\ud800-\\udbff][\\udc00-\\udfff]", hi = "[" + Sc + "]", Oc = "\\u200d", Pc = "(?:" + Tc + "|" + Ic + ")", $p = "(?:" + hi + "|" + Ic + ")", Nc = "(?:" + As + "(?:d|ll|m|re|s|t|ve))?", Rc = "(?:" + As + "(?:D|LL|M|RE|S|T|VE))?", Fc = Dp + "?", Mc = "[" + Ec + "]?", Bp = "(?:" + Oc + "(?:" + [Lc, Ts, Is].join("|") + ")" + Mc + Fc + ")*", Vp = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Up = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Dc = Mc + Fc + Bp, Wp = "(?:" + [Mp, Ts, Is].join("|") + ")" + Dc, Hp = "(?:" + [Lc + Wa + "?", Wa, Ts, Is, Fp].join("|") + ")", Gp = RegExp(As, "g"), zp = RegExp(Wa, "g"), Ls = RegExp(ks + "(?=" + ks + ")|" + Hp + Dc, "g"), qp = RegExp([
      hi + "?" + Tc + "+" + Nc + "(?=" + [Ac, hi, "$"].join("|") + ")",
      $p + "+" + Rc + "(?=" + [Ac, hi + Pc, "$"].join("|") + ")",
      hi + "?" + Pc + "+" + Nc,
      hi + "+" + Rc,
      Up,
      Vp,
      kc,
      Wp
    ].join("|"), "g"), Kp = RegExp("[" + Oc + Ua + bc + Ec + "]"), jp = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Yp = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Xp = -1, dt = {};
    dt[ft] = dt[En] = dt[wr] = dt[jn] = dt[Xi] = dt[Ba] = dt[ws] = dt[Cs] = dt[Ss] = !0, dt[ge] = dt[Je] = dt[te] = dt[xt] = dt[Xe] = dt[at] = dt[Qt] = dt[cn] = dt[J] = dt[be] = dt[At] = dt[I] = dt[O] = dt[Z] = dt[xe] = !1;
    var ut = {};
    ut[ge] = ut[Je] = ut[te] = ut[Xe] = ut[xt] = ut[at] = ut[ft] = ut[En] = ut[wr] = ut[jn] = ut[Xi] = ut[J] = ut[be] = ut[At] = ut[I] = ut[O] = ut[Z] = ut[pe] = ut[Ba] = ut[ws] = ut[Cs] = ut[Ss] = !0, ut[Qt] = ut[cn] = ut[xe] = !1;
    var Jp = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Zp = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Qp = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, e_ = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, t_ = parseFloat, n_ = parseInt, $c = typeof da == "object" && da && da.Object === Object && da, r_ = typeof self == "object" && self && self.Object === Object && self, Bt = $c || r_ || Function("return this")(), Os = n && !n.nodeType && n, Br = Os && !0 && e && !e.nodeType && e, Bc = Br && Br.exports === Os, Ps = Bc && $c.process, xn = function() {
      try {
        var M = Br && Br.require && Br.require("util").types;
        return M || Ps && Ps.binding && Ps.binding("util");
      } catch {
      }
    }(), Vc = xn && xn.isArrayBuffer, Uc = xn && xn.isDate, Wc = xn && xn.isMap, Hc = xn && xn.isRegExp, Gc = xn && xn.isSet, zc = xn && xn.isTypedArray;
    function fn(M, G, B) {
      switch (B.length) {
        case 0:
          return M.call(G);
        case 1:
          return M.call(G, B[0]);
        case 2:
          return M.call(G, B[0], B[1]);
        case 3:
          return M.call(G, B[0], B[1], B[2]);
      }
      return M.apply(G, B);
    }
    function i_(M, G, B, de) {
      for (var Ne = -1, et = M == null ? 0 : M.length; ++Ne < et; ) {
        var It = M[Ne];
        G(de, It, B(It), M);
      }
      return de;
    }
    function An(M, G) {
      for (var B = -1, de = M == null ? 0 : M.length; ++B < de && G(M[B], B, M) !== !1; )
        ;
      return M;
    }
    function a_(M, G) {
      for (var B = M == null ? 0 : M.length; B-- && G(M[B], B, M) !== !1; )
        ;
      return M;
    }
    function qc(M, G) {
      for (var B = -1, de = M == null ? 0 : M.length; ++B < de; )
        if (!G(M[B], B, M))
          return !1;
      return !0;
    }
    function Cr(M, G) {
      for (var B = -1, de = M == null ? 0 : M.length, Ne = 0, et = []; ++B < de; ) {
        var It = M[B];
        G(It, B, M) && (et[Ne++] = It);
      }
      return et;
    }
    function Ha(M, G) {
      var B = M == null ? 0 : M.length;
      return !!B && vi(M, G, 0) > -1;
    }
    function Ns(M, G, B) {
      for (var de = -1, Ne = M == null ? 0 : M.length; ++de < Ne; )
        if (B(G, M[de]))
          return !0;
      return !1;
    }
    function vt(M, G) {
      for (var B = -1, de = M == null ? 0 : M.length, Ne = Array(de); ++B < de; )
        Ne[B] = G(M[B], B, M);
      return Ne;
    }
    function Sr(M, G) {
      for (var B = -1, de = G.length, Ne = M.length; ++B < de; )
        M[Ne + B] = G[B];
      return M;
    }
    function Rs(M, G, B, de) {
      var Ne = -1, et = M == null ? 0 : M.length;
      for (de && et && (B = M[++Ne]); ++Ne < et; )
        B = G(B, M[Ne], Ne, M);
      return B;
    }
    function o_(M, G, B, de) {
      var Ne = M == null ? 0 : M.length;
      for (de && Ne && (B = M[--Ne]); Ne--; )
        B = G(B, M[Ne], Ne, M);
      return B;
    }
    function Fs(M, G) {
      for (var B = -1, de = M == null ? 0 : M.length; ++B < de; )
        if (G(M[B], B, M))
          return !0;
      return !1;
    }
    var s_ = Ms("length");
    function l_(M) {
      return M.split("");
    }
    function u_(M) {
      return M.match(pp) || [];
    }
    function Kc(M, G, B) {
      var de;
      return B(M, function(Ne, et, It) {
        if (G(Ne, et, It))
          return de = et, !1;
      }), de;
    }
    function Ga(M, G, B, de) {
      for (var Ne = M.length, et = B + (de ? 1 : -1); de ? et-- : ++et < Ne; )
        if (G(M[et], et, M))
          return et;
      return -1;
    }
    function vi(M, G, B) {
      return G === G ? w_(M, G, B) : Ga(M, jc, B);
    }
    function c_(M, G, B, de) {
      for (var Ne = B - 1, et = M.length; ++Ne < et; )
        if (de(M[Ne], G))
          return Ne;
      return -1;
    }
    function jc(M) {
      return M !== M;
    }
    function Yc(M, G) {
      var B = M == null ? 0 : M.length;
      return B ? $s(M, G) / B : j;
    }
    function Ms(M) {
      return function(G) {
        return G == null ? r : G[M];
      };
    }
    function Ds(M) {
      return function(G) {
        return M == null ? r : M[G];
      };
    }
    function Xc(M, G, B, de, Ne) {
      return Ne(M, function(et, It, ot) {
        B = de ? (de = !1, et) : G(B, et, It, ot);
      }), B;
    }
    function f_(M, G) {
      var B = M.length;
      for (M.sort(G); B--; )
        M[B] = M[B].value;
      return M;
    }
    function $s(M, G) {
      for (var B, de = -1, Ne = M.length; ++de < Ne; ) {
        var et = G(M[de]);
        et !== r && (B = B === r ? et : B + et);
      }
      return B;
    }
    function Bs(M, G) {
      for (var B = -1, de = Array(M); ++B < M; )
        de[B] = G(B);
      return de;
    }
    function d_(M, G) {
      return vt(G, function(B) {
        return [B, M[B]];
      });
    }
    function Jc(M) {
      return M && M.slice(0, tf(M) + 1).replace(xs, "");
    }
    function dn(M) {
      return function(G) {
        return M(G);
      };
    }
    function Vs(M, G) {
      return vt(G, function(B) {
        return M[B];
      });
    }
    function Ji(M, G) {
      return M.has(G);
    }
    function Zc(M, G) {
      for (var B = -1, de = M.length; ++B < de && vi(G, M[B], 0) > -1; )
        ;
      return B;
    }
    function Qc(M, G) {
      for (var B = M.length; B-- && vi(G, M[B], 0) > -1; )
        ;
      return B;
    }
    function h_(M, G) {
      for (var B = M.length, de = 0; B--; )
        M[B] === G && ++de;
      return de;
    }
    var v_ = Ds(Jp), m_ = Ds(Zp);
    function g_(M) {
      return "\\" + e_[M];
    }
    function p_(M, G) {
      return M == null ? r : M[G];
    }
    function mi(M) {
      return Kp.test(M);
    }
    function __(M) {
      return jp.test(M);
    }
    function y_(M) {
      for (var G, B = []; !(G = M.next()).done; )
        B.push(G.value);
      return B;
    }
    function Us(M) {
      var G = -1, B = Array(M.size);
      return M.forEach(function(de, Ne) {
        B[++G] = [Ne, de];
      }), B;
    }
    function ef(M, G) {
      return function(B) {
        return M(G(B));
      };
    }
    function Er(M, G) {
      for (var B = -1, de = M.length, Ne = 0, et = []; ++B < de; ) {
        var It = M[B];
        (It === G || It === v) && (M[B] = v, et[Ne++] = B);
      }
      return et;
    }
    function za(M) {
      var G = -1, B = Array(M.size);
      return M.forEach(function(de) {
        B[++G] = de;
      }), B;
    }
    function b_(M) {
      var G = -1, B = Array(M.size);
      return M.forEach(function(de) {
        B[++G] = [de, de];
      }), B;
    }
    function w_(M, G, B) {
      for (var de = B - 1, Ne = M.length; ++de < Ne; )
        if (M[de] === G)
          return de;
      return -1;
    }
    function C_(M, G, B) {
      for (var de = B + 1; de--; )
        if (M[de] === G)
          return de;
      return de;
    }
    function gi(M) {
      return mi(M) ? E_(M) : s_(M);
    }
    function $n(M) {
      return mi(M) ? x_(M) : l_(M);
    }
    function tf(M) {
      for (var G = M.length; G-- && hp.test(M.charAt(G)); )
        ;
      return G;
    }
    var S_ = Ds(Qp);
    function E_(M) {
      for (var G = Ls.lastIndex = 0; Ls.test(M); )
        ++G;
      return G;
    }
    function x_(M) {
      return M.match(Ls) || [];
    }
    function A_(M) {
      return M.match(qp) || [];
    }
    var k_ = function M(G) {
      G = G == null ? Bt : pi.defaults(Bt.Object(), G, pi.pick(Bt, Yp));
      var B = G.Array, de = G.Date, Ne = G.Error, et = G.Function, It = G.Math, ot = G.Object, Ws = G.RegExp, T_ = G.String, kn = G.TypeError, qa = B.prototype, I_ = et.prototype, _i = ot.prototype, Ka = G["__core-js_shared__"], ja = I_.toString, it = _i.hasOwnProperty, L_ = 0, nf = function() {
        var t = /[^.]+$/.exec(Ka && Ka.keys && Ka.keys.IE_PROTO || "");
        return t ? "Symbol(src)_1." + t : "";
      }(), Ya = _i.toString, O_ = ja.call(ot), P_ = Bt._, N_ = Ws(
        "^" + ja.call(it).replace(Es, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Xa = Bc ? G.Buffer : r, xr = G.Symbol, Ja = G.Uint8Array, rf = Xa ? Xa.allocUnsafe : r, Za = ef(ot.getPrototypeOf, ot), af = ot.create, of = _i.propertyIsEnumerable, Qa = qa.splice, sf = xr ? xr.isConcatSpreadable : r, Zi = xr ? xr.iterator : r, Vr = xr ? xr.toStringTag : r, eo = function() {
        try {
          var t = zr(ot, "defineProperty");
          return t({}, "", {}), t;
        } catch {
        }
      }(), R_ = G.clearTimeout !== Bt.clearTimeout && G.clearTimeout, F_ = de && de.now !== Bt.Date.now && de.now, M_ = G.setTimeout !== Bt.setTimeout && G.setTimeout, to = It.ceil, no = It.floor, Hs = ot.getOwnPropertySymbols, D_ = Xa ? Xa.isBuffer : r, lf = G.isFinite, $_ = qa.join, B_ = ef(ot.keys, ot), Lt = It.max, Wt = It.min, V_ = de.now, U_ = G.parseInt, uf = It.random, W_ = qa.reverse, Gs = zr(G, "DataView"), Qi = zr(G, "Map"), zs = zr(G, "Promise"), yi = zr(G, "Set"), ea = zr(G, "WeakMap"), ta = zr(ot, "create"), ro = ea && new ea(), bi = {}, H_ = qr(Gs), G_ = qr(Qi), z_ = qr(zs), q_ = qr(yi), K_ = qr(ea), io = xr ? xr.prototype : r, na = io ? io.valueOf : r, cf = io ? io.toString : r;
      function _(t) {
        if (yt(t) && !Fe(t) && !(t instanceof Ke)) {
          if (t instanceof Tn)
            return t;
          if (it.call(t, "__wrapped__"))
            return fd(t);
        }
        return new Tn(t);
      }
      var wi = /* @__PURE__ */ function() {
        function t() {
        }
        return function(i) {
          if (!gt(i))
            return {};
          if (af)
            return af(i);
          t.prototype = i;
          var u = new t();
          return t.prototype = r, u;
        };
      }();
      function ao() {
      }
      function Tn(t, i) {
        this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!i, this.__index__ = 0, this.__values__ = r;
      }
      _.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: sp,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: lp,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: _c,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _
        }
      }, _.prototype = ao.prototype, _.prototype.constructor = _, Tn.prototype = wi(ao.prototype), Tn.prototype.constructor = Tn;
      function Ke(t) {
        this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = re, this.__views__ = [];
      }
      function j_() {
        var t = new Ke(this.__wrapped__);
        return t.__actions__ = en(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = en(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = en(this.__views__), t;
      }
      function Y_() {
        if (this.__filtered__) {
          var t = new Ke(this);
          t.__dir__ = -1, t.__filtered__ = !0;
        } else
          t = this.clone(), t.__dir__ *= -1;
        return t;
      }
      function X_() {
        var t = this.__wrapped__.value(), i = this.__dir__, u = Fe(t), d = i < 0, g = u ? t.length : 0, w = lb(0, g, this.__views__), x = w.start, N = w.end, D = N - x, Y = d ? N : x - 1, X = this.__iteratees__, ee = X.length, ce = 0, _e = Wt(D, this.__takeCount__);
        if (!u || !d && g == D && _e == D)
          return Rf(t, this.__actions__);
        var Ae = [];
        e:
          for (; D-- && ce < _e; ) {
            Y += i;
            for (var Be = -1, ke = t[Y]; ++Be < ee; ) {
              var ze = X[Be], je = ze.iteratee, mn = ze.type, Yt = je(ke);
              if (mn == Ce)
                ke = Yt;
              else if (!Yt) {
                if (mn == ue)
                  continue e;
                break e;
              }
            }
            Ae[ce++] = ke;
          }
        return Ae;
      }
      Ke.prototype = wi(ao.prototype), Ke.prototype.constructor = Ke;
      function Ur(t) {
        var i = -1, u = t == null ? 0 : t.length;
        for (this.clear(); ++i < u; ) {
          var d = t[i];
          this.set(d[0], d[1]);
        }
      }
      function J_() {
        this.__data__ = ta ? ta(null) : {}, this.size = 0;
      }
      function Z_(t) {
        var i = this.has(t) && delete this.__data__[t];
        return this.size -= i ? 1 : 0, i;
      }
      function Q_(t) {
        var i = this.__data__;
        if (ta) {
          var u = i[t];
          return u === f ? r : u;
        }
        return it.call(i, t) ? i[t] : r;
      }
      function ey(t) {
        var i = this.__data__;
        return ta ? i[t] !== r : it.call(i, t);
      }
      function ty(t, i) {
        var u = this.__data__;
        return this.size += this.has(t) ? 0 : 1, u[t] = ta && i === r ? f : i, this;
      }
      Ur.prototype.clear = J_, Ur.prototype.delete = Z_, Ur.prototype.get = Q_, Ur.prototype.has = ey, Ur.prototype.set = ty;
      function tr(t) {
        var i = -1, u = t == null ? 0 : t.length;
        for (this.clear(); ++i < u; ) {
          var d = t[i];
          this.set(d[0], d[1]);
        }
      }
      function ny() {
        this.__data__ = [], this.size = 0;
      }
      function ry(t) {
        var i = this.__data__, u = oo(i, t);
        if (u < 0)
          return !1;
        var d = i.length - 1;
        return u == d ? i.pop() : Qa.call(i, u, 1), --this.size, !0;
      }
      function iy(t) {
        var i = this.__data__, u = oo(i, t);
        return u < 0 ? r : i[u][1];
      }
      function ay(t) {
        return oo(this.__data__, t) > -1;
      }
      function oy(t, i) {
        var u = this.__data__, d = oo(u, t);
        return d < 0 ? (++this.size, u.push([t, i])) : u[d][1] = i, this;
      }
      tr.prototype.clear = ny, tr.prototype.delete = ry, tr.prototype.get = iy, tr.prototype.has = ay, tr.prototype.set = oy;
      function nr(t) {
        var i = -1, u = t == null ? 0 : t.length;
        for (this.clear(); ++i < u; ) {
          var d = t[i];
          this.set(d[0], d[1]);
        }
      }
      function sy() {
        this.size = 0, this.__data__ = {
          hash: new Ur(),
          map: new (Qi || tr)(),
          string: new Ur()
        };
      }
      function ly(t) {
        var i = yo(this, t).delete(t);
        return this.size -= i ? 1 : 0, i;
      }
      function uy(t) {
        return yo(this, t).get(t);
      }
      function cy(t) {
        return yo(this, t).has(t);
      }
      function fy(t, i) {
        var u = yo(this, t), d = u.size;
        return u.set(t, i), this.size += u.size == d ? 0 : 1, this;
      }
      nr.prototype.clear = sy, nr.prototype.delete = ly, nr.prototype.get = uy, nr.prototype.has = cy, nr.prototype.set = fy;
      function Wr(t) {
        var i = -1, u = t == null ? 0 : t.length;
        for (this.__data__ = new nr(); ++i < u; )
          this.add(t[i]);
      }
      function dy(t) {
        return this.__data__.set(t, f), this;
      }
      function hy(t) {
        return this.__data__.has(t);
      }
      Wr.prototype.add = Wr.prototype.push = dy, Wr.prototype.has = hy;
      function Bn(t) {
        var i = this.__data__ = new tr(t);
        this.size = i.size;
      }
      function vy() {
        this.__data__ = new tr(), this.size = 0;
      }
      function my(t) {
        var i = this.__data__, u = i.delete(t);
        return this.size = i.size, u;
      }
      function gy(t) {
        return this.__data__.get(t);
      }
      function py(t) {
        return this.__data__.has(t);
      }
      function _y(t, i) {
        var u = this.__data__;
        if (u instanceof tr) {
          var d = u.__data__;
          if (!Qi || d.length < o - 1)
            return d.push([t, i]), this.size = ++u.size, this;
          u = this.__data__ = new nr(d);
        }
        return u.set(t, i), this.size = u.size, this;
      }
      Bn.prototype.clear = vy, Bn.prototype.delete = my, Bn.prototype.get = gy, Bn.prototype.has = py, Bn.prototype.set = _y;
      function ff(t, i) {
        var u = Fe(t), d = !u && Kr(t), g = !u && !d && Lr(t), w = !u && !d && !g && xi(t), x = u || d || g || w, N = x ? Bs(t.length, T_) : [], D = N.length;
        for (var Y in t)
          (i || it.call(t, Y)) && !(x && // Safari 9 has enumerable `arguments.length` in strict mode.
          (Y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          g && (Y == "offset" || Y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          w && (Y == "buffer" || Y == "byteLength" || Y == "byteOffset") || // Skip index properties.
          or(Y, D))) && N.push(Y);
        return N;
      }
      function df(t) {
        var i = t.length;
        return i ? t[nl(0, i - 1)] : r;
      }
      function yy(t, i) {
        return bo(en(t), Hr(i, 0, t.length));
      }
      function by(t) {
        return bo(en(t));
      }
      function qs(t, i, u) {
        (u !== r && !Vn(t[i], u) || u === r && !(i in t)) && rr(t, i, u);
      }
      function ra(t, i, u) {
        var d = t[i];
        (!(it.call(t, i) && Vn(d, u)) || u === r && !(i in t)) && rr(t, i, u);
      }
      function oo(t, i) {
        for (var u = t.length; u--; )
          if (Vn(t[u][0], i))
            return u;
        return -1;
      }
      function wy(t, i, u, d) {
        return Ar(t, function(g, w, x) {
          i(d, g, u(g), x);
        }), d;
      }
      function hf(t, i) {
        return t && Xn(i, Rt(i), t);
      }
      function Cy(t, i) {
        return t && Xn(i, nn(i), t);
      }
      function rr(t, i, u) {
        i == "__proto__" && eo ? eo(t, i, {
          configurable: !0,
          enumerable: !0,
          value: u,
          writable: !0
        }) : t[i] = u;
      }
      function Ks(t, i) {
        for (var u = -1, d = i.length, g = B(d), w = t == null; ++u < d; )
          g[u] = w ? r : kl(t, i[u]);
        return g;
      }
      function Hr(t, i, u) {
        return t === t && (u !== r && (t = t <= u ? t : u), i !== r && (t = t >= i ? t : i)), t;
      }
      function In(t, i, u, d, g, w) {
        var x, N = i & m, D = i & p, Y = i & y;
        if (u && (x = g ? u(t, d, g, w) : u(t)), x !== r)
          return x;
        if (!gt(t))
          return t;
        var X = Fe(t);
        if (X) {
          if (x = cb(t), !N)
            return en(t, x);
        } else {
          var ee = Ht(t), ce = ee == cn || ee == we;
          if (Lr(t))
            return Df(t, N);
          if (ee == At || ee == ge || ce && !g) {
            if (x = D || ce ? {} : nd(t), !N)
              return D ? Qy(t, Cy(x, t)) : Zy(t, hf(x, t));
          } else {
            if (!ut[ee])
              return g ? t : {};
            x = fb(t, ee, N);
          }
        }
        w || (w = new Bn());
        var _e = w.get(t);
        if (_e)
          return _e;
        w.set(t, x), Od(t) ? t.forEach(function(ke) {
          x.add(In(ke, i, u, ke, t, w));
        }) : Id(t) && t.forEach(function(ke, ze) {
          x.set(ze, In(ke, i, u, ze, t, w));
        });
        var Ae = Y ? D ? hl : dl : D ? nn : Rt, Be = X ? r : Ae(t);
        return An(Be || t, function(ke, ze) {
          Be && (ze = ke, ke = t[ze]), ra(x, ze, In(ke, i, u, ze, t, w));
        }), x;
      }
      function Sy(t) {
        var i = Rt(t);
        return function(u) {
          return vf(u, t, i);
        };
      }
      function vf(t, i, u) {
        var d = u.length;
        if (t == null)
          return !d;
        for (t = ot(t); d--; ) {
          var g = u[d], w = i[g], x = t[g];
          if (x === r && !(g in t) || !w(x))
            return !1;
        }
        return !0;
      }
      function mf(t, i, u) {
        if (typeof t != "function")
          throw new kn(l);
        return ca(function() {
          t.apply(r, u);
        }, i);
      }
      function ia(t, i, u, d) {
        var g = -1, w = Ha, x = !0, N = t.length, D = [], Y = i.length;
        if (!N)
          return D;
        u && (i = vt(i, dn(u))), d ? (w = Ns, x = !1) : i.length >= o && (w = Ji, x = !1, i = new Wr(i));
        e:
          for (; ++g < N; ) {
            var X = t[g], ee = u == null ? X : u(X);
            if (X = d || X !== 0 ? X : 0, x && ee === ee) {
              for (var ce = Y; ce--; )
                if (i[ce] === ee)
                  continue e;
              D.push(X);
            } else w(i, ee, d) || D.push(X);
          }
        return D;
      }
      var Ar = Wf(Yn), gf = Wf(Ys, !0);
      function Ey(t, i) {
        var u = !0;
        return Ar(t, function(d, g, w) {
          return u = !!i(d, g, w), u;
        }), u;
      }
      function so(t, i, u) {
        for (var d = -1, g = t.length; ++d < g; ) {
          var w = t[d], x = i(w);
          if (x != null && (N === r ? x === x && !vn(x) : u(x, N)))
            var N = x, D = w;
        }
        return D;
      }
      function xy(t, i, u, d) {
        var g = t.length;
        for (u = $e(u), u < 0 && (u = -u > g ? 0 : g + u), d = d === r || d > g ? g : $e(d), d < 0 && (d += g), d = u > d ? 0 : Nd(d); u < d; )
          t[u++] = i;
        return t;
      }
      function pf(t, i) {
        var u = [];
        return Ar(t, function(d, g, w) {
          i(d, g, w) && u.push(d);
        }), u;
      }
      function Vt(t, i, u, d, g) {
        var w = -1, x = t.length;
        for (u || (u = hb), g || (g = []); ++w < x; ) {
          var N = t[w];
          i > 0 && u(N) ? i > 1 ? Vt(N, i - 1, u, d, g) : Sr(g, N) : d || (g[g.length] = N);
        }
        return g;
      }
      var js = Hf(), _f = Hf(!0);
      function Yn(t, i) {
        return t && js(t, i, Rt);
      }
      function Ys(t, i) {
        return t && _f(t, i, Rt);
      }
      function lo(t, i) {
        return Cr(i, function(u) {
          return sr(t[u]);
        });
      }
      function Gr(t, i) {
        i = Tr(i, t);
        for (var u = 0, d = i.length; t != null && u < d; )
          t = t[Jn(i[u++])];
        return u && u == d ? t : r;
      }
      function yf(t, i, u) {
        var d = i(t);
        return Fe(t) ? d : Sr(d, u(t));
      }
      function Kt(t) {
        return t == null ? t === r ? lt : Nt : Vr && Vr in ot(t) ? sb(t) : bb(t);
      }
      function Xs(t, i) {
        return t > i;
      }
      function Ay(t, i) {
        return t != null && it.call(t, i);
      }
      function ky(t, i) {
        return t != null && i in ot(t);
      }
      function Ty(t, i, u) {
        return t >= Wt(i, u) && t < Lt(i, u);
      }
      function Js(t, i, u) {
        for (var d = u ? Ns : Ha, g = t[0].length, w = t.length, x = w, N = B(w), D = 1 / 0, Y = []; x--; ) {
          var X = t[x];
          x && i && (X = vt(X, dn(i))), D = Wt(X.length, D), N[x] = !u && (i || g >= 120 && X.length >= 120) ? new Wr(x && X) : r;
        }
        X = t[0];
        var ee = -1, ce = N[0];
        e:
          for (; ++ee < g && Y.length < D; ) {
            var _e = X[ee], Ae = i ? i(_e) : _e;
            if (_e = u || _e !== 0 ? _e : 0, !(ce ? Ji(ce, Ae) : d(Y, Ae, u))) {
              for (x = w; --x; ) {
                var Be = N[x];
                if (!(Be ? Ji(Be, Ae) : d(t[x], Ae, u)))
                  continue e;
              }
              ce && ce.push(Ae), Y.push(_e);
            }
          }
        return Y;
      }
      function Iy(t, i, u, d) {
        return Yn(t, function(g, w, x) {
          i(d, u(g), w, x);
        }), d;
      }
      function aa(t, i, u) {
        i = Tr(i, t), t = od(t, i);
        var d = t == null ? t : t[Jn(On(i))];
        return d == null ? r : fn(d, t, u);
      }
      function bf(t) {
        return yt(t) && Kt(t) == ge;
      }
      function Ly(t) {
        return yt(t) && Kt(t) == te;
      }
      function Oy(t) {
        return yt(t) && Kt(t) == at;
      }
      function oa(t, i, u, d, g) {
        return t === i ? !0 : t == null || i == null || !yt(t) && !yt(i) ? t !== t && i !== i : Py(t, i, u, d, oa, g);
      }
      function Py(t, i, u, d, g, w) {
        var x = Fe(t), N = Fe(i), D = x ? Je : Ht(t), Y = N ? Je : Ht(i);
        D = D == ge ? At : D, Y = Y == ge ? At : Y;
        var X = D == At, ee = Y == At, ce = D == Y;
        if (ce && Lr(t)) {
          if (!Lr(i))
            return !1;
          x = !0, X = !1;
        }
        if (ce && !X)
          return w || (w = new Bn()), x || xi(t) ? Qf(t, i, u, d, g, w) : ab(t, i, D, u, d, g, w);
        if (!(u & b)) {
          var _e = X && it.call(t, "__wrapped__"), Ae = ee && it.call(i, "__wrapped__");
          if (_e || Ae) {
            var Be = _e ? t.value() : t, ke = Ae ? i.value() : i;
            return w || (w = new Bn()), g(Be, ke, u, d, w);
          }
        }
        return ce ? (w || (w = new Bn()), ob(t, i, u, d, g, w)) : !1;
      }
      function Ny(t) {
        return yt(t) && Ht(t) == J;
      }
      function Zs(t, i, u, d) {
        var g = u.length, w = g, x = !d;
        if (t == null)
          return !w;
        for (t = ot(t); g--; ) {
          var N = u[g];
          if (x && N[2] ? N[1] !== t[N[0]] : !(N[0] in t))
            return !1;
        }
        for (; ++g < w; ) {
          N = u[g];
          var D = N[0], Y = t[D], X = N[1];
          if (x && N[2]) {
            if (Y === r && !(D in t))
              return !1;
          } else {
            var ee = new Bn();
            if (d)
              var ce = d(Y, X, D, t, i, ee);
            if (!(ce === r ? oa(X, Y, b | C, d, ee) : ce))
              return !1;
          }
        }
        return !0;
      }
      function wf(t) {
        if (!gt(t) || mb(t))
          return !1;
        var i = sr(t) ? N_ : Sp;
        return i.test(qr(t));
      }
      function Ry(t) {
        return yt(t) && Kt(t) == I;
      }
      function Fy(t) {
        return yt(t) && Ht(t) == O;
      }
      function My(t) {
        return yt(t) && Ao(t.length) && !!dt[Kt(t)];
      }
      function Cf(t) {
        return typeof t == "function" ? t : t == null ? rn : typeof t == "object" ? Fe(t) ? xf(t[0], t[1]) : Ef(t) : Gd(t);
      }
      function Qs(t) {
        if (!ua(t))
          return B_(t);
        var i = [];
        for (var u in ot(t))
          it.call(t, u) && u != "constructor" && i.push(u);
        return i;
      }
      function Dy(t) {
        if (!gt(t))
          return yb(t);
        var i = ua(t), u = [];
        for (var d in t)
          d == "constructor" && (i || !it.call(t, d)) || u.push(d);
        return u;
      }
      function el(t, i) {
        return t < i;
      }
      function Sf(t, i) {
        var u = -1, d = tn(t) ? B(t.length) : [];
        return Ar(t, function(g, w, x) {
          d[++u] = i(g, w, x);
        }), d;
      }
      function Ef(t) {
        var i = ml(t);
        return i.length == 1 && i[0][2] ? id(i[0][0], i[0][1]) : function(u) {
          return u === t || Zs(u, t, i);
        };
      }
      function xf(t, i) {
        return pl(t) && rd(i) ? id(Jn(t), i) : function(u) {
          var d = kl(u, t);
          return d === r && d === i ? Tl(u, t) : oa(i, d, b | C);
        };
      }
      function uo(t, i, u, d, g) {
        t !== i && js(i, function(w, x) {
          if (g || (g = new Bn()), gt(w))
            $y(t, i, x, u, uo, d, g);
          else {
            var N = d ? d(yl(t, x), w, x + "", t, i, g) : r;
            N === r && (N = w), qs(t, x, N);
          }
        }, nn);
      }
      function $y(t, i, u, d, g, w, x) {
        var N = yl(t, u), D = yl(i, u), Y = x.get(D);
        if (Y) {
          qs(t, u, Y);
          return;
        }
        var X = w ? w(N, D, u + "", t, i, x) : r, ee = X === r;
        if (ee) {
          var ce = Fe(D), _e = !ce && Lr(D), Ae = !ce && !_e && xi(D);
          X = D, ce || _e || Ae ? Fe(N) ? X = N : Ct(N) ? X = en(N) : _e ? (ee = !1, X = Df(D, !0)) : Ae ? (ee = !1, X = $f(D, !0)) : X = [] : fa(D) || Kr(D) ? (X = N, Kr(N) ? X = Rd(N) : (!gt(N) || sr(N)) && (X = nd(D))) : ee = !1;
        }
        ee && (x.set(D, X), g(X, D, d, w, x), x.delete(D)), qs(t, u, X);
      }
      function Af(t, i) {
        var u = t.length;
        if (u)
          return i += i < 0 ? u : 0, or(i, u) ? t[i] : r;
      }
      function kf(t, i, u) {
        i.length ? i = vt(i, function(w) {
          return Fe(w) ? function(x) {
            return Gr(x, w.length === 1 ? w[0] : w);
          } : w;
        }) : i = [rn];
        var d = -1;
        i = vt(i, dn(Ee()));
        var g = Sf(t, function(w, x, N) {
          var D = vt(i, function(Y) {
            return Y(w);
          });
          return { criteria: D, index: ++d, value: w };
        });
        return f_(g, function(w, x) {
          return Jy(w, x, u);
        });
      }
      function By(t, i) {
        return Tf(t, i, function(u, d) {
          return Tl(t, d);
        });
      }
      function Tf(t, i, u) {
        for (var d = -1, g = i.length, w = {}; ++d < g; ) {
          var x = i[d], N = Gr(t, x);
          u(N, x) && sa(w, Tr(x, t), N);
        }
        return w;
      }
      function Vy(t) {
        return function(i) {
          return Gr(i, t);
        };
      }
      function tl(t, i, u, d) {
        var g = d ? c_ : vi, w = -1, x = i.length, N = t;
        for (t === i && (i = en(i)), u && (N = vt(t, dn(u))); ++w < x; )
          for (var D = 0, Y = i[w], X = u ? u(Y) : Y; (D = g(N, X, D, d)) > -1; )
            N !== t && Qa.call(N, D, 1), Qa.call(t, D, 1);
        return t;
      }
      function If(t, i) {
        for (var u = t ? i.length : 0, d = u - 1; u--; ) {
          var g = i[u];
          if (u == d || g !== w) {
            var w = g;
            or(g) ? Qa.call(t, g, 1) : al(t, g);
          }
        }
        return t;
      }
      function nl(t, i) {
        return t + no(uf() * (i - t + 1));
      }
      function Uy(t, i, u, d) {
        for (var g = -1, w = Lt(to((i - t) / (u || 1)), 0), x = B(w); w--; )
          x[d ? w : ++g] = t, t += u;
        return x;
      }
      function rl(t, i) {
        var u = "";
        if (!t || i < 1 || i > ie)
          return u;
        do
          i % 2 && (u += t), i = no(i / 2), i && (t += t);
        while (i);
        return u;
      }
      function We(t, i) {
        return bl(ad(t, i, rn), t + "");
      }
      function Wy(t) {
        return df(Ai(t));
      }
      function Hy(t, i) {
        var u = Ai(t);
        return bo(u, Hr(i, 0, u.length));
      }
      function sa(t, i, u, d) {
        if (!gt(t))
          return t;
        i = Tr(i, t);
        for (var g = -1, w = i.length, x = w - 1, N = t; N != null && ++g < w; ) {
          var D = Jn(i[g]), Y = u;
          if (D === "__proto__" || D === "constructor" || D === "prototype")
            return t;
          if (g != x) {
            var X = N[D];
            Y = d ? d(X, D, N) : r, Y === r && (Y = gt(X) ? X : or(i[g + 1]) ? [] : {});
          }
          ra(N, D, Y), N = N[D];
        }
        return t;
      }
      var Lf = ro ? function(t, i) {
        return ro.set(t, i), t;
      } : rn, Gy = eo ? function(t, i) {
        return eo(t, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Ll(i),
          writable: !0
        });
      } : rn;
      function zy(t) {
        return bo(Ai(t));
      }
      function Ln(t, i, u) {
        var d = -1, g = t.length;
        i < 0 && (i = -i > g ? 0 : g + i), u = u > g ? g : u, u < 0 && (u += g), g = i > u ? 0 : u - i >>> 0, i >>>= 0;
        for (var w = B(g); ++d < g; )
          w[d] = t[d + i];
        return w;
      }
      function qy(t, i) {
        var u;
        return Ar(t, function(d, g, w) {
          return u = i(d, g, w), !u;
        }), !!u;
      }
      function co(t, i, u) {
        var d = 0, g = t == null ? d : t.length;
        if (typeof i == "number" && i === i && g <= ye) {
          for (; d < g; ) {
            var w = d + g >>> 1, x = t[w];
            x !== null && !vn(x) && (u ? x <= i : x < i) ? d = w + 1 : g = w;
          }
          return g;
        }
        return il(t, i, rn, u);
      }
      function il(t, i, u, d) {
        var g = 0, w = t == null ? 0 : t.length;
        if (w === 0)
          return 0;
        i = u(i);
        for (var x = i !== i, N = i === null, D = vn(i), Y = i === r; g < w; ) {
          var X = no((g + w) / 2), ee = u(t[X]), ce = ee !== r, _e = ee === null, Ae = ee === ee, Be = vn(ee);
          if (x)
            var ke = d || Ae;
          else Y ? ke = Ae && (d || ce) : N ? ke = Ae && ce && (d || !_e) : D ? ke = Ae && ce && !_e && (d || !Be) : _e || Be ? ke = !1 : ke = d ? ee <= i : ee < i;
          ke ? g = X + 1 : w = X;
        }
        return Wt(w, fe);
      }
      function Of(t, i) {
        for (var u = -1, d = t.length, g = 0, w = []; ++u < d; ) {
          var x = t[u], N = i ? i(x) : x;
          if (!u || !Vn(N, D)) {
            var D = N;
            w[g++] = x === 0 ? 0 : x;
          }
        }
        return w;
      }
      function Pf(t) {
        return typeof t == "number" ? t : vn(t) ? j : +t;
      }
      function hn(t) {
        if (typeof t == "string")
          return t;
        if (Fe(t))
          return vt(t, hn) + "";
        if (vn(t))
          return cf ? cf.call(t) : "";
        var i = t + "";
        return i == "0" && 1 / t == -Pe ? "-0" : i;
      }
      function kr(t, i, u) {
        var d = -1, g = Ha, w = t.length, x = !0, N = [], D = N;
        if (u)
          x = !1, g = Ns;
        else if (w >= o) {
          var Y = i ? null : rb(t);
          if (Y)
            return za(Y);
          x = !1, g = Ji, D = new Wr();
        } else
          D = i ? [] : N;
        e:
          for (; ++d < w; ) {
            var X = t[d], ee = i ? i(X) : X;
            if (X = u || X !== 0 ? X : 0, x && ee === ee) {
              for (var ce = D.length; ce--; )
                if (D[ce] === ee)
                  continue e;
              i && D.push(ee), N.push(X);
            } else g(D, ee, u) || (D !== N && D.push(ee), N.push(X));
          }
        return N;
      }
      function al(t, i) {
        return i = Tr(i, t), t = od(t, i), t == null || delete t[Jn(On(i))];
      }
      function Nf(t, i, u, d) {
        return sa(t, i, u(Gr(t, i)), d);
      }
      function fo(t, i, u, d) {
        for (var g = t.length, w = d ? g : -1; (d ? w-- : ++w < g) && i(t[w], w, t); )
          ;
        return u ? Ln(t, d ? 0 : w, d ? w + 1 : g) : Ln(t, d ? w + 1 : 0, d ? g : w);
      }
      function Rf(t, i) {
        var u = t;
        return u instanceof Ke && (u = u.value()), Rs(i, function(d, g) {
          return g.func.apply(g.thisArg, Sr([d], g.args));
        }, u);
      }
      function ol(t, i, u) {
        var d = t.length;
        if (d < 2)
          return d ? kr(t[0]) : [];
        for (var g = -1, w = B(d); ++g < d; )
          for (var x = t[g], N = -1; ++N < d; )
            N != g && (w[g] = ia(w[g] || x, t[N], i, u));
        return kr(Vt(w, 1), i, u);
      }
      function Ff(t, i, u) {
        for (var d = -1, g = t.length, w = i.length, x = {}; ++d < g; ) {
          var N = d < w ? i[d] : r;
          u(x, t[d], N);
        }
        return x;
      }
      function sl(t) {
        return Ct(t) ? t : [];
      }
      function ll(t) {
        return typeof t == "function" ? t : rn;
      }
      function Tr(t, i) {
        return Fe(t) ? t : pl(t, i) ? [t] : cd(nt(t));
      }
      var Ky = We;
      function Ir(t, i, u) {
        var d = t.length;
        return u = u === r ? d : u, !i && u >= d ? t : Ln(t, i, u);
      }
      var Mf = R_ || function(t) {
        return Bt.clearTimeout(t);
      };
      function Df(t, i) {
        if (i)
          return t.slice();
        var u = t.length, d = rf ? rf(u) : new t.constructor(u);
        return t.copy(d), d;
      }
      function ul(t) {
        var i = new t.constructor(t.byteLength);
        return new Ja(i).set(new Ja(t)), i;
      }
      function jy(t, i) {
        var u = i ? ul(t.buffer) : t.buffer;
        return new t.constructor(u, t.byteOffset, t.byteLength);
      }
      function Yy(t) {
        var i = new t.constructor(t.source, yc.exec(t));
        return i.lastIndex = t.lastIndex, i;
      }
      function Xy(t) {
        return na ? ot(na.call(t)) : {};
      }
      function $f(t, i) {
        var u = i ? ul(t.buffer) : t.buffer;
        return new t.constructor(u, t.byteOffset, t.length);
      }
      function Bf(t, i) {
        if (t !== i) {
          var u = t !== r, d = t === null, g = t === t, w = vn(t), x = i !== r, N = i === null, D = i === i, Y = vn(i);
          if (!N && !Y && !w && t > i || w && x && D && !N && !Y || d && x && D || !u && D || !g)
            return 1;
          if (!d && !w && !Y && t < i || Y && u && g && !d && !w || N && u && g || !x && g || !D)
            return -1;
        }
        return 0;
      }
      function Jy(t, i, u) {
        for (var d = -1, g = t.criteria, w = i.criteria, x = g.length, N = u.length; ++d < x; ) {
          var D = Bf(g[d], w[d]);
          if (D) {
            if (d >= N)
              return D;
            var Y = u[d];
            return D * (Y == "desc" ? -1 : 1);
          }
        }
        return t.index - i.index;
      }
      function Vf(t, i, u, d) {
        for (var g = -1, w = t.length, x = u.length, N = -1, D = i.length, Y = Lt(w - x, 0), X = B(D + Y), ee = !d; ++N < D; )
          X[N] = i[N];
        for (; ++g < x; )
          (ee || g < w) && (X[u[g]] = t[g]);
        for (; Y--; )
          X[N++] = t[g++];
        return X;
      }
      function Uf(t, i, u, d) {
        for (var g = -1, w = t.length, x = -1, N = u.length, D = -1, Y = i.length, X = Lt(w - N, 0), ee = B(X + Y), ce = !d; ++g < X; )
          ee[g] = t[g];
        for (var _e = g; ++D < Y; )
          ee[_e + D] = i[D];
        for (; ++x < N; )
          (ce || g < w) && (ee[_e + u[x]] = t[g++]);
        return ee;
      }
      function en(t, i) {
        var u = -1, d = t.length;
        for (i || (i = B(d)); ++u < d; )
          i[u] = t[u];
        return i;
      }
      function Xn(t, i, u, d) {
        var g = !u;
        u || (u = {});
        for (var w = -1, x = i.length; ++w < x; ) {
          var N = i[w], D = d ? d(u[N], t[N], N, u, t) : r;
          D === r && (D = t[N]), g ? rr(u, N, D) : ra(u, N, D);
        }
        return u;
      }
      function Zy(t, i) {
        return Xn(t, gl(t), i);
      }
      function Qy(t, i) {
        return Xn(t, ed(t), i);
      }
      function ho(t, i) {
        return function(u, d) {
          var g = Fe(u) ? i_ : wy, w = i ? i() : {};
          return g(u, t, Ee(d, 2), w);
        };
      }
      function Ci(t) {
        return We(function(i, u) {
          var d = -1, g = u.length, w = g > 1 ? u[g - 1] : r, x = g > 2 ? u[2] : r;
          for (w = t.length > 3 && typeof w == "function" ? (g--, w) : r, x && jt(u[0], u[1], x) && (w = g < 3 ? r : w, g = 1), i = ot(i); ++d < g; ) {
            var N = u[d];
            N && t(i, N, d, w);
          }
          return i;
        });
      }
      function Wf(t, i) {
        return function(u, d) {
          if (u == null)
            return u;
          if (!tn(u))
            return t(u, d);
          for (var g = u.length, w = i ? g : -1, x = ot(u); (i ? w-- : ++w < g) && d(x[w], w, x) !== !1; )
            ;
          return u;
        };
      }
      function Hf(t) {
        return function(i, u, d) {
          for (var g = -1, w = ot(i), x = d(i), N = x.length; N--; ) {
            var D = x[t ? N : ++g];
            if (u(w[D], D, w) === !1)
              break;
          }
          return i;
        };
      }
      function eb(t, i, u) {
        var d = i & S, g = la(t);
        function w() {
          var x = this && this !== Bt && this instanceof w ? g : t;
          return x.apply(d ? u : this, arguments);
        }
        return w;
      }
      function Gf(t) {
        return function(i) {
          i = nt(i);
          var u = mi(i) ? $n(i) : r, d = u ? u[0] : i.charAt(0), g = u ? Ir(u, 1).join("") : i.slice(1);
          return d[t]() + g;
        };
      }
      function Si(t) {
        return function(i) {
          return Rs(Wd(Ud(i).replace(Gp, "")), t, "");
        };
      }
      function la(t) {
        return function() {
          var i = arguments;
          switch (i.length) {
            case 0:
              return new t();
            case 1:
              return new t(i[0]);
            case 2:
              return new t(i[0], i[1]);
            case 3:
              return new t(i[0], i[1], i[2]);
            case 4:
              return new t(i[0], i[1], i[2], i[3]);
            case 5:
              return new t(i[0], i[1], i[2], i[3], i[4]);
            case 6:
              return new t(i[0], i[1], i[2], i[3], i[4], i[5]);
            case 7:
              return new t(i[0], i[1], i[2], i[3], i[4], i[5], i[6]);
          }
          var u = wi(t.prototype), d = t.apply(u, i);
          return gt(d) ? d : u;
        };
      }
      function tb(t, i, u) {
        var d = la(t);
        function g() {
          for (var w = arguments.length, x = B(w), N = w, D = Ei(g); N--; )
            x[N] = arguments[N];
          var Y = w < 3 && x[0] !== D && x[w - 1] !== D ? [] : Er(x, D);
          if (w -= Y.length, w < u)
            return Yf(
              t,
              i,
              vo,
              g.placeholder,
              r,
              x,
              Y,
              r,
              r,
              u - w
            );
          var X = this && this !== Bt && this instanceof g ? d : t;
          return fn(X, this, x);
        }
        return g;
      }
      function zf(t) {
        return function(i, u, d) {
          var g = ot(i);
          if (!tn(i)) {
            var w = Ee(u, 3);
            i = Rt(i), u = function(N) {
              return w(g[N], N, g);
            };
          }
          var x = t(i, u, d);
          return x > -1 ? g[w ? i[x] : x] : r;
        };
      }
      function qf(t) {
        return ar(function(i) {
          var u = i.length, d = u, g = Tn.prototype.thru;
          for (t && i.reverse(); d--; ) {
            var w = i[d];
            if (typeof w != "function")
              throw new kn(l);
            if (g && !x && _o(w) == "wrapper")
              var x = new Tn([], !0);
          }
          for (d = x ? d : u; ++d < u; ) {
            w = i[d];
            var N = _o(w), D = N == "wrapper" ? vl(w) : r;
            D && _l(D[0]) && D[1] == (E | k | F | V) && !D[4].length && D[9] == 1 ? x = x[_o(D[0])].apply(x, D[3]) : x = w.length == 1 && _l(w) ? x[N]() : x.thru(w);
          }
          return function() {
            var Y = arguments, X = Y[0];
            if (x && Y.length == 1 && Fe(X))
              return x.plant(X).value();
            for (var ee = 0, ce = u ? i[ee].apply(this, Y) : X; ++ee < u; )
              ce = i[ee].call(this, ce);
            return ce;
          };
        });
      }
      function vo(t, i, u, d, g, w, x, N, D, Y) {
        var X = i & E, ee = i & S, ce = i & R, _e = i & (k | L), Ae = i & W, Be = ce ? r : la(t);
        function ke() {
          for (var ze = arguments.length, je = B(ze), mn = ze; mn--; )
            je[mn] = arguments[mn];
          if (_e)
            var Yt = Ei(ke), gn = h_(je, Yt);
          if (d && (je = Vf(je, d, g, _e)), w && (je = Uf(je, w, x, _e)), ze -= gn, _e && ze < Y) {
            var St = Er(je, Yt);
            return Yf(
              t,
              i,
              vo,
              ke.placeholder,
              u,
              je,
              St,
              N,
              D,
              Y - ze
            );
          }
          var Un = ee ? u : this, ur = ce ? Un[t] : t;
          return ze = je.length, N ? je = wb(je, N) : Ae && ze > 1 && je.reverse(), X && D < ze && (je.length = D), this && this !== Bt && this instanceof ke && (ur = Be || la(ur)), ur.apply(Un, je);
        }
        return ke;
      }
      function Kf(t, i) {
        return function(u, d) {
          return Iy(u, t, i(d), {});
        };
      }
      function mo(t, i) {
        return function(u, d) {
          var g;
          if (u === r && d === r)
            return i;
          if (u !== r && (g = u), d !== r) {
            if (g === r)
              return d;
            typeof u == "string" || typeof d == "string" ? (u = hn(u), d = hn(d)) : (u = Pf(u), d = Pf(d)), g = t(u, d);
          }
          return g;
        };
      }
      function cl(t) {
        return ar(function(i) {
          return i = vt(i, dn(Ee())), We(function(u) {
            var d = this;
            return t(i, function(g) {
              return fn(g, d, u);
            });
          });
        });
      }
      function go(t, i) {
        i = i === r ? " " : hn(i);
        var u = i.length;
        if (u < 2)
          return u ? rl(i, t) : i;
        var d = rl(i, to(t / gi(i)));
        return mi(i) ? Ir($n(d), 0, t).join("") : d.slice(0, t);
      }
      function nb(t, i, u, d) {
        var g = i & S, w = la(t);
        function x() {
          for (var N = -1, D = arguments.length, Y = -1, X = d.length, ee = B(X + D), ce = this && this !== Bt && this instanceof x ? w : t; ++Y < X; )
            ee[Y] = d[Y];
          for (; D--; )
            ee[Y++] = arguments[++N];
          return fn(ce, g ? u : this, ee);
        }
        return x;
      }
      function jf(t) {
        return function(i, u, d) {
          return d && typeof d != "number" && jt(i, u, d) && (u = d = r), i = lr(i), u === r ? (u = i, i = 0) : u = lr(u), d = d === r ? i < u ? 1 : -1 : lr(d), Uy(i, u, d, t);
        };
      }
      function po(t) {
        return function(i, u) {
          return typeof i == "string" && typeof u == "string" || (i = Pn(i), u = Pn(u)), t(i, u);
        };
      }
      function Yf(t, i, u, d, g, w, x, N, D, Y) {
        var X = i & k, ee = X ? x : r, ce = X ? r : x, _e = X ? w : r, Ae = X ? r : w;
        i |= X ? F : P, i &= ~(X ? P : F), i & $ || (i &= ~(S | R));
        var Be = [
          t,
          i,
          g,
          _e,
          ee,
          Ae,
          ce,
          N,
          D,
          Y
        ], ke = u.apply(r, Be);
        return _l(t) && sd(ke, Be), ke.placeholder = d, ld(ke, t, i);
      }
      function fl(t) {
        var i = It[t];
        return function(u, d) {
          if (u = Pn(u), d = d == null ? 0 : Wt($e(d), 292), d && lf(u)) {
            var g = (nt(u) + "e").split("e"), w = i(g[0] + "e" + (+g[1] + d));
            return g = (nt(w) + "e").split("e"), +(g[0] + "e" + (+g[1] - d));
          }
          return i(u);
        };
      }
      var rb = yi && 1 / za(new yi([, -0]))[1] == Pe ? function(t) {
        return new yi(t);
      } : Nl;
      function Xf(t) {
        return function(i) {
          var u = Ht(i);
          return u == J ? Us(i) : u == O ? b_(i) : d_(i, t(i));
        };
      }
      function ir(t, i, u, d, g, w, x, N) {
        var D = i & R;
        if (!D && typeof t != "function")
          throw new kn(l);
        var Y = d ? d.length : 0;
        if (Y || (i &= ~(F | P), d = g = r), x = x === r ? x : Lt($e(x), 0), N = N === r ? N : $e(N), Y -= g ? g.length : 0, i & P) {
          var X = d, ee = g;
          d = g = r;
        }
        var ce = D ? r : vl(t), _e = [
          t,
          i,
          u,
          d,
          g,
          X,
          ee,
          w,
          x,
          N
        ];
        if (ce && _b(_e, ce), t = _e[0], i = _e[1], u = _e[2], d = _e[3], g = _e[4], N = _e[9] = _e[9] === r ? D ? 0 : t.length : Lt(_e[9] - Y, 0), !N && i & (k | L) && (i &= ~(k | L)), !i || i == S)
          var Ae = eb(t, i, u);
        else i == k || i == L ? Ae = tb(t, i, N) : (i == F || i == (S | F)) && !g.length ? Ae = nb(t, i, u, d) : Ae = vo.apply(r, _e);
        var Be = ce ? Lf : sd;
        return ld(Be(Ae, _e), t, i);
      }
      function Jf(t, i, u, d) {
        return t === r || Vn(t, _i[u]) && !it.call(d, u) ? i : t;
      }
      function Zf(t, i, u, d, g, w) {
        return gt(t) && gt(i) && (w.set(i, t), uo(t, i, r, Zf, w), w.delete(i)), t;
      }
      function ib(t) {
        return fa(t) ? r : t;
      }
      function Qf(t, i, u, d, g, w) {
        var x = u & b, N = t.length, D = i.length;
        if (N != D && !(x && D > N))
          return !1;
        var Y = w.get(t), X = w.get(i);
        if (Y && X)
          return Y == i && X == t;
        var ee = -1, ce = !0, _e = u & C ? new Wr() : r;
        for (w.set(t, i), w.set(i, t); ++ee < N; ) {
          var Ae = t[ee], Be = i[ee];
          if (d)
            var ke = x ? d(Be, Ae, ee, i, t, w) : d(Ae, Be, ee, t, i, w);
          if (ke !== r) {
            if (ke)
              continue;
            ce = !1;
            break;
          }
          if (_e) {
            if (!Fs(i, function(ze, je) {
              if (!Ji(_e, je) && (Ae === ze || g(Ae, ze, u, d, w)))
                return _e.push(je);
            })) {
              ce = !1;
              break;
            }
          } else if (!(Ae === Be || g(Ae, Be, u, d, w))) {
            ce = !1;
            break;
          }
        }
        return w.delete(t), w.delete(i), ce;
      }
      function ab(t, i, u, d, g, w, x) {
        switch (u) {
          case Xe:
            if (t.byteLength != i.byteLength || t.byteOffset != i.byteOffset)
              return !1;
            t = t.buffer, i = i.buffer;
          case te:
            return !(t.byteLength != i.byteLength || !w(new Ja(t), new Ja(i)));
          case xt:
          case at:
          case be:
            return Vn(+t, +i);
          case Qt:
            return t.name == i.name && t.message == i.message;
          case I:
          case Z:
            return t == i + "";
          case J:
            var N = Us;
          case O:
            var D = d & b;
            if (N || (N = za), t.size != i.size && !D)
              return !1;
            var Y = x.get(t);
            if (Y)
              return Y == i;
            d |= C, x.set(t, i);
            var X = Qf(N(t), N(i), d, g, w, x);
            return x.delete(t), X;
          case pe:
            if (na)
              return na.call(t) == na.call(i);
        }
        return !1;
      }
      function ob(t, i, u, d, g, w) {
        var x = u & b, N = dl(t), D = N.length, Y = dl(i), X = Y.length;
        if (D != X && !x)
          return !1;
        for (var ee = D; ee--; ) {
          var ce = N[ee];
          if (!(x ? ce in i : it.call(i, ce)))
            return !1;
        }
        var _e = w.get(t), Ae = w.get(i);
        if (_e && Ae)
          return _e == i && Ae == t;
        var Be = !0;
        w.set(t, i), w.set(i, t);
        for (var ke = x; ++ee < D; ) {
          ce = N[ee];
          var ze = t[ce], je = i[ce];
          if (d)
            var mn = x ? d(je, ze, ce, i, t, w) : d(ze, je, ce, t, i, w);
          if (!(mn === r ? ze === je || g(ze, je, u, d, w) : mn)) {
            Be = !1;
            break;
          }
          ke || (ke = ce == "constructor");
        }
        if (Be && !ke) {
          var Yt = t.constructor, gn = i.constructor;
          Yt != gn && "constructor" in t && "constructor" in i && !(typeof Yt == "function" && Yt instanceof Yt && typeof gn == "function" && gn instanceof gn) && (Be = !1);
        }
        return w.delete(t), w.delete(i), Be;
      }
      function ar(t) {
        return bl(ad(t, r, vd), t + "");
      }
      function dl(t) {
        return yf(t, Rt, gl);
      }
      function hl(t) {
        return yf(t, nn, ed);
      }
      var vl = ro ? function(t) {
        return ro.get(t);
      } : Nl;
      function _o(t) {
        for (var i = t.name + "", u = bi[i], d = it.call(bi, i) ? u.length : 0; d--; ) {
          var g = u[d], w = g.func;
          if (w == null || w == t)
            return g.name;
        }
        return i;
      }
      function Ei(t) {
        var i = it.call(_, "placeholder") ? _ : t;
        return i.placeholder;
      }
      function Ee() {
        var t = _.iteratee || Ol;
        return t = t === Ol ? Cf : t, arguments.length ? t(arguments[0], arguments[1]) : t;
      }
      function yo(t, i) {
        var u = t.__data__;
        return vb(i) ? u[typeof i == "string" ? "string" : "hash"] : u.map;
      }
      function ml(t) {
        for (var i = Rt(t), u = i.length; u--; ) {
          var d = i[u], g = t[d];
          i[u] = [d, g, rd(g)];
        }
        return i;
      }
      function zr(t, i) {
        var u = p_(t, i);
        return wf(u) ? u : r;
      }
      function sb(t) {
        var i = it.call(t, Vr), u = t[Vr];
        try {
          t[Vr] = r;
          var d = !0;
        } catch {
        }
        var g = Ya.call(t);
        return d && (i ? t[Vr] = u : delete t[Vr]), g;
      }
      var gl = Hs ? function(t) {
        return t == null ? [] : (t = ot(t), Cr(Hs(t), function(i) {
          return of.call(t, i);
        }));
      } : Rl, ed = Hs ? function(t) {
        for (var i = []; t; )
          Sr(i, gl(t)), t = Za(t);
        return i;
      } : Rl, Ht = Kt;
      (Gs && Ht(new Gs(new ArrayBuffer(1))) != Xe || Qi && Ht(new Qi()) != J || zs && Ht(zs.resolve()) != Sn || yi && Ht(new yi()) != O || ea && Ht(new ea()) != xe) && (Ht = function(t) {
        var i = Kt(t), u = i == At ? t.constructor : r, d = u ? qr(u) : "";
        if (d)
          switch (d) {
            case H_:
              return Xe;
            case G_:
              return J;
            case z_:
              return Sn;
            case q_:
              return O;
            case K_:
              return xe;
          }
        return i;
      });
      function lb(t, i, u) {
        for (var d = -1, g = u.length; ++d < g; ) {
          var w = u[d], x = w.size;
          switch (w.type) {
            case "drop":
              t += x;
              break;
            case "dropRight":
              i -= x;
              break;
            case "take":
              i = Wt(i, t + x);
              break;
            case "takeRight":
              t = Lt(t, i - x);
              break;
          }
        }
        return { start: t, end: i };
      }
      function ub(t) {
        var i = t.match(mp);
        return i ? i[1].split(gp) : [];
      }
      function td(t, i, u) {
        i = Tr(i, t);
        for (var d = -1, g = i.length, w = !1; ++d < g; ) {
          var x = Jn(i[d]);
          if (!(w = t != null && u(t, x)))
            break;
          t = t[x];
        }
        return w || ++d != g ? w : (g = t == null ? 0 : t.length, !!g && Ao(g) && or(x, g) && (Fe(t) || Kr(t)));
      }
      function cb(t) {
        var i = t.length, u = new t.constructor(i);
        return i && typeof t[0] == "string" && it.call(t, "index") && (u.index = t.index, u.input = t.input), u;
      }
      function nd(t) {
        return typeof t.constructor == "function" && !ua(t) ? wi(Za(t)) : {};
      }
      function fb(t, i, u) {
        var d = t.constructor;
        switch (i) {
          case te:
            return ul(t);
          case xt:
          case at:
            return new d(+t);
          case Xe:
            return jy(t, u);
          case ft:
          case En:
          case wr:
          case jn:
          case Xi:
          case Ba:
          case ws:
          case Cs:
          case Ss:
            return $f(t, u);
          case J:
            return new d();
          case be:
          case Z:
            return new d(t);
          case I:
            return Yy(t);
          case O:
            return new d();
          case pe:
            return Xy(t);
        }
      }
      function db(t, i) {
        var u = i.length;
        if (!u)
          return t;
        var d = u - 1;
        return i[d] = (u > 1 ? "& " : "") + i[d], i = i.join(u > 2 ? ", " : " "), t.replace(vp, `{
/* [wrapped with ` + i + `] */
`);
      }
      function hb(t) {
        return Fe(t) || Kr(t) || !!(sf && t && t[sf]);
      }
      function or(t, i) {
        var u = typeof t;
        return i = i ?? ie, !!i && (u == "number" || u != "symbol" && xp.test(t)) && t > -1 && t % 1 == 0 && t < i;
      }
      function jt(t, i, u) {
        if (!gt(u))
          return !1;
        var d = typeof i;
        return (d == "number" ? tn(u) && or(i, u.length) : d == "string" && i in u) ? Vn(u[i], t) : !1;
      }
      function pl(t, i) {
        if (Fe(t))
          return !1;
        var u = typeof t;
        return u == "number" || u == "symbol" || u == "boolean" || t == null || vn(t) ? !0 : cp.test(t) || !up.test(t) || i != null && t in ot(i);
      }
      function vb(t) {
        var i = typeof t;
        return i == "string" || i == "number" || i == "symbol" || i == "boolean" ? t !== "__proto__" : t === null;
      }
      function _l(t) {
        var i = _o(t), u = _[i];
        if (typeof u != "function" || !(i in Ke.prototype))
          return !1;
        if (t === u)
          return !0;
        var d = vl(u);
        return !!d && t === d[0];
      }
      function mb(t) {
        return !!nf && nf in t;
      }
      var gb = Ka ? sr : Fl;
      function ua(t) {
        var i = t && t.constructor, u = typeof i == "function" && i.prototype || _i;
        return t === u;
      }
      function rd(t) {
        return t === t && !gt(t);
      }
      function id(t, i) {
        return function(u) {
          return u == null ? !1 : u[t] === i && (i !== r || t in ot(u));
        };
      }
      function pb(t) {
        var i = Eo(t, function(d) {
          return u.size === h && u.clear(), d;
        }), u = i.cache;
        return i;
      }
      function _b(t, i) {
        var u = t[1], d = i[1], g = u | d, w = g < (S | R | E), x = d == E && u == k || d == E && u == V && t[7].length <= i[8] || d == (E | V) && i[7].length <= i[8] && u == k;
        if (!(w || x))
          return t;
        d & S && (t[2] = i[2], g |= u & S ? 0 : $);
        var N = i[3];
        if (N) {
          var D = t[3];
          t[3] = D ? Vf(D, N, i[4]) : N, t[4] = D ? Er(t[3], v) : i[4];
        }
        return N = i[5], N && (D = t[5], t[5] = D ? Uf(D, N, i[6]) : N, t[6] = D ? Er(t[5], v) : i[6]), N = i[7], N && (t[7] = N), d & E && (t[8] = t[8] == null ? i[8] : Wt(t[8], i[8])), t[9] == null && (t[9] = i[9]), t[0] = i[0], t[1] = g, t;
      }
      function yb(t) {
        var i = [];
        if (t != null)
          for (var u in ot(t))
            i.push(u);
        return i;
      }
      function bb(t) {
        return Ya.call(t);
      }
      function ad(t, i, u) {
        return i = Lt(i === r ? t.length - 1 : i, 0), function() {
          for (var d = arguments, g = -1, w = Lt(d.length - i, 0), x = B(w); ++g < w; )
            x[g] = d[i + g];
          g = -1;
          for (var N = B(i + 1); ++g < i; )
            N[g] = d[g];
          return N[i] = u(x), fn(t, this, N);
        };
      }
      function od(t, i) {
        return i.length < 2 ? t : Gr(t, Ln(i, 0, -1));
      }
      function wb(t, i) {
        for (var u = t.length, d = Wt(i.length, u), g = en(t); d--; ) {
          var w = i[d];
          t[d] = or(w, u) ? g[w] : r;
        }
        return t;
      }
      function yl(t, i) {
        if (!(i === "constructor" && typeof t[i] == "function") && i != "__proto__")
          return t[i];
      }
      var sd = ud(Lf), ca = M_ || function(t, i) {
        return Bt.setTimeout(t, i);
      }, bl = ud(Gy);
      function ld(t, i, u) {
        var d = i + "";
        return bl(t, db(d, Cb(ub(d), u)));
      }
      function ud(t) {
        var i = 0, u = 0;
        return function() {
          var d = V_(), g = ae - (d - u);
          if (u = d, g > 0) {
            if (++i >= K)
              return arguments[0];
          } else
            i = 0;
          return t.apply(r, arguments);
        };
      }
      function bo(t, i) {
        var u = -1, d = t.length, g = d - 1;
        for (i = i === r ? d : i; ++u < i; ) {
          var w = nl(u, g), x = t[w];
          t[w] = t[u], t[u] = x;
        }
        return t.length = i, t;
      }
      var cd = pb(function(t) {
        var i = [];
        return t.charCodeAt(0) === 46 && i.push(""), t.replace(fp, function(u, d, g, w) {
          i.push(g ? w.replace(yp, "$1") : d || u);
        }), i;
      });
      function Jn(t) {
        if (typeof t == "string" || vn(t))
          return t;
        var i = t + "";
        return i == "0" && 1 / t == -Pe ? "-0" : i;
      }
      function qr(t) {
        if (t != null) {
          try {
            return ja.call(t);
          } catch {
          }
          try {
            return t + "";
          } catch {
          }
        }
        return "";
      }
      function Cb(t, i) {
        return An(Oe, function(u) {
          var d = "_." + u[0];
          i & u[1] && !Ha(t, d) && t.push(d);
        }), t.sort();
      }
      function fd(t) {
        if (t instanceof Ke)
          return t.clone();
        var i = new Tn(t.__wrapped__, t.__chain__);
        return i.__actions__ = en(t.__actions__), i.__index__ = t.__index__, i.__values__ = t.__values__, i;
      }
      function Sb(t, i, u) {
        (u ? jt(t, i, u) : i === r) ? i = 1 : i = Lt($e(i), 0);
        var d = t == null ? 0 : t.length;
        if (!d || i < 1)
          return [];
        for (var g = 0, w = 0, x = B(to(d / i)); g < d; )
          x[w++] = Ln(t, g, g += i);
        return x;
      }
      function Eb(t) {
        for (var i = -1, u = t == null ? 0 : t.length, d = 0, g = []; ++i < u; ) {
          var w = t[i];
          w && (g[d++] = w);
        }
        return g;
      }
      function xb() {
        var t = arguments.length;
        if (!t)
          return [];
        for (var i = B(t - 1), u = arguments[0], d = t; d--; )
          i[d - 1] = arguments[d];
        return Sr(Fe(u) ? en(u) : [u], Vt(i, 1));
      }
      var Ab = We(function(t, i) {
        return Ct(t) ? ia(t, Vt(i, 1, Ct, !0)) : [];
      }), kb = We(function(t, i) {
        var u = On(i);
        return Ct(u) && (u = r), Ct(t) ? ia(t, Vt(i, 1, Ct, !0), Ee(u, 2)) : [];
      }), Tb = We(function(t, i) {
        var u = On(i);
        return Ct(u) && (u = r), Ct(t) ? ia(t, Vt(i, 1, Ct, !0), r, u) : [];
      });
      function Ib(t, i, u) {
        var d = t == null ? 0 : t.length;
        return d ? (i = u || i === r ? 1 : $e(i), Ln(t, i < 0 ? 0 : i, d)) : [];
      }
      function Lb(t, i, u) {
        var d = t == null ? 0 : t.length;
        return d ? (i = u || i === r ? 1 : $e(i), i = d - i, Ln(t, 0, i < 0 ? 0 : i)) : [];
      }
      function Ob(t, i) {
        return t && t.length ? fo(t, Ee(i, 3), !0, !0) : [];
      }
      function Pb(t, i) {
        return t && t.length ? fo(t, Ee(i, 3), !0) : [];
      }
      function Nb(t, i, u, d) {
        var g = t == null ? 0 : t.length;
        return g ? (u && typeof u != "number" && jt(t, i, u) && (u = 0, d = g), xy(t, i, u, d)) : [];
      }
      function dd(t, i, u) {
        var d = t == null ? 0 : t.length;
        if (!d)
          return -1;
        var g = u == null ? 0 : $e(u);
        return g < 0 && (g = Lt(d + g, 0)), Ga(t, Ee(i, 3), g);
      }
      function hd(t, i, u) {
        var d = t == null ? 0 : t.length;
        if (!d)
          return -1;
        var g = d - 1;
        return u !== r && (g = $e(u), g = u < 0 ? Lt(d + g, 0) : Wt(g, d - 1)), Ga(t, Ee(i, 3), g, !0);
      }
      function vd(t) {
        var i = t == null ? 0 : t.length;
        return i ? Vt(t, 1) : [];
      }
      function Rb(t) {
        var i = t == null ? 0 : t.length;
        return i ? Vt(t, Pe) : [];
      }
      function Fb(t, i) {
        var u = t == null ? 0 : t.length;
        return u ? (i = i === r ? 1 : $e(i), Vt(t, i)) : [];
      }
      function Mb(t) {
        for (var i = -1, u = t == null ? 0 : t.length, d = {}; ++i < u; ) {
          var g = t[i];
          d[g[0]] = g[1];
        }
        return d;
      }
      function md(t) {
        return t && t.length ? t[0] : r;
      }
      function Db(t, i, u) {
        var d = t == null ? 0 : t.length;
        if (!d)
          return -1;
        var g = u == null ? 0 : $e(u);
        return g < 0 && (g = Lt(d + g, 0)), vi(t, i, g);
      }
      function $b(t) {
        var i = t == null ? 0 : t.length;
        return i ? Ln(t, 0, -1) : [];
      }
      var Bb = We(function(t) {
        var i = vt(t, sl);
        return i.length && i[0] === t[0] ? Js(i) : [];
      }), Vb = We(function(t) {
        var i = On(t), u = vt(t, sl);
        return i === On(u) ? i = r : u.pop(), u.length && u[0] === t[0] ? Js(u, Ee(i, 2)) : [];
      }), Ub = We(function(t) {
        var i = On(t), u = vt(t, sl);
        return i = typeof i == "function" ? i : r, i && u.pop(), u.length && u[0] === t[0] ? Js(u, r, i) : [];
      });
      function Wb(t, i) {
        return t == null ? "" : $_.call(t, i);
      }
      function On(t) {
        var i = t == null ? 0 : t.length;
        return i ? t[i - 1] : r;
      }
      function Hb(t, i, u) {
        var d = t == null ? 0 : t.length;
        if (!d)
          return -1;
        var g = d;
        return u !== r && (g = $e(u), g = g < 0 ? Lt(d + g, 0) : Wt(g, d - 1)), i === i ? C_(t, i, g) : Ga(t, jc, g, !0);
      }
      function Gb(t, i) {
        return t && t.length ? Af(t, $e(i)) : r;
      }
      var zb = We(gd);
      function gd(t, i) {
        return t && t.length && i && i.length ? tl(t, i) : t;
      }
      function qb(t, i, u) {
        return t && t.length && i && i.length ? tl(t, i, Ee(u, 2)) : t;
      }
      function Kb(t, i, u) {
        return t && t.length && i && i.length ? tl(t, i, r, u) : t;
      }
      var jb = ar(function(t, i) {
        var u = t == null ? 0 : t.length, d = Ks(t, i);
        return If(t, vt(i, function(g) {
          return or(g, u) ? +g : g;
        }).sort(Bf)), d;
      });
      function Yb(t, i) {
        var u = [];
        if (!(t && t.length))
          return u;
        var d = -1, g = [], w = t.length;
        for (i = Ee(i, 3); ++d < w; ) {
          var x = t[d];
          i(x, d, t) && (u.push(x), g.push(d));
        }
        return If(t, g), u;
      }
      function wl(t) {
        return t == null ? t : W_.call(t);
      }
      function Xb(t, i, u) {
        var d = t == null ? 0 : t.length;
        return d ? (u && typeof u != "number" && jt(t, i, u) ? (i = 0, u = d) : (i = i == null ? 0 : $e(i), u = u === r ? d : $e(u)), Ln(t, i, u)) : [];
      }
      function Jb(t, i) {
        return co(t, i);
      }
      function Zb(t, i, u) {
        return il(t, i, Ee(u, 2));
      }
      function Qb(t, i) {
        var u = t == null ? 0 : t.length;
        if (u) {
          var d = co(t, i);
          if (d < u && Vn(t[d], i))
            return d;
        }
        return -1;
      }
      function e0(t, i) {
        return co(t, i, !0);
      }
      function t0(t, i, u) {
        return il(t, i, Ee(u, 2), !0);
      }
      function n0(t, i) {
        var u = t == null ? 0 : t.length;
        if (u) {
          var d = co(t, i, !0) - 1;
          if (Vn(t[d], i))
            return d;
        }
        return -1;
      }
      function r0(t) {
        return t && t.length ? Of(t) : [];
      }
      function i0(t, i) {
        return t && t.length ? Of(t, Ee(i, 2)) : [];
      }
      function a0(t) {
        var i = t == null ? 0 : t.length;
        return i ? Ln(t, 1, i) : [];
      }
      function o0(t, i, u) {
        return t && t.length ? (i = u || i === r ? 1 : $e(i), Ln(t, 0, i < 0 ? 0 : i)) : [];
      }
      function s0(t, i, u) {
        var d = t == null ? 0 : t.length;
        return d ? (i = u || i === r ? 1 : $e(i), i = d - i, Ln(t, i < 0 ? 0 : i, d)) : [];
      }
      function l0(t, i) {
        return t && t.length ? fo(t, Ee(i, 3), !1, !0) : [];
      }
      function u0(t, i) {
        return t && t.length ? fo(t, Ee(i, 3)) : [];
      }
      var c0 = We(function(t) {
        return kr(Vt(t, 1, Ct, !0));
      }), f0 = We(function(t) {
        var i = On(t);
        return Ct(i) && (i = r), kr(Vt(t, 1, Ct, !0), Ee(i, 2));
      }), d0 = We(function(t) {
        var i = On(t);
        return i = typeof i == "function" ? i : r, kr(Vt(t, 1, Ct, !0), r, i);
      });
      function h0(t) {
        return t && t.length ? kr(t) : [];
      }
      function v0(t, i) {
        return t && t.length ? kr(t, Ee(i, 2)) : [];
      }
      function m0(t, i) {
        return i = typeof i == "function" ? i : r, t && t.length ? kr(t, r, i) : [];
      }
      function Cl(t) {
        if (!(t && t.length))
          return [];
        var i = 0;
        return t = Cr(t, function(u) {
          if (Ct(u))
            return i = Lt(u.length, i), !0;
        }), Bs(i, function(u) {
          return vt(t, Ms(u));
        });
      }
      function pd(t, i) {
        if (!(t && t.length))
          return [];
        var u = Cl(t);
        return i == null ? u : vt(u, function(d) {
          return fn(i, r, d);
        });
      }
      var g0 = We(function(t, i) {
        return Ct(t) ? ia(t, i) : [];
      }), p0 = We(function(t) {
        return ol(Cr(t, Ct));
      }), _0 = We(function(t) {
        var i = On(t);
        return Ct(i) && (i = r), ol(Cr(t, Ct), Ee(i, 2));
      }), y0 = We(function(t) {
        var i = On(t);
        return i = typeof i == "function" ? i : r, ol(Cr(t, Ct), r, i);
      }), b0 = We(Cl);
      function w0(t, i) {
        return Ff(t || [], i || [], ra);
      }
      function C0(t, i) {
        return Ff(t || [], i || [], sa);
      }
      var S0 = We(function(t) {
        var i = t.length, u = i > 1 ? t[i - 1] : r;
        return u = typeof u == "function" ? (t.pop(), u) : r, pd(t, u);
      });
      function _d(t) {
        var i = _(t);
        return i.__chain__ = !0, i;
      }
      function E0(t, i) {
        return i(t), t;
      }
      function wo(t, i) {
        return i(t);
      }
      var x0 = ar(function(t) {
        var i = t.length, u = i ? t[0] : 0, d = this.__wrapped__, g = function(w) {
          return Ks(w, t);
        };
        return i > 1 || this.__actions__.length || !(d instanceof Ke) || !or(u) ? this.thru(g) : (d = d.slice(u, +u + (i ? 1 : 0)), d.__actions__.push({
          func: wo,
          args: [g],
          thisArg: r
        }), new Tn(d, this.__chain__).thru(function(w) {
          return i && !w.length && w.push(r), w;
        }));
      });
      function A0() {
        return _d(this);
      }
      function k0() {
        return new Tn(this.value(), this.__chain__);
      }
      function T0() {
        this.__values__ === r && (this.__values__ = Pd(this.value()));
        var t = this.__index__ >= this.__values__.length, i = t ? r : this.__values__[this.__index__++];
        return { done: t, value: i };
      }
      function I0() {
        return this;
      }
      function L0(t) {
        for (var i, u = this; u instanceof ao; ) {
          var d = fd(u);
          d.__index__ = 0, d.__values__ = r, i ? g.__wrapped__ = d : i = d;
          var g = d;
          u = u.__wrapped__;
        }
        return g.__wrapped__ = t, i;
      }
      function O0() {
        var t = this.__wrapped__;
        if (t instanceof Ke) {
          var i = t;
          return this.__actions__.length && (i = new Ke(this)), i = i.reverse(), i.__actions__.push({
            func: wo,
            args: [wl],
            thisArg: r
          }), new Tn(i, this.__chain__);
        }
        return this.thru(wl);
      }
      function P0() {
        return Rf(this.__wrapped__, this.__actions__);
      }
      var N0 = ho(function(t, i, u) {
        it.call(t, u) ? ++t[u] : rr(t, u, 1);
      });
      function R0(t, i, u) {
        var d = Fe(t) ? qc : Ey;
        return u && jt(t, i, u) && (i = r), d(t, Ee(i, 3));
      }
      function F0(t, i) {
        var u = Fe(t) ? Cr : pf;
        return u(t, Ee(i, 3));
      }
      var M0 = zf(dd), D0 = zf(hd);
      function $0(t, i) {
        return Vt(Co(t, i), 1);
      }
      function B0(t, i) {
        return Vt(Co(t, i), Pe);
      }
      function V0(t, i, u) {
        return u = u === r ? 1 : $e(u), Vt(Co(t, i), u);
      }
      function yd(t, i) {
        var u = Fe(t) ? An : Ar;
        return u(t, Ee(i, 3));
      }
      function bd(t, i) {
        var u = Fe(t) ? a_ : gf;
        return u(t, Ee(i, 3));
      }
      var U0 = ho(function(t, i, u) {
        it.call(t, u) ? t[u].push(i) : rr(t, u, [i]);
      });
      function W0(t, i, u, d) {
        t = tn(t) ? t : Ai(t), u = u && !d ? $e(u) : 0;
        var g = t.length;
        return u < 0 && (u = Lt(g + u, 0)), ko(t) ? u <= g && t.indexOf(i, u) > -1 : !!g && vi(t, i, u) > -1;
      }
      var H0 = We(function(t, i, u) {
        var d = -1, g = typeof i == "function", w = tn(t) ? B(t.length) : [];
        return Ar(t, function(x) {
          w[++d] = g ? fn(i, x, u) : aa(x, i, u);
        }), w;
      }), G0 = ho(function(t, i, u) {
        rr(t, u, i);
      });
      function Co(t, i) {
        var u = Fe(t) ? vt : Sf;
        return u(t, Ee(i, 3));
      }
      function z0(t, i, u, d) {
        return t == null ? [] : (Fe(i) || (i = i == null ? [] : [i]), u = d ? r : u, Fe(u) || (u = u == null ? [] : [u]), kf(t, i, u));
      }
      var q0 = ho(function(t, i, u) {
        t[u ? 0 : 1].push(i);
      }, function() {
        return [[], []];
      });
      function K0(t, i, u) {
        var d = Fe(t) ? Rs : Xc, g = arguments.length < 3;
        return d(t, Ee(i, 4), u, g, Ar);
      }
      function j0(t, i, u) {
        var d = Fe(t) ? o_ : Xc, g = arguments.length < 3;
        return d(t, Ee(i, 4), u, g, gf);
      }
      function Y0(t, i) {
        var u = Fe(t) ? Cr : pf;
        return u(t, xo(Ee(i, 3)));
      }
      function X0(t) {
        var i = Fe(t) ? df : Wy;
        return i(t);
      }
      function J0(t, i, u) {
        (u ? jt(t, i, u) : i === r) ? i = 1 : i = $e(i);
        var d = Fe(t) ? yy : Hy;
        return d(t, i);
      }
      function Z0(t) {
        var i = Fe(t) ? by : zy;
        return i(t);
      }
      function Q0(t) {
        if (t == null)
          return 0;
        if (tn(t))
          return ko(t) ? gi(t) : t.length;
        var i = Ht(t);
        return i == J || i == O ? t.size : Qs(t).length;
      }
      function ew(t, i, u) {
        var d = Fe(t) ? Fs : qy;
        return u && jt(t, i, u) && (i = r), d(t, Ee(i, 3));
      }
      var tw = We(function(t, i) {
        if (t == null)
          return [];
        var u = i.length;
        return u > 1 && jt(t, i[0], i[1]) ? i = [] : u > 2 && jt(i[0], i[1], i[2]) && (i = [i[0]]), kf(t, Vt(i, 1), []);
      }), So = F_ || function() {
        return Bt.Date.now();
      };
      function nw(t, i) {
        if (typeof i != "function")
          throw new kn(l);
        return t = $e(t), function() {
          if (--t < 1)
            return i.apply(this, arguments);
        };
      }
      function wd(t, i, u) {
        return i = u ? r : i, i = t && i == null ? t.length : i, ir(t, E, r, r, r, r, i);
      }
      function Cd(t, i) {
        var u;
        if (typeof i != "function")
          throw new kn(l);
        return t = $e(t), function() {
          return --t > 0 && (u = i.apply(this, arguments)), t <= 1 && (i = r), u;
        };
      }
      var Sl = We(function(t, i, u) {
        var d = S;
        if (u.length) {
          var g = Er(u, Ei(Sl));
          d |= F;
        }
        return ir(t, d, i, u, g);
      }), Sd = We(function(t, i, u) {
        var d = S | R;
        if (u.length) {
          var g = Er(u, Ei(Sd));
          d |= F;
        }
        return ir(i, d, t, u, g);
      });
      function Ed(t, i, u) {
        i = u ? r : i;
        var d = ir(t, k, r, r, r, r, r, i);
        return d.placeholder = Ed.placeholder, d;
      }
      function xd(t, i, u) {
        i = u ? r : i;
        var d = ir(t, L, r, r, r, r, r, i);
        return d.placeholder = xd.placeholder, d;
      }
      function Ad(t, i, u) {
        var d, g, w, x, N, D, Y = 0, X = !1, ee = !1, ce = !0;
        if (typeof t != "function")
          throw new kn(l);
        i = Pn(i) || 0, gt(u) && (X = !!u.leading, ee = "maxWait" in u, w = ee ? Lt(Pn(u.maxWait) || 0, i) : w, ce = "trailing" in u ? !!u.trailing : ce);
        function _e(St) {
          var Un = d, ur = g;
          return d = g = r, Y = St, x = t.apply(ur, Un), x;
        }
        function Ae(St) {
          return Y = St, N = ca(ze, i), X ? _e(St) : x;
        }
        function Be(St) {
          var Un = St - D, ur = St - Y, zd = i - Un;
          return ee ? Wt(zd, w - ur) : zd;
        }
        function ke(St) {
          var Un = St - D, ur = St - Y;
          return D === r || Un >= i || Un < 0 || ee && ur >= w;
        }
        function ze() {
          var St = So();
          if (ke(St))
            return je(St);
          N = ca(ze, Be(St));
        }
        function je(St) {
          return N = r, ce && d ? _e(St) : (d = g = r, x);
        }
        function mn() {
          N !== r && Mf(N), Y = 0, d = D = g = N = r;
        }
        function Yt() {
          return N === r ? x : je(So());
        }
        function gn() {
          var St = So(), Un = ke(St);
          if (d = arguments, g = this, D = St, Un) {
            if (N === r)
              return Ae(D);
            if (ee)
              return Mf(N), N = ca(ze, i), _e(D);
          }
          return N === r && (N = ca(ze, i)), x;
        }
        return gn.cancel = mn, gn.flush = Yt, gn;
      }
      var rw = We(function(t, i) {
        return mf(t, 1, i);
      }), iw = We(function(t, i, u) {
        return mf(t, Pn(i) || 0, u);
      });
      function aw(t) {
        return ir(t, W);
      }
      function Eo(t, i) {
        if (typeof t != "function" || i != null && typeof i != "function")
          throw new kn(l);
        var u = function() {
          var d = arguments, g = i ? i.apply(this, d) : d[0], w = u.cache;
          if (w.has(g))
            return w.get(g);
          var x = t.apply(this, d);
          return u.cache = w.set(g, x) || w, x;
        };
        return u.cache = new (Eo.Cache || nr)(), u;
      }
      Eo.Cache = nr;
      function xo(t) {
        if (typeof t != "function")
          throw new kn(l);
        return function() {
          var i = arguments;
          switch (i.length) {
            case 0:
              return !t.call(this);
            case 1:
              return !t.call(this, i[0]);
            case 2:
              return !t.call(this, i[0], i[1]);
            case 3:
              return !t.call(this, i[0], i[1], i[2]);
          }
          return !t.apply(this, i);
        };
      }
      function ow(t) {
        return Cd(2, t);
      }
      var sw = Ky(function(t, i) {
        i = i.length == 1 && Fe(i[0]) ? vt(i[0], dn(Ee())) : vt(Vt(i, 1), dn(Ee()));
        var u = i.length;
        return We(function(d) {
          for (var g = -1, w = Wt(d.length, u); ++g < w; )
            d[g] = i[g].call(this, d[g]);
          return fn(t, this, d);
        });
      }), El = We(function(t, i) {
        var u = Er(i, Ei(El));
        return ir(t, F, r, i, u);
      }), kd = We(function(t, i) {
        var u = Er(i, Ei(kd));
        return ir(t, P, r, i, u);
      }), lw = ar(function(t, i) {
        return ir(t, V, r, r, r, i);
      });
      function uw(t, i) {
        if (typeof t != "function")
          throw new kn(l);
        return i = i === r ? i : $e(i), We(t, i);
      }
      function cw(t, i) {
        if (typeof t != "function")
          throw new kn(l);
        return i = i == null ? 0 : Lt($e(i), 0), We(function(u) {
          var d = u[i], g = Ir(u, 0, i);
          return d && Sr(g, d), fn(t, this, g);
        });
      }
      function fw(t, i, u) {
        var d = !0, g = !0;
        if (typeof t != "function")
          throw new kn(l);
        return gt(u) && (d = "leading" in u ? !!u.leading : d, g = "trailing" in u ? !!u.trailing : g), Ad(t, i, {
          leading: d,
          maxWait: i,
          trailing: g
        });
      }
      function dw(t) {
        return wd(t, 1);
      }
      function hw(t, i) {
        return El(ll(i), t);
      }
      function vw() {
        if (!arguments.length)
          return [];
        var t = arguments[0];
        return Fe(t) ? t : [t];
      }
      function mw(t) {
        return In(t, y);
      }
      function gw(t, i) {
        return i = typeof i == "function" ? i : r, In(t, y, i);
      }
      function pw(t) {
        return In(t, m | y);
      }
      function _w(t, i) {
        return i = typeof i == "function" ? i : r, In(t, m | y, i);
      }
      function yw(t, i) {
        return i == null || vf(t, i, Rt(i));
      }
      function Vn(t, i) {
        return t === i || t !== t && i !== i;
      }
      var bw = po(Xs), ww = po(function(t, i) {
        return t >= i;
      }), Kr = bf(/* @__PURE__ */ function() {
        return arguments;
      }()) ? bf : function(t) {
        return yt(t) && it.call(t, "callee") && !of.call(t, "callee");
      }, Fe = B.isArray, Cw = Vc ? dn(Vc) : Ly;
      function tn(t) {
        return t != null && Ao(t.length) && !sr(t);
      }
      function Ct(t) {
        return yt(t) && tn(t);
      }
      function Sw(t) {
        return t === !0 || t === !1 || yt(t) && Kt(t) == xt;
      }
      var Lr = D_ || Fl, Ew = Uc ? dn(Uc) : Oy;
      function xw(t) {
        return yt(t) && t.nodeType === 1 && !fa(t);
      }
      function Aw(t) {
        if (t == null)
          return !0;
        if (tn(t) && (Fe(t) || typeof t == "string" || typeof t.splice == "function" || Lr(t) || xi(t) || Kr(t)))
          return !t.length;
        var i = Ht(t);
        if (i == J || i == O)
          return !t.size;
        if (ua(t))
          return !Qs(t).length;
        for (var u in t)
          if (it.call(t, u))
            return !1;
        return !0;
      }
      function kw(t, i) {
        return oa(t, i);
      }
      function Tw(t, i, u) {
        u = typeof u == "function" ? u : r;
        var d = u ? u(t, i) : r;
        return d === r ? oa(t, i, r, u) : !!d;
      }
      function xl(t) {
        if (!yt(t))
          return !1;
        var i = Kt(t);
        return i == Qt || i == Cn || typeof t.message == "string" && typeof t.name == "string" && !fa(t);
      }
      function Iw(t) {
        return typeof t == "number" && lf(t);
      }
      function sr(t) {
        if (!gt(t))
          return !1;
        var i = Kt(t);
        return i == cn || i == we || i == $t || i == er;
      }
      function Td(t) {
        return typeof t == "number" && t == $e(t);
      }
      function Ao(t) {
        return typeof t == "number" && t > -1 && t % 1 == 0 && t <= ie;
      }
      function gt(t) {
        var i = typeof t;
        return t != null && (i == "object" || i == "function");
      }
      function yt(t) {
        return t != null && typeof t == "object";
      }
      var Id = Wc ? dn(Wc) : Ny;
      function Lw(t, i) {
        return t === i || Zs(t, i, ml(i));
      }
      function Ow(t, i, u) {
        return u = typeof u == "function" ? u : r, Zs(t, i, ml(i), u);
      }
      function Pw(t) {
        return Ld(t) && t != +t;
      }
      function Nw(t) {
        if (gb(t))
          throw new Ne(s);
        return wf(t);
      }
      function Rw(t) {
        return t === null;
      }
      function Fw(t) {
        return t == null;
      }
      function Ld(t) {
        return typeof t == "number" || yt(t) && Kt(t) == be;
      }
      function fa(t) {
        if (!yt(t) || Kt(t) != At)
          return !1;
        var i = Za(t);
        if (i === null)
          return !0;
        var u = it.call(i, "constructor") && i.constructor;
        return typeof u == "function" && u instanceof u && ja.call(u) == O_;
      }
      var Al = Hc ? dn(Hc) : Ry;
      function Mw(t) {
        return Td(t) && t >= -ie && t <= ie;
      }
      var Od = Gc ? dn(Gc) : Fy;
      function ko(t) {
        return typeof t == "string" || !Fe(t) && yt(t) && Kt(t) == Z;
      }
      function vn(t) {
        return typeof t == "symbol" || yt(t) && Kt(t) == pe;
      }
      var xi = zc ? dn(zc) : My;
      function Dw(t) {
        return t === r;
      }
      function $w(t) {
        return yt(t) && Ht(t) == xe;
      }
      function Bw(t) {
        return yt(t) && Kt(t) == H;
      }
      var Vw = po(el), Uw = po(function(t, i) {
        return t <= i;
      });
      function Pd(t) {
        if (!t)
          return [];
        if (tn(t))
          return ko(t) ? $n(t) : en(t);
        if (Zi && t[Zi])
          return y_(t[Zi]());
        var i = Ht(t), u = i == J ? Us : i == O ? za : Ai;
        return u(t);
      }
      function lr(t) {
        if (!t)
          return t === 0 ? t : 0;
        if (t = Pn(t), t === Pe || t === -Pe) {
          var i = t < 0 ? -1 : 1;
          return i * se;
        }
        return t === t ? t : 0;
      }
      function $e(t) {
        var i = lr(t), u = i % 1;
        return i === i ? u ? i - u : i : 0;
      }
      function Nd(t) {
        return t ? Hr($e(t), 0, re) : 0;
      }
      function Pn(t) {
        if (typeof t == "number")
          return t;
        if (vn(t))
          return j;
        if (gt(t)) {
          var i = typeof t.valueOf == "function" ? t.valueOf() : t;
          t = gt(i) ? i + "" : i;
        }
        if (typeof t != "string")
          return t === 0 ? t : +t;
        t = Jc(t);
        var u = Cp.test(t);
        return u || Ep.test(t) ? n_(t.slice(2), u ? 2 : 8) : wp.test(t) ? j : +t;
      }
      function Rd(t) {
        return Xn(t, nn(t));
      }
      function Ww(t) {
        return t ? Hr($e(t), -ie, ie) : t === 0 ? t : 0;
      }
      function nt(t) {
        return t == null ? "" : hn(t);
      }
      var Hw = Ci(function(t, i) {
        if (ua(i) || tn(i)) {
          Xn(i, Rt(i), t);
          return;
        }
        for (var u in i)
          it.call(i, u) && ra(t, u, i[u]);
      }), Fd = Ci(function(t, i) {
        Xn(i, nn(i), t);
      }), To = Ci(function(t, i, u, d) {
        Xn(i, nn(i), t, d);
      }), Gw = Ci(function(t, i, u, d) {
        Xn(i, Rt(i), t, d);
      }), zw = ar(Ks);
      function qw(t, i) {
        var u = wi(t);
        return i == null ? u : hf(u, i);
      }
      var Kw = We(function(t, i) {
        t = ot(t);
        var u = -1, d = i.length, g = d > 2 ? i[2] : r;
        for (g && jt(i[0], i[1], g) && (d = 1); ++u < d; )
          for (var w = i[u], x = nn(w), N = -1, D = x.length; ++N < D; ) {
            var Y = x[N], X = t[Y];
            (X === r || Vn(X, _i[Y]) && !it.call(t, Y)) && (t[Y] = w[Y]);
          }
        return t;
      }), jw = We(function(t) {
        return t.push(r, Zf), fn(Md, r, t);
      });
      function Yw(t, i) {
        return Kc(t, Ee(i, 3), Yn);
      }
      function Xw(t, i) {
        return Kc(t, Ee(i, 3), Ys);
      }
      function Jw(t, i) {
        return t == null ? t : js(t, Ee(i, 3), nn);
      }
      function Zw(t, i) {
        return t == null ? t : _f(t, Ee(i, 3), nn);
      }
      function Qw(t, i) {
        return t && Yn(t, Ee(i, 3));
      }
      function e1(t, i) {
        return t && Ys(t, Ee(i, 3));
      }
      function t1(t) {
        return t == null ? [] : lo(t, Rt(t));
      }
      function n1(t) {
        return t == null ? [] : lo(t, nn(t));
      }
      function kl(t, i, u) {
        var d = t == null ? r : Gr(t, i);
        return d === r ? u : d;
      }
      function r1(t, i) {
        return t != null && td(t, i, Ay);
      }
      function Tl(t, i) {
        return t != null && td(t, i, ky);
      }
      var i1 = Kf(function(t, i, u) {
        i != null && typeof i.toString != "function" && (i = Ya.call(i)), t[i] = u;
      }, Ll(rn)), a1 = Kf(function(t, i, u) {
        i != null && typeof i.toString != "function" && (i = Ya.call(i)), it.call(t, i) ? t[i].push(u) : t[i] = [u];
      }, Ee), o1 = We(aa);
      function Rt(t) {
        return tn(t) ? ff(t) : Qs(t);
      }
      function nn(t) {
        return tn(t) ? ff(t, !0) : Dy(t);
      }
      function s1(t, i) {
        var u = {};
        return i = Ee(i, 3), Yn(t, function(d, g, w) {
          rr(u, i(d, g, w), d);
        }), u;
      }
      function l1(t, i) {
        var u = {};
        return i = Ee(i, 3), Yn(t, function(d, g, w) {
          rr(u, g, i(d, g, w));
        }), u;
      }
      var u1 = Ci(function(t, i, u) {
        uo(t, i, u);
      }), Md = Ci(function(t, i, u, d) {
        uo(t, i, u, d);
      }), c1 = ar(function(t, i) {
        var u = {};
        if (t == null)
          return u;
        var d = !1;
        i = vt(i, function(w) {
          return w = Tr(w, t), d || (d = w.length > 1), w;
        }), Xn(t, hl(t), u), d && (u = In(u, m | p | y, ib));
        for (var g = i.length; g--; )
          al(u, i[g]);
        return u;
      });
      function f1(t, i) {
        return Dd(t, xo(Ee(i)));
      }
      var d1 = ar(function(t, i) {
        return t == null ? {} : By(t, i);
      });
      function Dd(t, i) {
        if (t == null)
          return {};
        var u = vt(hl(t), function(d) {
          return [d];
        });
        return i = Ee(i), Tf(t, u, function(d, g) {
          return i(d, g[0]);
        });
      }
      function h1(t, i, u) {
        i = Tr(i, t);
        var d = -1, g = i.length;
        for (g || (g = 1, t = r); ++d < g; ) {
          var w = t == null ? r : t[Jn(i[d])];
          w === r && (d = g, w = u), t = sr(w) ? w.call(t) : w;
        }
        return t;
      }
      function v1(t, i, u) {
        return t == null ? t : sa(t, i, u);
      }
      function m1(t, i, u, d) {
        return d = typeof d == "function" ? d : r, t == null ? t : sa(t, i, u, d);
      }
      var $d = Xf(Rt), Bd = Xf(nn);
      function g1(t, i, u) {
        var d = Fe(t), g = d || Lr(t) || xi(t);
        if (i = Ee(i, 4), u == null) {
          var w = t && t.constructor;
          g ? u = d ? new w() : [] : gt(t) ? u = sr(w) ? wi(Za(t)) : {} : u = {};
        }
        return (g ? An : Yn)(t, function(x, N, D) {
          return i(u, x, N, D);
        }), u;
      }
      function p1(t, i) {
        return t == null ? !0 : al(t, i);
      }
      function _1(t, i, u) {
        return t == null ? t : Nf(t, i, ll(u));
      }
      function y1(t, i, u, d) {
        return d = typeof d == "function" ? d : r, t == null ? t : Nf(t, i, ll(u), d);
      }
      function Ai(t) {
        return t == null ? [] : Vs(t, Rt(t));
      }
      function b1(t) {
        return t == null ? [] : Vs(t, nn(t));
      }
      function w1(t, i, u) {
        return u === r && (u = i, i = r), u !== r && (u = Pn(u), u = u === u ? u : 0), i !== r && (i = Pn(i), i = i === i ? i : 0), Hr(Pn(t), i, u);
      }
      function C1(t, i, u) {
        return i = lr(i), u === r ? (u = i, i = 0) : u = lr(u), t = Pn(t), Ty(t, i, u);
      }
      function S1(t, i, u) {
        if (u && typeof u != "boolean" && jt(t, i, u) && (i = u = r), u === r && (typeof i == "boolean" ? (u = i, i = r) : typeof t == "boolean" && (u = t, t = r)), t === r && i === r ? (t = 0, i = 1) : (t = lr(t), i === r ? (i = t, t = 0) : i = lr(i)), t > i) {
          var d = t;
          t = i, i = d;
        }
        if (u || t % 1 || i % 1) {
          var g = uf();
          return Wt(t + g * (i - t + t_("1e-" + ((g + "").length - 1))), i);
        }
        return nl(t, i);
      }
      var E1 = Si(function(t, i, u) {
        return i = i.toLowerCase(), t + (u ? Vd(i) : i);
      });
      function Vd(t) {
        return Il(nt(t).toLowerCase());
      }
      function Ud(t) {
        return t = nt(t), t && t.replace(Ap, v_).replace(zp, "");
      }
      function x1(t, i, u) {
        t = nt(t), i = hn(i);
        var d = t.length;
        u = u === r ? d : Hr($e(u), 0, d);
        var g = u;
        return u -= i.length, u >= 0 && t.slice(u, g) == i;
      }
      function A1(t) {
        return t = nt(t), t && op.test(t) ? t.replace(pc, m_) : t;
      }
      function k1(t) {
        return t = nt(t), t && dp.test(t) ? t.replace(Es, "\\$&") : t;
      }
      var T1 = Si(function(t, i, u) {
        return t + (u ? "-" : "") + i.toLowerCase();
      }), I1 = Si(function(t, i, u) {
        return t + (u ? " " : "") + i.toLowerCase();
      }), L1 = Gf("toLowerCase");
      function O1(t, i, u) {
        t = nt(t), i = $e(i);
        var d = i ? gi(t) : 0;
        if (!i || d >= i)
          return t;
        var g = (i - d) / 2;
        return go(no(g), u) + t + go(to(g), u);
      }
      function P1(t, i, u) {
        t = nt(t), i = $e(i);
        var d = i ? gi(t) : 0;
        return i && d < i ? t + go(i - d, u) : t;
      }
      function N1(t, i, u) {
        t = nt(t), i = $e(i);
        var d = i ? gi(t) : 0;
        return i && d < i ? go(i - d, u) + t : t;
      }
      function R1(t, i, u) {
        return u || i == null ? i = 0 : i && (i = +i), U_(nt(t).replace(xs, ""), i || 0);
      }
      function F1(t, i, u) {
        return (u ? jt(t, i, u) : i === r) ? i = 1 : i = $e(i), rl(nt(t), i);
      }
      function M1() {
        var t = arguments, i = nt(t[0]);
        return t.length < 3 ? i : i.replace(t[1], t[2]);
      }
      var D1 = Si(function(t, i, u) {
        return t + (u ? "_" : "") + i.toLowerCase();
      });
      function $1(t, i, u) {
        return u && typeof u != "number" && jt(t, i, u) && (i = u = r), u = u === r ? re : u >>> 0, u ? (t = nt(t), t && (typeof i == "string" || i != null && !Al(i)) && (i = hn(i), !i && mi(t)) ? Ir($n(t), 0, u) : t.split(i, u)) : [];
      }
      var B1 = Si(function(t, i, u) {
        return t + (u ? " " : "") + Il(i);
      });
      function V1(t, i, u) {
        return t = nt(t), u = u == null ? 0 : Hr($e(u), 0, t.length), i = hn(i), t.slice(u, u + i.length) == i;
      }
      function U1(t, i, u) {
        var d = _.templateSettings;
        u && jt(t, i, u) && (i = r), t = nt(t), i = To({}, i, d, Jf);
        var g = To({}, i.imports, d.imports, Jf), w = Rt(g), x = Vs(g, w), N, D, Y = 0, X = i.interpolate || Va, ee = "__p += '", ce = Ws(
          (i.escape || Va).source + "|" + X.source + "|" + (X === _c ? bp : Va).source + "|" + (i.evaluate || Va).source + "|$",
          "g"
        ), _e = "//# sourceURL=" + (it.call(i, "sourceURL") ? (i.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Xp + "]") + `
`;
        t.replace(ce, function(ke, ze, je, mn, Yt, gn) {
          return je || (je = mn), ee += t.slice(Y, gn).replace(kp, g_), ze && (N = !0, ee += `' +
__e(` + ze + `) +
'`), Yt && (D = !0, ee += `';
` + Yt + `;
__p += '`), je && (ee += `' +
((__t = (` + je + `)) == null ? '' : __t) +
'`), Y = gn + ke.length, ke;
        }), ee += `';
`;
        var Ae = it.call(i, "variable") && i.variable;
        if (!Ae)
          ee = `with (obj) {
` + ee + `
}
`;
        else if (_p.test(Ae))
          throw new Ne(c);
        ee = (D ? ee.replace(np, "") : ee).replace(rp, "$1").replace(ip, "$1;"), ee = "function(" + (Ae || "obj") + `) {
` + (Ae ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (N ? ", __e = _.escape" : "") + (D ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ee + `return __p
}`;
        var Be = Hd(function() {
          return et(w, _e + "return " + ee).apply(r, x);
        });
        if (Be.source = ee, xl(Be))
          throw Be;
        return Be;
      }
      function W1(t) {
        return nt(t).toLowerCase();
      }
      function H1(t) {
        return nt(t).toUpperCase();
      }
      function G1(t, i, u) {
        if (t = nt(t), t && (u || i === r))
          return Jc(t);
        if (!t || !(i = hn(i)))
          return t;
        var d = $n(t), g = $n(i), w = Zc(d, g), x = Qc(d, g) + 1;
        return Ir(d, w, x).join("");
      }
      function z1(t, i, u) {
        if (t = nt(t), t && (u || i === r))
          return t.slice(0, tf(t) + 1);
        if (!t || !(i = hn(i)))
          return t;
        var d = $n(t), g = Qc(d, $n(i)) + 1;
        return Ir(d, 0, g).join("");
      }
      function q1(t, i, u) {
        if (t = nt(t), t && (u || i === r))
          return t.replace(xs, "");
        if (!t || !(i = hn(i)))
          return t;
        var d = $n(t), g = Zc(d, $n(i));
        return Ir(d, g).join("");
      }
      function K1(t, i) {
        var u = me, d = le;
        if (gt(i)) {
          var g = "separator" in i ? i.separator : g;
          u = "length" in i ? $e(i.length) : u, d = "omission" in i ? hn(i.omission) : d;
        }
        t = nt(t);
        var w = t.length;
        if (mi(t)) {
          var x = $n(t);
          w = x.length;
        }
        if (u >= w)
          return t;
        var N = u - gi(d);
        if (N < 1)
          return d;
        var D = x ? Ir(x, 0, N).join("") : t.slice(0, N);
        if (g === r)
          return D + d;
        if (x && (N += D.length - N), Al(g)) {
          if (t.slice(N).search(g)) {
            var Y, X = D;
            for (g.global || (g = Ws(g.source, nt(yc.exec(g)) + "g")), g.lastIndex = 0; Y = g.exec(X); )
              var ee = Y.index;
            D = D.slice(0, ee === r ? N : ee);
          }
        } else if (t.indexOf(hn(g), N) != N) {
          var ce = D.lastIndexOf(g);
          ce > -1 && (D = D.slice(0, ce));
        }
        return D + d;
      }
      function j1(t) {
        return t = nt(t), t && ap.test(t) ? t.replace(gc, S_) : t;
      }
      var Y1 = Si(function(t, i, u) {
        return t + (u ? " " : "") + i.toUpperCase();
      }), Il = Gf("toUpperCase");
      function Wd(t, i, u) {
        return t = nt(t), i = u ? r : i, i === r ? __(t) ? A_(t) : u_(t) : t.match(i) || [];
      }
      var Hd = We(function(t, i) {
        try {
          return fn(t, r, i);
        } catch (u) {
          return xl(u) ? u : new Ne(u);
        }
      }), X1 = ar(function(t, i) {
        return An(i, function(u) {
          u = Jn(u), rr(t, u, Sl(t[u], t));
        }), t;
      });
      function J1(t) {
        var i = t == null ? 0 : t.length, u = Ee();
        return t = i ? vt(t, function(d) {
          if (typeof d[1] != "function")
            throw new kn(l);
          return [u(d[0]), d[1]];
        }) : [], We(function(d) {
          for (var g = -1; ++g < i; ) {
            var w = t[g];
            if (fn(w[0], this, d))
              return fn(w[1], this, d);
          }
        });
      }
      function Z1(t) {
        return Sy(In(t, m));
      }
      function Ll(t) {
        return function() {
          return t;
        };
      }
      function Q1(t, i) {
        return t == null || t !== t ? i : t;
      }
      var eC = qf(), tC = qf(!0);
      function rn(t) {
        return t;
      }
      function Ol(t) {
        return Cf(typeof t == "function" ? t : In(t, m));
      }
      function nC(t) {
        return Ef(In(t, m));
      }
      function rC(t, i) {
        return xf(t, In(i, m));
      }
      var iC = We(function(t, i) {
        return function(u) {
          return aa(u, t, i);
        };
      }), aC = We(function(t, i) {
        return function(u) {
          return aa(t, u, i);
        };
      });
      function Pl(t, i, u) {
        var d = Rt(i), g = lo(i, d);
        u == null && !(gt(i) && (g.length || !d.length)) && (u = i, i = t, t = this, g = lo(i, Rt(i)));
        var w = !(gt(u) && "chain" in u) || !!u.chain, x = sr(t);
        return An(g, function(N) {
          var D = i[N];
          t[N] = D, x && (t.prototype[N] = function() {
            var Y = this.__chain__;
            if (w || Y) {
              var X = t(this.__wrapped__), ee = X.__actions__ = en(this.__actions__);
              return ee.push({ func: D, args: arguments, thisArg: t }), X.__chain__ = Y, X;
            }
            return D.apply(t, Sr([this.value()], arguments));
          });
        }), t;
      }
      function oC() {
        return Bt._ === this && (Bt._ = P_), this;
      }
      function Nl() {
      }
      function sC(t) {
        return t = $e(t), We(function(i) {
          return Af(i, t);
        });
      }
      var lC = cl(vt), uC = cl(qc), cC = cl(Fs);
      function Gd(t) {
        return pl(t) ? Ms(Jn(t)) : Vy(t);
      }
      function fC(t) {
        return function(i) {
          return t == null ? r : Gr(t, i);
        };
      }
      var dC = jf(), hC = jf(!0);
      function Rl() {
        return [];
      }
      function Fl() {
        return !1;
      }
      function vC() {
        return {};
      }
      function mC() {
        return "";
      }
      function gC() {
        return !0;
      }
      function pC(t, i) {
        if (t = $e(t), t < 1 || t > ie)
          return [];
        var u = re, d = Wt(t, re);
        i = Ee(i), t -= re;
        for (var g = Bs(d, i); ++u < t; )
          i(u);
        return g;
      }
      function _C(t) {
        return Fe(t) ? vt(t, Jn) : vn(t) ? [t] : en(cd(nt(t)));
      }
      function yC(t) {
        var i = ++L_;
        return nt(t) + i;
      }
      var bC = mo(function(t, i) {
        return t + i;
      }, 0), wC = fl("ceil"), CC = mo(function(t, i) {
        return t / i;
      }, 1), SC = fl("floor");
      function EC(t) {
        return t && t.length ? so(t, rn, Xs) : r;
      }
      function xC(t, i) {
        return t && t.length ? so(t, Ee(i, 2), Xs) : r;
      }
      function AC(t) {
        return Yc(t, rn);
      }
      function kC(t, i) {
        return Yc(t, Ee(i, 2));
      }
      function TC(t) {
        return t && t.length ? so(t, rn, el) : r;
      }
      function IC(t, i) {
        return t && t.length ? so(t, Ee(i, 2), el) : r;
      }
      var LC = mo(function(t, i) {
        return t * i;
      }, 1), OC = fl("round"), PC = mo(function(t, i) {
        return t - i;
      }, 0);
      function NC(t) {
        return t && t.length ? $s(t, rn) : 0;
      }
      function RC(t, i) {
        return t && t.length ? $s(t, Ee(i, 2)) : 0;
      }
      return _.after = nw, _.ary = wd, _.assign = Hw, _.assignIn = Fd, _.assignInWith = To, _.assignWith = Gw, _.at = zw, _.before = Cd, _.bind = Sl, _.bindAll = X1, _.bindKey = Sd, _.castArray = vw, _.chain = _d, _.chunk = Sb, _.compact = Eb, _.concat = xb, _.cond = J1, _.conforms = Z1, _.constant = Ll, _.countBy = N0, _.create = qw, _.curry = Ed, _.curryRight = xd, _.debounce = Ad, _.defaults = Kw, _.defaultsDeep = jw, _.defer = rw, _.delay = iw, _.difference = Ab, _.differenceBy = kb, _.differenceWith = Tb, _.drop = Ib, _.dropRight = Lb, _.dropRightWhile = Ob, _.dropWhile = Pb, _.fill = Nb, _.filter = F0, _.flatMap = $0, _.flatMapDeep = B0, _.flatMapDepth = V0, _.flatten = vd, _.flattenDeep = Rb, _.flattenDepth = Fb, _.flip = aw, _.flow = eC, _.flowRight = tC, _.fromPairs = Mb, _.functions = t1, _.functionsIn = n1, _.groupBy = U0, _.initial = $b, _.intersection = Bb, _.intersectionBy = Vb, _.intersectionWith = Ub, _.invert = i1, _.invertBy = a1, _.invokeMap = H0, _.iteratee = Ol, _.keyBy = G0, _.keys = Rt, _.keysIn = nn, _.map = Co, _.mapKeys = s1, _.mapValues = l1, _.matches = nC, _.matchesProperty = rC, _.memoize = Eo, _.merge = u1, _.mergeWith = Md, _.method = iC, _.methodOf = aC, _.mixin = Pl, _.negate = xo, _.nthArg = sC, _.omit = c1, _.omitBy = f1, _.once = ow, _.orderBy = z0, _.over = lC, _.overArgs = sw, _.overEvery = uC, _.overSome = cC, _.partial = El, _.partialRight = kd, _.partition = q0, _.pick = d1, _.pickBy = Dd, _.property = Gd, _.propertyOf = fC, _.pull = zb, _.pullAll = gd, _.pullAllBy = qb, _.pullAllWith = Kb, _.pullAt = jb, _.range = dC, _.rangeRight = hC, _.rearg = lw, _.reject = Y0, _.remove = Yb, _.rest = uw, _.reverse = wl, _.sampleSize = J0, _.set = v1, _.setWith = m1, _.shuffle = Z0, _.slice = Xb, _.sortBy = tw, _.sortedUniq = r0, _.sortedUniqBy = i0, _.split = $1, _.spread = cw, _.tail = a0, _.take = o0, _.takeRight = s0, _.takeRightWhile = l0, _.takeWhile = u0, _.tap = E0, _.throttle = fw, _.thru = wo, _.toArray = Pd, _.toPairs = $d, _.toPairsIn = Bd, _.toPath = _C, _.toPlainObject = Rd, _.transform = g1, _.unary = dw, _.union = c0, _.unionBy = f0, _.unionWith = d0, _.uniq = h0, _.uniqBy = v0, _.uniqWith = m0, _.unset = p1, _.unzip = Cl, _.unzipWith = pd, _.update = _1, _.updateWith = y1, _.values = Ai, _.valuesIn = b1, _.without = g0, _.words = Wd, _.wrap = hw, _.xor = p0, _.xorBy = _0, _.xorWith = y0, _.zip = b0, _.zipObject = w0, _.zipObjectDeep = C0, _.zipWith = S0, _.entries = $d, _.entriesIn = Bd, _.extend = Fd, _.extendWith = To, Pl(_, _), _.add = bC, _.attempt = Hd, _.camelCase = E1, _.capitalize = Vd, _.ceil = wC, _.clamp = w1, _.clone = mw, _.cloneDeep = pw, _.cloneDeepWith = _w, _.cloneWith = gw, _.conformsTo = yw, _.deburr = Ud, _.defaultTo = Q1, _.divide = CC, _.endsWith = x1, _.eq = Vn, _.escape = A1, _.escapeRegExp = k1, _.every = R0, _.find = M0, _.findIndex = dd, _.findKey = Yw, _.findLast = D0, _.findLastIndex = hd, _.findLastKey = Xw, _.floor = SC, _.forEach = yd, _.forEachRight = bd, _.forIn = Jw, _.forInRight = Zw, _.forOwn = Qw, _.forOwnRight = e1, _.get = kl, _.gt = bw, _.gte = ww, _.has = r1, _.hasIn = Tl, _.head = md, _.identity = rn, _.includes = W0, _.indexOf = Db, _.inRange = C1, _.invoke = o1, _.isArguments = Kr, _.isArray = Fe, _.isArrayBuffer = Cw, _.isArrayLike = tn, _.isArrayLikeObject = Ct, _.isBoolean = Sw, _.isBuffer = Lr, _.isDate = Ew, _.isElement = xw, _.isEmpty = Aw, _.isEqual = kw, _.isEqualWith = Tw, _.isError = xl, _.isFinite = Iw, _.isFunction = sr, _.isInteger = Td, _.isLength = Ao, _.isMap = Id, _.isMatch = Lw, _.isMatchWith = Ow, _.isNaN = Pw, _.isNative = Nw, _.isNil = Fw, _.isNull = Rw, _.isNumber = Ld, _.isObject = gt, _.isObjectLike = yt, _.isPlainObject = fa, _.isRegExp = Al, _.isSafeInteger = Mw, _.isSet = Od, _.isString = ko, _.isSymbol = vn, _.isTypedArray = xi, _.isUndefined = Dw, _.isWeakMap = $w, _.isWeakSet = Bw, _.join = Wb, _.kebabCase = T1, _.last = On, _.lastIndexOf = Hb, _.lowerCase = I1, _.lowerFirst = L1, _.lt = Vw, _.lte = Uw, _.max = EC, _.maxBy = xC, _.mean = AC, _.meanBy = kC, _.min = TC, _.minBy = IC, _.stubArray = Rl, _.stubFalse = Fl, _.stubObject = vC, _.stubString = mC, _.stubTrue = gC, _.multiply = LC, _.nth = Gb, _.noConflict = oC, _.noop = Nl, _.now = So, _.pad = O1, _.padEnd = P1, _.padStart = N1, _.parseInt = R1, _.random = S1, _.reduce = K0, _.reduceRight = j0, _.repeat = F1, _.replace = M1, _.result = h1, _.round = OC, _.runInContext = M, _.sample = X0, _.size = Q0, _.snakeCase = D1, _.some = ew, _.sortedIndex = Jb, _.sortedIndexBy = Zb, _.sortedIndexOf = Qb, _.sortedLastIndex = e0, _.sortedLastIndexBy = t0, _.sortedLastIndexOf = n0, _.startCase = B1, _.startsWith = V1, _.subtract = PC, _.sum = NC, _.sumBy = RC, _.template = U1, _.times = pC, _.toFinite = lr, _.toInteger = $e, _.toLength = Nd, _.toLower = W1, _.toNumber = Pn, _.toSafeInteger = Ww, _.toString = nt, _.toUpper = H1, _.trim = G1, _.trimEnd = z1, _.trimStart = q1, _.truncate = K1, _.unescape = j1, _.uniqueId = yC, _.upperCase = Y1, _.upperFirst = Il, _.each = yd, _.eachRight = bd, _.first = md, Pl(_, function() {
        var t = {};
        return Yn(_, function(i, u) {
          it.call(_.prototype, u) || (t[u] = i);
        }), t;
      }(), { chain: !1 }), _.VERSION = a, An(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(t) {
        _[t].placeholder = _;
      }), An(["drop", "take"], function(t, i) {
        Ke.prototype[t] = function(u) {
          u = u === r ? 1 : Lt($e(u), 0);
          var d = this.__filtered__ && !i ? new Ke(this) : this.clone();
          return d.__filtered__ ? d.__takeCount__ = Wt(u, d.__takeCount__) : d.__views__.push({
            size: Wt(u, re),
            type: t + (d.__dir__ < 0 ? "Right" : "")
          }), d;
        }, Ke.prototype[t + "Right"] = function(u) {
          return this.reverse()[t](u).reverse();
        };
      }), An(["filter", "map", "takeWhile"], function(t, i) {
        var u = i + 1, d = u == ue || u == Se;
        Ke.prototype[t] = function(g) {
          var w = this.clone();
          return w.__iteratees__.push({
            iteratee: Ee(g, 3),
            type: u
          }), w.__filtered__ = w.__filtered__ || d, w;
        };
      }), An(["head", "last"], function(t, i) {
        var u = "take" + (i ? "Right" : "");
        Ke.prototype[t] = function() {
          return this[u](1).value()[0];
        };
      }), An(["initial", "tail"], function(t, i) {
        var u = "drop" + (i ? "" : "Right");
        Ke.prototype[t] = function() {
          return this.__filtered__ ? new Ke(this) : this[u](1);
        };
      }), Ke.prototype.compact = function() {
        return this.filter(rn);
      }, Ke.prototype.find = function(t) {
        return this.filter(t).head();
      }, Ke.prototype.findLast = function(t) {
        return this.reverse().find(t);
      }, Ke.prototype.invokeMap = We(function(t, i) {
        return typeof t == "function" ? new Ke(this) : this.map(function(u) {
          return aa(u, t, i);
        });
      }), Ke.prototype.reject = function(t) {
        return this.filter(xo(Ee(t)));
      }, Ke.prototype.slice = function(t, i) {
        t = $e(t);
        var u = this;
        return u.__filtered__ && (t > 0 || i < 0) ? new Ke(u) : (t < 0 ? u = u.takeRight(-t) : t && (u = u.drop(t)), i !== r && (i = $e(i), u = i < 0 ? u.dropRight(-i) : u.take(i - t)), u);
      }, Ke.prototype.takeRightWhile = function(t) {
        return this.reverse().takeWhile(t).reverse();
      }, Ke.prototype.toArray = function() {
        return this.take(re);
      }, Yn(Ke.prototype, function(t, i) {
        var u = /^(?:filter|find|map|reject)|While$/.test(i), d = /^(?:head|last)$/.test(i), g = _[d ? "take" + (i == "last" ? "Right" : "") : i], w = d || /^find/.test(i);
        g && (_.prototype[i] = function() {
          var x = this.__wrapped__, N = d ? [1] : arguments, D = x instanceof Ke, Y = N[0], X = D || Fe(x), ee = function(ze) {
            var je = g.apply(_, Sr([ze], N));
            return d && ce ? je[0] : je;
          };
          X && u && typeof Y == "function" && Y.length != 1 && (D = X = !1);
          var ce = this.__chain__, _e = !!this.__actions__.length, Ae = w && !ce, Be = D && !_e;
          if (!w && X) {
            x = Be ? x : new Ke(this);
            var ke = t.apply(x, N);
            return ke.__actions__.push({ func: wo, args: [ee], thisArg: r }), new Tn(ke, ce);
          }
          return Ae && Be ? t.apply(this, N) : (ke = this.thru(ee), Ae ? d ? ke.value()[0] : ke.value() : ke);
        });
      }), An(["pop", "push", "shift", "sort", "splice", "unshift"], function(t) {
        var i = qa[t], u = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru", d = /^(?:pop|shift)$/.test(t);
        _.prototype[t] = function() {
          var g = arguments;
          if (d && !this.__chain__) {
            var w = this.value();
            return i.apply(Fe(w) ? w : [], g);
          }
          return this[u](function(x) {
            return i.apply(Fe(x) ? x : [], g);
          });
        };
      }), Yn(Ke.prototype, function(t, i) {
        var u = _[i];
        if (u) {
          var d = u.name + "";
          it.call(bi, d) || (bi[d] = []), bi[d].push({ name: i, func: u });
        }
      }), bi[vo(r, R).name] = [{
        name: "wrapper",
        func: r
      }], Ke.prototype.clone = j_, Ke.prototype.reverse = Y_, Ke.prototype.value = X_, _.prototype.at = x0, _.prototype.chain = A0, _.prototype.commit = k0, _.prototype.next = T0, _.prototype.plant = L0, _.prototype.reverse = O0, _.prototype.toJSON = _.prototype.valueOf = _.prototype.value = P0, _.prototype.first = _.prototype.head, Zi && (_.prototype[Zi] = I0), _;
    }, pi = k_();
    Br ? ((Br.exports = pi)._ = pi, Os._ = pi) : Bt._ = pi;
  }).call(da);
})(Vo, Vo.exports);
var zC = Vo.exports;
const Ml = /* @__PURE__ */ GC(zC), Mu = (e) => {
  const n = (s) => Ml.get(e.value, `features.${s}.enabled`) ?? !1;
  return {
    isEnabled: n,
    isDisabled: (s) => !n(s),
    getFeatureOption: (s) => Ml.get(e.value, `features.${s}`) ?? null,
    getConfiguration: (s) => Ml.get(e.value, s) ?? null
  };
}, rs = (e) => {
  const { getConfiguration: n } = Mu(e), r = A(
    () => n("colors")
  );
  return {
    colorVars: A(() => r.value ? Object.entries(r.value).reduce((o, [s, l]) => `${o}--${s}: var(--wh-${s}, ${l});`, "") : "")
  };
}, qC = ["textContent"], KC = {
  key: 0,
  class: "wh-flex wh-flex-wrap wh-flex-col md:wh-flex-row md:wh-items-center md:wh-justify-center wh-gap-3 xl:wh-gap-5 lg:wh-px-20"
}, jC = ["textContent"], YC = ["href"], XC = /* @__PURE__ */ Qe({
  __name: "TheFooter",
  props: {
    menuItems: {},
    configuration: {}
  },
  setup(e) {
    const n = e, { configuration: r, menuItems: a } = ht(n), { colorVars: o } = rs(r), s = () => {
      tarteaucitron.userInterface.openPanel();
    };
    return (l, c) => (z(), ne("footer", {
      class: "TheFooter wh-footer wh-relative md:wh-fixed wh-flex wh-flex-col md:wh-flex-row wh-justify-around md:wh-items-center wh-bottom-[95px] md:wh-bottom-0 wh-left-0 md:wh-left-[65px] wh-z-30 md:wh-text-center wh-bg-white wh-w-full wh-shadow-[0px_0px_1px_0px_rgba(0,0,0,0.1)]",
      style: Di(q(o))
    }, [
      Q("p", {
        class: "wh-mb-5 md:wh-mb-0",
        textContent: Ve(
          l.$t("wh:footer:copyright", {
            year: (/* @__PURE__ */ new Date()).getFullYear()
          })
        )
      }, null, 8, qC),
      Q("nav", null, [
        q(a).length > 0 ? (z(), ne("ul", KC, [
          Q("li", null, [
            Q("a", {
              href: "javascript:;",
              onClick: s,
              textContent: Ve(l.$t("wh:cookies:managing"))
            }, null, 8, jC)
          ]),
          (z(!0), ne(Ie, null, pt(q(a), (f, h) => (z(), ne("li", { key: h }, [
            Q("a", {
              href: f.url,
              class: ""
            }, Ve(f.title), 9, YC)
          ]))), 128))
        ])) : qe("", !0)
      ])
    ], 4));
  }
}), Ut = (e, n) => {
  const r = e.__vccOpts || e;
  for (const [a, o] of n)
    r[a] = o;
  return r;
}, JC = /* @__PURE__ */ Ut(XC, [["__scopeId", "data-v-4ecb259b"]]);
function Nv(e) {
  return FC() ? (Zt(e), !0) : !1;
}
function Oi(e) {
  return typeof e == "function" ? e() : q(e);
}
const Rv = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const ZC = () => {
};
function QC(e, n) {
  var r;
  if (typeof e == "number")
    return e + n;
  const a = ((r = e.match(/^-?\d+\.?\d*/)) == null ? void 0 : r[0]) || "", o = e.slice(a.length), s = Number.parseFloat(a) + n;
  return Number.isNaN(s) ? e : s + o;
}
function Fv(e) {
  return $i();
}
function eS(e, n = !0, r) {
  Fv() ? qt(e, r) : n ? e() : Jt(e);
}
function tS(e, n) {
  Fv() && Ou(e, n);
}
const Mv = Rv ? window : void 0, nS = Rv ? window.document : void 0;
function rS() {
  const e = oe(!1), n = $i();
  return n && qt(() => {
    e.value = !0;
  }, n), e;
}
function iS(e) {
  const n = rS();
  return A(() => (n.value, !!e()));
}
function ha(e, n = {}) {
  const { window: r = Mv } = n, a = iS(() => r && "matchMedia" in r && typeof r.matchMedia == "function");
  let o;
  const s = oe(!1), l = (h) => {
    s.value = h.matches;
  }, c = () => {
    o && ("removeEventListener" in o ? o.removeEventListener("change", l) : o.removeListener(l));
  }, f = Mr(() => {
    a.value && (c(), o = r.matchMedia(Oi(e)), "addEventListener" in o ? o.addEventListener("change", l) : o.addListener(l), s.value = o.matches);
  });
  return Nv(() => {
    f(), c(), o = void 0;
  }), s;
}
const aS = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
  xxl: 2560
};
function oS(e, n = {}) {
  function r(v, m) {
    let p = Oi(e[Oi(v)]);
    return m != null && (p = QC(p, m)), typeof p == "number" && (p = `${p}px`), p;
  }
  const { window: a = Mv, strategy: o = "min-width" } = n;
  function s(v) {
    return a ? a.matchMedia(v).matches : !1;
  }
  const l = (v) => ha(() => `(min-width: ${r(v)})`, n), c = (v) => ha(() => `(max-width: ${r(v)})`, n), f = Object.keys(e).reduce((v, m) => (Object.defineProperty(v, m, {
    get: () => o === "min-width" ? l(m) : c(m),
    enumerable: !0,
    configurable: !0
  }), v), {});
  function h() {
    const v = Object.keys(e).map((m) => [m, l(m)]);
    return A(() => v.filter(([, m]) => m.value).map(([m]) => m));
  }
  return Object.assign(f, {
    greaterOrEqual: l,
    smallerOrEqual: c,
    greater(v) {
      return ha(() => `(min-width: ${r(v, 0.1)})`, n);
    },
    smaller(v) {
      return ha(() => `(max-width: ${r(v, -0.1)})`, n);
    },
    between(v, m) {
      return ha(() => `(min-width: ${r(v)}) and (max-width: ${r(m, -0.1)})`, n);
    },
    isGreater(v) {
      return s(`(min-width: ${r(v, 0.1)})`);
    },
    isGreaterOrEqual(v) {
      return s(`(min-width: ${r(v)})`);
    },
    isSmaller(v) {
      return s(`(max-width: ${r(v, -0.1)})`);
    },
    isSmallerOrEqual(v) {
      return s(`(max-width: ${r(v)})`);
    },
    isInBetween(v, m) {
      return s(`(min-width: ${r(v)}) and (max-width: ${r(m, -0.1)})`);
    },
    current: h,
    active() {
      const v = h();
      return A(() => v.value.length === 0 ? "" : v.value.at(-1));
    }
  });
}
function Uo(e, n = ZC, r = {}) {
  const {
    immediate: a = !0,
    manual: o = !1,
    type: s = "text/javascript",
    async: l = !0,
    crossOrigin: c,
    referrerPolicy: f,
    noModule: h,
    defer: v,
    document: m = nS,
    attrs: p = {}
  } = r, y = oe(null);
  let b = null;
  const C = ($) => new Promise((k, L) => {
    const F = (V) => (y.value = V, k(V), V);
    if (!m) {
      k(!1);
      return;
    }
    let P = !1, E = m.querySelector(`script[src="${Oi(e)}"]`);
    E ? E.hasAttribute("data-loaded") && F(E) : (E = m.createElement("script"), E.type = s, E.async = l, E.src = Oi(e), v && (E.defer = v), c && (E.crossOrigin = c), h && (E.noModule = h), f && (E.referrerPolicy = f), Object.entries(p).forEach(([V, W]) => E?.setAttribute(V, W)), P = !0), E.addEventListener("error", (V) => L(V)), E.addEventListener("abort", (V) => L(V)), E.addEventListener("load", () => {
      E.setAttribute("data-loaded", "true"), n(E), F(E);
    }), P && (E = m.head.appendChild(E)), $ || F(E);
  }), S = ($ = !0) => (b || (b = C($)), b), R = () => {
    if (!m)
      return;
    b = null, y.value && (y.value = null);
    const $ = m.querySelector(`script[src="${Oi(e)}"]`);
    $ && m.head.removeChild($);
  };
  return a && !o && eS(S), o || tS(R), { scriptTag: y, load: S, unload: R };
}
/*!
  * shared v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const qd = typeof window < "u", ai = (e, n = !1) => n ? Symbol.for(e) : Symbol(e), sS = (e, n, r) => lS({ l: e, k: n, s: r }), lS = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Gt = (e) => typeof e == "number" && isFinite(e), uS = (e) => $v(e) === "[object Date]", Ni = (e) => $v(e) === "[object RegExp]", is = (e) => Ye(e) && Object.keys(e).length === 0, zt = Object.assign;
let Kd;
const dr = () => Kd || (Kd = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function jd(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const cS = Object.prototype.hasOwnProperty;
function Wo(e, n) {
  return cS.call(e, n);
}
const kt = Array.isArray, mt = (e) => typeof e == "function", ve = (e) => typeof e == "string", st = (e) => typeof e == "boolean", rt = (e) => e !== null && typeof e == "object", fS = (e) => rt(e) && mt(e.then) && mt(e.catch), Dv = Object.prototype.toString, $v = (e) => Dv.call(e), Ye = (e) => {
  if (!rt(e))
    return !1;
  const n = Object.getPrototypeOf(e);
  return n === null || n.constructor === Object;
}, dS = (e) => e == null ? "" : kt(e) || Ye(e) && e.toString === Dv ? JSON.stringify(e, null, 2) : String(e);
function hS(e, n = "") {
  return e.reduce((r, a, o) => o === 0 ? r + a : r + n + a, "");
}
function as(e) {
  let n = e;
  return () => ++n;
}
function vS(e, n) {
  typeof console < "u" && (console.warn("[intlify] " + e), n && console.warn(n.stack));
}
const Io = (e) => !rt(e) || kt(e);
function Fo(e, n) {
  if (Io(e) || Io(n))
    throw new Error("Invalid value");
  const r = [{ src: e, des: n }];
  for (; r.length; ) {
    const { src: a, des: o } = r.pop();
    Object.keys(a).forEach((s) => {
      Io(a[s]) || Io(o[s]) ? o[s] = a[s] : r.push({ src: a[s], des: o[s] });
    });
  }
}
/*!
  * message-compiler v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function mS(e, n, r) {
  return { line: e, column: n, offset: r };
}
function Ho(e, n, r) {
  return { start: e, end: n };
}
const gS = /\{([0-9a-zA-Z]+)\}/g;
function Bv(e, ...n) {
  return n.length === 1 && pS(n[0]) && (n = n[0]), (!n || !n.hasOwnProperty) && (n = {}), e.replace(gS, (r, a) => n.hasOwnProperty(a) ? n[a] : "");
}
const Vv = Object.assign, Yd = (e) => typeof e == "string", pS = (e) => e !== null && typeof e == "object";
function Uv(e, n = "") {
  return e.reduce((r, a, o) => o === 0 ? r + a : r + n + a, "");
}
const Du = {
  USE_MODULO_SYNTAX: 1,
  __EXTEND_POINT__: 2
}, _S = {
  [Du.USE_MODULO_SYNTAX]: "Use modulo before '{{0}}'."
};
function yS(e, n, ...r) {
  const a = Bv(_S[e], ...r || []), o = { message: String(a), code: e };
  return n && (o.location = n), o;
}
const Le = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, bS = {
  // tokenizer error messages
  [Le.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [Le.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [Le.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [Le.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [Le.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [Le.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [Le.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [Le.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [Le.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [Le.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [Le.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [Le.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [Le.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [Le.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [Le.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [Le.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function Hi(e, n, r = {}) {
  const { domain: a, messages: o, args: s } = r, l = Bv((o || bS)[e] || "", ...s || []), c = new SyntaxError(String(l));
  return c.code = e, n && (c.location = n), c.domain = a, c;
}
function wS(e) {
  throw e;
}
const cr = " ", CS = "\r", Xt = `
`, SS = "\u2028", ES = "\u2029";
function xS(e) {
  const n = e;
  let r = 0, a = 1, o = 1, s = 0;
  const l = (E) => n[E] === CS && n[E + 1] === Xt, c = (E) => n[E] === Xt, f = (E) => n[E] === ES, h = (E) => n[E] === SS, v = (E) => l(E) || c(E) || f(E) || h(E), m = () => r, p = () => a, y = () => o, b = () => s, C = (E) => l(E) || f(E) || h(E) ? Xt : n[E], S = () => C(r), R = () => C(r + s);
  function $() {
    return s = 0, v(r) && (a++, o = 0), l(r) && r++, r++, o++, n[r];
  }
  function k() {
    return l(r + s) && s++, s++, n[r + s];
  }
  function L() {
    r = 0, a = 1, o = 1, s = 0;
  }
  function F(E = 0) {
    s = E;
  }
  function P() {
    const E = r + s;
    for (; E !== r; )
      $();
    s = 0;
  }
  return {
    index: m,
    line: p,
    column: y,
    peekOffset: b,
    charAt: C,
    currentChar: S,
    currentPeek: R,
    next: $,
    peek: k,
    reset: L,
    resetPeek: F,
    skipToPeek: P
  };
}
const Or = void 0, AS = ".", Xd = "'", kS = "tokenizer";
function TS(e, n = {}) {
  const r = n.location !== !1, a = xS(e), o = () => a.index(), s = () => mS(a.line(), a.column(), a.index()), l = s(), c = o(), f = {
    currentType: 14,
    offset: c,
    startLoc: l,
    endLoc: l,
    lastType: 14,
    lastOffset: c,
    lastStartLoc: l,
    lastEndLoc: l,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, h = () => f, { onError: v } = n;
  function m(I, O, Z, ...pe) {
    const lt = h();
    if (O.column += Z, O.offset += Z, v) {
      const xe = r ? Ho(lt.startLoc, O) : null, H = Hi(I, xe, {
        domain: kS,
        args: pe
      });
      v(H);
    }
  }
  function p(I, O, Z) {
    I.endLoc = s(), I.currentType = O;
    const pe = { type: O };
    return r && (pe.loc = Ho(I.startLoc, I.endLoc)), Z != null && (pe.value = Z), pe;
  }
  const y = (I) => p(
    I,
    14
    /* TokenTypes.EOF */
  );
  function b(I, O) {
    return I.currentChar() === O ? (I.next(), O) : (m(Le.EXPECTED_TOKEN, s(), 0, O), "");
  }
  function C(I) {
    let O = "";
    for (; I.currentPeek() === cr || I.currentPeek() === Xt; )
      O += I.currentPeek(), I.peek();
    return O;
  }
  function S(I) {
    const O = C(I);
    return I.skipToPeek(), O;
  }
  function R(I) {
    if (I === Or)
      return !1;
    const O = I.charCodeAt(0);
    return O >= 97 && O <= 122 || // a-z
    O >= 65 && O <= 90 || // A-Z
    O === 95;
  }
  function $(I) {
    if (I === Or)
      return !1;
    const O = I.charCodeAt(0);
    return O >= 48 && O <= 57;
  }
  function k(I, O) {
    const { currentType: Z } = O;
    if (Z !== 2)
      return !1;
    C(I);
    const pe = R(I.currentPeek());
    return I.resetPeek(), pe;
  }
  function L(I, O) {
    const { currentType: Z } = O;
    if (Z !== 2)
      return !1;
    C(I);
    const pe = I.currentPeek() === "-" ? I.peek() : I.currentPeek(), lt = $(pe);
    return I.resetPeek(), lt;
  }
  function F(I, O) {
    const { currentType: Z } = O;
    if (Z !== 2)
      return !1;
    C(I);
    const pe = I.currentPeek() === Xd;
    return I.resetPeek(), pe;
  }
  function P(I, O) {
    const { currentType: Z } = O;
    if (Z !== 8)
      return !1;
    C(I);
    const pe = I.currentPeek() === ".";
    return I.resetPeek(), pe;
  }
  function E(I, O) {
    const { currentType: Z } = O;
    if (Z !== 9)
      return !1;
    C(I);
    const pe = R(I.currentPeek());
    return I.resetPeek(), pe;
  }
  function V(I, O) {
    const { currentType: Z } = O;
    if (!(Z === 8 || Z === 12))
      return !1;
    C(I);
    const pe = I.currentPeek() === ":";
    return I.resetPeek(), pe;
  }
  function W(I, O) {
    const { currentType: Z } = O;
    if (Z !== 10)
      return !1;
    const pe = () => {
      const xe = I.currentPeek();
      return xe === "{" ? R(I.peek()) : xe === "@" || xe === "%" || xe === "|" || xe === ":" || xe === "." || xe === cr || !xe ? !1 : xe === Xt ? (I.peek(), pe()) : K(I, !1);
    }, lt = pe();
    return I.resetPeek(), lt;
  }
  function me(I) {
    C(I);
    const O = I.currentPeek() === "|";
    return I.resetPeek(), O;
  }
  function le(I) {
    const O = C(I), Z = I.currentPeek() === "%" && I.peek() === "{";
    return I.resetPeek(), {
      isModulo: Z,
      hasSpace: O.length > 0
    };
  }
  function K(I, O = !0) {
    const Z = (lt = !1, xe = "", H = !1) => {
      const te = I.currentPeek();
      return te === "{" ? xe === "%" ? !1 : lt : te === "@" || !te ? xe === "%" ? !0 : lt : te === "%" ? (I.peek(), Z(lt, "%", !0)) : te === "|" ? xe === "%" || H ? !0 : !(xe === cr || xe === Xt) : te === cr ? (I.peek(), Z(!0, cr, H)) : te === Xt ? (I.peek(), Z(!0, Xt, H)) : !0;
    }, pe = Z();
    return O && I.resetPeek(), pe;
  }
  function ae(I, O) {
    const Z = I.currentChar();
    return Z === Or ? Or : O(Z) ? (I.next(), Z) : null;
  }
  function ue(I) {
    const O = I.charCodeAt(0);
    return O >= 97 && O <= 122 || // a-z
    O >= 65 && O <= 90 || // A-Z
    O >= 48 && O <= 57 || // 0-9
    O === 95 || // _
    O === 36;
  }
  function Ce(I) {
    return ae(I, ue);
  }
  function Se(I) {
    const O = I.charCodeAt(0);
    return O >= 97 && O <= 122 || // a-z
    O >= 65 && O <= 90 || // A-Z
    O >= 48 && O <= 57 || // 0-9
    O === 95 || // _
    O === 36 || // $
    O === 45;
  }
  function Pe(I) {
    return ae(I, Se);
  }
  function ie(I) {
    const O = I.charCodeAt(0);
    return O >= 48 && O <= 57;
  }
  function se(I) {
    return ae(I, ie);
  }
  function j(I) {
    const O = I.charCodeAt(0);
    return O >= 48 && O <= 57 || // 0-9
    O >= 65 && O <= 70 || // A-F
    O >= 97 && O <= 102;
  }
  function re(I) {
    return ae(I, j);
  }
  function fe(I) {
    let O = "", Z = "";
    for (; O = se(I); )
      Z += O;
    return Z;
  }
  function ye(I) {
    S(I);
    const O = I.currentChar();
    return O !== "%" && m(Le.EXPECTED_TOKEN, s(), 0, O), I.next(), "%";
  }
  function Oe(I) {
    let O = "";
    for (; ; ) {
      const Z = I.currentChar();
      if (Z === "{" || Z === "}" || Z === "@" || Z === "|" || !Z)
        break;
      if (Z === "%")
        if (K(I))
          O += Z, I.next();
        else
          break;
      else if (Z === cr || Z === Xt)
        if (K(I))
          O += Z, I.next();
        else {
          if (me(I))
            break;
          O += Z, I.next();
        }
      else
        O += Z, I.next();
    }
    return O;
  }
  function ge(I) {
    S(I);
    let O = "", Z = "";
    for (; O = Pe(I); )
      Z += O;
    return I.currentChar() === Or && m(Le.UNTERMINATED_CLOSING_BRACE, s(), 0), Z;
  }
  function Je(I) {
    S(I);
    let O = "";
    return I.currentChar() === "-" ? (I.next(), O += `-${fe(I)}`) : O += fe(I), I.currentChar() === Or && m(Le.UNTERMINATED_CLOSING_BRACE, s(), 0), O;
  }
  function $t(I) {
    return I !== Xd && I !== Xt;
  }
  function xt(I) {
    S(I), b(I, "'");
    let O = "", Z = "";
    for (; O = ae(I, $t); )
      O === "\\" ? Z += at(I) : Z += O;
    const pe = I.currentChar();
    return pe === Xt || pe === Or ? (m(Le.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, s(), 0), pe === Xt && (I.next(), b(I, "'")), Z) : (b(I, "'"), Z);
  }
  function at(I) {
    const O = I.currentChar();
    switch (O) {
      case "\\":
      case "'":
        return I.next(), `\\${O}`;
      case "u":
        return Cn(I, O, 4);
      case "U":
        return Cn(I, O, 6);
      default:
        return m(Le.UNKNOWN_ESCAPE_SEQUENCE, s(), 0, O), "";
    }
  }
  function Cn(I, O, Z) {
    b(I, O);
    let pe = "";
    for (let lt = 0; lt < Z; lt++) {
      const xe = re(I);
      if (!xe) {
        m(Le.INVALID_UNICODE_ESCAPE_SEQUENCE, s(), 0, `\\${O}${pe}${I.currentChar()}`);
        break;
      }
      pe += xe;
    }
    return `\\${O}${pe}`;
  }
  function Qt(I) {
    return I !== "{" && I !== "}" && I !== cr && I !== Xt;
  }
  function cn(I) {
    S(I);
    let O = "", Z = "";
    for (; O = ae(I, Qt); )
      Z += O;
    return Z;
  }
  function we(I) {
    let O = "", Z = "";
    for (; O = Ce(I); )
      Z += O;
    return Z;
  }
  function J(I) {
    const O = (Z) => {
      const pe = I.currentChar();
      return pe === "{" || pe === "%" || pe === "@" || pe === "|" || pe === "(" || pe === ")" || !pe || pe === cr ? Z : (Z += pe, I.next(), O(Z));
    };
    return O("");
  }
  function be(I) {
    S(I);
    const O = b(
      I,
      "|"
      /* TokenChars.Pipe */
    );
    return S(I), O;
  }
  function Nt(I, O) {
    let Z = null;
    switch (I.currentChar()) {
      case "{":
        return O.braceNest >= 1 && m(Le.NOT_ALLOW_NEST_PLACEHOLDER, s(), 0), I.next(), Z = p(
          O,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), S(I), O.braceNest++, Z;
      case "}":
        return O.braceNest > 0 && O.currentType === 2 && m(Le.EMPTY_PLACEHOLDER, s(), 0), I.next(), Z = p(
          O,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), O.braceNest--, O.braceNest > 0 && S(I), O.inLinked && O.braceNest === 0 && (O.inLinked = !1), Z;
      case "@":
        return O.braceNest > 0 && m(Le.UNTERMINATED_CLOSING_BRACE, s(), 0), Z = At(I, O) || y(O), O.braceNest = 0, Z;
      default: {
        let lt = !0, xe = !0, H = !0;
        if (me(I))
          return O.braceNest > 0 && m(Le.UNTERMINATED_CLOSING_BRACE, s(), 0), Z = p(O, 1, be(I)), O.braceNest = 0, O.inLinked = !1, Z;
        if (O.braceNest > 0 && (O.currentType === 5 || O.currentType === 6 || O.currentType === 7))
          return m(Le.UNTERMINATED_CLOSING_BRACE, s(), 0), O.braceNest = 0, Sn(I, O);
        if (lt = k(I, O))
          return Z = p(O, 5, ge(I)), S(I), Z;
        if (xe = L(I, O))
          return Z = p(O, 6, Je(I)), S(I), Z;
        if (H = F(I, O))
          return Z = p(O, 7, xt(I)), S(I), Z;
        if (!lt && !xe && !H)
          return Z = p(O, 13, cn(I)), m(Le.INVALID_TOKEN_IN_PLACEHOLDER, s(), 0, Z.value), S(I), Z;
        break;
      }
    }
    return Z;
  }
  function At(I, O) {
    const { currentType: Z } = O;
    let pe = null;
    const lt = I.currentChar();
    switch ((Z === 8 || Z === 9 || Z === 12 || Z === 10) && (lt === Xt || lt === cr) && m(Le.INVALID_LINKED_FORMAT, s(), 0), lt) {
      case "@":
        return I.next(), pe = p(
          O,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), O.inLinked = !0, pe;
      case ".":
        return S(I), I.next(), p(
          O,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return S(I), I.next(), p(
          O,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return me(I) ? (pe = p(O, 1, be(I)), O.braceNest = 0, O.inLinked = !1, pe) : P(I, O) || V(I, O) ? (S(I), At(I, O)) : E(I, O) ? (S(I), p(O, 12, we(I))) : W(I, O) ? (S(I), lt === "{" ? Nt(I, O) || pe : p(O, 11, J(I))) : (Z === 8 && m(Le.INVALID_LINKED_FORMAT, s(), 0), O.braceNest = 0, O.inLinked = !1, Sn(I, O));
    }
  }
  function Sn(I, O) {
    let Z = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (O.braceNest > 0)
      return Nt(I, O) || y(O);
    if (O.inLinked)
      return At(I, O) || y(O);
    switch (I.currentChar()) {
      case "{":
        return Nt(I, O) || y(O);
      case "}":
        return m(Le.UNBALANCED_CLOSING_BRACE, s(), 0), I.next(), p(
          O,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return At(I, O) || y(O);
      default: {
        if (me(I))
          return Z = p(O, 1, be(I)), O.braceNest = 0, O.inLinked = !1, Z;
        const { isModulo: lt, hasSpace: xe } = le(I);
        if (lt)
          return xe ? p(O, 0, Oe(I)) : p(O, 4, ye(I));
        if (K(I))
          return p(O, 0, Oe(I));
        break;
      }
    }
    return Z;
  }
  function er() {
    const { currentType: I, offset: O, startLoc: Z, endLoc: pe } = f;
    return f.lastType = I, f.lastOffset = O, f.lastStartLoc = Z, f.lastEndLoc = pe, f.offset = o(), f.startLoc = s(), a.currentChar() === Or ? p(
      f,
      14
      /* TokenTypes.EOF */
    ) : Sn(a, f);
  }
  return {
    nextToken: er,
    currentOffset: o,
    currentPosition: s,
    context: h
  };
}
const IS = "parser", LS = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function OS(e, n, r) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const a = parseInt(n || r, 16);
      return a <= 55295 || a >= 57344 ? String.fromCodePoint(a) : "�";
    }
  }
}
function PS(e = {}) {
  const n = e.location !== !1, { onError: r, onWarn: a } = e;
  function o(k, L, F, P, ...E) {
    const V = k.currentPosition();
    if (V.offset += P, V.column += P, r) {
      const W = n ? Ho(F, V) : null, me = Hi(L, W, {
        domain: IS,
        args: E
      });
      r(me);
    }
  }
  function s(k, L, F, P, ...E) {
    const V = k.currentPosition();
    if (V.offset += P, V.column += P, a) {
      const W = n ? Ho(F, V) : null;
      a(yS(L, W, E));
    }
  }
  function l(k, L, F) {
    const P = { type: k };
    return n && (P.start = L, P.end = L, P.loc = { start: F, end: F }), P;
  }
  function c(k, L, F, P) {
    n && (k.end = L, k.loc && (k.loc.end = F));
  }
  function f(k, L) {
    const F = k.context(), P = l(3, F.offset, F.startLoc);
    return P.value = L, c(P, k.currentOffset(), k.currentPosition()), P;
  }
  function h(k, L) {
    const F = k.context(), { lastOffset: P, lastStartLoc: E } = F, V = l(5, P, E);
    return V.index = parseInt(L, 10), k.nextToken(), c(V, k.currentOffset(), k.currentPosition()), V;
  }
  function v(k, L, F) {
    const P = k.context(), { lastOffset: E, lastStartLoc: V } = P, W = l(4, E, V);
    return W.key = L, F === !0 && (W.modulo = !0), k.nextToken(), c(W, k.currentOffset(), k.currentPosition()), W;
  }
  function m(k, L) {
    const F = k.context(), { lastOffset: P, lastStartLoc: E } = F, V = l(9, P, E);
    return V.value = L.replace(LS, OS), k.nextToken(), c(V, k.currentOffset(), k.currentPosition()), V;
  }
  function p(k) {
    const L = k.nextToken(), F = k.context(), { lastOffset: P, lastStartLoc: E } = F, V = l(8, P, E);
    return L.type !== 12 ? (o(k, Le.UNEXPECTED_EMPTY_LINKED_MODIFIER, F.lastStartLoc, 0), V.value = "", c(V, P, E), {
      nextConsumeToken: L,
      node: V
    }) : (L.value == null && o(k, Le.UNEXPECTED_LEXICAL_ANALYSIS, F.lastStartLoc, 0, Wn(L)), V.value = L.value || "", c(V, k.currentOffset(), k.currentPosition()), {
      node: V
    });
  }
  function y(k, L) {
    const F = k.context(), P = l(7, F.offset, F.startLoc);
    return P.value = L, c(P, k.currentOffset(), k.currentPosition()), P;
  }
  function b(k) {
    const L = k.context(), F = l(6, L.offset, L.startLoc);
    let P = k.nextToken();
    if (P.type === 9) {
      const E = p(k);
      F.modifier = E.node, P = E.nextConsumeToken || k.nextToken();
    }
    switch (P.type !== 10 && o(k, Le.UNEXPECTED_LEXICAL_ANALYSIS, L.lastStartLoc, 0, Wn(P)), P = k.nextToken(), P.type === 2 && (P = k.nextToken()), P.type) {
      case 11:
        P.value == null && o(k, Le.UNEXPECTED_LEXICAL_ANALYSIS, L.lastStartLoc, 0, Wn(P)), F.key = y(k, P.value || "");
        break;
      case 5:
        P.value == null && o(k, Le.UNEXPECTED_LEXICAL_ANALYSIS, L.lastStartLoc, 0, Wn(P)), F.key = v(k, P.value || "");
        break;
      case 6:
        P.value == null && o(k, Le.UNEXPECTED_LEXICAL_ANALYSIS, L.lastStartLoc, 0, Wn(P)), F.key = h(k, P.value || "");
        break;
      case 7:
        P.value == null && o(k, Le.UNEXPECTED_LEXICAL_ANALYSIS, L.lastStartLoc, 0, Wn(P)), F.key = m(k, P.value || "");
        break;
      default: {
        o(k, Le.UNEXPECTED_EMPTY_LINKED_KEY, L.lastStartLoc, 0);
        const E = k.context(), V = l(7, E.offset, E.startLoc);
        return V.value = "", c(V, E.offset, E.startLoc), F.key = V, c(F, E.offset, E.startLoc), {
          nextConsumeToken: P,
          node: F
        };
      }
    }
    return c(F, k.currentOffset(), k.currentPosition()), {
      node: F
    };
  }
  function C(k) {
    const L = k.context(), F = L.currentType === 1 ? k.currentOffset() : L.offset, P = L.currentType === 1 ? L.endLoc : L.startLoc, E = l(2, F, P);
    E.items = [];
    let V = null, W = null;
    do {
      const K = V || k.nextToken();
      switch (V = null, K.type) {
        case 0:
          K.value == null && o(k, Le.UNEXPECTED_LEXICAL_ANALYSIS, L.lastStartLoc, 0, Wn(K)), E.items.push(f(k, K.value || ""));
          break;
        case 6:
          K.value == null && o(k, Le.UNEXPECTED_LEXICAL_ANALYSIS, L.lastStartLoc, 0, Wn(K)), E.items.push(h(k, K.value || ""));
          break;
        case 4:
          W = !0;
          break;
        case 5:
          K.value == null && o(k, Le.UNEXPECTED_LEXICAL_ANALYSIS, L.lastStartLoc, 0, Wn(K)), E.items.push(v(k, K.value || "", !!W)), W && (s(k, Du.USE_MODULO_SYNTAX, L.lastStartLoc, 0, Wn(K)), W = null);
          break;
        case 7:
          K.value == null && o(k, Le.UNEXPECTED_LEXICAL_ANALYSIS, L.lastStartLoc, 0, Wn(K)), E.items.push(m(k, K.value || ""));
          break;
        case 8: {
          const ae = b(k);
          E.items.push(ae.node), V = ae.nextConsumeToken || null;
          break;
        }
      }
    } while (L.currentType !== 14 && L.currentType !== 1);
    const me = L.currentType === 1 ? L.lastOffset : k.currentOffset(), le = L.currentType === 1 ? L.lastEndLoc : k.currentPosition();
    return c(E, me, le), E;
  }
  function S(k, L, F, P) {
    const E = k.context();
    let V = P.items.length === 0;
    const W = l(1, L, F);
    W.cases = [], W.cases.push(P);
    do {
      const me = C(k);
      V || (V = me.items.length === 0), W.cases.push(me);
    } while (E.currentType !== 14);
    return V && o(k, Le.MUST_HAVE_MESSAGES_IN_PLURAL, F, 0), c(W, k.currentOffset(), k.currentPosition()), W;
  }
  function R(k) {
    const L = k.context(), { offset: F, startLoc: P } = L, E = C(k);
    return L.currentType === 14 ? E : S(k, F, P, E);
  }
  function $(k) {
    const L = TS(k, Vv({}, e)), F = L.context(), P = l(0, F.offset, F.startLoc);
    return n && P.loc && (P.loc.source = k), P.body = R(L), e.onCacheKey && (P.cacheKey = e.onCacheKey(k)), F.currentType !== 14 && o(L, Le.UNEXPECTED_LEXICAL_ANALYSIS, F.lastStartLoc, 0, k[F.offset] || ""), c(P, L.currentOffset(), L.currentPosition()), P;
  }
  return { parse: $ };
}
function Wn(e) {
  if (e.type === 14)
    return "EOF";
  const n = (e.value || "").replace(/\r?\n/gu, "\\n");
  return n.length > 10 ? n.slice(0, 9) + "…" : n;
}
function NS(e, n = {}) {
  const r = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => r, helper: (s) => (r.helpers.add(s), s) };
}
function Jd(e, n) {
  for (let r = 0; r < e.length; r++)
    $u(e[r], n);
}
function $u(e, n) {
  switch (e.type) {
    case 1:
      Jd(e.cases, n), n.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Jd(e.items, n);
      break;
    case 6: {
      $u(e.key, n), n.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), n.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      n.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), n.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      n.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), n.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function RS(e, n = {}) {
  const r = NS(e);
  r.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && $u(e.body, r);
  const a = r.context();
  e.helpers = Array.from(a.helpers);
}
function FS(e) {
  const n = e.body;
  return n.type === 2 ? Zd(n) : n.cases.forEach((r) => Zd(r)), e;
}
function Zd(e) {
  if (e.items.length === 1) {
    const n = e.items[0];
    (n.type === 3 || n.type === 9) && (e.static = n.value, delete n.value);
  } else {
    const n = [];
    for (let r = 0; r < e.items.length; r++) {
      const a = e.items[r];
      if (!(a.type === 3 || a.type === 9) || a.value == null)
        break;
      n.push(a.value);
    }
    if (n.length === e.items.length) {
      e.static = Uv(n);
      for (let r = 0; r < e.items.length; r++) {
        const a = e.items[r];
        (a.type === 3 || a.type === 9) && delete a.value;
      }
    }
  }
}
const MS = "minifier";
function Ti(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const n = e;
      Ti(n.body), n.b = n.body, delete n.body;
      break;
    }
    case 1: {
      const n = e, r = n.cases;
      for (let a = 0; a < r.length; a++)
        Ti(r[a]);
      n.c = r, delete n.cases;
      break;
    }
    case 2: {
      const n = e, r = n.items;
      for (let a = 0; a < r.length; a++)
        Ti(r[a]);
      n.i = r, delete n.items, n.static && (n.s = n.static, delete n.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const n = e;
      n.value && (n.v = n.value, delete n.value);
      break;
    }
    case 6: {
      const n = e;
      Ti(n.key), n.k = n.key, delete n.key, n.modifier && (Ti(n.modifier), n.m = n.modifier, delete n.modifier);
      break;
    }
    case 5: {
      const n = e;
      n.i = n.index, delete n.index;
      break;
    }
    case 4: {
      const n = e;
      n.k = n.key, delete n.key;
      break;
    }
    default:
      throw Hi(Le.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: MS,
        args: [e.type]
      });
  }
  delete e.type;
}
const DS = "parser";
function $S(e, n) {
  const { sourceMap: r, filename: a, breakLineCode: o, needIndent: s } = n, l = n.location !== !1, c = {
    filename: a,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: o,
    needIndent: s,
    indentLevel: 0
  };
  l && e.loc && (c.source = e.loc.source);
  const f = () => c;
  function h(S, R) {
    c.code += S;
  }
  function v(S, R = !0) {
    const $ = R ? o : "";
    h(s ? $ + "  ".repeat(S) : $);
  }
  function m(S = !0) {
    const R = ++c.indentLevel;
    S && v(R);
  }
  function p(S = !0) {
    const R = --c.indentLevel;
    S && v(R);
  }
  function y() {
    v(c.indentLevel);
  }
  return {
    context: f,
    push: h,
    indent: m,
    deindent: p,
    newline: y,
    helper: (S) => `_${S}`,
    needIndent: () => c.needIndent
  };
}
function BS(e, n) {
  const { helper: r } = e;
  e.push(`${r(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Ri(e, n.key), n.modifier ? (e.push(", "), Ri(e, n.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function VS(e, n) {
  const { helper: r, needIndent: a } = e;
  e.push(`${r(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(a());
  const o = n.items.length;
  for (let s = 0; s < o && (Ri(e, n.items[s]), s !== o - 1); s++)
    e.push(", ");
  e.deindent(a()), e.push("])");
}
function US(e, n) {
  const { helper: r, needIndent: a } = e;
  if (n.cases.length > 1) {
    e.push(`${r(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(a());
    const o = n.cases.length;
    for (let s = 0; s < o && (Ri(e, n.cases[s]), s !== o - 1); s++)
      e.push(", ");
    e.deindent(a()), e.push("])");
  }
}
function WS(e, n) {
  n.body ? Ri(e, n.body) : e.push("null");
}
function Ri(e, n) {
  const { helper: r } = e;
  switch (n.type) {
    case 0:
      WS(e, n);
      break;
    case 1:
      US(e, n);
      break;
    case 2:
      VS(e, n);
      break;
    case 6:
      BS(e, n);
      break;
    case 8:
      e.push(JSON.stringify(n.value), n);
      break;
    case 7:
      e.push(JSON.stringify(n.value), n);
      break;
    case 5:
      e.push(`${r(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${r(
        "list"
        /* HelperNameMap.LIST */
      )}(${n.index}))`, n);
      break;
    case 4:
      e.push(`${r(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${r(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(n.key)}))`, n);
      break;
    case 9:
      e.push(JSON.stringify(n.value), n);
      break;
    case 3:
      e.push(JSON.stringify(n.value), n);
      break;
    default:
      throw Hi(Le.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: DS,
        args: [n.type]
      });
  }
}
const HS = (e, n = {}) => {
  const r = Yd(n.mode) ? n.mode : "normal", a = Yd(n.filename) ? n.filename : "message.intl", o = !!n.sourceMap, s = n.breakLineCode != null ? n.breakLineCode : r === "arrow" ? ";" : `
`, l = n.needIndent ? n.needIndent : r !== "arrow", c = e.helpers || [], f = $S(e, {
    mode: r,
    filename: a,
    sourceMap: o,
    breakLineCode: s,
    needIndent: l
  });
  f.push(r === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), f.indent(l), c.length > 0 && (f.push(`const { ${Uv(c.map((m) => `${m}: _${m}`), ", ")} } = ctx`), f.newline()), f.push("return "), Ri(f, e), f.deindent(l), f.push("}"), delete e.helpers;
  const { code: h, map: v } = f.context();
  return {
    ast: e,
    code: h,
    map: v ? v.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function GS(e, n = {}) {
  const r = Vv({}, n), a = !!r.jit, o = !!r.minify, s = r.optimize == null ? !0 : r.optimize, c = PS(r).parse(e);
  return a ? (s && FS(c), o && Ti(c), { ast: c, code: "" }) : (RS(c, r), HS(c, r));
}
/*!
  * core-base v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function zS() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (dr().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (dr().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (dr().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const Dr = [];
Dr[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Dr[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Dr[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
Dr[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
Dr[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
Dr[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
Dr[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const qS = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function KS(e) {
  return qS.test(e);
}
function jS(e) {
  const n = e.charCodeAt(0), r = e.charCodeAt(e.length - 1);
  return n === r && (n === 34 || n === 39) ? e.slice(1, -1) : e;
}
function YS(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function XS(e) {
  const n = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : KS(n) ? jS(n) : "*" + n;
}
function JS(e) {
  const n = [];
  let r = -1, a = 0, o = 0, s, l, c, f, h, v, m;
  const p = [];
  p[
    0
    /* Actions.APPEND */
  ] = () => {
    l === void 0 ? l = c : l += c;
  }, p[
    1
    /* Actions.PUSH */
  ] = () => {
    l !== void 0 && (n.push(l), l = void 0);
  }, p[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    p[
      0
      /* Actions.APPEND */
    ](), o++;
  }, p[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (o > 0)
      o--, a = 4, p[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (o = 0, l === void 0 || (l = XS(l), l === !1))
        return !1;
      p[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function y() {
    const b = e[r + 1];
    if (a === 5 && b === "'" || a === 6 && b === '"')
      return r++, c = "\\" + b, p[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; a !== null; )
    if (r++, s = e[r], !(s === "\\" && y())) {
      if (f = YS(s), m = Dr[a], h = m[f] || m.l || 8, h === 8 || (a = h[0], h[1] !== void 0 && (v = p[h[1]], v && (c = s, v() === !1))))
        return;
      if (a === 7)
        return n;
    }
}
const Qd = /* @__PURE__ */ new Map();
function ZS(e, n) {
  return rt(e) ? e[n] : null;
}
function QS(e, n) {
  if (!rt(e))
    return null;
  let r = Qd.get(n);
  if (r || (r = JS(n), r && Qd.set(n, r)), !r)
    return null;
  const a = r.length;
  let o = e, s = 0;
  for (; s < a; ) {
    const l = o[r[s]];
    if (l === void 0 || mt(o))
      return null;
    o = l, s++;
  }
  return o;
}
const eE = (e) => e, tE = (e) => "", nE = "text", rE = (e) => e.length === 0 ? "" : hS(e), iE = dS;
function eh(e, n) {
  return e = Math.abs(e), n === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function aE(e) {
  const n = Gt(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (Gt(e.named.count) || Gt(e.named.n)) ? Gt(e.named.count) ? e.named.count : Gt(e.named.n) ? e.named.n : n : n;
}
function oE(e, n) {
  n.count || (n.count = e), n.n || (n.n = e);
}
function sE(e = {}) {
  const n = e.locale, r = aE(e), a = rt(e.pluralRules) && ve(n) && mt(e.pluralRules[n]) ? e.pluralRules[n] : eh, o = rt(e.pluralRules) && ve(n) && mt(e.pluralRules[n]) ? eh : void 0, s = (R) => R[a(r, R.length, o)], l = e.list || [], c = (R) => l[R], f = e.named || {};
  Gt(e.pluralIndex) && oE(r, f);
  const h = (R) => f[R];
  function v(R) {
    const $ = mt(e.messages) ? e.messages(R) : rt(e.messages) ? e.messages[R] : !1;
    return $ || (e.parent ? e.parent.message(R) : tE);
  }
  const m = (R) => e.modifiers ? e.modifiers[R] : eE, p = Ye(e.processor) && mt(e.processor.normalize) ? e.processor.normalize : rE, y = Ye(e.processor) && mt(e.processor.interpolate) ? e.processor.interpolate : iE, b = Ye(e.processor) && ve(e.processor.type) ? e.processor.type : nE, S = {
    list: c,
    named: h,
    plural: s,
    linked: (R, ...$) => {
      const [k, L] = $;
      let F = "text", P = "";
      $.length === 1 ? rt(k) ? (P = k.modifier || P, F = k.type || F) : ve(k) && (P = k || P) : $.length === 2 && (ve(k) && (P = k || P), ve(L) && (F = L || F));
      const E = v(R)(S), V = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        F === "vnode" && kt(E) && P ? E[0] : E
      );
      return P ? m(P)(V, F) : V;
    },
    message: v,
    type: b,
    interpolate: y,
    normalize: p,
    values: zt({}, l, f)
  };
  return S;
}
let ba = null;
function lE(e) {
  ba = e;
}
function uE(e, n, r) {
  ba && ba.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: n,
    meta: r
  });
}
const cE = /* @__PURE__ */ fE(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function fE(e) {
  return (n) => ba && ba.emit(e, n);
}
const Wv = Du.__EXTEND_POINT__, jr = as(Wv), dE = {
  NOT_FOUND_KEY: Wv,
  // 2
  FALLBACK_TO_TRANSLATE: jr(),
  // 3
  CANNOT_FORMAT_NUMBER: jr(),
  // 4
  FALLBACK_TO_NUMBER_FORMAT: jr(),
  // 5
  CANNOT_FORMAT_DATE: jr(),
  // 6
  FALLBACK_TO_DATE_FORMAT: jr(),
  // 7
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: jr(),
  // 8
  __EXTEND_POINT__: jr()
  // 9
}, Hv = Le.__EXTEND_POINT__, Yr = as(Hv), Hn = {
  INVALID_ARGUMENT: Hv,
  // 17
  INVALID_DATE_ARGUMENT: Yr(),
  // 18
  INVALID_ISO_DATE_ARGUMENT: Yr(),
  // 19
  NOT_SUPPORT_NON_STRING_MESSAGE: Yr(),
  // 20
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: Yr(),
  // 21
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: Yr(),
  // 22
  NOT_SUPPORT_LOCALE_TYPE: Yr(),
  // 23
  __EXTEND_POINT__: Yr()
  // 24
};
function Zn(e) {
  return Hi(e, null, void 0);
}
function Bu(e, n) {
  return n.locale != null ? th(n.locale) : th(e.locale);
}
let Dl;
function th(e) {
  if (ve(e))
    return e;
  if (mt(e)) {
    if (e.resolvedOnce && Dl != null)
      return Dl;
    if (e.constructor.name === "Function") {
      const n = e();
      if (fS(n))
        throw Zn(Hn.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Dl = n;
    } else
      throw Zn(Hn.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw Zn(Hn.NOT_SUPPORT_LOCALE_TYPE);
}
function hE(e, n, r) {
  return [.../* @__PURE__ */ new Set([
    r,
    ...kt(n) ? n : rt(n) ? Object.keys(n) : ve(n) ? [n] : [r]
  ])];
}
function Gv(e, n, r) {
  const a = ve(r) ? r : wa, o = e;
  o.__localeChainCache || (o.__localeChainCache = /* @__PURE__ */ new Map());
  let s = o.__localeChainCache.get(a);
  if (!s) {
    s = [];
    let l = [r];
    for (; kt(l); )
      l = nh(s, l, n);
    const c = kt(n) || !Ye(n) ? n : n.default ? n.default : null;
    l = ve(c) ? [c] : c, kt(l) && nh(s, l, !1), o.__localeChainCache.set(a, s);
  }
  return s;
}
function nh(e, n, r) {
  let a = !0;
  for (let o = 0; o < n.length && st(a); o++) {
    const s = n[o];
    ve(s) && (a = vE(e, n[o], r));
  }
  return a;
}
function vE(e, n, r) {
  let a;
  const o = n.split("-");
  do {
    const s = o.join("-");
    a = mE(e, s, r), o.splice(-1, 1);
  } while (o.length && a === !0);
  return a;
}
function mE(e, n, r) {
  let a = !1;
  if (!e.includes(n) && (a = !0, n)) {
    a = n[n.length - 1] !== "!";
    const o = n.replace(/!/g, "");
    e.push(o), (kt(r) || Ye(r)) && r[o] && (a = r[o]);
  }
  return a;
}
const gE = "9.13.1", os = -1, wa = "en-US", rh = "", ih = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function pE() {
  return {
    upper: (e, n) => n === "text" && ve(e) ? e.toUpperCase() : n === "vnode" && rt(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, n) => n === "text" && ve(e) ? e.toLowerCase() : n === "vnode" && rt(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, n) => n === "text" && ve(e) ? ih(e) : n === "vnode" && rt(e) && "__v_isVNode" in e ? ih(e.children) : e
  };
}
let zv;
function ah(e) {
  zv = e;
}
let qv;
function _E(e) {
  qv = e;
}
let Kv;
function yE(e) {
  Kv = e;
}
let jv = null;
const bE = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  jv = e;
}, wE = /* @__NO_SIDE_EFFECTS__ */ () => jv;
let Yv = null;
const oh = (e) => {
  Yv = e;
}, CE = () => Yv;
let sh = 0;
function SE(e = {}) {
  const n = mt(e.onWarn) ? e.onWarn : vS, r = ve(e.version) ? e.version : gE, a = ve(e.locale) || mt(e.locale) ? e.locale : wa, o = mt(a) ? wa : a, s = kt(e.fallbackLocale) || Ye(e.fallbackLocale) || ve(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : o, l = Ye(e.messages) ? e.messages : { [o]: {} }, c = Ye(e.datetimeFormats) ? e.datetimeFormats : { [o]: {} }, f = Ye(e.numberFormats) ? e.numberFormats : { [o]: {} }, h = zt({}, e.modifiers || {}, pE()), v = e.pluralRules || {}, m = mt(e.missing) ? e.missing : null, p = st(e.missingWarn) || Ni(e.missingWarn) ? e.missingWarn : !0, y = st(e.fallbackWarn) || Ni(e.fallbackWarn) ? e.fallbackWarn : !0, b = !!e.fallbackFormat, C = !!e.unresolving, S = mt(e.postTranslation) ? e.postTranslation : null, R = Ye(e.processor) ? e.processor : null, $ = st(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, k = !!e.escapeParameter, L = mt(e.messageCompiler) ? e.messageCompiler : zv, F = mt(e.messageResolver) ? e.messageResolver : qv || ZS, P = mt(e.localeFallbacker) ? e.localeFallbacker : Kv || hE, E = rt(e.fallbackContext) ? e.fallbackContext : void 0, V = e, W = rt(V.__datetimeFormatters) ? V.__datetimeFormatters : /* @__PURE__ */ new Map(), me = rt(V.__numberFormatters) ? V.__numberFormatters : /* @__PURE__ */ new Map(), le = rt(V.__meta) ? V.__meta : {};
  sh++;
  const K = {
    version: r,
    cid: sh,
    locale: a,
    fallbackLocale: s,
    messages: l,
    modifiers: h,
    pluralRules: v,
    missing: m,
    missingWarn: p,
    fallbackWarn: y,
    fallbackFormat: b,
    unresolving: C,
    postTranslation: S,
    processor: R,
    warnHtmlMessage: $,
    escapeParameter: k,
    messageCompiler: L,
    messageResolver: F,
    localeFallbacker: P,
    fallbackContext: E,
    onWarn: n,
    __meta: le
  };
  return K.datetimeFormats = c, K.numberFormats = f, K.__datetimeFormatters = W, K.__numberFormatters = me, __INTLIFY_PROD_DEVTOOLS__ && uE(K, r, le), K;
}
function Vu(e, n, r, a, o) {
  const { missing: s, onWarn: l } = e;
  if (s !== null) {
    const c = s(e, r, n, o);
    return ve(c) ? c : n;
  } else
    return n;
}
function va(e, n, r) {
  const a = e;
  a.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, r, n);
}
function EE(e, n) {
  return e === n ? !1 : e.split("-")[0] === n.split("-")[0];
}
function xE(e, n) {
  const r = n.indexOf(e);
  if (r === -1)
    return !1;
  for (let a = r + 1; a < n.length; a++)
    if (EE(e, n[a]))
      return !0;
  return !1;
}
function $l(e) {
  return (r) => AE(r, e);
}
function AE(e, n) {
  const r = n.b || n.body;
  if ((r.t || r.type) === 1) {
    const a = r, o = a.c || a.cases;
    return e.plural(o.reduce((s, l) => [
      ...s,
      lh(e, l)
    ], []));
  } else
    return lh(e, r);
}
function lh(e, n) {
  const r = n.s || n.static;
  if (r)
    return e.type === "text" ? r : e.normalize([r]);
  {
    const a = (n.i || n.items).reduce((o, s) => [...o, nu(e, s)], []);
    return e.normalize(a);
  }
}
function nu(e, n) {
  const r = n.t || n.type;
  switch (r) {
    case 3: {
      const a = n;
      return a.v || a.value;
    }
    case 9: {
      const a = n;
      return a.v || a.value;
    }
    case 4: {
      const a = n;
      return e.interpolate(e.named(a.k || a.key));
    }
    case 5: {
      const a = n;
      return e.interpolate(e.list(a.i != null ? a.i : a.index));
    }
    case 6: {
      const a = n, o = a.m || a.modifier;
      return e.linked(nu(e, a.k || a.key), o ? nu(e, o) : void 0, e.type);
    }
    case 7: {
      const a = n;
      return a.v || a.value;
    }
    case 8: {
      const a = n;
      return a.v || a.value;
    }
    default:
      throw new Error(`unhandled node type on format message part: ${r}`);
  }
}
const Xv = (e) => e;
let Ii = /* @__PURE__ */ Object.create(null);
const Fi = (e) => rt(e) && (e.t === 0 || e.type === 0) && ("b" in e || "body" in e);
function Jv(e, n = {}) {
  let r = !1;
  const a = n.onError || wS;
  return n.onError = (o) => {
    r = !0, a(o);
  }, { ...GS(e, n), detectError: r };
}
const kE = /* @__NO_SIDE_EFFECTS__ */ (e, n) => {
  if (!ve(e))
    throw Zn(Hn.NOT_SUPPORT_NON_STRING_MESSAGE);
  {
    st(n.warnHtmlMessage) && n.warnHtmlMessage;
    const a = (n.onCacheKey || Xv)(e), o = Ii[a];
    if (o)
      return o;
    const { code: s, detectError: l } = Jv(e, n), c = new Function(`return ${s}`)();
    return l ? c : Ii[a] = c;
  }
};
function TE(e, n) {
  if (__INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && ve(e)) {
    st(n.warnHtmlMessage) && n.warnHtmlMessage;
    const a = (n.onCacheKey || Xv)(e), o = Ii[a];
    if (o)
      return o;
    const { ast: s, detectError: l } = Jv(e, {
      ...n,
      location: !1,
      jit: !0
    }), c = $l(s);
    return l ? c : Ii[a] = c;
  } else {
    const r = e.cacheKey;
    if (r) {
      const a = Ii[r];
      return a || (Ii[r] = $l(e));
    } else
      return $l(e);
  }
}
const uh = () => "", Nn = (e) => mt(e);
function ch(e, ...n) {
  const { fallbackFormat: r, postTranslation: a, unresolving: o, messageCompiler: s, fallbackLocale: l, messages: c } = e, [f, h] = ru(...n), v = st(h.missingWarn) ? h.missingWarn : e.missingWarn, m = st(h.fallbackWarn) ? h.fallbackWarn : e.fallbackWarn, p = st(h.escapeParameter) ? h.escapeParameter : e.escapeParameter, y = !!h.resolvedMessage, b = ve(h.default) || st(h.default) ? st(h.default) ? s ? f : () => f : h.default : r ? s ? f : () => f : "", C = r || b !== "", S = Bu(e, h);
  p && IE(h);
  let [R, $, k] = y ? [
    f,
    S,
    c[S] || {}
  ] : Zv(e, f, S, l, m, v), L = R, F = f;
  if (!y && !(ve(L) || Fi(L) || Nn(L)) && C && (L = b, F = L), !y && (!(ve(L) || Fi(L) || Nn(L)) || !ve($)))
    return o ? os : f;
  let P = !1;
  const E = () => {
    P = !0;
  }, V = Nn(L) ? L : Qv(e, f, $, L, F, E);
  if (P)
    return L;
  const W = PE(e, $, k, h), me = sE(W), le = LE(e, V, me), K = a ? a(le, f) : le;
  if (__INTLIFY_PROD_DEVTOOLS__) {
    const ae = {
      timestamp: Date.now(),
      key: ve(f) ? f : Nn(L) ? L.key : "",
      locale: $ || (Nn(L) ? L.locale : ""),
      format: ve(L) ? L : Nn(L) ? L.source : "",
      message: K
    };
    ae.meta = zt({}, e.__meta, /* @__PURE__ */ wE() || {}), cE(ae);
  }
  return K;
}
function IE(e) {
  kt(e.list) ? e.list = e.list.map((n) => ve(n) ? jd(n) : n) : rt(e.named) && Object.keys(e.named).forEach((n) => {
    ve(e.named[n]) && (e.named[n] = jd(e.named[n]));
  });
}
function Zv(e, n, r, a, o, s) {
  const { messages: l, onWarn: c, messageResolver: f, localeFallbacker: h } = e, v = h(e, a, r);
  let m = {}, p, y = null;
  const b = "translate";
  for (let C = 0; C < v.length && (p = v[C], m = l[p] || {}, (y = f(m, n)) === null && (y = m[n]), !(ve(y) || Fi(y) || Nn(y))); C++)
    if (!xE(p, v)) {
      const S = Vu(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        n,
        p,
        s,
        b
      );
      S !== n && (y = S);
    }
  return [y, p, m];
}
function Qv(e, n, r, a, o, s) {
  const { messageCompiler: l, warnHtmlMessage: c } = e;
  if (Nn(a)) {
    const h = a;
    return h.locale = h.locale || r, h.key = h.key || n, h;
  }
  if (l == null) {
    const h = () => a;
    return h.locale = r, h.key = n, h;
  }
  const f = l(a, OE(e, r, o, a, c, s));
  return f.locale = r, f.key = n, f.source = a, f;
}
function LE(e, n, r) {
  return n(r);
}
function ru(...e) {
  const [n, r, a] = e, o = {};
  if (!ve(n) && !Gt(n) && !Nn(n) && !Fi(n))
    throw Zn(Hn.INVALID_ARGUMENT);
  const s = Gt(n) ? String(n) : (Nn(n), n);
  return Gt(r) ? o.plural = r : ve(r) ? o.default = r : Ye(r) && !is(r) ? o.named = r : kt(r) && (o.list = r), Gt(a) ? o.plural = a : ve(a) ? o.default = a : Ye(a) && zt(o, a), [s, o];
}
function OE(e, n, r, a, o, s) {
  return {
    locale: n,
    key: r,
    warnHtmlMessage: o,
    onError: (l) => {
      throw s && s(l), l;
    },
    onCacheKey: (l) => sS(n, r, l)
  };
}
function PE(e, n, r, a) {
  const { modifiers: o, pluralRules: s, messageResolver: l, fallbackLocale: c, fallbackWarn: f, missingWarn: h, fallbackContext: v } = e, p = {
    locale: n,
    modifiers: o,
    pluralRules: s,
    messages: (y) => {
      let b = l(r, y);
      if (b == null && v) {
        const [, , C] = Zv(v, y, n, c, f, h);
        b = l(C, y);
      }
      if (ve(b) || Fi(b)) {
        let C = !1;
        const R = Qv(e, y, n, b, y, () => {
          C = !0;
        });
        return C ? uh : R;
      } else return Nn(b) ? b : uh;
    }
  };
  return e.processor && (p.processor = e.processor), a.list && (p.list = a.list), a.named && (p.named = a.named), Gt(a.plural) && (p.pluralIndex = a.plural), p;
}
function fh(e, ...n) {
  const { datetimeFormats: r, unresolving: a, fallbackLocale: o, onWarn: s, localeFallbacker: l } = e, { __datetimeFormatters: c } = e, [f, h, v, m] = iu(...n), p = st(v.missingWarn) ? v.missingWarn : e.missingWarn;
  st(v.fallbackWarn) ? v.fallbackWarn : e.fallbackWarn;
  const y = !!v.part, b = Bu(e, v), C = l(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    b
  );
  if (!ve(f) || f === "")
    return new Intl.DateTimeFormat(b, m).format(h);
  let S = {}, R, $ = null;
  const k = "datetime format";
  for (let P = 0; P < C.length && (R = C[P], S = r[R] || {}, $ = S[f], !Ye($)); P++)
    Vu(e, f, R, p, k);
  if (!Ye($) || !ve(R))
    return a ? os : f;
  let L = `${R}__${f}`;
  is(m) || (L = `${L}__${JSON.stringify(m)}`);
  let F = c.get(L);
  return F || (F = new Intl.DateTimeFormat(R, zt({}, $, m)), c.set(L, F)), y ? F.formatToParts(h) : F.format(h);
}
const em = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function iu(...e) {
  const [n, r, a, o] = e, s = {};
  let l = {}, c;
  if (ve(n)) {
    const f = n.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!f)
      throw Zn(Hn.INVALID_ISO_DATE_ARGUMENT);
    const h = f[3] ? f[3].trim().startsWith("T") ? `${f[1].trim()}${f[3].trim()}` : `${f[1].trim()}T${f[3].trim()}` : f[1].trim();
    c = new Date(h);
    try {
      c.toISOString();
    } catch {
      throw Zn(Hn.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (uS(n)) {
    if (isNaN(n.getTime()))
      throw Zn(Hn.INVALID_DATE_ARGUMENT);
    c = n;
  } else if (Gt(n))
    c = n;
  else
    throw Zn(Hn.INVALID_ARGUMENT);
  return ve(r) ? s.key = r : Ye(r) && Object.keys(r).forEach((f) => {
    em.includes(f) ? l[f] = r[f] : s[f] = r[f];
  }), ve(a) ? s.locale = a : Ye(a) && (l = a), Ye(o) && (l = o), [s.key || "", c, s, l];
}
function dh(e, n, r) {
  const a = e;
  for (const o in r) {
    const s = `${n}__${o}`;
    a.__datetimeFormatters.has(s) && a.__datetimeFormatters.delete(s);
  }
}
function hh(e, ...n) {
  const { numberFormats: r, unresolving: a, fallbackLocale: o, onWarn: s, localeFallbacker: l } = e, { __numberFormatters: c } = e, [f, h, v, m] = au(...n), p = st(v.missingWarn) ? v.missingWarn : e.missingWarn;
  st(v.fallbackWarn) ? v.fallbackWarn : e.fallbackWarn;
  const y = !!v.part, b = Bu(e, v), C = l(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    b
  );
  if (!ve(f) || f === "")
    return new Intl.NumberFormat(b, m).format(h);
  let S = {}, R, $ = null;
  const k = "number format";
  for (let P = 0; P < C.length && (R = C[P], S = r[R] || {}, $ = S[f], !Ye($)); P++)
    Vu(e, f, R, p, k);
  if (!Ye($) || !ve(R))
    return a ? os : f;
  let L = `${R}__${f}`;
  is(m) || (L = `${L}__${JSON.stringify(m)}`);
  let F = c.get(L);
  return F || (F = new Intl.NumberFormat(R, zt({}, $, m)), c.set(L, F)), y ? F.formatToParts(h) : F.format(h);
}
const tm = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function au(...e) {
  const [n, r, a, o] = e, s = {};
  let l = {};
  if (!Gt(n))
    throw Zn(Hn.INVALID_ARGUMENT);
  const c = n;
  return ve(r) ? s.key = r : Ye(r) && Object.keys(r).forEach((f) => {
    tm.includes(f) ? l[f] = r[f] : s[f] = r[f];
  }), ve(a) ? s.locale = a : Ye(a) && (l = a), Ye(o) && (l = o), [s.key || "", c, s, l];
}
function vh(e, n, r) {
  const a = e;
  for (const o in r) {
    const s = `${n}__${o}`;
    a.__numberFormatters.has(s) && a.__numberFormatters.delete(s);
  }
}
zS();
/*!
  * vue-i18n v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const NE = "9.13.1";
function RE() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (dr().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (dr().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (dr().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (dr().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (dr().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const nm = dE.__EXTEND_POINT__, fr = as(nm);
fr(), fr(), fr(), fr(), fr(), fr(), fr(), fr(), fr();
const rm = Hn.__EXTEND_POINT__, an = as(rm), gr = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: rm,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: an(),
  // 25
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: an(),
  // 26
  NOT_INSTALLED: an(),
  // 27
  NOT_AVAILABLE_IN_LEGACY_MODE: an(),
  // 28
  // directive module errors
  REQUIRED_VALUE: an(),
  // 29
  INVALID_VALUE: an(),
  // 30
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: an(),
  // 31
  NOT_INSTALLED_WITH_PROVIDE: an(),
  // 32
  // unexpected error
  UNEXPECTED_ERROR: an(),
  // 33
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: an(),
  // 34
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: an(),
  // 35
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: an(),
  // 36
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: an(),
  // 37
  // for enhancement
  __EXTEND_POINT__: an()
  // 38
};
function Rr(e, ...n) {
  return Hi(e, null, void 0);
}
const ou = /* @__PURE__ */ ai("__translateVNode"), su = /* @__PURE__ */ ai("__datetimeParts"), lu = /* @__PURE__ */ ai("__numberParts"), FE = ai("__setPluralRules"), im = /* @__PURE__ */ ai("__injectWithOption"), uu = /* @__PURE__ */ ai("__dispose");
function Ca(e) {
  if (!rt(e))
    return e;
  for (const n in e)
    if (Wo(e, n))
      if (!n.includes("."))
        rt(e[n]) && Ca(e[n]);
      else {
        const r = n.split("."), a = r.length - 1;
        let o = e, s = !1;
        for (let l = 0; l < a; l++) {
          if (r[l] in o || (o[r[l]] = {}), !rt(o[r[l]])) {
            s = !0;
            break;
          }
          o = o[r[l]];
        }
        s || (o[r[a]] = e[n], delete e[n]), rt(o[r[a]]) && Ca(o[r[a]]);
      }
  return e;
}
function Uu(e, n) {
  const { messages: r, __i18n: a, messageResolver: o, flatJson: s } = n, l = Ye(r) ? r : kt(a) ? {} : { [e]: {} };
  if (kt(a) && a.forEach((c) => {
    if ("locale" in c && "resource" in c) {
      const { locale: f, resource: h } = c;
      f ? (l[f] = l[f] || {}, Fo(h, l[f])) : Fo(h, l);
    } else
      ve(c) && Fo(JSON.parse(c), l);
  }), o == null && s)
    for (const c in l)
      Wo(l, c) && Ca(l[c]);
  return l;
}
function am(e) {
  return e.type;
}
function ME(e, n, r) {
  let a = rt(n.messages) ? n.messages : {};
  "__i18nGlobal" in r && (a = Uu(e.locale.value, {
    messages: a,
    __i18n: r.__i18nGlobal
  }));
  const o = Object.keys(a);
  o.length && o.forEach((s) => {
    e.mergeLocaleMessage(s, a[s]);
  });
  {
    if (rt(n.datetimeFormats)) {
      const s = Object.keys(n.datetimeFormats);
      s.length && s.forEach((l) => {
        e.mergeDateTimeFormat(l, n.datetimeFormats[l]);
      });
    }
    if (rt(n.numberFormats)) {
      const s = Object.keys(n.numberFormats);
      s.length && s.forEach((l) => {
        e.mergeNumberFormat(l, n.numberFormats[l]);
      });
    }
  }
}
function mh(e) {
  return T(Lv, null, e, 0);
}
const gh = "__INTLIFY_META__", ph = () => [], DE = () => !1;
let _h = 0;
function yh(e) {
  return (n, r, a, o) => e(r, a, $i() || void 0, o);
}
const $E = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = $i();
  let n = null;
  return e && (n = am(e)[gh]) ? { [gh]: n } : null;
};
function BE(e = {}, n) {
  const { __root: r, __injectWithOption: a } = e, o = r === void 0, s = e.flatJson, l = qd ? oe : Ue, c = !!e.translateExistCompatible;
  let f = st(e.inheritLocale) ? e.inheritLocale : !0;
  const h = l(
    // prettier-ignore
    r && f ? r.locale.value : ve(e.locale) ? e.locale : wa
  ), v = l(
    // prettier-ignore
    r && f ? r.fallbackLocale.value : ve(e.fallbackLocale) || kt(e.fallbackLocale) || Ye(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : h.value
  ), m = l(Uu(h.value, e)), p = l(Ye(e.datetimeFormats) ? e.datetimeFormats : { [h.value]: {} }), y = l(Ye(e.numberFormats) ? e.numberFormats : { [h.value]: {} });
  let b = r ? r.missingWarn : st(e.missingWarn) || Ni(e.missingWarn) ? e.missingWarn : !0, C = r ? r.fallbackWarn : st(e.fallbackWarn) || Ni(e.fallbackWarn) ? e.fallbackWarn : !0, S = r ? r.fallbackRoot : st(e.fallbackRoot) ? e.fallbackRoot : !0, R = !!e.fallbackFormat, $ = mt(e.missing) ? e.missing : null, k = mt(e.missing) ? yh(e.missing) : null, L = mt(e.postTranslation) ? e.postTranslation : null, F = r ? r.warnHtmlMessage : st(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, P = !!e.escapeParameter;
  const E = r ? r.modifiers : Ye(e.modifiers) ? e.modifiers : {};
  let V = e.pluralRules || r && r.pluralRules, W;
  W = (() => {
    o && oh(null);
    const H = {
      version: NE,
      locale: h.value,
      fallbackLocale: v.value,
      messages: m.value,
      modifiers: E,
      pluralRules: V,
      missing: k === null ? void 0 : k,
      missingWarn: b,
      fallbackWarn: C,
      fallbackFormat: R,
      unresolving: !0,
      postTranslation: L === null ? void 0 : L,
      warnHtmlMessage: F,
      escapeParameter: P,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    H.datetimeFormats = p.value, H.numberFormats = y.value, H.__datetimeFormatters = Ye(W) ? W.__datetimeFormatters : void 0, H.__numberFormatters = Ye(W) ? W.__numberFormatters : void 0;
    const te = SE(H);
    return o && oh(te), te;
  })(), va(W, h.value, v.value);
  function le() {
    return [
      h.value,
      v.value,
      m.value,
      p.value,
      y.value
    ];
  }
  const K = A({
    get: () => h.value,
    set: (H) => {
      h.value = H, W.locale = h.value;
    }
  }), ae = A({
    get: () => v.value,
    set: (H) => {
      v.value = H, W.fallbackLocale = v.value, va(W, h.value, H);
    }
  }), ue = A(() => m.value), Ce = /* @__PURE__ */ A(() => p.value), Se = /* @__PURE__ */ A(() => y.value);
  function Pe() {
    return mt(L) ? L : null;
  }
  function ie(H) {
    L = H, W.postTranslation = H;
  }
  function se() {
    return $;
  }
  function j(H) {
    H !== null && (k = yh(H)), $ = H, W.missing = k;
  }
  const re = (H, te, Xe, ft, En, wr) => {
    le();
    let jn;
    try {
      __INTLIFY_PROD_DEVTOOLS__, o || (W.fallbackContext = r ? CE() : void 0), jn = H(W);
    } finally {
      __INTLIFY_PROD_DEVTOOLS__, o || (W.fallbackContext = void 0);
    }
    if (Xe !== "translate exists" && // for not `te` (e.g `t`)
    Gt(jn) && jn === os || Xe === "translate exists" && !jn) {
      const [Xi, Ba] = te();
      return r && S ? ft(r) : En(Xi);
    } else {
      if (wr(jn))
        return jn;
      throw Rr(gr.UNEXPECTED_RETURN_TYPE);
    }
  };
  function fe(...H) {
    return re((te) => Reflect.apply(ch, null, [te, ...H]), () => ru(...H), "translate", (te) => Reflect.apply(te.t, te, [...H]), (te) => te, (te) => ve(te));
  }
  function ye(...H) {
    const [te, Xe, ft] = H;
    if (ft && !rt(ft))
      throw Rr(gr.INVALID_ARGUMENT);
    return fe(te, Xe, zt({ resolvedMessage: !0 }, ft || {}));
  }
  function Oe(...H) {
    return re((te) => Reflect.apply(fh, null, [te, ...H]), () => iu(...H), "datetime format", (te) => Reflect.apply(te.d, te, [...H]), () => rh, (te) => ve(te));
  }
  function ge(...H) {
    return re((te) => Reflect.apply(hh, null, [te, ...H]), () => au(...H), "number format", (te) => Reflect.apply(te.n, te, [...H]), () => rh, (te) => ve(te));
  }
  function Je(H) {
    return H.map((te) => ve(te) || Gt(te) || st(te) ? mh(String(te)) : te);
  }
  const xt = {
    normalize: Je,
    interpolate: (H) => H,
    type: "vnode"
  };
  function at(...H) {
    return re(
      (te) => {
        let Xe;
        const ft = te;
        try {
          ft.processor = xt, Xe = Reflect.apply(ch, null, [ft, ...H]);
        } finally {
          ft.processor = null;
        }
        return Xe;
      },
      () => ru(...H),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (te) => te[ou](...H),
      (te) => [mh(te)],
      (te) => kt(te)
    );
  }
  function Cn(...H) {
    return re(
      (te) => Reflect.apply(hh, null, [te, ...H]),
      () => au(...H),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (te) => te[lu](...H),
      ph,
      (te) => ve(te) || kt(te)
    );
  }
  function Qt(...H) {
    return re(
      (te) => Reflect.apply(fh, null, [te, ...H]),
      () => iu(...H),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (te) => te[su](...H),
      ph,
      (te) => ve(te) || kt(te)
    );
  }
  function cn(H) {
    V = H, W.pluralRules = V;
  }
  function we(H, te) {
    return re(() => {
      if (!H)
        return !1;
      const Xe = ve(te) ? te : h.value, ft = Nt(Xe), En = W.messageResolver(ft, H);
      return c ? En != null : Fi(En) || Nn(En) || ve(En);
    }, () => [H], "translate exists", (Xe) => Reflect.apply(Xe.te, Xe, [H, te]), DE, (Xe) => st(Xe));
  }
  function J(H) {
    let te = null;
    const Xe = Gv(W, v.value, h.value);
    for (let ft = 0; ft < Xe.length; ft++) {
      const En = m.value[Xe[ft]] || {}, wr = W.messageResolver(En, H);
      if (wr != null) {
        te = wr;
        break;
      }
    }
    return te;
  }
  function be(H) {
    const te = J(H);
    return te ?? (r ? r.tm(H) || {} : {});
  }
  function Nt(H) {
    return m.value[H] || {};
  }
  function At(H, te) {
    if (s) {
      const Xe = { [H]: te };
      for (const ft in Xe)
        Wo(Xe, ft) && Ca(Xe[ft]);
      te = Xe[H];
    }
    m.value[H] = te, W.messages = m.value;
  }
  function Sn(H, te) {
    m.value[H] = m.value[H] || {};
    const Xe = { [H]: te };
    if (s)
      for (const ft in Xe)
        Wo(Xe, ft) && Ca(Xe[ft]);
    te = Xe[H], Fo(te, m.value[H]), W.messages = m.value;
  }
  function er(H) {
    return p.value[H] || {};
  }
  function I(H, te) {
    p.value[H] = te, W.datetimeFormats = p.value, dh(W, H, te);
  }
  function O(H, te) {
    p.value[H] = zt(p.value[H] || {}, te), W.datetimeFormats = p.value, dh(W, H, te);
  }
  function Z(H) {
    return y.value[H] || {};
  }
  function pe(H, te) {
    y.value[H] = te, W.numberFormats = y.value, vh(W, H, te);
  }
  function lt(H, te) {
    y.value[H] = zt(y.value[H] || {}, te), W.numberFormats = y.value, vh(W, H, te);
  }
  _h++, r && qd && (Re(r.locale, (H) => {
    f && (h.value = H, W.locale = H, va(W, h.value, v.value));
  }), Re(r.fallbackLocale, (H) => {
    f && (v.value = H, W.fallbackLocale = H, va(W, h.value, v.value));
  }));
  const xe = {
    id: _h,
    locale: K,
    fallbackLocale: ae,
    get inheritLocale() {
      return f;
    },
    set inheritLocale(H) {
      f = H, H && r && (h.value = r.locale.value, v.value = r.fallbackLocale.value, va(W, h.value, v.value));
    },
    get availableLocales() {
      return Object.keys(m.value).sort();
    },
    messages: ue,
    get modifiers() {
      return E;
    },
    get pluralRules() {
      return V || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return b;
    },
    set missingWarn(H) {
      b = H, W.missingWarn = b;
    },
    get fallbackWarn() {
      return C;
    },
    set fallbackWarn(H) {
      C = H, W.fallbackWarn = C;
    },
    get fallbackRoot() {
      return S;
    },
    set fallbackRoot(H) {
      S = H;
    },
    get fallbackFormat() {
      return R;
    },
    set fallbackFormat(H) {
      R = H, W.fallbackFormat = R;
    },
    get warnHtmlMessage() {
      return F;
    },
    set warnHtmlMessage(H) {
      F = H, W.warnHtmlMessage = H;
    },
    get escapeParameter() {
      return P;
    },
    set escapeParameter(H) {
      P = H, W.escapeParameter = H;
    },
    t: fe,
    getLocaleMessage: Nt,
    setLocaleMessage: At,
    mergeLocaleMessage: Sn,
    getPostTranslationHandler: Pe,
    setPostTranslationHandler: ie,
    getMissingHandler: se,
    setMissingHandler: j,
    [FE]: cn
  };
  return xe.datetimeFormats = Ce, xe.numberFormats = Se, xe.rt = ye, xe.te = we, xe.tm = be, xe.d = Oe, xe.n = ge, xe.getDateTimeFormat = er, xe.setDateTimeFormat = I, xe.mergeDateTimeFormat = O, xe.getNumberFormat = Z, xe.setNumberFormat = pe, xe.mergeNumberFormat = lt, xe[im] = a, xe[ou] = at, xe[su] = Qt, xe[lu] = Cn, xe;
}
const Wu = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function VE({ slots: e }, n) {
  return n.length === 1 && n[0] === "default" ? (e.default ? e.default() : []).reduce((a, o) => [
    ...a,
    // prettier-ignore
    ...o.type === Ie ? o.children : [o]
  ], []) : n.reduce((r, a) => {
    const o = e[a];
    return o && (r[a] = o()), r;
  }, {});
}
function om(e) {
  return Ie;
}
zt({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validator: (e) => Gt(e) || !isNaN(e)
  }
}, Wu);
function UE(e) {
  return kt(e) && !ve(e[0]);
}
function sm(e, n, r, a) {
  const { slots: o, attrs: s } = n;
  return () => {
    const l = { part: !0 };
    let c = {};
    e.locale && (l.locale = e.locale), ve(e.format) ? l.key = e.format : rt(e.format) && (ve(e.format.key) && (l.key = e.format.key), c = Object.keys(e.format).reduce((p, y) => r.includes(y) ? zt({}, p, { [y]: e.format[y] }) : p, {}));
    const f = a(e.value, l, c);
    let h = [l.key];
    kt(f) ? h = f.map((p, y) => {
      const b = o[p.type], C = b ? b({ [p.type]: p.value, index: y, parts: f }) : [p.value];
      return UE(C) && (C[0].key = `${p.type}-${y}`), C;
    }) : ve(f) && (h = [f]);
    const v = zt({}, s), m = ve(e.tag) || rt(e.tag) ? e.tag : om();
    return Rn(m, v, h);
  };
}
zt({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Wu);
zt({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Wu);
const WE = /* @__PURE__ */ ai("global-vue-i18n");
function yr(e = {}) {
  const n = $i();
  if (n == null)
    throw Rr(gr.MUST_BE_CALL_SETUP_TOP);
  if (!n.isCE && n.appContext.app != null && !n.appContext.app.__VUE_I18N_SYMBOL__)
    throw Rr(gr.NOT_INSTALLED);
  const r = HE(n), a = zE(r), o = am(n), s = GE(e, o);
  if (__VUE_I18N_LEGACY_API__ && r.mode === "legacy" && !e.__useComponent) {
    if (!r.allowComposition)
      throw Rr(gr.NOT_AVAILABLE_IN_LEGACY_MODE);
    return YE(n, s, a, e);
  }
  if (s === "global")
    return ME(a, e, o), a;
  if (s === "parent") {
    let f = qE(r, n, e.__useComponent);
    return f == null && (f = a), f;
  }
  const l = r;
  let c = l.__getInstance(n);
  if (c == null) {
    const f = zt({}, e);
    "__i18n" in o && (f.__i18n = o.__i18n), a && (f.__root = a), c = BE(f), l.__composerExtend && (c[uu] = l.__composerExtend(c)), jE(l, n, c), l.__setInstance(n, c);
  }
  return c;
}
function HE(e) {
  {
    const n = Ze(e.isCE ? WE : e.appContext.app.__VUE_I18N_SYMBOL__);
    if (!n)
      throw Rr(e.isCE ? gr.NOT_INSTALLED_WITH_PROVIDE : gr.UNEXPECTED_ERROR);
    return n;
  }
}
function GE(e, n) {
  return is(e) ? "__i18n" in n ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function zE(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function qE(e, n, r = !1) {
  let a = null;
  const o = n.root;
  let s = KE(n, r);
  for (; s != null; ) {
    const l = e;
    if (e.mode === "composition")
      a = l.__getInstance(s);
    else if (__VUE_I18N_LEGACY_API__) {
      const c = l.__getInstance(s);
      c != null && (a = c.__composer, r && a && !a[im] && (a = null));
    }
    if (a != null || o === s)
      break;
    s = s.parent;
  }
  return a;
}
function KE(e, n = !1) {
  return e == null ? null : n && e.vnode.ctx || e.parent;
}
function jE(e, n, r) {
  qt(() => {
  }, n), Ou(() => {
    const a = r;
    e.__deleteInstance(n);
    const o = a[uu];
    o && (o(), delete a[uu]);
  }, n);
}
function YE(e, n, r, a = {}) {
  const o = n === "local", s = Ue(null);
  if (o && e.proxy && !(e.proxy.$options.i18n || e.proxy.$options.__i18n))
    throw Rr(gr.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  const l = st(a.inheritLocale) ? a.inheritLocale : !ve(a.locale), c = oe(
    // prettier-ignore
    !o || l ? r.locale.value : ve(a.locale) ? a.locale : wa
  ), f = oe(
    // prettier-ignore
    !o || l ? r.fallbackLocale.value : ve(a.fallbackLocale) || kt(a.fallbackLocale) || Ye(a.fallbackLocale) || a.fallbackLocale === !1 ? a.fallbackLocale : c.value
  ), h = oe(Uu(c.value, a)), v = oe(Ye(a.datetimeFormats) ? a.datetimeFormats : { [c.value]: {} }), m = oe(Ye(a.numberFormats) ? a.numberFormats : { [c.value]: {} }), p = o ? r.missingWarn : st(a.missingWarn) || Ni(a.missingWarn) ? a.missingWarn : !0, y = o ? r.fallbackWarn : st(a.fallbackWarn) || Ni(a.fallbackWarn) ? a.fallbackWarn : !0, b = o ? r.fallbackRoot : st(a.fallbackRoot) ? a.fallbackRoot : !0, C = !!a.fallbackFormat, S = mt(a.missing) ? a.missing : null, R = mt(a.postTranslation) ? a.postTranslation : null, $ = o ? r.warnHtmlMessage : st(a.warnHtmlMessage) ? a.warnHtmlMessage : !0, k = !!a.escapeParameter, L = o ? r.modifiers : Ye(a.modifiers) ? a.modifiers : {}, F = a.pluralRules || o && r.pluralRules;
  function P() {
    return [
      c.value,
      f.value,
      h.value,
      v.value,
      m.value
    ];
  }
  const E = A({
    get: () => s.value ? s.value.locale.value : c.value,
    set: (J) => {
      s.value && (s.value.locale.value = J), c.value = J;
    }
  }), V = A({
    get: () => s.value ? s.value.fallbackLocale.value : f.value,
    set: (J) => {
      s.value && (s.value.fallbackLocale.value = J), f.value = J;
    }
  }), W = A(() => s.value ? s.value.messages.value : h.value), me = A(() => v.value), le = A(() => m.value);
  function K() {
    return s.value ? s.value.getPostTranslationHandler() : R;
  }
  function ae(J) {
    s.value && s.value.setPostTranslationHandler(J);
  }
  function ue() {
    return s.value ? s.value.getMissingHandler() : S;
  }
  function Ce(J) {
    s.value && s.value.setMissingHandler(J);
  }
  function Se(J) {
    return P(), J();
  }
  function Pe(...J) {
    return s.value ? Se(() => Reflect.apply(s.value.t, null, [...J])) : Se(() => "");
  }
  function ie(...J) {
    return s.value ? Reflect.apply(s.value.rt, null, [...J]) : "";
  }
  function se(...J) {
    return s.value ? Se(() => Reflect.apply(s.value.d, null, [...J])) : Se(() => "");
  }
  function j(...J) {
    return s.value ? Se(() => Reflect.apply(s.value.n, null, [...J])) : Se(() => "");
  }
  function re(J) {
    return s.value ? s.value.tm(J) : {};
  }
  function fe(J, be) {
    return s.value ? s.value.te(J, be) : !1;
  }
  function ye(J) {
    return s.value ? s.value.getLocaleMessage(J) : {};
  }
  function Oe(J, be) {
    s.value && (s.value.setLocaleMessage(J, be), h.value[J] = be);
  }
  function ge(J, be) {
    s.value && s.value.mergeLocaleMessage(J, be);
  }
  function Je(J) {
    return s.value ? s.value.getDateTimeFormat(J) : {};
  }
  function $t(J, be) {
    s.value && (s.value.setDateTimeFormat(J, be), v.value[J] = be);
  }
  function xt(J, be) {
    s.value && s.value.mergeDateTimeFormat(J, be);
  }
  function at(J) {
    return s.value ? s.value.getNumberFormat(J) : {};
  }
  function Cn(J, be) {
    s.value && (s.value.setNumberFormat(J, be), m.value[J] = be);
  }
  function Qt(J, be) {
    s.value && s.value.mergeNumberFormat(J, be);
  }
  const cn = {
    get id() {
      return s.value ? s.value.id : -1;
    },
    locale: E,
    fallbackLocale: V,
    messages: W,
    datetimeFormats: me,
    numberFormats: le,
    get inheritLocale() {
      return s.value ? s.value.inheritLocale : l;
    },
    set inheritLocale(J) {
      s.value && (s.value.inheritLocale = J);
    },
    get availableLocales() {
      return s.value ? s.value.availableLocales : Object.keys(h.value);
    },
    get modifiers() {
      return s.value ? s.value.modifiers : L;
    },
    get pluralRules() {
      return s.value ? s.value.pluralRules : F;
    },
    get isGlobal() {
      return s.value ? s.value.isGlobal : !1;
    },
    get missingWarn() {
      return s.value ? s.value.missingWarn : p;
    },
    set missingWarn(J) {
      s.value && (s.value.missingWarn = J);
    },
    get fallbackWarn() {
      return s.value ? s.value.fallbackWarn : y;
    },
    set fallbackWarn(J) {
      s.value && (s.value.missingWarn = J);
    },
    get fallbackRoot() {
      return s.value ? s.value.fallbackRoot : b;
    },
    set fallbackRoot(J) {
      s.value && (s.value.fallbackRoot = J);
    },
    get fallbackFormat() {
      return s.value ? s.value.fallbackFormat : C;
    },
    set fallbackFormat(J) {
      s.value && (s.value.fallbackFormat = J);
    },
    get warnHtmlMessage() {
      return s.value ? s.value.warnHtmlMessage : $;
    },
    set warnHtmlMessage(J) {
      s.value && (s.value.warnHtmlMessage = J);
    },
    get escapeParameter() {
      return s.value ? s.value.escapeParameter : k;
    },
    set escapeParameter(J) {
      s.value && (s.value.escapeParameter = J);
    },
    t: Pe,
    getPostTranslationHandler: K,
    setPostTranslationHandler: ae,
    getMissingHandler: ue,
    setMissingHandler: Ce,
    rt: ie,
    d: se,
    n: j,
    tm: re,
    te: fe,
    getLocaleMessage: ye,
    setLocaleMessage: Oe,
    mergeLocaleMessage: ge,
    getDateTimeFormat: Je,
    setDateTimeFormat: $t,
    mergeDateTimeFormat: xt,
    getNumberFormat: at,
    setNumberFormat: Cn,
    mergeNumberFormat: Qt
  };
  function we(J) {
    J.locale.value = c.value, J.fallbackLocale.value = f.value, Object.keys(h.value).forEach((be) => {
      J.mergeLocaleMessage(be, h.value[be]);
    }), Object.keys(v.value).forEach((be) => {
      J.mergeDateTimeFormat(be, v.value[be]);
    }), Object.keys(m.value).forEach((be) => {
      J.mergeNumberFormat(be, m.value[be]);
    }), J.escapeParameter = k, J.fallbackFormat = C, J.fallbackRoot = b, J.fallbackWarn = y, J.missingWarn = p, J.warnHtmlMessage = $;
  }
  return Pu(() => {
    if (e.proxy == null || e.proxy.$i18n == null)
      throw Rr(gr.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const J = s.value = e.proxy.$i18n.__composer;
    n === "global" ? (c.value = J.locale.value, f.value = J.fallbackLocale.value, h.value = J.messages.value, v.value = J.datetimeFormats.value, m.value = J.numberFormats.value) : o && we(J);
  }), cn;
}
RE();
__INTLIFY_JIT_COMPILATION__ ? ah(TE) : ah(kE);
_E(QS);
yE(Gv);
if (__INTLIFY_PROD_DEVTOOLS__) {
  const e = dr();
  e.__INTLIFY__ = !0, lE(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
/**
 * Vue 3 Carousel 0.4.0
 * (c) 2024
 * @license MIT
 */
const Ft = {
  itemsToShow: 1,
  itemsToScroll: 1,
  modelValue: 0,
  transition: 300,
  autoplay: 0,
  snapAlign: "center",
  wrapAround: !1,
  throttle: 16,
  pauseAutoplayOnHover: !1,
  mouseDrag: !0,
  touchDrag: !0,
  dir: "ltr",
  breakpoints: void 0,
  i18n: {
    ariaNextSlide: "Navigate to next slide",
    ariaPreviousSlide: "Navigate to previous slide",
    ariaNavigateToSlide: "Navigate to slide {slideNumber}",
    ariaGallery: "Gallery",
    itemXofY: "Item {currentSlide} of {slidesCount}",
    iconArrowUp: "Arrow pointing upwards",
    iconArrowDown: "Arrow pointing downwards",
    iconArrowRight: "Arrow pointing to the right",
    iconArrowLeft: "Arrow pointing to the left"
  }
}, bh = {
  // count of items to showed per view
  itemsToShow: {
    default: Ft.itemsToShow,
    type: Number
  },
  // count of items to be scrolled
  itemsToScroll: {
    default: Ft.itemsToScroll,
    type: Number
  },
  // control infinite scrolling mode
  wrapAround: {
    default: Ft.wrapAround,
    type: Boolean
  },
  // control max drag
  throttle: {
    default: Ft.throttle,
    type: Number
  },
  // control snap position alignment
  snapAlign: {
    default: Ft.snapAlign,
    validator(e) {
      return ["start", "end", "center", "center-even", "center-odd"].includes(e);
    }
  },
  // sliding transition time in ms
  transition: {
    default: Ft.transition,
    type: Number
  },
  // an object to store breakpoints
  breakpoints: {
    default: Ft.breakpoints,
    type: Object
  },
  // time to auto advance slides in ms
  autoplay: {
    default: Ft.autoplay,
    type: Number
  },
  // pause autoplay when mouse hover over the carousel
  pauseAutoplayOnHover: {
    default: Ft.pauseAutoplayOnHover,
    type: Boolean
  },
  // slide number number of initial slide
  modelValue: {
    default: void 0,
    type: Number
  },
  // toggle mouse dragging.
  mouseDrag: {
    default: Ft.mouseDrag,
    type: Boolean
  },
  // toggle mouse dragging.
  touchDrag: {
    default: Ft.touchDrag,
    type: Boolean
  },
  // control snap position alignment
  dir: {
    default: Ft.dir,
    validator(e) {
      return ["rtl", "ltr"].includes(e);
    }
  },
  // aria-labels and additional text labels
  i18n: {
    default: Ft.i18n,
    type: Object
  },
  // an object to pass all settings
  settings: {
    default() {
      return {};
    },
    type: Object
  }
};
function XE({ config: e, slidesCount: n }) {
  const { snapAlign: r, wrapAround: a, itemsToShow: o = 1 } = e;
  if (a)
    return Math.max(n - 1, 0);
  let s;
  switch (r) {
    case "start":
      s = n - o;
      break;
    case "end":
      s = n - 1;
      break;
    case "center":
    case "center-odd":
      s = n - Math.ceil((o - 0.5) / 2);
      break;
    case "center-even":
      s = n - Math.ceil(o / 2);
      break;
    default:
      s = 0;
      break;
  }
  return Math.max(s, 0);
}
function JE({ config: e, slidesCount: n }) {
  const { wrapAround: r, snapAlign: a, itemsToShow: o = 1 } = e;
  let s = 0;
  if (r || o > n)
    return s;
  switch (a) {
    case "start":
      s = 0;
      break;
    case "end":
      s = o - 1;
      break;
    case "center":
    case "center-odd":
      s = Math.floor((o - 1) / 2);
      break;
    case "center-even":
      s = Math.floor((o - 2) / 2);
      break;
    default:
      s = 0;
      break;
  }
  return s;
}
function cu({ val: e, max: n, min: r }) {
  return n < r ? e : Math.min(Math.max(e, r), n);
}
function ZE({ config: e, currentSlide: n, slidesCount: r }) {
  const { snapAlign: a, wrapAround: o, itemsToShow: s = 1 } = e;
  let l = n;
  switch (a) {
    case "center":
    case "center-odd":
      l -= (s - 1) / 2;
      break;
    case "center-even":
      l -= (s - 2) / 2;
      break;
    case "end":
      l -= s - 1;
      break;
  }
  return o ? l : cu({
    val: l,
    max: r - s,
    min: 0
  });
}
function lm(e) {
  return e ? e.reduce((n, r) => {
    var a;
    return r.type === Ie ? [...n, ...lm(r.children)] : ((a = r.type) === null || a === void 0 ? void 0 : a.name) === "CarouselSlide" ? [...n, r] : n;
  }, []) : [];
}
function fu({ val: e, max: n, min: r = 0 }) {
  return e > n ? fu({ val: e - (n + 1), max: n, min: r }) : e < r ? fu({ val: e + (n + 1), max: n, min: r }) : e;
}
function QE(e, n) {
  let r;
  return n ? function(...a) {
    const o = this;
    r || (e.apply(o, a), r = !0, setTimeout(() => r = !1, n));
  } : e;
}
function ex(e, n) {
  let r;
  return function(...a) {
    r && clearTimeout(r), r = setTimeout(() => {
      e(...a), r = null;
    }, n);
  };
}
function tx(e = "", n = {}) {
  return Object.entries(n).reduce((r, [a, o]) => r.replace(`{${a}}`, String(o)), e);
}
var nx = Qe({
  name: "ARIA",
  setup() {
    const e = Ze("config", mr(Object.assign({}, Ft))), n = Ze("currentSlide", oe(0)), r = Ze("slidesCount", oe(0));
    return () => Rn("div", {
      class: ["carousel__liveregion", "carousel__sr-only"],
      "aria-live": "polite",
      "aria-atomic": "true"
    }, tx(e.i18n.itemXofY, {
      currentSlide: n.value + 1,
      slidesCount: r.value
    }));
  }
}), rx = Qe({
  name: "Carousel",
  props: bh,
  setup(e, { slots: n, emit: r, expose: a }) {
    var o;
    const s = oe(null), l = oe([]), c = oe(0), f = oe(0), h = mr(Object.assign({}, Ft)), v = oe((o = e.modelValue) !== null && o !== void 0 ? o : 0), m = oe(0), p = oe(0), y = oe(0), b = oe(0);
    let C = null, S = null;
    Et("config", h), Et("slidesCount", f), Et("currentSlide", v), Et("maxSlide", y), Et("minSlide", b), Et("slideWidth", c);
    const R = A(() => Object.assign({}, e.breakpoints)), $ = A(() => Object.assign(Object.assign(Object.assign({}, Ft), e), { i18n: Object.assign(Object.assign({}, Ft.i18n), e.i18n), breakpoints: void 0 }));
    function k() {
      const we = Object.keys(R.value || {}).map((be) => Number(be)).sort((be, Nt) => +Nt - +be);
      let J = Object.assign({}, $.value);
      we.some((be) => {
        const Nt = window.matchMedia(`(min-width: ${be}px)`).matches;
        return Nt && (J = Object.assign(Object.assign({}, J), R.value[be])), Nt;
      }), L(J);
    }
    function L(we) {
      Object.entries(we).forEach(([J, be]) => h[J] = be);
    }
    const F = ex(() => {
      k(), E(), P();
    }, 16);
    function P() {
      if (!s.value)
        return;
      const we = s.value.getBoundingClientRect();
      c.value = we.width / h.itemsToShow;
    }
    function E() {
      f.value <= 0 || (p.value = Math.ceil((f.value - 1) / 2), y.value = XE({ config: h, slidesCount: f.value }), b.value = JE({ config: h, slidesCount: f.value }), h.wrapAround || (v.value = cu({
        val: v.value,
        max: y.value,
        min: b.value
      })));
    }
    qt(() => {
      Jt(() => P()), setTimeout(() => P(), 1e3), k(), se(), window.addEventListener("resize", F, { passive: !0 }), r("init");
    }), Ou(() => {
      S && clearTimeout(S), C && clearInterval(C), window.removeEventListener("resize", F, {
        passive: !0
      });
    });
    let V = !1;
    const W = { x: 0, y: 0 }, me = { x: 0, y: 0 }, le = mr({ x: 0, y: 0 }), K = oe(!1), ae = oe(!1), ue = () => {
      K.value = !0;
    }, Ce = () => {
      K.value = !1;
    };
    function Se(we) {
      ["INPUT", "TEXTAREA", "SELECT"].includes(we.target.tagName) || (V = we.type === "touchstart", V || we.preventDefault(), !(!V && we.button !== 0 || re.value) && (W.x = V ? we.touches[0].clientX : we.clientX, W.y = V ? we.touches[0].clientY : we.clientY, document.addEventListener(V ? "touchmove" : "mousemove", Pe), document.addEventListener(V ? "touchend" : "mouseup", ie)));
    }
    const Pe = QE((we) => {
      ae.value = !0, me.x = V ? we.touches[0].clientX : we.clientX, me.y = V ? we.touches[0].clientY : we.clientY;
      const J = me.x - W.x, be = me.y - W.y;
      le.y = be, le.x = J;
    }, h.throttle);
    function ie() {
      const we = h.dir === "rtl" ? -1 : 1, J = Math.sign(le.x) * 0.4, be = Math.round(le.x / c.value + J) * we;
      if (be && !V) {
        const Nt = (At) => {
          At.preventDefault(), window.removeEventListener("click", Nt);
        };
        window.addEventListener("click", Nt);
      }
      fe(v.value - be), le.x = 0, le.y = 0, ae.value = !1, document.removeEventListener(V ? "touchmove" : "mousemove", Pe), document.removeEventListener(V ? "touchend" : "mouseup", ie);
    }
    function se() {
      !h.autoplay || h.autoplay <= 0 || (C = setInterval(() => {
        h.pauseAutoplayOnHover && K.value || ye();
      }, h.autoplay));
    }
    function j() {
      C && (clearInterval(C), C = null), se();
    }
    const re = oe(!1);
    function fe(we) {
      const J = h.wrapAround ? we : cu({
        val: we,
        max: y.value,
        min: b.value
      });
      v.value === J || re.value || (r("slide-start", {
        slidingToIndex: we,
        currentSlideIndex: v.value,
        prevSlideIndex: m.value,
        slidesCount: f.value
      }), re.value = !0, m.value = v.value, v.value = J, S = setTimeout(() => {
        if (h.wrapAround) {
          const be = fu({
            val: J,
            max: y.value,
            min: 0
          });
          be !== v.value && (v.value = be, r("loop", {
            currentSlideIndex: v.value,
            slidingToIndex: we
          }));
        }
        r("update:modelValue", v.value), r("slide-end", {
          currentSlideIndex: v.value,
          prevSlideIndex: m.value,
          slidesCount: f.value
        }), re.value = !1, j();
      }, h.transition));
    }
    function ye() {
      fe(v.value + h.itemsToScroll);
    }
    function Oe() {
      fe(v.value - h.itemsToScroll);
    }
    const ge = { slideTo: fe, next: ye, prev: Oe };
    Et("nav", ge), Et("isSliding", re);
    const Je = A(() => ZE({
      config: h,
      currentSlide: v.value,
      slidesCount: f.value
    }));
    Et("slidesToScroll", Je);
    const $t = A(() => {
      const we = h.dir === "rtl" ? -1 : 1, J = Je.value * c.value * we;
      return {
        transform: `translateX(${le.x - J}px)`,
        transition: `${re.value ? h.transition : 0}ms`,
        margin: h.wrapAround ? `0 -${f.value * c.value}px` : "",
        width: "100%"
      };
    });
    function xt() {
      k(), E(), P(), j();
    }
    Object.keys(bh).forEach((we) => {
      ["modelValue"].includes(we) || Re(() => e[we], xt);
    }), Re(() => e.modelValue, (we) => {
      we !== v.value && fe(Number(we));
    }), Re(f, E), r("before-init");
    const at = {
      config: h,
      slidesCount: f,
      slideWidth: c,
      next: ye,
      prev: Oe,
      slideTo: fe,
      currentSlide: v,
      maxSlide: y,
      minSlide: b,
      middleSlide: p
    };
    a({
      updateBreakpointsConfigs: k,
      updateSlidesData: E,
      updateSlideWidth: P,
      restartCarousel: xt,
      slideTo: fe,
      next: ye,
      prev: Oe,
      nav: ge,
      data: at
    });
    const Cn = n.default || n.slides, Qt = n.addons, cn = mr(at);
    return () => {
      const we = lm(Cn?.(cn)), J = Qt?.(cn) || [];
      we.forEach((Sn, er) => Sn.props.index = er);
      let be = we;
      if (h.wrapAround) {
        const Sn = we.map((I, O) => tu(I, {
          index: -we.length + O,
          isClone: !0,
          key: `clone-before-${O}`
        })), er = we.map((I, O) => tu(I, {
          index: we.length + O,
          isClone: !0,
          key: `clone-after-${O}`
        }));
        be = [...Sn, ...we, ...er];
      }
      l.value = we, f.value = Math.max(we.length, 1);
      const Nt = Rn("ol", {
        class: "carousel__track",
        style: $t.value,
        onMousedownCapture: h.mouseDrag ? Se : null,
        onTouchstartPassiveCapture: h.touchDrag ? Se : null
      }, be), At = Rn("div", { class: "carousel__viewport" }, Nt);
      return Rn("section", {
        ref: s,
        class: {
          carousel: !0,
          "is-sliding": re.value,
          "is-dragging": ae.value,
          "is-hover": K.value,
          "carousel--rtl": h.dir === "rtl"
        },
        dir: h.dir,
        "aria-label": h.i18n.ariaGallery,
        tabindex: "0",
        onMouseenter: ue,
        onMouseleave: Ce
      }, [At, J, Rn(nx)]);
    };
  }
}), wh;
(function(e) {
  e.arrowUp = "arrowUp", e.arrowDown = "arrowDown", e.arrowRight = "arrowRight", e.arrowLeft = "arrowLeft";
})(wh || (wh = {}));
var ix = Qe({
  name: "CarouselSlide",
  props: {
    index: {
      type: Number,
      default: 1
    },
    isClone: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, { slots: n }) {
    const r = Ze("config", mr(Object.assign({}, Ft))), a = Ze("currentSlide", oe(0)), o = Ze("slidesToScroll", oe(0)), s = Ze("isSliding", oe(!1)), l = A(() => e.index === a.value), c = A(() => e.index === a.value - 1), f = A(() => e.index === a.value + 1), h = A(() => {
      const v = Math.floor(o.value), m = Math.ceil(o.value + r.itemsToShow - 1);
      return e.index >= v && e.index <= m;
    });
    return () => {
      var v;
      return Rn("li", {
        style: { width: `${100 / r.itemsToShow}%` },
        class: {
          carousel__slide: !0,
          "carousel__slide--clone": e.isClone,
          "carousel__slide--visible": h.value,
          "carousel__slide--active": l.value,
          "carousel__slide--prev": c.value,
          "carousel__slide--next": f.value,
          "carousel__slide--sliding": s.value
        },
        "aria-hidden": !h.value
      }, (v = n.default) === null || v === void 0 ? void 0 : v.call(n, {
        isActive: l.value,
        isClone: e.isClone,
        isPrev: c.value,
        isNext: f.value,
        isSliding: s.value,
        isVisible: h.value
      }));
    };
  }
});
function he(e, n) {
  return (r) => Object.keys(e).reduce((a, o) => {
    const l = typeof e[o] == "object" && e[o] != null && !Array.isArray(e[o]) ? e[o] : {
      type: e[o]
    };
    return r && o in r ? a[o] = {
      ...l,
      default: r[o]
    } : a[o] = l, n && !a[o].source && (a[o].source = n), a;
  }, {});
}
const ct = he({
  class: [String, Array, Object],
  style: {
    type: [String, Array, Object],
    default: null
  }
}, "component"), Pt = typeof window < "u", Hu = Pt && "IntersectionObserver" in window;
function um(e, n, r) {
  const a = n.length - 1;
  if (a < 0) return e === void 0 ? r : e;
  for (let o = 0; o < a; o++) {
    if (e == null)
      return r;
    e = e[n[o]];
  }
  return e == null || e[n[a]] === void 0 ? r : e[n[a]];
}
function Gi(e, n) {
  if (e === n) return !0;
  if (e instanceof Date && n instanceof Date && e.getTime() !== n.getTime() || e !== Object(e) || n !== Object(n))
    return !1;
  const r = Object.keys(e);
  return r.length !== Object.keys(n).length ? !1 : r.every((a) => Gi(e[a], n[a]));
}
function ax(e, n, r) {
  return e == null || !n || typeof n != "string" ? r : e[n] !== void 0 ? e[n] : (n = n.replace(/\[(\w+)\]/g, ".$1"), n = n.replace(/^\./, ""), um(e, n.split("."), r));
}
function hr(e, n, r) {
  if (n === !0) return e === void 0 ? r : e;
  if (n == null || typeof n == "boolean") return r;
  if (e !== Object(e)) {
    if (typeof n != "function") return r;
    const o = n(e, r);
    return typeof o > "u" ? r : o;
  }
  if (typeof n == "string") return ax(e, n, r);
  if (Array.isArray(n)) return um(e, n, r);
  if (typeof n != "function") return r;
  const a = n(e, r);
  return typeof a > "u" ? r : a;
}
function Ge(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "px";
  if (!(e == null || e === ""))
    return isNaN(+e) ? String(e) : isFinite(+e) ? `${Number(e)}${n}` : void 0;
}
function du(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function cm(e) {
  if (e && "$el" in e) {
    const n = e.$el;
    return n?.nodeType === Node.TEXT_NODE ? n.nextElementSibling : n;
  }
  return e;
}
const Ch = Object.freeze({
  enter: 13,
  tab: 9,
  delete: 46,
  esc: 27,
  space: 32,
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  end: 35,
  home: 36,
  del: 46,
  backspace: 8,
  insert: 45,
  pageup: 33,
  pagedown: 34,
  shift: 16
});
function Bl(e, n) {
  return n.every((r) => e.hasOwnProperty(r));
}
function fm(e, n) {
  const r = {}, a = new Set(Object.keys(e));
  for (const o of n)
    a.has(o) && (r[o] = e[o]);
  return r;
}
function Sh(e, n, r) {
  const a = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ Object.create(null);
  for (const s in e)
    n.some((l) => l instanceof RegExp ? l.test(s) : l === s) && !r?.some((l) => l === s) ? a[s] = e[s] : o[s] = e[s];
  return [a, o];
}
function oi(e, n) {
  const r = {
    ...e
  };
  return n.forEach((a) => delete r[a]), r;
}
function ox(e, n) {
  const r = {};
  return n.forEach((a) => r[a] = e[a]), r;
}
const dm = /^on[^a-z]/, Gu = (e) => dm.test(e), sx = ["onAfterscriptexecute", "onAnimationcancel", "onAnimationend", "onAnimationiteration", "onAnimationstart", "onAuxclick", "onBeforeinput", "onBeforescriptexecute", "onChange", "onClick", "onCompositionend", "onCompositionstart", "onCompositionupdate", "onContextmenu", "onCopy", "onCut", "onDblclick", "onFocusin", "onFocusout", "onFullscreenchange", "onFullscreenerror", "onGesturechange", "onGestureend", "onGesturestart", "onGotpointercapture", "onInput", "onKeydown", "onKeypress", "onKeyup", "onLostpointercapture", "onMousedown", "onMousemove", "onMouseout", "onMouseover", "onMouseup", "onMousewheel", "onPaste", "onPointercancel", "onPointerdown", "onPointerenter", "onPointerleave", "onPointermove", "onPointerout", "onPointerover", "onPointerup", "onReset", "onSelect", "onSubmit", "onTouchcancel", "onTouchend", "onTouchmove", "onTouchstart", "onTransitioncancel", "onTransitionend", "onTransitionrun", "onTransitionstart", "onWheel"];
function hm(e) {
  const [n, r] = Sh(e, [dm]), a = oi(n, sx), [o, s] = Sh(r, ["class", "style", "id", /^data-/]);
  return Object.assign(o, n), Object.assign(s, a), [o, s];
}
function Mn(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function lx(e, n) {
  let r = 0;
  const a = function() {
    for (var o = arguments.length, s = new Array(o), l = 0; l < o; l++)
      s[l] = arguments[l];
    clearTimeout(r), r = setTimeout(() => e(...s), q(n));
  };
  return a.clear = () => {
    clearTimeout(r);
  }, a.immediate = e, a;
}
function Fr(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return Math.max(n, Math.min(r, e));
}
function Eh(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0";
  return e + r.repeat(Math.max(0, n - e.length));
}
function ux(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  const r = [];
  let a = 0;
  for (; a < e.length; )
    r.push(e.substr(a, n)), a += n;
  return r;
}
function vr() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 ? arguments[2] : void 0;
  const a = {};
  for (const o in e)
    a[o] = e[o];
  for (const o in n) {
    const s = e[o], l = n[o];
    if (du(s) && du(l)) {
      a[o] = vr(s, l, r);
      continue;
    }
    if (Array.isArray(s) && Array.isArray(l) && r) {
      a[o] = r(s, l);
      continue;
    }
    a[o] = l;
  }
  return a;
}
function vm(e) {
  return e.map((n) => n.type === Ie ? vm(n.children) : n).flat();
}
function Jr() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  if (Jr.cache.has(e)) return Jr.cache.get(e);
  const n = e.replace(/[^a-z]/gi, "-").replace(/\B([A-Z])/g, "-$1").toLowerCase();
  return Jr.cache.set(e, n), n;
}
Jr.cache = /* @__PURE__ */ new Map();
function _a(e, n) {
  if (!n || typeof n != "object") return [];
  if (Array.isArray(n))
    return n.map((r) => _a(e, r)).flat(1);
  if (n.suspense)
    return _a(e, n.ssContent);
  if (Array.isArray(n.children))
    return n.children.map((r) => _a(e, r)).flat(1);
  if (n.component) {
    if (Object.getOwnPropertySymbols(n.component.provides).includes(e))
      return [n.component];
    if (n.component.subTree)
      return _a(e, n.component.subTree).flat(1);
  }
  return [];
}
function zu(e) {
  const n = mr({}), r = A(e);
  return Mr(() => {
    for (const a in r.value)
      n[a] = r.value[a];
  }, {
    flush: "sync"
  }), ht(n);
}
function Go(e, n) {
  return e.includes(n);
}
function mm(e) {
  return e[2].toLowerCase() + e.slice(3);
}
const on = () => [Function, Array];
function xh(e, n) {
  return n = "on" + Ov(n), !!(e[n] || e[`${n}Once`] || e[`${n}Capture`] || e[`${n}OnceCapture`] || e[`${n}CaptureOnce`]);
}
function cx(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
    r[a - 1] = arguments[a];
  if (Array.isArray(e))
    for (const o of e)
      o(...r);
  else typeof e == "function" && e(...r);
}
function Sa(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  const r = ["button", "[href]", 'input:not([type="hidden"])', "select", "textarea", "[tabindex]"].map((a) => `${a}${n ? ':not([tabindex="-1"])' : ""}:not([disabled])`).join(", ");
  return [...e.querySelectorAll(r)];
}
function gm(e, n, r) {
  let a, o = e.indexOf(document.activeElement);
  const s = n === "next" ? 1 : -1;
  do
    o += s, a = e[o];
  while ((!a || a.offsetParent == null || !(r?.(a) ?? !0)) && o < e.length && o >= 0);
  return a;
}
function zo(e, n) {
  const r = Sa(e);
  if (!n)
    (e === document.activeElement || !e.contains(document.activeElement)) && r[0]?.focus();
  else if (n === "first")
    r[0]?.focus();
  else if (n === "last")
    r.at(-1)?.focus();
  else if (typeof n == "number")
    r[n]?.focus();
  else {
    const a = gm(r, n);
    a ? a.focus() : zo(e, n === "next" ? "first" : "last");
  }
}
function qo(e, n) {
  if (!(Pt && typeof CSS < "u" && typeof CSS.supports < "u" && CSS.supports(`selector(${n})`))) return null;
  try {
    return !!e && e.matches(n);
  } catch {
    return null;
  }
}
function pm(e) {
  return e.some((n) => MC(n) ? n.type === DC ? !1 : n.type !== Ie || pm(n.children) : !0) ? e : null;
}
function fx(e, n) {
  if (!Pt || e === 0)
    return n(), () => {
    };
  const r = window.setTimeout(n, e);
  return () => window.clearTimeout(r);
}
function dx(e, n) {
  const r = e.clientX, a = e.clientY, o = n.getBoundingClientRect(), s = o.left, l = o.top, c = o.right, f = o.bottom;
  return r >= s && r <= c && a >= l && a <= f;
}
function hu() {
  const e = Ue(), n = (r) => {
    e.value = r;
  };
  return Object.defineProperty(n, "value", {
    enumerable: !0,
    get: () => e.value,
    set: (r) => e.value = r
  }), Object.defineProperty(n, "el", {
    enumerable: !0,
    get: () => cm(e.value)
  }), n;
}
const _m = ["top", "bottom"], hx = ["start", "end", "left", "right"];
function vu(e, n) {
  let [r, a] = e.split(" ");
  return a || (a = Go(_m, r) ? "start" : Go(hx, r) ? "top" : "center"), {
    side: Ah(r, n),
    align: Ah(a, n)
  };
}
function Ah(e, n) {
  return e === "start" ? n ? "right" : "left" : e === "end" ? n ? "left" : "right" : e;
}
function Vl(e) {
  return {
    side: {
      center: "center",
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[e.side],
    align: e.align
  };
}
function Ul(e) {
  return {
    side: e.side,
    align: {
      center: "center",
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[e.align]
  };
}
function kh(e) {
  return {
    side: e.align,
    align: e.side
  };
}
function Th(e) {
  return Go(_m, e.side) ? "y" : "x";
}
class Zr {
  constructor(n) {
    let {
      x: r,
      y: a,
      width: o,
      height: s
    } = n;
    this.x = r, this.y = a, this.width = o, this.height = s;
  }
  get top() {
    return this.y;
  }
  get bottom() {
    return this.y + this.height;
  }
  get left() {
    return this.x;
  }
  get right() {
    return this.x + this.width;
  }
}
function Ih(e, n) {
  return {
    x: {
      before: Math.max(0, n.left - e.left),
      after: Math.max(0, e.right - n.right)
    },
    y: {
      before: Math.max(0, n.top - e.top),
      after: Math.max(0, e.bottom - n.bottom)
    }
  };
}
function ym(e) {
  return Array.isArray(e) ? new Zr({
    x: e[0],
    y: e[1],
    width: 0,
    height: 0
  }) : e.getBoundingClientRect();
}
function qu(e) {
  const n = e.getBoundingClientRect(), r = getComputedStyle(e), a = r.transform;
  if (a) {
    let o, s, l, c, f;
    if (a.startsWith("matrix3d("))
      o = a.slice(9, -1).split(/, /), s = +o[0], l = +o[5], c = +o[12], f = +o[13];
    else if (a.startsWith("matrix("))
      o = a.slice(7, -1).split(/, /), s = +o[0], l = +o[3], c = +o[4], f = +o[5];
    else
      return new Zr(n);
    const h = r.transformOrigin, v = n.x - c - (1 - s) * parseFloat(h), m = n.y - f - (1 - l) * parseFloat(h.slice(h.indexOf(" ") + 1)), p = s ? n.width / s : e.offsetWidth + 1, y = l ? n.height / l : e.offsetHeight + 1;
    return new Zr({
      x: v,
      y: m,
      width: p,
      height: y
    });
  } else
    return new Zr(n);
}
function Li(e, n, r) {
  if (typeof e.animate > "u") return {
    finished: Promise.resolve()
  };
  let a;
  try {
    a = e.animate(n, r);
  } catch {
    return {
      finished: Promise.resolve()
    };
  }
  return typeof a.finished > "u" && (a.finished = new Promise((o) => {
    a.onfinish = () => {
      o(a);
    };
  })), a;
}
const Mo = /* @__PURE__ */ new WeakMap();
function vx(e, n) {
  Object.keys(n).forEach((r) => {
    if (Gu(r)) {
      const a = mm(r), o = Mo.get(e);
      if (n[r] == null)
        o?.forEach((s) => {
          const [l, c] = s;
          l === a && (e.removeEventListener(a, c), o.delete(s));
        });
      else if (!o || ![...o].some((s) => s[0] === a && s[1] === n[r])) {
        e.addEventListener(a, n[r]);
        const s = o || /* @__PURE__ */ new Set();
        s.add([a, n[r]]), Mo.has(e) || Mo.set(e, s);
      }
    } else
      n[r] == null ? e.removeAttribute(r) : e.setAttribute(r, n[r]);
  });
}
function mx(e, n) {
  Object.keys(n).forEach((r) => {
    if (Gu(r)) {
      const a = mm(r), o = Mo.get(e);
      o?.forEach((s) => {
        const [l, c] = s;
        l === a && (e.removeEventListener(a, c), o.delete(s));
      });
    } else
      e.removeAttribute(r);
  });
}
const ki = 2.4, Lh = 0.2126729, Oh = 0.7151522, Ph = 0.072175, gx = 0.55, px = 0.58, _x = 0.57, yx = 0.62, Lo = 0.03, Nh = 1.45, bx = 5e-4, wx = 1.25, Cx = 1.25, Rh = 0.078, Fh = 12.82051282051282, Oo = 0.06, Mh = 1e-3;
function Dh(e, n) {
  const r = (e.r / 255) ** ki, a = (e.g / 255) ** ki, o = (e.b / 255) ** ki, s = (n.r / 255) ** ki, l = (n.g / 255) ** ki, c = (n.b / 255) ** ki;
  let f = r * Lh + a * Oh + o * Ph, h = s * Lh + l * Oh + c * Ph;
  if (f <= Lo && (f += (Lo - f) ** Nh), h <= Lo && (h += (Lo - h) ** Nh), Math.abs(h - f) < bx) return 0;
  let v;
  if (h > f) {
    const m = (h ** gx - f ** px) * wx;
    v = m < Mh ? 0 : m < Rh ? m - m * Fh * Oo : m - Oo;
  } else {
    const m = (h ** yx - f ** _x) * Cx;
    v = m > -Mh ? 0 : m > -Rh ? m - m * Fh * Oo : m + Oo;
  }
  return v * 100;
}
function Qr(e) {
  ns(`Vuetify: ${e}`);
}
function Sx(e) {
  ns(`Vuetify error: ${e}`);
}
function Ex(e, n) {
  n = Array.isArray(n) ? n.slice(0, -1).map((r) => `'${r}'`).join(", ") + ` or '${n.at(-1)}'` : `'${n}'`, ns(`[Vuetify UPGRADE] '${e}' is deprecated, use ${n} instead.`);
}
function mu(e) {
  return !!e && /^(#|var\(--|(rgb|hsl)a?\()/.test(e);
}
function xx(e) {
  return mu(e) && !/^((rgb|hsl)a?\()?var\(--/.test(e);
}
const $h = /^(?<fn>(?:rgb|hsl)a?)\((?<values>.+)\)/, Ax = {
  rgb: (e, n, r, a) => ({
    r: e,
    g: n,
    b: r,
    a
  }),
  rgba: (e, n, r, a) => ({
    r: e,
    g: n,
    b: r,
    a
  }),
  hsl: (e, n, r, a) => Bh({
    h: e,
    s: n,
    l: r,
    a
  }),
  hsla: (e, n, r, a) => Bh({
    h: e,
    s: n,
    l: r,
    a
  }),
  hsv: (e, n, r, a) => Ea({
    h: e,
    s: n,
    v: r,
    a
  }),
  hsva: (e, n, r, a) => Ea({
    h: e,
    s: n,
    v: r,
    a
  })
};
function ya(e) {
  if (typeof e == "number")
    return (isNaN(e) || e < 0 || e > 16777215) && Qr(`'${e}' is not a valid hex color`), {
      r: (e & 16711680) >> 16,
      g: (e & 65280) >> 8,
      b: e & 255
    };
  if (typeof e == "string" && $h.test(e)) {
    const {
      groups: n
    } = e.match($h), {
      fn: r,
      values: a
    } = n, o = a.split(/,\s*/).map((s) => s.endsWith("%") && ["hsl", "hsla", "hsv", "hsva"].includes(r) ? parseFloat(s) / 100 : parseFloat(s));
    return Ax[r](...o);
  } else if (typeof e == "string") {
    let n = e.startsWith("#") ? e.slice(1) : e;
    [3, 4].includes(n.length) ? n = n.split("").map((a) => a + a).join("") : [6, 8].includes(n.length) || Qr(`'${e}' is not a valid hex(a) color`);
    const r = parseInt(n, 16);
    return (isNaN(r) || r < 0 || r > 4294967295) && Qr(`'${e}' is not a valid hex(a) color`), kx(n);
  } else if (typeof e == "object") {
    if (Bl(e, ["r", "g", "b"]))
      return e;
    if (Bl(e, ["h", "s", "l"]))
      return Ea(bm(e));
    if (Bl(e, ["h", "s", "v"]))
      return Ea(e);
  }
  throw new TypeError(`Invalid color: ${e == null ? e : String(e) || e.constructor.name}
Expected #hex, #hexa, rgb(), rgba(), hsl(), hsla(), object or number`);
}
function Ea(e) {
  const {
    h: n,
    s: r,
    v: a,
    a: o
  } = e, s = (c) => {
    const f = (c + n / 60) % 6;
    return a - a * r * Math.max(Math.min(f, 4 - f, 1), 0);
  }, l = [s(5), s(3), s(1)].map((c) => Math.round(c * 255));
  return {
    r: l[0],
    g: l[1],
    b: l[2],
    a: o
  };
}
function Bh(e) {
  return Ea(bm(e));
}
function bm(e) {
  const {
    h: n,
    s: r,
    l: a,
    a: o
  } = e, s = a + r * Math.min(a, 1 - a), l = s === 0 ? 0 : 2 - 2 * a / s;
  return {
    h: n,
    s: l,
    v: s,
    a: o
  };
}
function kx(e) {
  e = Tx(e);
  let [n, r, a, o] = ux(e, 2).map((s) => parseInt(s, 16));
  return o = o === void 0 ? o : o / 255, {
    r: n,
    g: r,
    b: a,
    a: o
  };
}
function Tx(e) {
  return e.startsWith("#") && (e = e.slice(1)), e = e.replace(/([^0-9a-f])/gi, "F"), (e.length === 3 || e.length === 4) && (e = e.split("").map((n) => n + n).join("")), e.length !== 6 && (e = Eh(Eh(e, 6), 8, "F")), e;
}
function Ix(e) {
  const n = Math.abs(Dh(ya(0), ya(e)));
  return Math.abs(Dh(ya(16777215), ya(e))) > Math.min(n, 50) ? "#fff" : "#000";
}
function Dt(e, n) {
  const r = $i();
  if (!r)
    throw new Error(`[Vuetify] ${e} must be called from inside a setup function`);
  return r;
}
function br() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "composables";
  const n = Dt(e).type;
  return Jr(n?.aliasName || n?.name);
}
let wm = 0, Do = /* @__PURE__ */ new WeakMap();
function Qn() {
  const e = Dt("getUid");
  if (Do.has(e)) return Do.get(e);
  {
    const n = wm++;
    return Do.set(e, n), n;
  }
}
Qn.reset = () => {
  wm = 0, Do = /* @__PURE__ */ new WeakMap();
};
function Lx(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Dt("injectSelf");
  const {
    provides: r
  } = n;
  if (r && e in r)
    return r[e];
}
const Ko = Symbol.for("vuetify:defaults");
function Ku() {
  const e = Ze(Ko);
  if (!e) throw new Error("[Vuetify] Could not find defaults instance");
  return e;
}
function ss(e, n) {
  const r = Ku(), a = oe(e), o = A(() => {
    if (q(n?.disabled)) return r.value;
    const l = q(n?.scoped), c = q(n?.reset), f = q(n?.root);
    if (a.value == null && !(l || c || f)) return r.value;
    let h = vr(a.value, {
      prev: r.value
    });
    if (l) return h;
    if (c || f) {
      const v = Number(c || 1 / 0);
      for (let m = 0; m <= v && !(!h || !("prev" in h)); m++)
        h = h.prev;
      return h && typeof f == "string" && f in h && (h = vr(vr(h, {
        prev: h
      }), h[f])), h;
    }
    return h.prev ? vr(h.prev, h) : h;
  });
  return Et(Ko, o), o;
}
function Ox(e, n) {
  return typeof e.props?.[n] < "u" || typeof e.props?.[Jr(n)] < "u";
}
function Px() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ku();
  const a = Dt("useDefaults");
  if (n = n ?? a.type.name ?? a.type.__name, !n)
    throw new Error("[Vuetify] Could not determine component name");
  const o = A(() => r.value?.[e._as ?? n]), s = new Proxy(e, {
    get(f, h) {
      const v = Reflect.get(f, h);
      return h === "class" || h === "style" ? [o.value?.[h], v].filter((m) => m != null) : typeof h == "string" && !Ox(a.vnode, h) ? o.value?.[h] !== void 0 ? o.value?.[h] : r.value?.global?.[h] !== void 0 ? r.value?.global?.[h] : v : v;
    }
  }), l = Ue();
  Mr(() => {
    if (o.value) {
      const f = Object.entries(o.value).filter((h) => {
        let [v] = h;
        return v.startsWith(v[0].toUpperCase());
      });
      l.value = f.length ? Object.fromEntries(f) : void 0;
    } else
      l.value = void 0;
  });
  function c() {
    const f = Lx(Ko, a);
    Et(Ko, A(() => l.value ? vr(f?.value ?? {}, l.value) : f?.value));
  }
  return {
    props: s,
    provideSubDefaults: c
  };
}
function Oa(e) {
  if (e._setup = e._setup ?? e.setup, !e.name)
    return Qr("The component is missing an explicit name, unable to generate default prop value"), e;
  if (e._setup) {
    e.props = he(e.props ?? {}, e.name)();
    const n = Object.keys(e.props).filter((r) => r !== "class" && r !== "style");
    e.filterProps = function(a) {
      return fm(a, n);
    }, e.props._as = String, e.setup = function(a, o) {
      const s = Ku();
      if (!s.value) return e._setup(a, o);
      const {
        props: l,
        provideSubDefaults: c
      } = Px(a, a._as ?? e.name, s), f = e._setup(l, o);
      return c(), f;
    };
  }
  return e;
}
function He() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  return (n) => (e ? Oa : Qe)(n);
}
function Nx(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "div", r = arguments.length > 2 ? arguments[2] : void 0;
  return He()({
    name: r ?? Ov(Pv(e.replace(/__/g, "-"))),
    props: {
      tag: {
        type: String,
        default: n
      },
      ...ct()
    },
    setup(a, o) {
      let {
        slots: s
      } = o;
      return () => Rn(a.tag, {
        class: [e, a.class],
        style: a.style
      }, s.default?.());
    }
  });
}
function Cm(e) {
  if (typeof e.getRootNode != "function") {
    for (; e.parentNode; ) e = e.parentNode;
    return e !== document ? null : document;
  }
  const n = e.getRootNode();
  return n !== document && n.getRootNode({
    composed: !0
  }) !== document ? null : n;
}
const jo = "cubic-bezier(0.4, 0, 0.2, 1)", Rx = "cubic-bezier(0.0, 0, 0.2, 1)", Fx = "cubic-bezier(0.4, 0, 1, 1)";
function Sm(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  for (; e; ) {
    if (n ? Mx(e) : ju(e)) return e;
    e = e.parentElement;
  }
  return document.scrollingElement;
}
function Yo(e, n) {
  const r = [];
  if (n && e && !n.contains(e)) return r;
  for (; e && (ju(e) && r.push(e), e !== n); )
    e = e.parentElement;
  return r;
}
function ju(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE) return !1;
  const n = window.getComputedStyle(e);
  return n.overflowY === "scroll" || n.overflowY === "auto" && e.scrollHeight > e.clientHeight;
}
function Mx(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE) return !1;
  const n = window.getComputedStyle(e);
  return ["scroll", "auto"].includes(n.overflowY);
}
function Dx(e) {
  for (; e; ) {
    if (window.getComputedStyle(e).position === "fixed")
      return !0;
    e = e.offsetParent;
  }
  return !1;
}
function tt(e) {
  const n = Dt("useRender");
  n.render = e;
}
function Xo(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "content";
  const r = hu(), a = oe();
  if (Pt) {
    const o = new ResizeObserver((s) => {
      s.length && (n === "content" ? a.value = s[0].contentRect : a.value = s[0].target.getBoundingClientRect());
    });
    _r(() => {
      o.disconnect();
    }), Re(() => r.el, (s, l) => {
      l && (o.unobserve(l), a.value = void 0), s && o.observe(s);
    }, {
      flush: "post"
    });
  }
  return {
    resizeRef: r,
    contentRect: Nu(a)
  };
}
function ri(e, n) {
  let r;
  function a() {
    r = Ru(), r.run(() => n.length ? n(() => {
      r?.stop(), a();
    }) : n());
  }
  Re(e, (o) => {
    o && !r ? a() : o || (r?.stop(), r = void 0);
  }, {
    immediate: !0
  }), Zt(() => {
    r?.stop();
  });
}
function Ot(e, n, r) {
  let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (m) => m, o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (m) => m;
  const s = Dt("useProxiedModel"), l = oe(e[n] !== void 0 ? e[n] : r), c = Jr(n), h = c !== n ? A(() => (e[n], !!((s.vnode.props?.hasOwnProperty(n) || s.vnode.props?.hasOwnProperty(c)) && (s.vnode.props?.hasOwnProperty(`onUpdate:${n}`) || s.vnode.props?.hasOwnProperty(`onUpdate:${c}`))))) : A(() => (e[n], !!(s.vnode.props?.hasOwnProperty(n) && s.vnode.props?.hasOwnProperty(`onUpdate:${n}`))));
  ri(() => !h.value, () => {
    Re(() => e[n], (m) => {
      l.value = m;
    });
  });
  const v = A({
    get() {
      const m = e[n];
      return a(h.value ? m : l.value);
    },
    set(m) {
      const p = o(m), y = bn(h.value ? e[n] : l.value);
      y === p || a(y) === m || (l.value = p, s?.emit(`update:${n}`, p));
    }
  });
  return Object.defineProperty(v, "externalValue", {
    get: () => h.value ? e[n] : l.value
  }), v;
}
const Em = Symbol.for("vuetify:locale");
function ls() {
  const e = Ze(Em);
  if (!e) throw new Error("[Vuetify] Could not find injected locale instance");
  return e;
}
function si() {
  const e = Ze(Em);
  if (!e) throw new Error("[Vuetify] Could not find injected rtl instance");
  return {
    isRtl: e.isRtl,
    rtlClasses: e.rtlClasses
  };
}
const Vh = Symbol.for("vuetify:theme"), un = he({
  theme: String
}, "theme");
function Dn(e) {
  Dt("provideTheme");
  const n = Ze(Vh, null);
  if (!n) throw new Error("Could not find Vuetify theme injection");
  const r = A(() => e.theme ?? n.name.value), a = A(() => n.themes.value[r.value]), o = A(() => n.isDisabled ? void 0 : `v-theme--${r.value}`), s = {
    ...n,
    name: r,
    current: a,
    themeClasses: o
  };
  return Et(Vh, s), s;
}
const qn = he({
  tag: {
    type: String,
    default: "div"
  }
}, "tag"), $x = he({
  disabled: Boolean,
  group: Boolean,
  hideOnLeave: Boolean,
  leaveAbsolute: Boolean,
  mode: String,
  origin: String
}, "transition");
function wn(e, n, r) {
  return He()({
    name: e,
    props: $x({
      mode: r,
      origin: n
    }),
    setup(a, o) {
      let {
        slots: s
      } = o;
      const l = {
        onBeforeEnter(c) {
          a.origin && (c.style.transformOrigin = a.origin);
        },
        onLeave(c) {
          if (a.leaveAbsolute) {
            const {
              offsetTop: f,
              offsetLeft: h,
              offsetWidth: v,
              offsetHeight: m
            } = c;
            c._transitionInitialStyles = {
              position: c.style.position,
              top: c.style.top,
              left: c.style.left,
              width: c.style.width,
              height: c.style.height
            }, c.style.position = "absolute", c.style.top = `${f}px`, c.style.left = `${h}px`, c.style.width = `${v}px`, c.style.height = `${m}px`;
          }
          a.hideOnLeave && c.style.setProperty("display", "none", "important");
        },
        onAfterLeave(c) {
          if (a.leaveAbsolute && c?._transitionInitialStyles) {
            const {
              position: f,
              top: h,
              left: v,
              width: m,
              height: p
            } = c._transitionInitialStyles;
            delete c._transitionInitialStyles, c.style.position = f || "", c.style.top = h || "", c.style.left = v || "", c.style.width = m || "", c.style.height = p || "";
          }
        }
      };
      return () => {
        const c = a.group ? Fu : ti;
        return Rn(c, {
          name: a.disabled ? "" : e,
          css: !a.disabled,
          ...a.group ? void 0 : {
            mode: a.mode
          },
          ...a.disabled ? {} : l
        }, s.default);
      };
    }
  });
}
function xm(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "in-out";
  return He()({
    name: e,
    props: {
      mode: {
        type: String,
        default: r
      },
      disabled: Boolean,
      group: Boolean
    },
    setup(a, o) {
      let {
        slots: s
      } = o;
      const l = a.group ? Fu : ti;
      return () => Rn(l, {
        name: a.disabled ? "" : e,
        css: !a.disabled,
        // mode: props.mode, // TODO: vuejs/vue-next#3104
        ...a.disabled ? {} : n
      }, s.default);
    }
  });
}
function Am() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  const r = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1) ? "width" : "height", a = Pv(`offset-${r}`);
  return {
    onBeforeEnter(l) {
      l._parent = l.parentNode, l._initialStyle = {
        transition: l.style.transition,
        overflow: l.style.overflow,
        [r]: l.style[r]
      };
    },
    onEnter(l) {
      const c = l._initialStyle;
      l.style.setProperty("transition", "none", "important"), l.style.overflow = "hidden";
      const f = `${l[a]}px`;
      l.style[r] = "0", l.offsetHeight, l.style.transition = c.transition, e && l._parent && l._parent.classList.add(e), requestAnimationFrame(() => {
        l.style[r] = f;
      });
    },
    onAfterEnter: s,
    onEnterCancelled: s,
    onLeave(l) {
      l._initialStyle = {
        transition: "",
        overflow: l.style.overflow,
        [r]: l.style[r]
      }, l.style.overflow = "hidden", l.style[r] = `${l[a]}px`, l.offsetHeight, requestAnimationFrame(() => l.style[r] = "0");
    },
    onAfterLeave: o,
    onLeaveCancelled: o
  };
  function o(l) {
    e && l._parent && l._parent.classList.remove(e), s(l);
  }
  function s(l) {
    const c = l._initialStyle[r];
    l.style.overflow = l._initialStyle.overflow, c != null && (l.style[r] = c), delete l._initialStyle;
  }
}
const Bx = he({
  target: [Object, Array]
}, "v-dialog-transition"), Yu = He()({
  name: "VDialogTransition",
  props: Bx(),
  setup(e, n) {
    let {
      slots: r
    } = n;
    const a = {
      onBeforeEnter(o) {
        o.style.pointerEvents = "none", o.style.visibility = "hidden";
      },
      async onEnter(o, s) {
        await new Promise((p) => requestAnimationFrame(p)), await new Promise((p) => requestAnimationFrame(p)), o.style.visibility = "";
        const {
          x: l,
          y: c,
          sx: f,
          sy: h,
          speed: v
        } = Wh(e.target, o), m = Li(o, [{
          transform: `translate(${l}px, ${c}px) scale(${f}, ${h})`,
          opacity: 0
        }, {}], {
          duration: 225 * v,
          easing: Rx
        });
        Uh(o)?.forEach((p) => {
          Li(p, [{
            opacity: 0
          }, {
            opacity: 0,
            offset: 0.33
          }, {}], {
            duration: 225 * 2 * v,
            easing: jo
          });
        }), m.finished.then(() => s());
      },
      onAfterEnter(o) {
        o.style.removeProperty("pointer-events");
      },
      onBeforeLeave(o) {
        o.style.pointerEvents = "none";
      },
      async onLeave(o, s) {
        await new Promise((p) => requestAnimationFrame(p));
        const {
          x: l,
          y: c,
          sx: f,
          sy: h,
          speed: v
        } = Wh(e.target, o);
        Li(o, [{}, {
          transform: `translate(${l}px, ${c}px) scale(${f}, ${h})`,
          opacity: 0
        }], {
          duration: 125 * v,
          easing: Fx
        }).finished.then(() => s()), Uh(o)?.forEach((p) => {
          Li(p, [{}, {
            opacity: 0,
            offset: 0.2
          }, {
            opacity: 0
          }], {
            duration: 125 * 2 * v,
            easing: jo
          });
        });
      },
      onAfterLeave(o) {
        o.style.removeProperty("pointer-events");
      }
    };
    return () => e.target ? T(ti, Te({
      name: "dialog-transition"
    }, a, {
      css: !1
    }), r) : T(ti, {
      name: "dialog-transition"
    }, r);
  }
});
function Uh(e) {
  const n = e.querySelector(":scope > .v-card, :scope > .v-sheet, :scope > .v-list")?.children;
  return n && [...n];
}
function Wh(e, n) {
  const r = ym(e), a = qu(n), [o, s] = getComputedStyle(n).transformOrigin.split(" ").map((R) => parseFloat(R)), [l, c] = getComputedStyle(n).getPropertyValue("--v-overlay-anchor-origin").split(" ");
  let f = r.left + r.width / 2;
  l === "left" || c === "left" ? f -= r.width / 2 : (l === "right" || c === "right") && (f += r.width / 2);
  let h = r.top + r.height / 2;
  l === "top" || c === "top" ? h -= r.height / 2 : (l === "bottom" || c === "bottom") && (h += r.height / 2);
  const v = r.width / a.width, m = r.height / a.height, p = Math.max(1, v, m), y = v / p || 0, b = m / p || 0, C = a.width * a.height / (window.innerWidth * window.innerHeight), S = C > 0.12 ? Math.min(1.5, (C - 0.12) * 10 + 1) : 1;
  return {
    x: f - (o + a.left),
    y: h - (s + a.top),
    sx: y,
    sy: b,
    speed: S
  };
}
wn("fab-transition", "center center", "out-in");
wn("dialog-bottom-transition");
wn("dialog-top-transition");
const Hh = wn("fade-transition");
wn("scale-transition");
wn("scroll-x-transition");
wn("scroll-x-reverse-transition");
wn("scroll-y-transition");
wn("scroll-y-reverse-transition");
wn("slide-x-transition");
wn("slide-x-reverse-transition");
const km = wn("slide-y-transition");
wn("slide-y-reverse-transition");
const Vx = xm("expand-transition", Am()), Tm = xm("expand-x-transition", Am("", !0)), Ux = he({
  defaults: Object,
  disabled: Boolean,
  reset: [Number, String],
  root: [Boolean, String],
  scoped: Boolean
}, "VDefaultsProvider"), Fn = He(!1)({
  name: "VDefaultsProvider",
  props: Ux(),
  setup(e, n) {
    let {
      slots: r
    } = n;
    const {
      defaults: a,
      disabled: o,
      reset: s,
      root: l,
      scoped: c
    } = ht(e);
    return ss(a, {
      reset: s,
      root: l,
      scoped: c,
      disabled: o
    }), () => r.default?.();
  }
}), li = he({
  height: [Number, String],
  maxHeight: [Number, String],
  maxWidth: [Number, String],
  minHeight: [Number, String],
  minWidth: [Number, String],
  width: [Number, String]
}, "dimension");
function ui(e) {
  return {
    dimensionStyles: A(() => {
      const r = {}, a = Ge(e.height), o = Ge(e.maxHeight), s = Ge(e.maxWidth), l = Ge(e.minHeight), c = Ge(e.minWidth), f = Ge(e.width);
      return a != null && (r.height = a), o != null && (r.maxHeight = o), s != null && (r.maxWidth = s), l != null && (r.minHeight = l), c != null && (r.minWidth = c), f != null && (r.width = f), r;
    })
  };
}
function Wx(e) {
  return {
    aspectStyles: A(() => {
      const n = Number(e.aspectRatio);
      return n ? {
        paddingBottom: String(1 / n * 100) + "%"
      } : void 0;
    })
  };
}
const Im = he({
  aspectRatio: [String, Number],
  contentClass: null,
  inline: Boolean,
  ...ct(),
  ...li()
}, "VResponsive"), Gh = He()({
  name: "VResponsive",
  props: Im(),
  setup(e, n) {
    let {
      slots: r
    } = n;
    const {
      aspectStyles: a
    } = Wx(e), {
      dimensionStyles: o
    } = ui(e);
    return tt(() => T("div", {
      class: ["v-responsive", {
        "v-responsive--inline": e.inline
      }, e.class],
      style: [o.value, e.style]
    }, [T("div", {
      class: "v-responsive__sizer",
      style: a.value
    }, null), r.additional?.(), r.default && T("div", {
      class: ["v-responsive__content", e.contentClass]
    }, [r.default()])])), {};
  }
});
function Xu(e) {
  return zu(() => {
    const n = [], r = {};
    if (e.value.background)
      if (mu(e.value.background)) {
        if (r.backgroundColor = e.value.background, !e.value.text && xx(e.value.background)) {
          const a = ya(e.value.background);
          if (a.a == null || a.a === 1) {
            const o = Ix(a);
            r.color = o, r.caretColor = o;
          }
        }
      } else
        n.push(`bg-${e.value.background}`);
    return e.value.text && (mu(e.value.text) ? (r.color = e.value.text, r.caretColor = e.value.text) : n.push(`text-${e.value.text}`)), {
      colorClasses: n,
      colorStyles: r
    };
  });
}
function ci(e, n) {
  const r = A(() => ({
    text: Pi(e) ? e.value : n ? e[n] : null
  })), {
    colorClasses: a,
    colorStyles: o
  } = Xu(r);
  return {
    textColorClasses: a,
    textColorStyles: o
  };
}
function pr(e, n) {
  const r = A(() => ({
    background: Pi(e) ? e.value : n ? e[n] : null
  })), {
    colorClasses: a,
    colorStyles: o
  } = Xu(r);
  return {
    backgroundColorClasses: a,
    backgroundColorStyles: o
  };
}
const fi = he({
  rounded: {
    type: [Boolean, Number, String],
    default: void 0
  },
  tile: Boolean
}, "rounded");
function di(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : br();
  return {
    roundedClasses: A(() => {
      const a = Pi(e) ? e.value : e.rounded, o = Pi(e) ? e.value : e.tile, s = [];
      if (a === !0 || a === "")
        s.push(`${n}--rounded`);
      else if (typeof a == "string" || a === 0)
        for (const l of String(a).split(" "))
          s.push(`rounded-${l}`);
      else (o || a === !1) && s.push("rounded-0");
      return s;
    })
  };
}
const Pa = he({
  transition: {
    type: [Boolean, String, Object],
    default: "fade-transition",
    validator: (e) => e !== !0
  }
}, "transition"), Nr = (e, n) => {
  let {
    slots: r
  } = n;
  const {
    transition: a,
    disabled: o,
    group: s,
    ...l
  } = e, {
    component: c = s ? Fu : ti,
    ...f
  } = typeof a == "object" ? a : {};
  return Rn(c, Te(typeof a == "string" ? {
    name: o ? "" : a
  } : f, typeof a == "string" ? {} : Object.fromEntries(Object.entries({
    disabled: o,
    group: s
  }).filter((h) => {
    let [v, m] = h;
    return m !== void 0;
  })), l), r);
};
function Hx(e, n) {
  if (!Hu) return;
  const r = n.modifiers || {}, a = n.value, {
    handler: o,
    options: s
  } = typeof a == "object" ? a : {
    handler: a,
    options: {}
  }, l = new IntersectionObserver(function() {
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], f = arguments.length > 1 ? arguments[1] : void 0;
    const h = e._observe?.[n.instance.$.uid];
    if (!h) return;
    const v = c.some((m) => m.isIntersecting);
    o && (!r.quiet || h.init) && (!r.once || v || h.init) && o(v, c, f), v && r.once ? Lm(e, n) : h.init = !0;
  }, s);
  e._observe = Object(e._observe), e._observe[n.instance.$.uid] = {
    init: !1,
    observer: l
  }, l.observe(e);
}
function Lm(e, n) {
  const r = e._observe?.[n.instance.$.uid];
  r && (r.observer.unobserve(e), delete e._observe[n.instance.$.uid]);
}
const Om = {
  mounted: Hx,
  unmounted: Lm
}, Gx = he({
  alt: String,
  cover: Boolean,
  color: String,
  draggable: {
    type: [Boolean, String],
    default: void 0
  },
  eager: Boolean,
  gradient: String,
  lazySrc: String,
  options: {
    type: Object,
    // For more information on types, navigate to:
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    default: () => ({
      root: void 0,
      rootMargin: void 0,
      threshold: void 0
    })
  },
  sizes: String,
  src: {
    type: [String, Object],
    default: ""
  },
  crossorigin: String,
  referrerpolicy: String,
  srcset: String,
  position: String,
  ...Im(),
  ...ct(),
  ...fi(),
  ...Pa()
}, "VImg"), zx = He()({
  name: "VImg",
  directives: {
    intersect: Om
  },
  props: Gx(),
  emits: {
    loadstart: (e) => !0,
    load: (e) => !0,
    error: (e) => !0
  },
  setup(e, n) {
    let {
      emit: r,
      slots: a
    } = n;
    const {
      backgroundColorClasses: o,
      backgroundColorStyles: s
    } = pr(Me(e, "color")), {
      roundedClasses: l
    } = di(e), c = Dt("VImg"), f = Ue(""), h = oe(), v = Ue(e.eager ? "loading" : "idle"), m = Ue(), p = Ue(), y = A(() => e.src && typeof e.src == "object" ? {
      src: e.src.src,
      srcset: e.srcset || e.src.srcset,
      lazySrc: e.lazySrc || e.src.lazySrc,
      aspect: Number(e.aspectRatio || e.src.aspect || 0)
    } : {
      src: e.src,
      srcset: e.srcset,
      lazySrc: e.lazySrc,
      aspect: Number(e.aspectRatio || 0)
    }), b = A(() => y.value.aspect || m.value / p.value || 0);
    Re(() => e.src, () => {
      C(v.value !== "idle");
    }), Re(b, (K, ae) => {
      !K && ae && h.value && L(h.value);
    }), Pu(() => C());
    function C(K) {
      if (!(e.eager && K) && !(Hu && !K && !e.eager)) {
        if (v.value = "loading", y.value.lazySrc) {
          const ae = new Image();
          ae.src = y.value.lazySrc, L(ae, null);
        }
        y.value.src && Jt(() => {
          r("loadstart", h.value?.currentSrc || y.value.src), setTimeout(() => {
            if (!c.isUnmounted)
              if (h.value?.complete) {
                if (h.value.naturalWidth || R(), v.value === "error") return;
                b.value || L(h.value, null), v.value === "loading" && S();
              } else
                b.value || L(h.value), $();
          });
        });
      }
    }
    function S() {
      c.isUnmounted || ($(), L(h.value), v.value = "loaded", r("load", h.value?.currentSrc || y.value.src));
    }
    function R() {
      c.isUnmounted || (v.value = "error", r("error", h.value?.currentSrc || y.value.src));
    }
    function $() {
      const K = h.value;
      K && (f.value = K.currentSrc || K.src);
    }
    let k = -1;
    _r(() => {
      clearTimeout(k);
    });
    function L(K) {
      let ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      const ue = () => {
        if (clearTimeout(k), c.isUnmounted) return;
        const {
          naturalHeight: Ce,
          naturalWidth: Se
        } = K;
        Ce || Se ? (m.value = Se, p.value = Ce) : !K.complete && v.value === "loading" && ae != null ? k = window.setTimeout(ue, ae) : (K.currentSrc.endsWith(".svg") || K.currentSrc.startsWith("data:image/svg+xml")) && (m.value = 1, p.value = 1);
      };
      ue();
    }
    const F = A(() => ({
      "v-img__img--cover": e.cover,
      "v-img__img--contain": !e.cover
    })), P = () => {
      if (!y.value.src || v.value === "idle") return null;
      const K = T("img", {
        class: ["v-img__img", F.value],
        style: {
          objectPosition: e.position
        },
        src: y.value.src,
        srcset: y.value.srcset,
        alt: e.alt,
        crossorigin: e.crossorigin,
        referrerpolicy: e.referrerpolicy,
        draggable: e.draggable,
        sizes: e.sizes,
        ref: h,
        onLoad: S,
        onError: R
      }, null), ae = a.sources?.();
      return T(Nr, {
        transition: e.transition,
        appear: !0
      }, {
        default: () => [Gn(ae ? T("picture", {
          class: "v-img__picture"
        }, [ae, K]) : K, [[Vi, v.value === "loaded"]])]
      });
    }, E = () => T(Nr, {
      transition: e.transition
    }, {
      default: () => [y.value.lazySrc && v.value !== "loaded" && T("img", {
        class: ["v-img__img", "v-img__img--preload", F.value],
        style: {
          objectPosition: e.position
        },
        src: y.value.lazySrc,
        alt: e.alt,
        crossorigin: e.crossorigin,
        referrerpolicy: e.referrerpolicy,
        draggable: e.draggable
      }, null)]
    }), V = () => a.placeholder ? T(Nr, {
      transition: e.transition,
      appear: !0
    }, {
      default: () => [(v.value === "loading" || v.value === "error" && !a.error) && T("div", {
        class: "v-img__placeholder"
      }, [a.placeholder()])]
    }) : null, W = () => a.error ? T(Nr, {
      transition: e.transition,
      appear: !0
    }, {
      default: () => [v.value === "error" && T("div", {
        class: "v-img__error"
      }, [a.error()])]
    }) : null, me = () => e.gradient ? T("div", {
      class: "v-img__gradient",
      style: {
        backgroundImage: `linear-gradient(${e.gradient})`
      }
    }, null) : null, le = Ue(!1);
    {
      const K = Re(b, (ae) => {
        ae && (requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            le.value = !0;
          });
        }), K());
      });
    }
    return tt(() => {
      const K = Gh.filterProps(e);
      return Gn(T(Gh, Te({
        class: ["v-img", {
          "v-img--booting": !le.value
        }, o.value, l.value, e.class],
        style: [{
          width: Ge(e.width === "auto" ? m.value : e.width)
        }, s.value, e.style]
      }, K, {
        aspectRatio: b.value,
        "aria-label": e.alt,
        role: e.alt ? "img" : void 0
      }), {
        additional: () => T(Ie, null, [T(P, null, null), T(E, null, null), T(me, null, null), T(V, null, null), T(W, null, null)]),
        default: a.default
      }), [[Bi("intersect"), {
        handler: C,
        options: e.options
      }, null, {
        once: !0
      }]]);
    }), {
      currentSrc: f,
      image: h,
      state: v,
      naturalWidth: m,
      naturalHeight: p
    };
  }
}), Ju = he({
  border: [Boolean, Number, String]
}, "border");
function Zu(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : br();
  return {
    borderClasses: A(() => {
      const a = Pi(e) ? e.value : e.border, o = [];
      if (a === !0 || a === "")
        o.push(`${n}--border`);
      else if (typeof a == "string" || a === 0)
        for (const s of String(a).split(" "))
          o.push(`border-${s}`);
      return o;
    })
  };
}
const us = he({
  elevation: {
    type: [Number, String],
    validator(e) {
      const n = parseInt(e);
      return !isNaN(n) && n >= 0 && // Material Design has a maximum elevation of 24
      // https://material.io/design/environment/elevation.html#default-elevations
      n <= 24;
    }
  }
}, "elevation");
function cs(e) {
  return {
    elevationClasses: A(() => {
      const r = Pi(e) ? e.value : e.elevation, a = [];
      return r == null || a.push(`elevation-${r}`), a;
    })
  };
}
function qx() {
  const e = Ue(!1);
  return qt(() => {
    window.requestAnimationFrame(() => {
      e.value = !0;
    });
  }), {
    ssrBootStyles: A(() => e.value ? void 0 : {
      transition: "none !important"
    }),
    isBooted: Nu(e)
  };
}
const Kx = [null, "default", "comfortable", "compact"], zi = he({
  density: {
    type: String,
    default: "default",
    validator: (e) => Kx.includes(e)
  }
}, "density");
function qi(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : br();
  return {
    densityClasses: A(() => `${n}--density-${e.density}`)
  };
}
const jx = ["elevated", "flat", "tonal", "outlined", "text", "plain"];
function Qu(e, n) {
  return T(Ie, null, [e && T("span", {
    key: "overlay",
    class: `${n}__overlay`
  }, null), T("span", {
    key: "underlay",
    class: `${n}__underlay`
  }, null)]);
}
const Na = he({
  color: String,
  variant: {
    type: String,
    default: "elevated",
    validator: (e) => jx.includes(e)
  }
}, "variant");
function ec(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : br();
  const r = A(() => {
    const {
      variant: s
    } = q(e);
    return `${n}--variant-${s}`;
  }), {
    colorClasses: a,
    colorStyles: o
  } = Xu(A(() => {
    const {
      variant: s,
      color: l
    } = q(e);
    return {
      [["elevated", "flat"].includes(s) ? "background" : "text"]: l
    };
  }));
  return {
    colorClasses: a,
    colorStyles: o,
    variantClasses: r
  };
}
const Pm = he({
  modelValue: {
    type: null,
    default: void 0
  },
  multiple: Boolean,
  mandatory: [Boolean, String],
  max: Number,
  selectedClass: String,
  disabled: Boolean
}, "group"), Yx = he({
  value: null,
  disabled: Boolean,
  selectedClass: String
}, "group-item");
function Xx(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  const a = Dt("useGroupItem");
  if (!a)
    throw new Error("[Vuetify] useGroupItem composable must be used inside a component setup function");
  const o = Qn();
  Et(Symbol.for(`${n.description}:id`), o);
  const s = Ze(n, null);
  if (!s) {
    if (!r) return s;
    throw new Error(`[Vuetify] Could not find useGroup injection with symbol ${n.description}`);
  }
  const l = Me(e, "value"), c = A(() => !!(s.disabled.value || e.disabled));
  s.register({
    id: o,
    value: l,
    disabled: c
  }, a), _r(() => {
    s.unregister(o);
  });
  const f = A(() => s.isSelected(o)), h = A(() => s.items.value[0].id === o), v = A(() => s.items.value[s.items.value.length - 1].id === o), m = A(() => f.value && [s.selectedClass.value, e.selectedClass]);
  return Re(f, (p) => {
    a.emit("group:selected", {
      value: p
    });
  }, {
    flush: "sync"
  }), {
    id: o,
    isSelected: f,
    isFirst: h,
    isLast: v,
    toggle: () => s.select(o, !f.value),
    select: (p) => s.select(o, p),
    selectedClass: m,
    value: l,
    disabled: c,
    group: s
  };
}
function Nm(e, n) {
  let r = !1;
  const a = mr([]), o = Ot(e, "modelValue", [], (p) => p == null ? [] : Rm(a, Mn(p)), (p) => {
    const y = Zx(a, p);
    return e.multiple ? y : y[0];
  }), s = Dt("useGroup");
  function l(p, y) {
    const b = p, C = Symbol.for(`${n.description}:id`), R = _a(C, s?.vnode).indexOf(y);
    q(b.value) == null && (b.value = R, b.useIndexAsValue = !0), R > -1 ? a.splice(R, 0, b) : a.push(b);
  }
  function c(p) {
    if (r) return;
    f();
    const y = a.findIndex((b) => b.id === p);
    a.splice(y, 1);
  }
  function f() {
    const p = a.find((y) => !y.disabled);
    p && e.mandatory === "force" && !o.value.length && (o.value = [p.id]);
  }
  qt(() => {
    f();
  }), _r(() => {
    r = !0;
  }), $C(() => {
    for (let p = 0; p < a.length; p++)
      a[p].useIndexAsValue && (a[p].value = p);
  });
  function h(p, y) {
    const b = a.find((C) => C.id === p);
    if (!(y && b?.disabled))
      if (e.multiple) {
        const C = o.value.slice(), S = C.findIndex(($) => $ === p), R = ~S;
        if (y = y ?? !R, R && e.mandatory && C.length <= 1 || !R && e.max != null && C.length + 1 > e.max) return;
        S < 0 && y ? C.push(p) : S >= 0 && !y && C.splice(S, 1), o.value = C;
      } else {
        const C = o.value.includes(p);
        if (e.mandatory && C) return;
        o.value = y ?? !C ? [p] : [];
      }
  }
  function v(p) {
    if (e.multiple && Qr('This method is not supported when using "multiple" prop'), o.value.length) {
      const y = o.value[0], b = a.findIndex((R) => R.id === y);
      let C = (b + p) % a.length, S = a[C];
      for (; S.disabled && C !== b; )
        C = (C + p) % a.length, S = a[C];
      if (S.disabled) return;
      o.value = [a[C].id];
    } else {
      const y = a.find((b) => !b.disabled);
      y && (o.value = [y.id]);
    }
  }
  const m = {
    register: l,
    unregister: c,
    selected: o,
    select: h,
    disabled: Me(e, "disabled"),
    prev: () => v(a.length - 1),
    next: () => v(1),
    isSelected: (p) => o.value.includes(p),
    selectedClass: A(() => e.selectedClass),
    items: A(() => a),
    getItemIndex: (p) => Jx(a, p)
  };
  return Et(n, m), m;
}
function Jx(e, n) {
  const r = Rm(e, [n]);
  return r.length ? e.findIndex((a) => a.id === r[0]) : -1;
}
function Rm(e, n) {
  const r = [];
  return n.forEach((a) => {
    const o = e.find((l) => Gi(a, l.value)), s = e[a];
    o?.value != null ? r.push(o.id) : s != null && r.push(s.id);
  }), r;
}
function Zx(e, n) {
  const r = [];
  return n.forEach((a) => {
    const o = e.findIndex((s) => s.id === a);
    if (~o) {
      const s = e[o];
      r.push(s.value != null ? s.value : o);
    }
  }), r;
}
const _t = [String, Function, Object, Array], Qx = Symbol.for("vuetify:icons"), fs = he({
  icon: {
    type: _t
  },
  // Could not remove this and use makeTagProps, types complained because it is not required
  tag: {
    type: String,
    required: !0
  }
}, "icon"), zh = He()({
  name: "VComponentIcon",
  props: fs(),
  setup(e, n) {
    let {
      slots: r
    } = n;
    return () => {
      const a = e.icon;
      return T(e.tag, null, {
        default: () => [e.icon ? T(a, null, null) : r.default?.()]
      });
    };
  }
}), eA = Oa({
  name: "VSvgIcon",
  inheritAttrs: !1,
  props: fs(),
  setup(e, n) {
    let {
      attrs: r
    } = n;
    return () => T(e.tag, Te(r, {
      style: null
    }), {
      default: () => [T("svg", {
        class: "v-icon__svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        role: "img",
        "aria-hidden": "true"
      }, [Array.isArray(e.icon) ? e.icon.map((a) => Array.isArray(a) ? T("path", {
        d: a[0],
        "fill-opacity": a[1]
      }, null) : T("path", {
        d: a
      }, null)) : T("path", {
        d: e.icon
      }, null)])]
    });
  }
});
Oa({
  name: "VLigatureIcon",
  props: fs(),
  setup(e) {
    return () => T(e.tag, null, {
      default: () => [e.icon]
    });
  }
});
Oa({
  name: "VClassIcon",
  props: fs(),
  setup(e) {
    return () => T(e.tag, {
      class: e.icon
    }, null);
  }
});
const tA = (e) => {
  const n = Ze(Qx);
  if (!n) throw new Error("Missing Vuetify Icons provide!");
  return {
    iconData: A(() => {
      const a = q(e);
      if (!a) return {
        component: zh
      };
      let o = a;
      if (typeof o == "string" && (o = o.trim(), o.startsWith("$") && (o = n.aliases?.[o.slice(1)])), o || Qr(`Could not find aliased icon "${a}"`), Array.isArray(o))
        return {
          component: eA,
          icon: o
        };
      if (typeof o != "string")
        return {
          component: zh,
          icon: o
        };
      const s = Object.keys(n.sets).find((f) => typeof o == "string" && o.startsWith(`${f}:`)), l = s ? o.slice(s.length + 1) : o;
      return {
        component: n.sets[s ?? n.defaultSet].component,
        icon: l
      };
    })
  };
}, nA = ["x-small", "small", "default", "large", "x-large"], tc = he({
  size: {
    type: [String, Number],
    default: "default"
  }
}, "size");
function nc(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : br();
  return zu(() => {
    let r, a;
    return Go(nA, e.size) ? r = `${n}--size-${e.size}` : e.size && (a = {
      width: Ge(e.size),
      height: Ge(e.size)
    }), {
      sizeClasses: r,
      sizeStyles: a
    };
  });
}
const rA = he({
  color: String,
  disabled: Boolean,
  start: Boolean,
  end: Boolean,
  icon: _t,
  ...ct(),
  ...tc(),
  ...qn({
    tag: "i"
  }),
  ...un()
}, "VIcon"), _n = He()({
  name: "VIcon",
  props: rA(),
  setup(e, n) {
    let {
      attrs: r,
      slots: a
    } = n;
    const o = oe(), {
      themeClasses: s
    } = Dn(e), {
      iconData: l
    } = tA(A(() => o.value || e.icon)), {
      sizeClasses: c
    } = nc(e), {
      textColorClasses: f,
      textColorStyles: h
    } = ci(Me(e, "color"));
    return tt(() => {
      const v = a.default?.();
      v && (o.value = vm(v).filter((p) => p.type === Lv && p.children && typeof p.children == "string")[0]?.children);
      const m = !!(r.onClick || r.onClickOnce);
      return T(l.value.component, {
        tag: e.tag,
        icon: l.value.icon,
        class: ["v-icon", "notranslate", s.value, c.value, f.value, {
          "v-icon--clickable": m,
          "v-icon--disabled": e.disabled,
          "v-icon--start": e.start,
          "v-icon--end": e.end
        }, e.class],
        style: [c.value ? void 0 : {
          fontSize: Ge(e.size),
          height: Ge(e.size),
          width: Ge(e.size)
        }, h.value, e.style],
        role: m ? "button" : void 0,
        "aria-hidden": !m,
        tabindex: m ? e.disabled ? -1 : 0 : void 0
      }, {
        default: () => [v]
      });
    }), {};
  }
});
function iA(e, n) {
  const r = oe(), a = Ue(!1);
  if (Hu) {
    const o = new IntersectionObserver((s) => {
      a.value = !!s.find((l) => l.isIntersecting);
    }, n);
    _r(() => {
      o.disconnect();
    }), Re(r, (s, l) => {
      l && (o.unobserve(l), a.value = !1), s && o.observe(s);
    }, {
      flush: "post"
    });
  }
  return {
    intersectionRef: r,
    isIntersecting: a
  };
}
const qh = {
  center: "center",
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, aA = he({
  location: String
}, "location");
function oA(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = arguments.length > 2 ? arguments[2] : void 0;
  const {
    isRtl: a
  } = si();
  return {
    locationStyles: A(() => {
      if (!e.location) return {};
      const {
        side: s,
        align: l
      } = vu(e.location.split(" ").length > 1 ? e.location : `${e.location} center`, a.value);
      function c(h) {
        return r ? r(h) : 0;
      }
      const f = {};
      return s !== "center" && (n ? f[qh[s]] = `calc(100% - ${c(s)}px)` : f[s] = 0), l !== "center" ? n ? f[qh[l]] = `calc(100% - ${c(l)}px)` : f[l] = 0 : (s === "center" ? f.top = f.left = "50%" : f[{
        top: "left",
        bottom: "left",
        left: "top",
        right: "top"
      }[s]] = "50%", f.transform = {
        top: "translateX(-50%)",
        bottom: "translateX(-50%)",
        left: "translateY(-50%)",
        right: "translateY(-50%)",
        center: "translate(-50%, -50%)"
      }[s]), f;
    })
  };
}
const sA = he({
  absolute: Boolean,
  active: {
    type: Boolean,
    default: !0
  },
  bgColor: String,
  bgOpacity: [Number, String],
  bufferValue: {
    type: [Number, String],
    default: 0
  },
  bufferColor: String,
  bufferOpacity: [Number, String],
  clickable: Boolean,
  color: String,
  height: {
    type: [Number, String],
    default: 4
  },
  indeterminate: Boolean,
  max: {
    type: [Number, String],
    default: 100
  },
  modelValue: {
    type: [Number, String],
    default: 0
  },
  opacity: [Number, String],
  reverse: Boolean,
  stream: Boolean,
  striped: Boolean,
  roundedBar: Boolean,
  ...ct(),
  ...aA({
    location: "top"
  }),
  ...fi(),
  ...qn(),
  ...un()
}, "VProgressLinear"), lA = He()({
  name: "VProgressLinear",
  props: sA(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      slots: r
    } = n;
    const a = Ot(e, "modelValue"), {
      isRtl: o,
      rtlClasses: s
    } = si(), {
      themeClasses: l
    } = Dn(e), {
      locationStyles: c
    } = oA(e), {
      textColorClasses: f,
      textColorStyles: h
    } = ci(e, "color"), {
      backgroundColorClasses: v,
      backgroundColorStyles: m
    } = pr(A(() => e.bgColor || e.color)), {
      backgroundColorClasses: p,
      backgroundColorStyles: y
    } = pr(A(() => e.bufferColor || e.bgColor || e.color)), {
      backgroundColorClasses: b,
      backgroundColorStyles: C
    } = pr(e, "color"), {
      roundedClasses: S
    } = di(e), {
      intersectionRef: R,
      isIntersecting: $
    } = iA(), k = A(() => parseFloat(e.max)), L = A(() => parseFloat(e.height)), F = A(() => Fr(parseFloat(e.bufferValue) / k.value * 100, 0, 100)), P = A(() => Fr(parseFloat(a.value) / k.value * 100, 0, 100)), E = A(() => o.value !== e.reverse), V = A(() => e.indeterminate ? "fade-transition" : "slide-x-transition"), W = Pt && window.matchMedia?.("(forced-colors: active)").matches;
    function me(le) {
      if (!R.value) return;
      const {
        left: K,
        right: ae,
        width: ue
      } = R.value.getBoundingClientRect(), Ce = E.value ? ue - le.clientX + (ae - ue) : le.clientX - K;
      a.value = Math.round(Ce / ue * k.value);
    }
    return tt(() => T(e.tag, {
      ref: R,
      class: ["v-progress-linear", {
        "v-progress-linear--absolute": e.absolute,
        "v-progress-linear--active": e.active && $.value,
        "v-progress-linear--reverse": E.value,
        "v-progress-linear--rounded": e.rounded,
        "v-progress-linear--rounded-bar": e.roundedBar,
        "v-progress-linear--striped": e.striped
      }, S.value, l.value, s.value, e.class],
      style: [{
        bottom: e.location === "bottom" ? 0 : void 0,
        top: e.location === "top" ? 0 : void 0,
        height: e.active ? Ge(L.value) : 0,
        "--v-progress-linear-height": Ge(L.value),
        ...e.absolute ? c.value : {}
      }, e.style],
      role: "progressbar",
      "aria-hidden": e.active ? "false" : "true",
      "aria-valuemin": "0",
      "aria-valuemax": e.max,
      "aria-valuenow": e.indeterminate ? void 0 : P.value,
      onClick: e.clickable && me
    }, {
      default: () => [e.stream && T("div", {
        key: "stream",
        class: ["v-progress-linear__stream", f.value],
        style: {
          ...h.value,
          [E.value ? "left" : "right"]: Ge(-L.value),
          borderTop: `${Ge(L.value / 2)} dotted`,
          opacity: parseFloat(e.bufferOpacity),
          top: `calc(50% - ${Ge(L.value / 4)})`,
          width: Ge(100 - F.value, "%"),
          "--v-progress-linear-stream-to": Ge(L.value * (E.value ? 1 : -1))
        }
      }, null), T("div", {
        class: ["v-progress-linear__background", W ? void 0 : v.value],
        style: [m.value, {
          opacity: parseFloat(e.bgOpacity),
          width: e.stream ? 0 : void 0
        }]
      }, null), T("div", {
        class: ["v-progress-linear__buffer", W ? void 0 : p.value],
        style: [y.value, {
          opacity: parseFloat(e.bufferOpacity),
          width: Ge(F.value, "%")
        }]
      }, null), T(ti, {
        name: V.value
      }, {
        default: () => [e.indeterminate ? T("div", {
          class: "v-progress-linear__indeterminate"
        }, [["long", "short"].map((le) => T("div", {
          key: le,
          class: ["v-progress-linear__indeterminate", le, W ? void 0 : b.value],
          style: C.value
        }, null))]) : T("div", {
          class: ["v-progress-linear__determinate", W ? void 0 : b.value],
          style: [C.value, {
            width: Ge(P.value, "%")
          }]
        }, null)]
      }), r.default && T("div", {
        class: "v-progress-linear__content"
      }, [r.default({
        value: P.value,
        buffer: F.value
      })])]
    })), {};
  }
}), uA = he({
  loading: [Boolean, String]
}, "loader");
function cA(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : br();
  return {
    loaderClasses: A(() => ({
      [`${n}--loading`]: e.loading
    }))
  };
}
function fA(e, n) {
  let {
    slots: r
  } = n;
  return T("div", {
    class: `${e.name}__loader`
  }, [r.default?.({
    color: e.color,
    isActive: e.active
  }) || T(lA, {
    absolute: e.absolute,
    active: e.active,
    color: e.color,
    height: "2",
    indeterminate: !0
  }, null)]);
}
function dA() {
  const e = Dt("useRoute");
  return A(() => e?.proxy?.$route);
}
function hA() {
  return Dt("useRouter")?.proxy?.$router;
}
function Fm(e, n) {
  const r = zn("RouterLink"), a = A(() => !!(e.href || e.to)), o = A(() => a?.value || xh(n, "click") || xh(e, "click"));
  if (typeof r == "string" || !("useLink" in r))
    return {
      isLink: a,
      isClickable: o,
      href: Me(e, "href")
    };
  const s = A(() => ({
    ...e,
    to: Me(() => e.to || "")
  })), l = r.useLink(s.value), c = A(() => e.to ? l : void 0), f = dA();
  return {
    isLink: a,
    isClickable: o,
    route: c.value?.route,
    navigate: c.value?.navigate,
    isActive: A(() => c.value ? e.exact ? f.value ? c.value.isExactActive?.value && Gi(c.value.route.value.query, f.value.query) : c.value.isExactActive?.value ?? !1 : c.value.isActive?.value ?? !1 : !1),
    href: A(() => e.to ? c.value?.route.value.href : e.href)
  };
}
const Mm = he({
  href: String,
  replace: Boolean,
  to: [String, Object],
  exact: Boolean
}, "router");
let Wl = !1;
function vA(e, n) {
  let r = !1, a, o;
  Pt && (Jt(() => {
    window.addEventListener("popstate", s), a = e?.beforeEach((l, c, f) => {
      Wl ? r ? n(f) : f() : setTimeout(() => r ? n(f) : f()), Wl = !0;
    }), o = e?.afterEach(() => {
      Wl = !1;
    });
  }), Zt(() => {
    window.removeEventListener("popstate", s), a?.(), o?.();
  }));
  function s(l) {
    l.state?.replaced || (r = !0, setTimeout(() => r = !1));
  }
}
const gu = Symbol("rippleStop"), mA = 80;
function Kh(e, n) {
  e.style.transform = n, e.style.webkitTransform = n;
}
function pu(e) {
  return e.constructor.name === "TouchEvent";
}
function Dm(e) {
  return e.constructor.name === "KeyboardEvent";
}
const gA = function(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = 0, o = 0;
  if (!Dm(e)) {
    const m = n.getBoundingClientRect(), p = pu(e) ? e.touches[e.touches.length - 1] : e;
    a = p.clientX - m.left, o = p.clientY - m.top;
  }
  let s = 0, l = 0.3;
  n._ripple?.circle ? (l = 0.15, s = n.clientWidth / 2, s = r.center ? s : s + Math.sqrt((a - s) ** 2 + (o - s) ** 2) / 4) : s = Math.sqrt(n.clientWidth ** 2 + n.clientHeight ** 2) / 2;
  const c = `${(n.clientWidth - s * 2) / 2}px`, f = `${(n.clientHeight - s * 2) / 2}px`, h = r.center ? c : `${a - s}px`, v = r.center ? f : `${o - s}px`;
  return {
    radius: s,
    scale: l,
    x: h,
    y: v,
    centerX: c,
    centerY: f
  };
}, Jo = {
  /* eslint-disable max-statements */
  show(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!n?._ripple?.enabled)
      return;
    const a = document.createElement("span"), o = document.createElement("span");
    a.appendChild(o), a.className = "v-ripple__container", r.class && (a.className += ` ${r.class}`);
    const {
      radius: s,
      scale: l,
      x: c,
      y: f,
      centerX: h,
      centerY: v
    } = gA(e, n, r), m = `${s * 2}px`;
    o.className = "v-ripple__animation", o.style.width = m, o.style.height = m, n.appendChild(a);
    const p = window.getComputedStyle(n);
    p && p.position === "static" && (n.style.position = "relative", n.dataset.previousPosition = "static"), o.classList.add("v-ripple__animation--enter"), o.classList.add("v-ripple__animation--visible"), Kh(o, `translate(${c}, ${f}) scale3d(${l},${l},${l})`), o.dataset.activated = String(performance.now()), setTimeout(() => {
      o.classList.remove("v-ripple__animation--enter"), o.classList.add("v-ripple__animation--in"), Kh(o, `translate(${h}, ${v}) scale3d(1,1,1)`);
    }, 0);
  },
  hide(e) {
    if (!e?._ripple?.enabled) return;
    const n = e.getElementsByClassName("v-ripple__animation");
    if (n.length === 0) return;
    const r = n[n.length - 1];
    if (r.dataset.isHiding) return;
    r.dataset.isHiding = "true";
    const a = performance.now() - Number(r.dataset.activated), o = Math.max(250 - a, 0);
    setTimeout(() => {
      r.classList.remove("v-ripple__animation--in"), r.classList.add("v-ripple__animation--out"), setTimeout(() => {
        e.getElementsByClassName("v-ripple__animation").length === 1 && e.dataset.previousPosition && (e.style.position = e.dataset.previousPosition, delete e.dataset.previousPosition), r.parentNode?.parentNode === e && e.removeChild(r.parentNode);
      }, 300);
    }, o);
  }
};
function $m(e) {
  return typeof e > "u" || !!e;
}
function xa(e) {
  const n = {}, r = e.currentTarget;
  if (!(!r?._ripple || r._ripple.touched || e[gu])) {
    if (e[gu] = !0, pu(e))
      r._ripple.touched = !0, r._ripple.isTouch = !0;
    else if (r._ripple.isTouch) return;
    if (n.center = r._ripple.centered || Dm(e), r._ripple.class && (n.class = r._ripple.class), pu(e)) {
      if (r._ripple.showTimerCommit) return;
      r._ripple.showTimerCommit = () => {
        Jo.show(e, r, n);
      }, r._ripple.showTimer = window.setTimeout(() => {
        r?._ripple?.showTimerCommit && (r._ripple.showTimerCommit(), r._ripple.showTimerCommit = null);
      }, mA);
    } else
      Jo.show(e, r, n);
  }
}
function jh(e) {
  e[gu] = !0;
}
function pn(e) {
  const n = e.currentTarget;
  if (n?._ripple) {
    if (window.clearTimeout(n._ripple.showTimer), e.type === "touchend" && n._ripple.showTimerCommit) {
      n._ripple.showTimerCommit(), n._ripple.showTimerCommit = null, n._ripple.showTimer = window.setTimeout(() => {
        pn(e);
      });
      return;
    }
    window.setTimeout(() => {
      n._ripple && (n._ripple.touched = !1);
    }), Jo.hide(n);
  }
}
function Bm(e) {
  const n = e.currentTarget;
  n?._ripple && (n._ripple.showTimerCommit && (n._ripple.showTimerCommit = null), window.clearTimeout(n._ripple.showTimer));
}
let Aa = !1;
function Vm(e) {
  !Aa && (e.keyCode === Ch.enter || e.keyCode === Ch.space) && (Aa = !0, xa(e));
}
function Um(e) {
  Aa = !1, pn(e);
}
function Wm(e) {
  Aa && (Aa = !1, pn(e));
}
function Hm(e, n, r) {
  const {
    value: a,
    modifiers: o
  } = n, s = $m(a);
  if (s || Jo.hide(e), e._ripple = e._ripple ?? {}, e._ripple.enabled = s, e._ripple.centered = o.center, e._ripple.circle = o.circle, du(a) && a.class && (e._ripple.class = a.class), s && !r) {
    if (o.stop) {
      e.addEventListener("touchstart", jh, {
        passive: !0
      }), e.addEventListener("mousedown", jh);
      return;
    }
    e.addEventListener("touchstart", xa, {
      passive: !0
    }), e.addEventListener("touchend", pn, {
      passive: !0
    }), e.addEventListener("touchmove", Bm, {
      passive: !0
    }), e.addEventListener("touchcancel", pn), e.addEventListener("mousedown", xa), e.addEventListener("mouseup", pn), e.addEventListener("mouseleave", pn), e.addEventListener("keydown", Vm), e.addEventListener("keyup", Um), e.addEventListener("blur", Wm), e.addEventListener("dragstart", pn, {
      passive: !0
    });
  } else !s && r && Gm(e);
}
function Gm(e) {
  e.removeEventListener("mousedown", xa), e.removeEventListener("touchstart", xa), e.removeEventListener("touchend", pn), e.removeEventListener("touchmove", Bm), e.removeEventListener("touchcancel", pn), e.removeEventListener("mouseup", pn), e.removeEventListener("mouseleave", pn), e.removeEventListener("keydown", Vm), e.removeEventListener("keyup", Um), e.removeEventListener("dragstart", pn), e.removeEventListener("blur", Wm);
}
function pA(e, n) {
  Hm(e, n, !1);
}
function _A(e) {
  delete e._ripple, Gm(e);
}
function yA(e, n) {
  if (n.value === n.oldValue)
    return;
  const r = $m(n.oldValue);
  Hm(e, n, r);
}
const rc = {
  mounted: pA,
  unmounted: _A,
  updated: yA
}, bA = he({
  start: Boolean,
  end: Boolean,
  icon: _t,
  image: String,
  text: String,
  ...ct(),
  ...zi(),
  ...fi(),
  ...tc(),
  ...qn(),
  ...un(),
  ...Na({
    variant: "flat"
  })
}, "VAvatar"), ka = He()({
  name: "VAvatar",
  props: bA(),
  setup(e, n) {
    let {
      slots: r
    } = n;
    const {
      themeClasses: a
    } = Dn(e), {
      colorClasses: o,
      colorStyles: s,
      variantClasses: l
    } = ec(e), {
      densityClasses: c
    } = qi(e), {
      roundedClasses: f
    } = di(e), {
      sizeClasses: h,
      sizeStyles: v
    } = nc(e);
    return tt(() => T(e.tag, {
      class: ["v-avatar", {
        "v-avatar--start": e.start,
        "v-avatar--end": e.end
      }, a.value, o.value, c.value, f.value, h.value, l.value, e.class],
      style: [s.value, v.value, e.style]
    }, {
      default: () => [r.default ? T(Fn, {
        key: "content-defaults",
        defaults: {
          VImg: {
            cover: !0,
            src: e.image
          },
          VIcon: {
            icon: e.icon
          }
        }
      }, {
        default: () => [r.default()]
      }) : e.image ? T(zx, {
        key: "image",
        src: e.image,
        alt: "",
        cover: !0
      }, null) : e.icon ? T(_n, {
        key: "icon",
        icon: e.icon
      }, null) : e.text, Qu(!1, "v-avatar")]
    })), {};
  }
}), wA = he({
  text: String,
  onClick: on(),
  ...ct(),
  ...un()
}, "VLabel"), zm = He()({
  name: "VLabel",
  props: wA(),
  setup(e, n) {
    let {
      slots: r
    } = n;
    return tt(() => T("label", {
      class: ["v-label", {
        "v-label--clickable": !!e.onClick
      }, e.class],
      style: e.style,
      onClick: e.onClick
    }, [e.text, r.default?.()])), {};
  }
}), qm = Symbol.for("vuetify:selection-control-group"), Km = he({
  color: String,
  disabled: {
    type: Boolean,
    default: null
  },
  defaultsTarget: String,
  error: Boolean,
  id: String,
  inline: Boolean,
  falseIcon: _t,
  trueIcon: _t,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  multiple: {
    type: Boolean,
    default: null
  },
  name: String,
  readonly: {
    type: Boolean,
    default: null
  },
  modelValue: null,
  type: String,
  valueComparator: {
    type: Function,
    default: Gi
  },
  ...ct(),
  ...zi(),
  ...un()
}, "SelectionControlGroup"), CA = he({
  ...Km({
    defaultsTarget: "VSelectionControl"
  })
}, "VSelectionControlGroup");
He()({
  name: "VSelectionControlGroup",
  props: CA(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      slots: r
    } = n;
    const a = Ot(e, "modelValue"), o = Qn(), s = A(() => e.id || `v-selection-control-group-${o}`), l = A(() => e.name || s.value), c = /* @__PURE__ */ new Set();
    return Et(qm, {
      modelValue: a,
      forceUpdate: () => {
        c.forEach((f) => f());
      },
      onForceUpdate: (f) => {
        c.add(f), Zt(() => {
          c.delete(f);
        });
      }
    }), ss({
      [e.defaultsTarget]: {
        color: Me(e, "color"),
        disabled: Me(e, "disabled"),
        density: Me(e, "density"),
        error: Me(e, "error"),
        inline: Me(e, "inline"),
        modelValue: a,
        multiple: A(() => !!e.multiple || e.multiple == null && Array.isArray(a.value)),
        name: l,
        falseIcon: Me(e, "falseIcon"),
        trueIcon: Me(e, "trueIcon"),
        readonly: Me(e, "readonly"),
        ripple: Me(e, "ripple"),
        type: Me(e, "type"),
        valueComparator: Me(e, "valueComparator")
      }
    }), tt(() => T("div", {
      class: ["v-selection-control-group", {
        "v-selection-control-group--inline": e.inline
      }, e.class],
      style: e.style,
      role: e.type === "radio" ? "radiogroup" : void 0
    }, [r.default?.()])), {};
  }
});
const jm = he({
  label: String,
  baseColor: String,
  trueValue: null,
  falseValue: null,
  value: null,
  ...ct(),
  ...Km()
}, "VSelectionControl");
function SA(e) {
  const n = Ze(qm, void 0), {
    densityClasses: r
  } = qi(e), a = Ot(e, "modelValue"), o = A(() => e.trueValue !== void 0 ? e.trueValue : e.value !== void 0 ? e.value : !0), s = A(() => e.falseValue !== void 0 ? e.falseValue : !1), l = A(() => !!e.multiple || e.multiple == null && Array.isArray(a.value)), c = A({
    get() {
      const y = n ? n.modelValue.value : a.value;
      return l.value ? Mn(y).some((b) => e.valueComparator(b, o.value)) : e.valueComparator(y, o.value);
    },
    set(y) {
      if (e.readonly) return;
      const b = y ? o.value : s.value;
      let C = b;
      l.value && (C = y ? [...Mn(a.value), b] : Mn(a.value).filter((S) => !e.valueComparator(S, o.value))), n ? n.modelValue.value = C : a.value = C;
    }
  }), {
    textColorClasses: f,
    textColorStyles: h
  } = ci(A(() => {
    if (!(e.error || e.disabled))
      return c.value ? e.color : e.baseColor;
  })), {
    backgroundColorClasses: v,
    backgroundColorStyles: m
  } = pr(A(() => c.value && !e.error && !e.disabled ? e.color : e.baseColor)), p = A(() => c.value ? e.trueIcon : e.falseIcon);
  return {
    group: n,
    densityClasses: r,
    trueValue: o,
    falseValue: s,
    model: c,
    textColorClasses: f,
    textColorStyles: h,
    backgroundColorClasses: v,
    backgroundColorStyles: m,
    icon: p
  };
}
const Yh = He()({
  name: "VSelectionControl",
  directives: {
    Ripple: rc
  },
  inheritAttrs: !1,
  props: jm(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      attrs: r,
      slots: a
    } = n;
    const {
      group: o,
      densityClasses: s,
      icon: l,
      model: c,
      textColorClasses: f,
      textColorStyles: h,
      backgroundColorClasses: v,
      backgroundColorStyles: m,
      trueValue: p
    } = SA(e), y = Qn(), b = Ue(!1), C = Ue(!1), S = oe(), R = A(() => e.id || `input-${y}`), $ = A(() => !e.disabled && !e.readonly);
    o?.onForceUpdate(() => {
      S.value && (S.value.checked = c.value);
    });
    function k(E) {
      $.value && (b.value = !0, qo(E.target, ":focus-visible") !== !1 && (C.value = !0));
    }
    function L() {
      b.value = !1, C.value = !1;
    }
    function F(E) {
      E.stopPropagation();
    }
    function P(E) {
      if (!$.value) {
        S.value && (S.value.checked = c.value);
        return;
      }
      e.readonly && o && Jt(() => o.forceUpdate()), c.value = E.target.checked;
    }
    return tt(() => {
      const E = a.label ? a.label({
        label: e.label,
        props: {
          for: R.value
        }
      }) : e.label, [V, W] = hm(r), me = T("input", Te({
        ref: S,
        checked: c.value,
        disabled: !!e.disabled,
        id: R.value,
        onBlur: L,
        onFocus: k,
        onInput: P,
        "aria-disabled": !!e.disabled,
        "aria-label": e.label,
        type: e.type,
        value: p.value,
        name: e.name,
        "aria-checked": e.type === "checkbox" ? c.value : void 0
      }, W), null);
      return T("div", Te({
        class: ["v-selection-control", {
          "v-selection-control--dirty": c.value,
          "v-selection-control--disabled": e.disabled,
          "v-selection-control--error": e.error,
          "v-selection-control--focused": b.value,
          "v-selection-control--focus-visible": C.value,
          "v-selection-control--inline": e.inline
        }, s.value, e.class]
      }, V, {
        style: e.style
      }), [T("div", {
        class: ["v-selection-control__wrapper", f.value],
        style: h.value
      }, [a.default?.({
        backgroundColorClasses: v,
        backgroundColorStyles: m
      }), Gn(T("div", {
        class: ["v-selection-control__input"]
      }, [a.input?.({
        model: c,
        textColorClasses: f,
        textColorStyles: h,
        backgroundColorClasses: v,
        backgroundColorStyles: m,
        inputNode: me,
        icon: l.value,
        props: {
          onFocus: k,
          onBlur: L,
          id: R.value
        }
      }) ?? T(Ie, null, [l.value && T(_n, {
        key: "icon",
        icon: l.value
      }, null), me])]), [[Bi("ripple"), e.ripple && [!e.disabled && !e.readonly, null, ["center", "circle"]]]])]), E && T(zm, {
        for: R.value,
        onClick: F
      }, {
        default: () => [E]
      })]);
    }), {
      isFocused: b,
      input: S
    };
  }
}), EA = he({
  indeterminate: Boolean,
  indeterminateIcon: {
    type: _t,
    default: "$checkboxIndeterminate"
  },
  ...jm({
    falseIcon: "$checkboxOff",
    trueIcon: "$checkboxOn"
  })
}, "VCheckboxBtn"), xA = He()({
  name: "VCheckboxBtn",
  props: EA(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:indeterminate": (e) => !0
  },
  setup(e, n) {
    let {
      slots: r
    } = n;
    const a = Ot(e, "indeterminate"), o = Ot(e, "modelValue");
    function s(f) {
      a.value && (a.value = !1);
    }
    const l = A(() => a.value ? e.indeterminateIcon : e.falseIcon), c = A(() => a.value ? e.indeterminateIcon : e.trueIcon);
    return tt(() => {
      const f = oi(Yh.filterProps(e), ["modelValue"]);
      return T(Yh, Te(f, {
        modelValue: o.value,
        "onUpdate:modelValue": [(h) => o.value = h, s],
        class: ["v-checkbox-btn", e.class],
        style: e.style,
        type: "checkbox",
        falseIcon: l.value,
        trueIcon: c.value,
        "aria-checked": a.value ? "mixed" : void 0
      }), r);
    }), {};
  }
});
function Ym(e) {
  const {
    t: n
  } = ls();
  function r(a) {
    let {
      name: o
    } = a;
    const s = {
      prepend: "prependAction",
      prependInner: "prependAction",
      append: "appendAction",
      appendInner: "appendAction",
      clear: "clear"
    }[o], l = e[`onClick:${o}`], c = l && s ? n(`$vuetify.input.${s}`, e.label ?? "") : void 0;
    return T(_n, {
      icon: e[`${o}Icon`],
      "aria-label": c,
      onClick: l
    }, null);
  }
  return {
    InputIcon: r
  };
}
const AA = he({
  active: Boolean,
  color: String,
  messages: {
    type: [Array, String],
    default: () => []
  },
  ...ct(),
  ...Pa({
    transition: {
      component: km,
      leaveAbsolute: !0,
      group: !0
    }
  })
}, "VMessages"), kA = He()({
  name: "VMessages",
  props: AA(),
  setup(e, n) {
    let {
      slots: r
    } = n;
    const a = A(() => Mn(e.messages)), {
      textColorClasses: o,
      textColorStyles: s
    } = ci(A(() => e.color));
    return tt(() => T(Nr, {
      transition: e.transition,
      tag: "div",
      class: ["v-messages", o.value, e.class],
      style: [s.value, e.style],
      role: "alert",
      "aria-live": "polite"
    }, {
      default: () => [e.active && a.value.map((l, c) => T("div", {
        class: "v-messages__message",
        key: `${c}-${a.value}`
      }, [r.message ? r.message({
        message: l
      }) : l]))]
    })), {};
  }
}), Xm = he({
  focused: Boolean,
  "onUpdate:focused": on()
}, "focus");
function Jm(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : br();
  const r = Ot(e, "focused"), a = A(() => ({
    [`${n}--focused`]: r.value
  }));
  function o() {
    r.value = !0;
  }
  function s() {
    r.value = !1;
  }
  return {
    focusClasses: a,
    isFocused: r,
    focus: o,
    blur: s
  };
}
const TA = Symbol.for("vuetify:form");
function Zm() {
  return Ze(TA, null);
}
const IA = he({
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  errorMessages: {
    type: [Array, String],
    default: () => []
  },
  maxErrors: {
    type: [Number, String],
    default: 1
  },
  name: String,
  label: String,
  readonly: {
    type: Boolean,
    default: null
  },
  rules: {
    type: Array,
    default: () => []
  },
  modelValue: null,
  validateOn: String,
  validationValue: null,
  ...Xm()
}, "validation");
function LA(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : br(), r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Qn();
  const a = Ot(e, "modelValue"), o = A(() => e.validationValue === void 0 ? a.value : e.validationValue), s = Zm(), l = oe([]), c = Ue(!0), f = A(() => !!(Mn(a.value === "" ? null : a.value).length || Mn(o.value === "" ? null : o.value).length)), h = A(() => !!(e.disabled ?? s?.isDisabled.value)), v = A(() => !!(e.readonly ?? s?.isReadonly.value)), m = A(() => e.errorMessages?.length ? Mn(e.errorMessages).concat(l.value).slice(0, Math.max(0, +e.maxErrors)) : l.value), p = A(() => {
    let F = (e.validateOn ?? s?.validateOn.value) || "input";
    F === "lazy" && (F = "input lazy");
    const P = new Set(F?.split(" ") ?? []);
    return {
      blur: P.has("blur") || P.has("input"),
      input: P.has("input"),
      submit: P.has("submit"),
      lazy: P.has("lazy")
    };
  }), y = A(() => e.error || e.errorMessages?.length ? !1 : e.rules.length ? c.value ? l.value.length || p.value.lazy ? null : !0 : !l.value.length : !0), b = Ue(!1), C = A(() => ({
    [`${n}--error`]: y.value === !1,
    [`${n}--dirty`]: f.value,
    [`${n}--disabled`]: h.value,
    [`${n}--readonly`]: v.value
  })), S = Dt("validation"), R = A(() => e.name ?? q(r));
  Pu(() => {
    s?.register({
      id: R.value,
      vm: S,
      validate: L,
      reset: $,
      resetValidation: k
    });
  }), _r(() => {
    s?.unregister(R.value);
  }), qt(async () => {
    p.value.lazy || await L(!0), s?.update(R.value, y.value, m.value);
  }), ri(() => p.value.input, () => {
    Re(o, () => {
      if (o.value != null)
        L();
      else if (e.focused) {
        const F = Re(() => e.focused, (P) => {
          P || L(), F();
        });
      }
    });
  }), ri(() => p.value.blur, () => {
    Re(() => e.focused, (F) => {
      F || L();
    });
  }), Re([y, m], () => {
    s?.update(R.value, y.value, m.value);
  });
  async function $() {
    a.value = null, await Jt(), await k();
  }
  async function k() {
    c.value = !0, p.value.lazy ? l.value = [] : await L(!0);
  }
  async function L() {
    let F = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    const P = [];
    b.value = !0;
    for (const E of e.rules) {
      if (P.length >= +(e.maxErrors ?? 1))
        break;
      const W = await (typeof E == "function" ? E : () => E)(o.value);
      if (W !== !0) {
        if (W !== !1 && typeof W != "string") {
          console.warn(`${W} is not a valid value. Rule functions must return boolean true or a string.`);
          continue;
        }
        P.push(W || "");
      }
    }
    return l.value = P, b.value = !1, c.value = F, l.value;
  }
  return {
    errorMessages: m,
    isDirty: f,
    isDisabled: h,
    isReadonly: v,
    isPristine: c,
    isValid: y,
    isValidating: b,
    reset: $,
    resetValidation: k,
    validate: L,
    validationClasses: C
  };
}
const Qm = he({
  id: String,
  appendIcon: _t,
  centerAffix: {
    type: Boolean,
    default: !0
  },
  prependIcon: _t,
  hideDetails: [Boolean, String],
  hideSpinButtons: Boolean,
  hint: String,
  persistentHint: Boolean,
  messages: {
    type: [Array, String],
    default: () => []
  },
  direction: {
    type: String,
    default: "horizontal",
    validator: (e) => ["horizontal", "vertical"].includes(e)
  },
  "onClick:prepend": on(),
  "onClick:append": on(),
  ...ct(),
  ...zi(),
  ...ox(li(), ["maxWidth", "minWidth", "width"]),
  ...un(),
  ...IA()
}, "VInput"), Xh = He()({
  name: "VInput",
  props: {
    ...Qm()
  },
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      attrs: r,
      slots: a,
      emit: o
    } = n;
    const {
      densityClasses: s
    } = qi(e), {
      dimensionStyles: l
    } = ui(e), {
      themeClasses: c
    } = Dn(e), {
      rtlClasses: f
    } = si(), {
      InputIcon: h
    } = Ym(e), v = Qn(), m = A(() => e.id || `input-${v}`), p = A(() => `${m.value}-messages`), {
      errorMessages: y,
      isDirty: b,
      isDisabled: C,
      isReadonly: S,
      isPristine: R,
      isValid: $,
      isValidating: k,
      reset: L,
      resetValidation: F,
      validate: P,
      validationClasses: E
    } = LA(e, "v-input", m), V = A(() => ({
      id: m,
      messagesId: p,
      isDirty: b,
      isDisabled: C,
      isReadonly: S,
      isPristine: R,
      isValid: $,
      isValidating: k,
      reset: L,
      resetValidation: F,
      validate: P
    })), W = A(() => e.errorMessages?.length || !R.value && y.value.length ? y.value : e.hint && (e.persistentHint || e.focused) ? e.hint : e.messages);
    return tt(() => {
      const me = !!(a.prepend || e.prependIcon), le = !!(a.append || e.appendIcon), K = W.value.length > 0, ae = !e.hideDetails || e.hideDetails === "auto" && (K || !!a.details);
      return T("div", {
        class: ["v-input", `v-input--${e.direction}`, {
          "v-input--center-affix": e.centerAffix,
          "v-input--hide-spin-buttons": e.hideSpinButtons
        }, s.value, c.value, f.value, E.value, e.class],
        style: [l.value, e.style]
      }, [me && T("div", {
        key: "prepend",
        class: "v-input__prepend"
      }, [a.prepend?.(V.value), e.prependIcon && T(h, {
        key: "prepend-icon",
        name: "prepend"
      }, null)]), a.default && T("div", {
        class: "v-input__control"
      }, [a.default?.(V.value)]), le && T("div", {
        key: "append",
        class: "v-input__append"
      }, [e.appendIcon && T(h, {
        key: "append-icon",
        name: "append"
      }, null), a.append?.(V.value)]), ae && T("div", {
        class: "v-input__details"
      }, [T(kA, {
        id: p.value,
        active: K,
        messages: W.value
      }, {
        message: a.message
      }), a.details?.(V.value)])]);
    }), {
      reset: L,
      resetValidation: F,
      validate: P,
      isValid: $,
      errorMessages: y
    };
  }
}), OA = Symbol.for("vuetify:display"), PA = he({
  mobile: {
    type: Boolean,
    default: !1
  },
  mobileBreakpoint: [Number, String]
}, "display");
function ic() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : br();
  const r = Ze(OA);
  if (!r) throw new Error("Could not find Vuetify display injection");
  const a = A(() => {
    if (e.mobile != null) return e.mobile;
    if (!e.mobileBreakpoint) return r.mobile.value;
    const s = typeof e.mobileBreakpoint == "number" ? e.mobileBreakpoint : r.thresholds.value[e.mobileBreakpoint];
    return r.width.value < s;
  }), o = A(() => n ? {
    [`${n}--mobile`]: a.value
  } : {});
  return {
    ...r,
    displayClasses: o,
    mobile: a
  };
}
const NA = Symbol.for("vuetify:goto");
function RA() {
  return {
    container: void 0,
    duration: 300,
    layout: !1,
    offset: 0,
    easing: "easeInOutCubic",
    patterns: {
      linear: (e) => e,
      easeInQuad: (e) => e ** 2,
      easeOutQuad: (e) => e * (2 - e),
      easeInOutQuad: (e) => e < 0.5 ? 2 * e ** 2 : -1 + (4 - 2 * e) * e,
      easeInCubic: (e) => e ** 3,
      easeOutCubic: (e) => --e ** 3 + 1,
      easeInOutCubic: (e) => e < 0.5 ? 4 * e ** 3 : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1,
      easeInQuart: (e) => e ** 4,
      easeOutQuart: (e) => 1 - --e ** 4,
      easeInOutQuart: (e) => e < 0.5 ? 8 * e ** 4 : 1 - 8 * --e ** 4,
      easeInQuint: (e) => e ** 5,
      easeOutQuint: (e) => 1 + --e ** 5,
      easeInOutQuint: (e) => e < 0.5 ? 16 * e ** 5 : 1 + 16 * --e ** 5
    }
  };
}
function FA(e) {
  return ac(e) ?? (document.scrollingElement || document.body);
}
function ac(e) {
  return typeof e == "string" ? document.querySelector(e) : cm(e);
}
function Hl(e, n, r) {
  if (typeof e == "number") return n && r ? -e : e;
  let a = ac(e), o = 0;
  for (; a; )
    o += n ? a.offsetLeft : a.offsetTop, a = a.offsetParent;
  return o;
}
async function Jh(e, n, r, a) {
  const o = r ? "scrollLeft" : "scrollTop", s = vr(a?.options ?? RA(), n), l = a?.rtl.value, c = (typeof e == "number" ? e : ac(e)) ?? 0, f = s.container === "parent" && c instanceof HTMLElement ? c.parentElement : FA(s.container), h = typeof s.easing == "function" ? s.easing : s.patterns[s.easing];
  if (!h) throw new TypeError(`Easing function "${s.easing}" not found.`);
  let v;
  if (typeof c == "number")
    v = Hl(c, r, l);
  else if (v = Hl(c, r, l) - Hl(f, r, l), s.layout) {
    const b = window.getComputedStyle(c).getPropertyValue("--v-layout-top");
    b && (v -= parseInt(b, 10));
  }
  v += s.offset, v = DA(f, v, !!l, !!r);
  const m = f[o] ?? 0;
  if (v === m) return Promise.resolve(v);
  const p = performance.now();
  return new Promise((y) => requestAnimationFrame(function b(C) {
    const R = (C - p) / s.duration, $ = Math.floor(m + (v - m) * h(Fr(R, 0, 1)));
    if (f[o] = $, R >= 1 && Math.abs($ - f[o]) < 10)
      return y(v);
    if (R > 2)
      return Qr("Scroll target is not reachable"), y(f[o]);
    requestAnimationFrame(b);
  }));
}
function MA() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const n = Ze(NA), {
    isRtl: r
  } = si();
  if (!n) throw new Error("[Vuetify] Could not find injected goto instance");
  const a = {
    ...n,
    // can be set via VLocaleProvider
    rtl: A(() => n.rtl.value || r.value)
  };
  async function o(s, l) {
    return Jh(s, vr(e, l), !1, a);
  }
  return o.horizontal = async (s, l) => Jh(s, vr(e, l), !0, a), o;
}
function DA(e, n, r, a) {
  const {
    scrollWidth: o,
    scrollHeight: s
  } = e, [l, c] = e === document.scrollingElement ? [window.innerWidth, window.innerHeight] : [e.offsetWidth, e.offsetHeight];
  let f, h;
  return a ? r ? (f = -(o - l), h = 0) : (f = 0, h = o - l) : (f = 0, h = s + -c), Math.max(Math.min(n, h), f);
}
function $A(e) {
  let {
    selectedElement: n,
    containerElement: r,
    isRtl: a,
    isHorizontal: o
  } = e;
  const s = Ta(o, r), l = eg(o, a, r), c = Ta(o, n), f = tg(o, n), h = c * 0.4;
  return l > f ? f - h : l + s < f + c ? f - s + c + h : l;
}
function BA(e) {
  let {
    selectedElement: n,
    containerElement: r,
    isHorizontal: a
  } = e;
  const o = Ta(a, r), s = tg(a, n), l = Ta(a, n);
  return s - o / 2 + l / 2;
}
function Zh(e, n) {
  return n?.[e ? "scrollWidth" : "scrollHeight"] || 0;
}
function VA(e, n) {
  return n?.[e ? "clientWidth" : "clientHeight"] || 0;
}
function eg(e, n, r) {
  if (!r)
    return 0;
  const {
    scrollLeft: a,
    offsetWidth: o,
    scrollWidth: s
  } = r;
  return e ? n ? s - o + a : a : r.scrollTop;
}
function Ta(e, n) {
  return n?.[e ? "offsetWidth" : "offsetHeight"] || 0;
}
function tg(e, n) {
  return n?.[e ? "offsetLeft" : "offsetTop"] || 0;
}
const UA = Symbol.for("vuetify:v-slide-group"), ng = he({
  centerActive: Boolean,
  direction: {
    type: String,
    default: "horizontal"
  },
  symbol: {
    type: null,
    default: UA
  },
  nextIcon: {
    type: _t,
    default: "$next"
  },
  prevIcon: {
    type: _t,
    default: "$prev"
  },
  showArrows: {
    type: [Boolean, String],
    validator: (e) => typeof e == "boolean" || ["always", "desktop", "mobile"].includes(e)
  },
  ...ct(),
  ...PA({
    mobile: null
  }),
  ...qn(),
  ...Pm({
    selectedClass: "v-slide-group-item--active"
  })
}, "VSlideGroup"), Qh = He()({
  name: "VSlideGroup",
  props: ng(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      slots: r
    } = n;
    const {
      isRtl: a
    } = si(), {
      displayClasses: o,
      mobile: s
    } = ic(e), l = Nm(e, e.symbol), c = Ue(!1), f = Ue(0), h = Ue(0), v = Ue(0), m = A(() => e.direction === "horizontal"), {
      resizeRef: p,
      contentRect: y
    } = Xo(), {
      resizeRef: b,
      contentRect: C
    } = Xo(), S = MA(), R = A(() => ({
      container: p.el,
      duration: 200,
      easing: "easeOutQuart"
    })), $ = A(() => l.selected.value.length ? l.items.value.findIndex((j) => j.id === l.selected.value[0]) : -1), k = A(() => l.selected.value.length ? l.items.value.findIndex((j) => j.id === l.selected.value[l.selected.value.length - 1]) : -1);
    if (Pt) {
      let j = -1;
      Re(() => [l.selected.value, y.value, C.value, m.value], () => {
        cancelAnimationFrame(j), j = requestAnimationFrame(() => {
          if (y.value && C.value) {
            const re = m.value ? "width" : "height";
            h.value = y.value[re], v.value = C.value[re], c.value = h.value + 1 < v.value;
          }
          if ($.value >= 0 && b.el) {
            const re = b.el.children[k.value];
            F(re, e.centerActive);
          }
        });
      });
    }
    const L = Ue(!1);
    function F(j, re) {
      let fe = 0;
      re ? fe = BA({
        containerElement: p.el,
        isHorizontal: m.value,
        selectedElement: j
      }) : fe = $A({
        containerElement: p.el,
        isHorizontal: m.value,
        isRtl: a.value,
        selectedElement: j
      }), P(fe);
    }
    function P(j) {
      if (!Pt || !p.el) return;
      const re = Ta(m.value, p.el), fe = eg(m.value, a.value, p.el);
      if (!(Zh(m.value, p.el) <= re || // Prevent scrolling by only a couple of pixels, which doesn't look smooth
      Math.abs(j - fe) < 16)) {
        if (m.value && a.value && p.el) {
          const {
            scrollWidth: Oe,
            offsetWidth: ge
          } = p.el;
          j = Oe - ge - j;
        }
        m.value ? S.horizontal(j, R.value) : S(j, R.value);
      }
    }
    function E(j) {
      const {
        scrollTop: re,
        scrollLeft: fe
      } = j.target;
      f.value = m.value ? fe : re;
    }
    function V(j) {
      if (L.value = !0, !(!c.value || !b.el)) {
        for (const re of j.composedPath())
          for (const fe of b.el.children)
            if (fe === re) {
              F(fe);
              return;
            }
      }
    }
    function W(j) {
      L.value = !1;
    }
    let me = !1;
    function le(j) {
      !me && !L.value && !(j.relatedTarget && b.el?.contains(j.relatedTarget)) && ue(), me = !1;
    }
    function K() {
      me = !0;
    }
    function ae(j) {
      if (!b.el) return;
      function re(fe) {
        j.preventDefault(), ue(fe);
      }
      m.value ? j.key === "ArrowRight" ? re(a.value ? "prev" : "next") : j.key === "ArrowLeft" && re(a.value ? "next" : "prev") : j.key === "ArrowDown" ? re("next") : j.key === "ArrowUp" && re("prev"), j.key === "Home" ? re("first") : j.key === "End" && re("last");
    }
    function ue(j) {
      if (!b.el) return;
      let re;
      if (!j)
        re = Sa(b.el)[0];
      else if (j === "next") {
        if (re = b.el.querySelector(":focus")?.nextElementSibling, !re) return ue("first");
      } else if (j === "prev") {
        if (re = b.el.querySelector(":focus")?.previousElementSibling, !re) return ue("last");
      } else j === "first" ? re = b.el.firstElementChild : j === "last" && (re = b.el.lastElementChild);
      re && re.focus({
        preventScroll: !0
      });
    }
    function Ce(j) {
      const re = m.value && a.value ? -1 : 1, fe = (j === "prev" ? -re : re) * h.value;
      let ye = f.value + fe;
      if (m.value && a.value && p.el) {
        const {
          scrollWidth: Oe,
          offsetWidth: ge
        } = p.el;
        ye += Oe - ge;
      }
      P(ye);
    }
    const Se = A(() => ({
      next: l.next,
      prev: l.prev,
      select: l.select,
      isSelected: l.isSelected
    })), Pe = A(() => {
      switch (e.showArrows) {
        case "always":
          return !0;
        case "desktop":
          return !s.value;
        case !0:
          return c.value || Math.abs(f.value) > 0;
        case "mobile":
          return s.value || c.value || Math.abs(f.value) > 0;
        default:
          return !s.value && (c.value || Math.abs(f.value) > 0);
      }
    }), ie = A(() => Math.abs(f.value) > 1), se = A(() => {
      if (!p.value) return !1;
      const j = Zh(m.value, p.el), re = VA(m.value, p.el);
      return j - re - Math.abs(f.value) > 1;
    });
    return tt(() => T(e.tag, {
      class: ["v-slide-group", {
        "v-slide-group--vertical": !m.value,
        "v-slide-group--has-affixes": Pe.value,
        "v-slide-group--is-overflowing": c.value
      }, o.value, e.class],
      style: e.style,
      tabindex: L.value || l.selected.value.length ? -1 : 0,
      onFocus: le
    }, {
      default: () => [Pe.value && T("div", {
        key: "prev",
        class: ["v-slide-group__prev", {
          "v-slide-group__prev--disabled": !ie.value
        }],
        onMousedown: K,
        onClick: () => ie.value && Ce("prev")
      }, [r.prev?.(Se.value) ?? T(Hh, null, {
        default: () => [T(_n, {
          icon: a.value ? e.nextIcon : e.prevIcon
        }, null)]
      })]), T("div", {
        key: "container",
        ref: p,
        class: "v-slide-group__container",
        onScroll: E
      }, [T("div", {
        ref: b,
        class: "v-slide-group__content",
        onFocusin: V,
        onFocusout: W,
        onKeydown: ae
      }, [r.default?.(Se.value)])]), Pe.value && T("div", {
        key: "next",
        class: ["v-slide-group__next", {
          "v-slide-group__next--disabled": !se.value
        }],
        onMousedown: K,
        onClick: () => se.value && Ce("next")
      }, [r.next?.(Se.value) ?? T(Hh, null, {
        default: () => [T(_n, {
          icon: a.value ? e.prevIcon : e.nextIcon
        }, null)]
      })])]
    })), {
      selected: l.selected,
      scrollTo: Ce,
      scrollOffset: f,
      focus: ue
    };
  }
}), rg = Symbol.for("vuetify:v-chip-group"), WA = he({
  column: Boolean,
  filter: Boolean,
  valueComparator: {
    type: Function,
    default: Gi
  },
  ...ng(),
  ...ct(),
  ...Pm({
    selectedClass: "v-chip--selected"
  }),
  ...qn(),
  ...un(),
  ...Na({
    variant: "tonal"
  })
}, "VChipGroup");
He()({
  name: "VChipGroup",
  props: WA(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      slots: r
    } = n;
    const {
      themeClasses: a
    } = Dn(e), {
      isSelected: o,
      select: s,
      next: l,
      prev: c,
      selected: f
    } = Nm(e, rg);
    return ss({
      VChip: {
        color: Me(e, "color"),
        disabled: Me(e, "disabled"),
        filter: Me(e, "filter"),
        variant: Me(e, "variant")
      }
    }), tt(() => {
      const h = Qh.filterProps(e);
      return T(Qh, Te(h, {
        class: ["v-chip-group", {
          "v-chip-group--column": e.column
        }, a.value, e.class],
        style: e.style
      }), {
        default: () => [r.default?.({
          isSelected: o,
          select: s,
          next: l,
          prev: c,
          selected: f.value
        })]
      });
    }), {};
  }
});
const HA = he({
  activeClass: String,
  appendAvatar: String,
  appendIcon: _t,
  closable: Boolean,
  closeIcon: {
    type: _t,
    default: "$delete"
  },
  closeLabel: {
    type: String,
    default: "$vuetify.close"
  },
  draggable: Boolean,
  filter: Boolean,
  filterIcon: {
    type: String,
    default: "$complete"
  },
  label: Boolean,
  link: {
    type: Boolean,
    default: void 0
  },
  pill: Boolean,
  prependAvatar: String,
  prependIcon: _t,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  text: String,
  modelValue: {
    type: Boolean,
    default: !0
  },
  onClick: on(),
  onClickOnce: on(),
  ...Ju(),
  ...ct(),
  ...zi(),
  ...us(),
  ...Yx(),
  ...fi(),
  ...Mm(),
  ...tc(),
  ...qn({
    tag: "span"
  }),
  ...un(),
  ...Na({
    variant: "tonal"
  })
}, "VChip"), GA = He()({
  name: "VChip",
  directives: {
    Ripple: rc
  },
  props: HA(),
  emits: {
    "click:close": (e) => !0,
    "update:modelValue": (e) => !0,
    "group:selected": (e) => !0,
    click: (e) => !0
  },
  setup(e, n) {
    let {
      attrs: r,
      emit: a,
      slots: o
    } = n;
    const {
      t: s
    } = ls(), {
      borderClasses: l
    } = Zu(e), {
      colorClasses: c,
      colorStyles: f,
      variantClasses: h
    } = ec(e), {
      densityClasses: v
    } = qi(e), {
      elevationClasses: m
    } = cs(e), {
      roundedClasses: p
    } = di(e), {
      sizeClasses: y
    } = nc(e), {
      themeClasses: b
    } = Dn(e), C = Ot(e, "modelValue"), S = Xx(e, rg, !1), R = Fm(e, r), $ = A(() => e.link !== !1 && R.isLink.value), k = A(() => !e.disabled && e.link !== !1 && (!!S || e.link || R.isClickable.value)), L = A(() => ({
      "aria-label": s(e.closeLabel),
      onClick(E) {
        E.preventDefault(), E.stopPropagation(), C.value = !1, a("click:close", E);
      }
    }));
    function F(E) {
      a("click", E), k.value && (R.navigate?.(E), S?.toggle());
    }
    function P(E) {
      (E.key === "Enter" || E.key === " ") && (E.preventDefault(), F(E));
    }
    return () => {
      const E = R.isLink.value ? "a" : e.tag, V = !!(e.appendIcon || e.appendAvatar), W = !!(V || o.append), me = !!(o.close || e.closable), le = !!(o.filter || e.filter) && S, K = !!(e.prependIcon || e.prependAvatar), ae = !!(K || o.prepend), ue = !S || S.isSelected.value;
      return C.value && Gn(T(E, {
        class: ["v-chip", {
          "v-chip--disabled": e.disabled,
          "v-chip--label": e.label,
          "v-chip--link": k.value,
          "v-chip--filter": le,
          "v-chip--pill": e.pill
        }, b.value, l.value, ue ? c.value : void 0, v.value, m.value, p.value, y.value, h.value, S?.selectedClass.value, e.class],
        style: [ue ? f.value : void 0, e.style],
        disabled: e.disabled || void 0,
        draggable: e.draggable,
        href: R.href.value,
        tabindex: k.value ? 0 : void 0,
        onClick: F,
        onKeydown: k.value && !$.value && P
      }, {
        default: () => [Qu(k.value, "v-chip"), le && T(Tm, {
          key: "filter"
        }, {
          default: () => [Gn(T("div", {
            class: "v-chip__filter"
          }, [o.filter ? T(Fn, {
            key: "filter-defaults",
            disabled: !e.filterIcon,
            defaults: {
              VIcon: {
                icon: e.filterIcon
              }
            }
          }, o.filter) : T(_n, {
            key: "filter-icon",
            icon: e.filterIcon
          }, null)]), [[Vi, S.isSelected.value]])]
        }), ae && T("div", {
          key: "prepend",
          class: "v-chip__prepend"
        }, [o.prepend ? T(Fn, {
          key: "prepend-defaults",
          disabled: !K,
          defaults: {
            VAvatar: {
              image: e.prependAvatar,
              start: !0
            },
            VIcon: {
              icon: e.prependIcon,
              start: !0
            }
          }
        }, o.prepend) : T(Ie, null, [e.prependIcon && T(_n, {
          key: "prepend-icon",
          icon: e.prependIcon,
          start: !0
        }, null), e.prependAvatar && T(ka, {
          key: "prepend-avatar",
          image: e.prependAvatar,
          start: !0
        }, null)])]), T("div", {
          class: "v-chip__content",
          "data-no-activator": ""
        }, [o.default?.({
          isSelected: S?.isSelected.value,
          selectedClass: S?.selectedClass.value,
          select: S?.select,
          toggle: S?.toggle,
          value: S?.value.value,
          disabled: e.disabled
        }) ?? e.text]), W && T("div", {
          key: "append",
          class: "v-chip__append"
        }, [o.append ? T(Fn, {
          key: "append-defaults",
          disabled: !V,
          defaults: {
            VAvatar: {
              end: !0,
              image: e.appendAvatar
            },
            VIcon: {
              end: !0,
              icon: e.appendIcon
            }
          }
        }, o.append) : T(Ie, null, [e.appendIcon && T(_n, {
          key: "append-icon",
          end: !0,
          icon: e.appendIcon
        }, null), e.appendAvatar && T(ka, {
          key: "append-avatar",
          end: !0,
          image: e.appendAvatar
        }, null)])]), me && T("button", Te({
          key: "close",
          class: "v-chip__close",
          type: "button"
        }, L.value), [o.close ? T(Fn, {
          key: "close-defaults",
          defaults: {
            VIcon: {
              icon: e.closeIcon,
              size: "x-small"
            }
          }
        }, o.close) : T(_n, {
          key: "close-icon",
          icon: e.closeIcon,
          size: "x-small"
        }, null)])]
      }), [[Bi("ripple"), k.value && e.ripple, null]]);
    };
  }
}), _u = Symbol.for("vuetify:list");
function ig() {
  const e = Ze(_u, {
    hasPrepend: Ue(!1),
    updateHasPrepend: () => null
  }), n = {
    hasPrepend: Ue(!1),
    updateHasPrepend: (r) => {
      r && (n.hasPrepend.value = r);
    }
  };
  return Et(_u, n), e;
}
function ag() {
  return Ze(_u, null);
}
const oc = (e) => {
  const n = {
    activate: (r) => {
      let {
        id: a,
        value: o,
        activated: s
      } = r;
      return a = bn(a), e && !o && s.size === 1 && s.has(a) || (o ? s.add(a) : s.delete(a)), s;
    },
    in: (r, a, o) => {
      let s = /* @__PURE__ */ new Set();
      if (r != null)
        for (const l of Mn(r))
          s = n.activate({
            id: l,
            value: !0,
            activated: new Set(s),
            children: a,
            parents: o
          });
      return s;
    },
    out: (r) => Array.from(r)
  };
  return n;
}, og = (e) => {
  const n = oc(e);
  return {
    activate: (a) => {
      let {
        activated: o,
        id: s,
        ...l
      } = a;
      s = bn(s);
      const c = o.has(s) ? /* @__PURE__ */ new Set([s]) : /* @__PURE__ */ new Set();
      return n.activate({
        ...l,
        id: s,
        activated: c
      });
    },
    in: (a, o, s) => {
      let l = /* @__PURE__ */ new Set();
      if (a != null) {
        const c = Mn(a);
        c.length && (l = n.in(c.slice(0, 1), o, s));
      }
      return l;
    },
    out: (a, o, s) => n.out(a, o, s)
  };
}, zA = (e) => {
  const n = oc(e);
  return {
    activate: (a) => {
      let {
        id: o,
        activated: s,
        children: l,
        ...c
      } = a;
      return o = bn(o), l.has(o) ? s : n.activate({
        id: o,
        activated: s,
        children: l,
        ...c
      });
    },
    in: n.in,
    out: n.out
  };
}, qA = (e) => {
  const n = og(e);
  return {
    activate: (a) => {
      let {
        id: o,
        activated: s,
        children: l,
        ...c
      } = a;
      return o = bn(o), l.has(o) ? s : n.activate({
        id: o,
        activated: s,
        children: l,
        ...c
      });
    },
    in: n.in,
    out: n.out
  };
}, KA = {
  open: (e) => {
    let {
      id: n,
      value: r,
      opened: a,
      parents: o
    } = e;
    if (r) {
      const s = /* @__PURE__ */ new Set();
      s.add(n);
      let l = o.get(n);
      for (; l != null; )
        s.add(l), l = o.get(l);
      return s;
    } else
      return a.delete(n), a;
  },
  select: () => null
}, sg = {
  open: (e) => {
    let {
      id: n,
      value: r,
      opened: a,
      parents: o
    } = e;
    if (r) {
      let s = o.get(n);
      for (a.add(n); s != null && s !== n; )
        a.add(s), s = o.get(s);
      return a;
    } else
      a.delete(n);
    return a;
  },
  select: () => null
}, jA = {
  open: sg.open,
  select: (e) => {
    let {
      id: n,
      value: r,
      opened: a,
      parents: o
    } = e;
    if (!r) return a;
    const s = [];
    let l = o.get(n);
    for (; l != null; )
      s.push(l), l = o.get(l);
    return new Set(s);
  }
}, sc = (e) => {
  const n = {
    select: (r) => {
      let {
        id: a,
        value: o,
        selected: s
      } = r;
      if (a = bn(a), e && !o) {
        const l = Array.from(s.entries()).reduce((c, f) => {
          let [h, v] = f;
          return v === "on" && c.push(h), c;
        }, []);
        if (l.length === 1 && l[0] === a) return s;
      }
      return s.set(a, o ? "on" : "off"), s;
    },
    in: (r, a, o) => {
      let s = /* @__PURE__ */ new Map();
      for (const l of r || [])
        s = n.select({
          id: l,
          value: !0,
          selected: new Map(s),
          children: a,
          parents: o
        });
      return s;
    },
    out: (r) => {
      const a = [];
      for (const [o, s] of r.entries())
        s === "on" && a.push(o);
      return a;
    }
  };
  return n;
}, lg = (e) => {
  const n = sc(e);
  return {
    select: (a) => {
      let {
        selected: o,
        id: s,
        ...l
      } = a;
      s = bn(s);
      const c = o.has(s) ? /* @__PURE__ */ new Map([[s, o.get(s)]]) : /* @__PURE__ */ new Map();
      return n.select({
        ...l,
        id: s,
        selected: c
      });
    },
    in: (a, o, s) => {
      let l = /* @__PURE__ */ new Map();
      return a?.length && (l = n.in(a.slice(0, 1), o, s)), l;
    },
    out: (a, o, s) => n.out(a, o, s)
  };
}, YA = (e) => {
  const n = sc(e);
  return {
    select: (a) => {
      let {
        id: o,
        selected: s,
        children: l,
        ...c
      } = a;
      return o = bn(o), l.has(o) ? s : n.select({
        id: o,
        selected: s,
        children: l,
        ...c
      });
    },
    in: n.in,
    out: n.out
  };
}, XA = (e) => {
  const n = lg(e);
  return {
    select: (a) => {
      let {
        id: o,
        selected: s,
        children: l,
        ...c
      } = a;
      return o = bn(o), l.has(o) ? s : n.select({
        id: o,
        selected: s,
        children: l,
        ...c
      });
    },
    in: n.in,
    out: n.out
  };
}, JA = (e) => {
  const n = {
    select: (r) => {
      let {
        id: a,
        value: o,
        selected: s,
        children: l,
        parents: c
      } = r;
      a = bn(a);
      const f = new Map(s), h = [a];
      for (; h.length; ) {
        const m = h.shift();
        s.set(m, o ? "on" : "off"), l.has(m) && h.push(...l.get(m));
      }
      let v = c.get(a);
      for (; v; ) {
        const m = l.get(v), p = m.every((b) => s.get(b) === "on"), y = m.every((b) => !s.has(b) || s.get(b) === "off");
        s.set(v, p ? "on" : y ? "off" : "indeterminate"), v = c.get(v);
      }
      return e && !o && Array.from(s.entries()).reduce((p, y) => {
        let [b, C] = y;
        return C === "on" && p.push(b), p;
      }, []).length === 0 ? f : s;
    },
    in: (r, a, o) => {
      let s = /* @__PURE__ */ new Map();
      for (const l of r || [])
        s = n.select({
          id: l,
          value: !0,
          selected: new Map(s),
          children: a,
          parents: o
        });
      return s;
    },
    out: (r, a) => {
      const o = [];
      for (const [s, l] of r.entries())
        l === "on" && !a.has(s) && o.push(s);
      return o;
    }
  };
  return n;
}, Ia = Symbol.for("vuetify:nested"), ug = {
  id: Ue(),
  root: {
    register: () => null,
    unregister: () => null,
    parents: oe(/* @__PURE__ */ new Map()),
    children: oe(/* @__PURE__ */ new Map()),
    open: () => null,
    openOnSelect: () => null,
    activate: () => null,
    select: () => null,
    activatable: oe(!1),
    selectable: oe(!1),
    opened: oe(/* @__PURE__ */ new Set()),
    activated: oe(/* @__PURE__ */ new Set()),
    selected: oe(/* @__PURE__ */ new Map()),
    selectedValues: oe([])
  }
}, ZA = he({
  activatable: Boolean,
  selectable: Boolean,
  activeStrategy: [String, Function, Object],
  selectStrategy: [String, Function, Object],
  openStrategy: [String, Object],
  opened: null,
  activated: null,
  selected: null,
  mandatory: Boolean
}, "nested"), QA = (e) => {
  let n = !1;
  const r = oe(/* @__PURE__ */ new Map()), a = oe(/* @__PURE__ */ new Map()), o = Ot(e, "opened", e.opened, (y) => new Set(y), (y) => [...y.values()]), s = A(() => {
    if (typeof e.activeStrategy == "object") return e.activeStrategy;
    if (typeof e.activeStrategy == "function") return e.activeStrategy(e.mandatory);
    switch (e.activeStrategy) {
      case "leaf":
        return zA(e.mandatory);
      case "single-leaf":
        return qA(e.mandatory);
      case "independent":
        return oc(e.mandatory);
      case "single-independent":
      default:
        return og(e.mandatory);
    }
  }), l = A(() => {
    if (typeof e.selectStrategy == "object") return e.selectStrategy;
    if (typeof e.selectStrategy == "function") return e.selectStrategy(e.mandatory);
    switch (e.selectStrategy) {
      case "single-leaf":
        return XA(e.mandatory);
      case "leaf":
        return YA(e.mandatory);
      case "independent":
        return sc(e.mandatory);
      case "single-independent":
        return lg(e.mandatory);
      case "classic":
      default:
        return JA(e.mandatory);
    }
  }), c = A(() => {
    if (typeof e.openStrategy == "object") return e.openStrategy;
    switch (e.openStrategy) {
      case "list":
        return jA;
      case "single":
        return KA;
      case "multiple":
      default:
        return sg;
    }
  }), f = Ot(e, "activated", e.activated, (y) => s.value.in(y, r.value, a.value), (y) => s.value.out(y, r.value, a.value)), h = Ot(e, "selected", e.selected, (y) => l.value.in(y, r.value, a.value), (y) => l.value.out(y, r.value, a.value));
  _r(() => {
    n = !0;
  });
  function v(y) {
    const b = [];
    let C = y;
    for (; C != null; )
      b.unshift(C), C = a.value.get(C);
    return b;
  }
  const m = Dt("nested"), p = {
    id: Ue(),
    root: {
      opened: o,
      activatable: Me(e, "activatable"),
      selectable: Me(e, "selectable"),
      activated: f,
      selected: h,
      selectedValues: A(() => {
        const y = [];
        for (const [b, C] of h.value.entries())
          C === "on" && y.push(b);
        return y;
      }),
      register: (y, b, C) => {
        b && y !== b && a.value.set(y, b), C && r.value.set(y, []), b != null && r.value.set(b, [...r.value.get(b) || [], y]);
      },
      unregister: (y) => {
        if (n) return;
        r.value.delete(y);
        const b = a.value.get(y);
        if (b) {
          const C = r.value.get(b) ?? [];
          r.value.set(b, C.filter((S) => S !== y));
        }
        a.value.delete(y);
      },
      open: (y, b, C) => {
        m.emit("click:open", {
          id: y,
          value: b,
          path: v(y),
          event: C
        });
        const S = c.value.open({
          id: y,
          value: b,
          opened: new Set(o.value),
          children: r.value,
          parents: a.value,
          event: C
        });
        S && (o.value = S);
      },
      openOnSelect: (y, b, C) => {
        const S = c.value.select({
          id: y,
          value: b,
          selected: new Map(h.value),
          opened: new Set(o.value),
          children: r.value,
          parents: a.value,
          event: C
        });
        S && (o.value = S);
      },
      select: (y, b, C) => {
        m.emit("click:select", {
          id: y,
          value: b,
          path: v(y),
          event: C
        });
        const S = l.value.select({
          id: y,
          value: b,
          selected: new Map(h.value),
          children: r.value,
          parents: a.value,
          event: C
        });
        S && (h.value = S), p.root.openOnSelect(y, b, C);
      },
      activate: (y, b, C) => {
        if (!e.activatable)
          return p.root.select(y, !0, C);
        m.emit("click:activate", {
          id: y,
          value: b,
          path: v(y),
          event: C
        });
        const S = s.value.activate({
          id: y,
          value: b,
          activated: new Set(f.value),
          children: r.value,
          parents: a.value,
          event: C
        });
        S && (f.value = S);
      },
      children: r,
      parents: a
    }
  };
  return Et(Ia, p), p.root;
}, cg = (e, n) => {
  const r = Ze(Ia, ug), a = Symbol(Qn()), o = A(() => e.value !== void 0 ? e.value : a), s = {
    ...r,
    id: o,
    open: (l, c) => r.root.open(o.value, l, c),
    openOnSelect: (l, c) => r.root.openOnSelect(o.value, l, c),
    isOpen: A(() => r.root.opened.value.has(o.value)),
    parent: A(() => r.root.parents.value.get(o.value)),
    activate: (l, c) => r.root.activate(o.value, l, c),
    isActivated: A(() => r.root.activated.value.has(bn(o.value))),
    select: (l, c) => r.root.select(o.value, l, c),
    isSelected: A(() => r.root.selected.value.get(bn(o.value)) === "on"),
    isIndeterminate: A(() => r.root.selected.value.get(o.value) === "indeterminate"),
    isLeaf: A(() => !r.root.children.value.get(o.value)),
    isGroupActivator: r.isGroupActivator
  };
  return !r.isGroupActivator && r.root.register(o.value, r.id.value, n), _r(() => {
    !r.isGroupActivator && r.root.unregister(o.value);
  }), n && Et(Ia, s), s;
}, ek = () => {
  const e = Ze(Ia, ug);
  Et(Ia, {
    ...e,
    isGroupActivator: !0
  });
}, tk = Oa({
  name: "VListGroupActivator",
  setup(e, n) {
    let {
      slots: r
    } = n;
    return ek(), () => r.default?.();
  }
}), nk = he({
  /* @deprecated */
  activeColor: String,
  baseColor: String,
  color: String,
  collapseIcon: {
    type: _t,
    default: "$collapse"
  },
  expandIcon: {
    type: _t,
    default: "$expand"
  },
  prependIcon: _t,
  appendIcon: _t,
  fluid: Boolean,
  subgroup: Boolean,
  title: String,
  value: null,
  ...ct(),
  ...qn()
}, "VListGroup"), ev = He()({
  name: "VListGroup",
  props: nk(),
  setup(e, n) {
    let {
      slots: r
    } = n;
    const {
      isOpen: a,
      open: o,
      id: s
    } = cg(Me(e, "value"), !0), l = A(() => `v-list-group--id-${String(s.value)}`), c = ag(), {
      isBooted: f
    } = qx();
    function h(y) {
      y.stopPropagation(), o(!a.value, y);
    }
    const v = A(() => ({
      onClick: h,
      class: "v-list-group__header",
      id: l.value
    })), m = A(() => a.value ? e.collapseIcon : e.expandIcon), p = A(() => ({
      VListItem: {
        active: a.value,
        activeColor: e.activeColor,
        baseColor: e.baseColor,
        color: e.color,
        prependIcon: e.prependIcon || e.subgroup && m.value,
        appendIcon: e.appendIcon || !e.subgroup && m.value,
        title: e.title,
        value: e.value
      }
    }));
    return tt(() => T(e.tag, {
      class: ["v-list-group", {
        "v-list-group--prepend": c?.hasPrepend.value,
        "v-list-group--fluid": e.fluid,
        "v-list-group--subgroup": e.subgroup,
        "v-list-group--open": a.value
      }, e.class],
      style: e.style
    }, {
      default: () => [r.activator && T(Fn, {
        defaults: p.value
      }, {
        default: () => [T(tk, null, {
          default: () => [r.activator({
            props: v.value,
            isOpen: a.value
          })]
        })]
      }), T(Nr, {
        transition: {
          component: Vx
        },
        disabled: !f.value
      }, {
        default: () => [Gn(T("div", {
          class: "v-list-group__items",
          role: "group",
          "aria-labelledby": l.value
        }, [r.default?.()]), [[Vi, a.value]])]
      })]
    })), {
      isOpen: a
    };
  }
}), rk = he({
  opacity: [Number, String],
  ...ct(),
  ...qn()
}, "VListItemSubtitle"), ik = He()({
  name: "VListItemSubtitle",
  props: rk(),
  setup(e, n) {
    let {
      slots: r
    } = n;
    return tt(() => T(e.tag, {
      class: ["v-list-item-subtitle", e.class],
      style: [{
        "--v-list-item-subtitle-opacity": e.opacity
      }, e.style]
    }, r)), {};
  }
}), ak = Nx("v-list-item-title"), ok = he({
  active: {
    type: Boolean,
    default: void 0
  },
  activeClass: String,
  /* @deprecated */
  activeColor: String,
  appendAvatar: String,
  appendIcon: _t,
  baseColor: String,
  disabled: Boolean,
  lines: [Boolean, String],
  link: {
    type: Boolean,
    default: void 0
  },
  nav: Boolean,
  prependAvatar: String,
  prependIcon: _t,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  slim: Boolean,
  subtitle: [String, Number],
  title: [String, Number],
  value: null,
  onClick: on(),
  onClickOnce: on(),
  ...Ju(),
  ...ct(),
  ...zi(),
  ...li(),
  ...us(),
  ...fi(),
  ...Mm(),
  ...qn(),
  ...un(),
  ...Na({
    variant: "text"
  })
}, "VListItem"), Zo = He()({
  name: "VListItem",
  directives: {
    Ripple: rc
  },
  props: ok(),
  emits: {
    click: (e) => !0
  },
  setup(e, n) {
    let {
      attrs: r,
      slots: a,
      emit: o
    } = n;
    const s = Fm(e, r), l = A(() => e.value === void 0 ? s.href.value : e.value), {
      activate: c,
      isActivated: f,
      select: h,
      isSelected: v,
      isIndeterminate: m,
      isGroupActivator: p,
      root: y,
      parent: b,
      openOnSelect: C
    } = cg(l, !1), S = ag(), R = A(() => e.active !== !1 && (e.active || s.isActive?.value || (y.activatable.value ? f.value : v.value))), $ = A(() => e.link !== !1 && s.isLink.value), k = A(() => !e.disabled && e.link !== !1 && (e.link || s.isClickable.value || !!S && (y.selectable.value || y.activatable.value || e.value != null))), L = A(() => e.rounded || e.nav), F = A(() => e.color ?? e.activeColor), P = A(() => ({
      color: R.value ? F.value ?? e.baseColor : e.baseColor,
      variant: e.variant
    }));
    Re(() => s.isActive?.value, (j) => {
      j && b.value != null && y.open(b.value, !0), j && C(j);
    }, {
      immediate: !0
    });
    const {
      themeClasses: E
    } = Dn(e), {
      borderClasses: V
    } = Zu(e), {
      colorClasses: W,
      colorStyles: me,
      variantClasses: le
    } = ec(P), {
      densityClasses: K
    } = qi(e), {
      dimensionStyles: ae
    } = ui(e), {
      elevationClasses: ue
    } = cs(e), {
      roundedClasses: Ce
    } = di(L), Se = A(() => e.lines ? `v-list-item--${e.lines}-line` : void 0), Pe = A(() => ({
      isActive: R.value,
      select: h,
      isSelected: v.value,
      isIndeterminate: m.value
    }));
    function ie(j) {
      o("click", j), k.value && (s.navigate?.(j), !p && (y.activatable.value ? c(!f.value, j) : (y.selectable.value || e.value != null) && h(!v.value, j)));
    }
    function se(j) {
      (j.key === "Enter" || j.key === " ") && (j.preventDefault(), ie(j));
    }
    return tt(() => {
      const j = $.value ? "a" : e.tag, re = a.title || e.title != null, fe = a.subtitle || e.subtitle != null, ye = !!(e.appendAvatar || e.appendIcon), Oe = !!(ye || a.append), ge = !!(e.prependAvatar || e.prependIcon), Je = !!(ge || a.prepend);
      return S?.updateHasPrepend(Je), e.activeColor && Ex("active-color", ["color", "base-color"]), Gn(T(j, {
        class: ["v-list-item", {
          "v-list-item--active": R.value,
          "v-list-item--disabled": e.disabled,
          "v-list-item--link": k.value,
          "v-list-item--nav": e.nav,
          "v-list-item--prepend": !Je && S?.hasPrepend.value,
          "v-list-item--slim": e.slim,
          [`${e.activeClass}`]: e.activeClass && R.value
        }, E.value, V.value, W.value, K.value, ue.value, Se.value, Ce.value, le.value, e.class],
        style: [me.value, ae.value, e.style],
        href: s.href.value,
        tabindex: k.value ? S ? -2 : 0 : void 0,
        onClick: ie,
        onKeydown: k.value && !$.value && se
      }, {
        default: () => [Qu(k.value || R.value, "v-list-item"), Je && T("div", {
          key: "prepend",
          class: "v-list-item__prepend"
        }, [a.prepend ? T(Fn, {
          key: "prepend-defaults",
          disabled: !ge,
          defaults: {
            VAvatar: {
              density: e.density,
              image: e.prependAvatar
            },
            VIcon: {
              density: e.density,
              icon: e.prependIcon
            },
            VListItemAction: {
              start: !0
            }
          }
        }, {
          default: () => [a.prepend?.(Pe.value)]
        }) : T(Ie, null, [e.prependAvatar && T(ka, {
          key: "prepend-avatar",
          density: e.density,
          image: e.prependAvatar
        }, null), e.prependIcon && T(_n, {
          key: "prepend-icon",
          density: e.density,
          icon: e.prependIcon
        }, null)]), T("div", {
          class: "v-list-item__spacer"
        }, null)]), T("div", {
          class: "v-list-item__content",
          "data-no-activator": ""
        }, [re && T(ak, {
          key: "title"
        }, {
          default: () => [a.title?.({
            title: e.title
          }) ?? e.title]
        }), fe && T(ik, {
          key: "subtitle"
        }, {
          default: () => [a.subtitle?.({
            subtitle: e.subtitle
          }) ?? e.subtitle]
        }), a.default?.(Pe.value)]), Oe && T("div", {
          key: "append",
          class: "v-list-item__append"
        }, [a.append ? T(Fn, {
          key: "append-defaults",
          disabled: !ye,
          defaults: {
            VAvatar: {
              density: e.density,
              image: e.appendAvatar
            },
            VIcon: {
              density: e.density,
              icon: e.appendIcon
            },
            VListItemAction: {
              end: !0
            }
          }
        }, {
          default: () => [a.append?.(Pe.value)]
        }) : T(Ie, null, [e.appendIcon && T(_n, {
          key: "append-icon",
          density: e.density,
          icon: e.appendIcon
        }, null), e.appendAvatar && T(ka, {
          key: "append-avatar",
          density: e.density,
          image: e.appendAvatar
        }, null)]), T("div", {
          class: "v-list-item__spacer"
        }, null)])]
      }), [[Bi("ripple"), k.value && e.ripple]]);
    }), {
      activate: c,
      isActivated: f,
      isGroupActivator: p,
      isSelected: v,
      list: S,
      select: h
    };
  }
}), sk = he({
  color: String,
  inset: Boolean,
  sticky: Boolean,
  title: String,
  ...ct(),
  ...qn()
}, "VListSubheader"), lk = He()({
  name: "VListSubheader",
  props: sk(),
  setup(e, n) {
    let {
      slots: r
    } = n;
    const {
      textColorClasses: a,
      textColorStyles: o
    } = ci(Me(e, "color"));
    return tt(() => {
      const s = !!(r.default || e.title);
      return T(e.tag, {
        class: ["v-list-subheader", {
          "v-list-subheader--inset": e.inset,
          "v-list-subheader--sticky": e.sticky
        }, a.value, e.class],
        style: [{
          textColorStyles: o
        }, e.style]
      }, {
        default: () => [s && T("div", {
          class: "v-list-subheader__text"
        }, [r.default?.() ?? e.title])]
      });
    }), {};
  }
}), uk = he({
  color: String,
  inset: Boolean,
  length: [Number, String],
  opacity: [Number, String],
  thickness: [Number, String],
  vertical: Boolean,
  ...ct(),
  ...un()
}, "VDivider"), ck = He()({
  name: "VDivider",
  props: uk(),
  setup(e, n) {
    let {
      attrs: r,
      slots: a
    } = n;
    const {
      themeClasses: o
    } = Dn(e), {
      textColorClasses: s,
      textColorStyles: l
    } = ci(Me(e, "color")), c = A(() => {
      const f = {};
      return e.length && (f[e.vertical ? "height" : "width"] = Ge(e.length)), e.thickness && (f[e.vertical ? "borderRightWidth" : "borderTopWidth"] = Ge(e.thickness)), f;
    });
    return tt(() => {
      const f = T("hr", {
        class: [{
          "v-divider": !0,
          "v-divider--inset": e.inset,
          "v-divider--vertical": e.vertical
        }, o.value, s.value, e.class],
        style: [c.value, l.value, {
          "--v-border-opacity": e.opacity
        }, e.style],
        "aria-orientation": !r.role || r.role === "separator" ? e.vertical ? "vertical" : "horizontal" : void 0,
        role: `${r.role || "separator"}`
      }, null);
      return a.default ? T("div", {
        class: ["v-divider__wrapper", {
          "v-divider__wrapper--vertical": e.vertical,
          "v-divider__wrapper--inset": e.inset
        }]
      }, [f, T("div", {
        class: "v-divider__content"
      }, [a.default()]), f]) : f;
    }), {};
  }
}), fk = he({
  items: Array,
  returnObject: Boolean
}, "VListChildren"), fg = He()({
  name: "VListChildren",
  props: fk(),
  setup(e, n) {
    let {
      slots: r
    } = n;
    return ig(), () => r.default?.() ?? e.items?.map((a) => {
      let {
        children: o,
        props: s,
        type: l,
        raw: c
      } = a;
      if (l === "divider")
        return r.divider?.({
          props: s
        }) ?? T(ck, s, null);
      if (l === "subheader")
        return r.subheader?.({
          props: s
        }) ?? T(lk, s, null);
      const f = {
        subtitle: r.subtitle ? (v) => r.subtitle?.({
          ...v,
          item: c
        }) : void 0,
        prepend: r.prepend ? (v) => r.prepend?.({
          ...v,
          item: c
        }) : void 0,
        append: r.append ? (v) => r.append?.({
          ...v,
          item: c
        }) : void 0,
        title: r.title ? (v) => r.title?.({
          ...v,
          item: c
        }) : void 0
      }, h = ev.filterProps(s);
      return o ? T(ev, Te({
        value: s?.value
      }, h), {
        activator: (v) => {
          let {
            props: m
          } = v;
          const p = {
            ...s,
            ...m,
            value: e.returnObject ? c : s.value
          };
          return r.header ? r.header({
            props: p
          }) : T(Zo, p, f);
        },
        default: () => T(fg, {
          items: o,
          returnObject: e.returnObject
        }, r)
      }) : r.item ? r.item({
        props: s
      }) : T(Zo, Te(s, {
        value: e.returnObject ? c : s.value
      }), f);
    });
  }
}), dg = he({
  items: {
    type: Array,
    default: () => []
  },
  itemTitle: {
    type: [String, Array, Function],
    default: "title"
  },
  itemValue: {
    type: [String, Array, Function],
    default: "value"
  },
  itemChildren: {
    type: [Boolean, String, Array, Function],
    default: "children"
  },
  itemProps: {
    type: [Boolean, String, Array, Function],
    default: "props"
  },
  returnObject: Boolean,
  valueComparator: {
    type: Function,
    default: Gi
  }
}, "list-items");
function yu(e, n) {
  const r = hr(n, e.itemTitle, n), a = hr(n, e.itemValue, r), o = hr(n, e.itemChildren), s = e.itemProps === !0 ? typeof n == "object" && n != null && !Array.isArray(n) ? "children" in n ? oi(n, ["children"]) : n : void 0 : hr(n, e.itemProps), l = {
    title: r,
    value: a,
    ...s
  };
  return {
    title: String(l.title ?? ""),
    value: l.value,
    props: l,
    children: Array.isArray(o) ? hg(e, o) : void 0,
    raw: n
  };
}
function hg(e, n) {
  const r = [];
  for (const a of n)
    r.push(yu(e, a));
  return r;
}
function dk(e) {
  const n = A(() => hg(e, e.items)), r = A(() => n.value.some((s) => s.value === null));
  function a(s) {
    return r.value || (s = s.filter((l) => l !== null)), s.map((l) => e.returnObject && typeof l == "string" ? yu(e, l) : n.value.find((c) => e.valueComparator(l, c.value)) || yu(e, l));
  }
  function o(s) {
    return e.returnObject ? s.map((l) => {
      let {
        raw: c
      } = l;
      return c;
    }) : s.map((l) => {
      let {
        value: c
      } = l;
      return c;
    });
  }
  return {
    items: n,
    transformIn: a,
    transformOut: o
  };
}
function hk(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean";
}
function vk(e, n) {
  const r = hr(n, e.itemType, "item"), a = hk(n) ? n : hr(n, e.itemTitle), o = hr(n, e.itemValue, void 0), s = hr(n, e.itemChildren), l = e.itemProps === !0 ? oi(n, ["children"]) : hr(n, e.itemProps), c = {
    title: a,
    value: o,
    ...l
  };
  return {
    type: r,
    title: c.title,
    value: c.value,
    props: c,
    children: r === "item" && s ? vg(e, s) : void 0,
    raw: n
  };
}
function vg(e, n) {
  const r = [];
  for (const a of n)
    r.push(vk(e, a));
  return r;
}
function mk(e) {
  return {
    items: A(() => vg(e, e.items))
  };
}
const gk = he({
  baseColor: String,
  /* @deprecated */
  activeColor: String,
  activeClass: String,
  bgColor: String,
  disabled: Boolean,
  expandIcon: String,
  collapseIcon: String,
  lines: {
    type: [Boolean, String],
    default: "one"
  },
  slim: Boolean,
  nav: Boolean,
  "onClick:open": on(),
  "onClick:select": on(),
  "onUpdate:opened": on(),
  ...ZA({
    selectStrategy: "single-leaf",
    openStrategy: "list"
  }),
  ...Ju(),
  ...ct(),
  ...zi(),
  ...li(),
  ...us(),
  itemType: {
    type: String,
    default: "type"
  },
  ...dg(),
  ...fi(),
  ...qn(),
  ...un(),
  ...Na({
    variant: "text"
  })
}, "VList"), pk = He()({
  name: "VList",
  props: gk(),
  emits: {
    "update:selected": (e) => !0,
    "update:activated": (e) => !0,
    "update:opened": (e) => !0,
    "click:open": (e) => !0,
    "click:activate": (e) => !0,
    "click:select": (e) => !0
  },
  setup(e, n) {
    let {
      slots: r
    } = n;
    const {
      items: a
    } = mk(e), {
      themeClasses: o
    } = Dn(e), {
      backgroundColorClasses: s,
      backgroundColorStyles: l
    } = pr(Me(e, "bgColor")), {
      borderClasses: c
    } = Zu(e), {
      densityClasses: f
    } = qi(e), {
      dimensionStyles: h
    } = ui(e), {
      elevationClasses: v
    } = cs(e), {
      roundedClasses: m
    } = di(e), {
      children: p,
      open: y,
      parents: b,
      select: C
    } = QA(e), S = A(() => e.lines ? `v-list--${e.lines}-line` : void 0), R = Me(e, "activeColor"), $ = Me(e, "baseColor"), k = Me(e, "color");
    ig(), ss({
      VListGroup: {
        activeColor: R,
        baseColor: $,
        color: k,
        expandIcon: Me(e, "expandIcon"),
        collapseIcon: Me(e, "collapseIcon")
      },
      VListItem: {
        activeClass: Me(e, "activeClass"),
        activeColor: R,
        baseColor: $,
        color: k,
        density: Me(e, "density"),
        disabled: Me(e, "disabled"),
        lines: Me(e, "lines"),
        nav: Me(e, "nav"),
        slim: Me(e, "slim"),
        variant: Me(e, "variant")
      }
    });
    const L = Ue(!1), F = oe();
    function P(K) {
      L.value = !0;
    }
    function E(K) {
      L.value = !1;
    }
    function V(K) {
      !L.value && !(K.relatedTarget && F.value?.contains(K.relatedTarget)) && le();
    }
    function W(K) {
      const ae = K.target;
      if (!(!F.value || ["INPUT", "TEXTAREA"].includes(ae.tagName))) {
        if (K.key === "ArrowDown")
          le("next");
        else if (K.key === "ArrowUp")
          le("prev");
        else if (K.key === "Home")
          le("first");
        else if (K.key === "End")
          le("last");
        else
          return;
        K.preventDefault();
      }
    }
    function me(K) {
      L.value = !0;
    }
    function le(K) {
      if (F.value)
        return zo(F.value, K);
    }
    return tt(() => T(e.tag, {
      ref: F,
      class: ["v-list", {
        "v-list--disabled": e.disabled,
        "v-list--nav": e.nav,
        "v-list--slim": e.slim
      }, o.value, s.value, c.value, f.value, v.value, S.value, m.value, e.class],
      style: [l.value, h.value, e.style],
      tabindex: e.disabled || L.value ? -1 : 0,
      role: "listbox",
      "aria-activedescendant": void 0,
      onFocusin: P,
      onFocusout: E,
      onFocus: V,
      onKeydown: W,
      onMousedown: me
    }, {
      default: () => [T(fg, {
        items: a.value,
        returnObject: e.returnObject
      }, r)]
    })), {
      open: y,
      select: C,
      focus: le,
      children: p,
      parents: b
    };
  }
});
function Gl(e, n) {
  return {
    x: e.x + n.x,
    y: e.y + n.y
  };
}
function _k(e, n) {
  return {
    x: e.x - n.x,
    y: e.y - n.y
  };
}
function tv(e, n) {
  if (e.side === "top" || e.side === "bottom") {
    const {
      side: r,
      align: a
    } = e, o = a === "left" ? 0 : a === "center" ? n.width / 2 : a === "right" ? n.width : a, s = r === "top" ? 0 : r === "bottom" ? n.height : r;
    return Gl({
      x: o,
      y: s
    }, n);
  } else if (e.side === "left" || e.side === "right") {
    const {
      side: r,
      align: a
    } = e, o = r === "left" ? 0 : r === "right" ? n.width : r, s = a === "top" ? 0 : a === "center" ? n.height / 2 : a === "bottom" ? n.height : a;
    return Gl({
      x: o,
      y: s
    }, n);
  }
  return Gl({
    x: n.width / 2,
    y: n.height / 2
  }, n);
}
const mg = {
  static: wk,
  // specific viewport position, usually centered
  connected: Sk
  // connected to a certain element
}, yk = he({
  locationStrategy: {
    type: [String, Function],
    default: "static",
    validator: (e) => typeof e == "function" || e in mg
  },
  location: {
    type: String,
    default: "bottom"
  },
  origin: {
    type: String,
    default: "auto"
  },
  offset: [Number, String, Array]
}, "VOverlay-location-strategies");
function bk(e, n) {
  const r = oe({}), a = oe();
  Pt && ri(() => !!(n.isActive.value && e.locationStrategy), (s) => {
    Re(() => e.locationStrategy, s), Zt(() => {
      window.removeEventListener("resize", o), a.value = void 0;
    }), window.addEventListener("resize", o, {
      passive: !0
    }), typeof e.locationStrategy == "function" ? a.value = e.locationStrategy(n, e, r)?.updateLocation : a.value = mg[e.locationStrategy](n, e, r)?.updateLocation;
  });
  function o(s) {
    a.value?.(s);
  }
  return {
    contentStyles: r,
    updateLocation: a
  };
}
function wk() {
}
function Ck(e, n) {
  n ? e.style.removeProperty("left") : e.style.removeProperty("right");
  const r = qu(e);
  return n ? r.x += parseFloat(e.style.right || 0) : r.x -= parseFloat(e.style.left || 0), r.y -= parseFloat(e.style.top || 0), r;
}
function Sk(e, n, r) {
  (Array.isArray(e.target.value) || Dx(e.target.value)) && Object.assign(r.value, {
    position: "fixed",
    top: 0,
    [e.isRtl.value ? "right" : "left"]: 0
  });
  const {
    preferredAnchor: o,
    preferredOrigin: s
  } = zu(() => {
    const b = vu(n.location, e.isRtl.value), C = n.origin === "overlap" ? b : n.origin === "auto" ? Vl(b) : vu(n.origin, e.isRtl.value);
    return b.side === C.side && b.align === Ul(C).align ? {
      preferredAnchor: kh(b),
      preferredOrigin: kh(C)
    } : {
      preferredAnchor: b,
      preferredOrigin: C
    };
  }), [l, c, f, h] = ["minWidth", "minHeight", "maxWidth", "maxHeight"].map((b) => A(() => {
    const C = parseFloat(n[b]);
    return isNaN(C) ? 1 / 0 : C;
  })), v = A(() => {
    if (Array.isArray(n.offset))
      return n.offset;
    if (typeof n.offset == "string") {
      const b = n.offset.split(" ").map(parseFloat);
      return b.length < 2 && b.push(0), b;
    }
    return typeof n.offset == "number" ? [n.offset, 0] : [0, 0];
  });
  let m = !1;
  const p = new ResizeObserver(() => {
    m && y();
  });
  Re([e.target, e.contentEl], (b, C) => {
    let [S, R] = b, [$, k] = C;
    $ && !Array.isArray($) && p.unobserve($), S && !Array.isArray(S) && p.observe(S), k && p.unobserve(k), R && p.observe(R);
  }, {
    immediate: !0
  }), Zt(() => {
    p.disconnect();
  });
  function y() {
    if (m = !1, requestAnimationFrame(() => m = !0), !e.target.value || !e.contentEl.value) return;
    const b = ym(e.target.value), C = Ck(e.contentEl.value, e.isRtl.value), S = Yo(e.contentEl.value), R = 12;
    S.length || (S.push(document.documentElement), e.contentEl.value.style.top && e.contentEl.value.style.left || (C.x -= parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-x") || 0), C.y -= parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-y") || 0)));
    const $ = S.reduce((le, K) => {
      const ae = K.getBoundingClientRect(), ue = new Zr({
        x: K === document.documentElement ? 0 : ae.x,
        y: K === document.documentElement ? 0 : ae.y,
        width: K.clientWidth,
        height: K.clientHeight
      });
      return le ? new Zr({
        x: Math.max(le.left, ue.left),
        y: Math.max(le.top, ue.top),
        width: Math.min(le.right, ue.right) - Math.max(le.left, ue.left),
        height: Math.min(le.bottom, ue.bottom) - Math.max(le.top, ue.top)
      }) : ue;
    }, void 0);
    $.x += R, $.y += R, $.width -= R * 2, $.height -= R * 2;
    let k = {
      anchor: o.value,
      origin: s.value
    };
    function L(le) {
      const K = new Zr(C), ae = tv(le.anchor, b), ue = tv(le.origin, K);
      let {
        x: Ce,
        y: Se
      } = _k(ae, ue);
      switch (le.anchor.side) {
        case "top":
          Se -= v.value[0];
          break;
        case "bottom":
          Se += v.value[0];
          break;
        case "left":
          Ce -= v.value[0];
          break;
        case "right":
          Ce += v.value[0];
          break;
      }
      switch (le.anchor.align) {
        case "top":
          Se -= v.value[1];
          break;
        case "bottom":
          Se += v.value[1];
          break;
        case "left":
          Ce -= v.value[1];
          break;
        case "right":
          Ce += v.value[1];
          break;
      }
      return K.x += Ce, K.y += Se, K.width = Math.min(K.width, f.value), K.height = Math.min(K.height, h.value), {
        overflows: Ih(K, $),
        x: Ce,
        y: Se
      };
    }
    let F = 0, P = 0;
    const E = {
      x: 0,
      y: 0
    }, V = {
      x: !1,
      y: !1
    };
    let W = -1;
    for (; ; ) {
      if (W++ > 10) {
        Sx("Infinite loop detected in connectedLocationStrategy");
        break;
      }
      const {
        x: le,
        y: K,
        overflows: ae
      } = L(k);
      F += le, P += K, C.x += le, C.y += K;
      {
        const ue = Th(k.anchor), Ce = ae.x.before || ae.x.after, Se = ae.y.before || ae.y.after;
        let Pe = !1;
        if (["x", "y"].forEach((ie) => {
          if (ie === "x" && Ce && !V.x || ie === "y" && Se && !V.y) {
            const se = {
              anchor: {
                ...k.anchor
              },
              origin: {
                ...k.origin
              }
            }, j = ie === "x" ? ue === "y" ? Ul : Vl : ue === "y" ? Vl : Ul;
            se.anchor = j(se.anchor), se.origin = j(se.origin);
            const {
              overflows: re
            } = L(se);
            (re[ie].before <= ae[ie].before && re[ie].after <= ae[ie].after || re[ie].before + re[ie].after < (ae[ie].before + ae[ie].after) / 2) && (k = se, Pe = V[ie] = !0);
          }
        }), Pe) continue;
      }
      ae.x.before && (F += ae.x.before, C.x += ae.x.before), ae.x.after && (F -= ae.x.after, C.x -= ae.x.after), ae.y.before && (P += ae.y.before, C.y += ae.y.before), ae.y.after && (P -= ae.y.after, C.y -= ae.y.after);
      {
        const ue = Ih(C, $);
        E.x = $.width - ue.x.before - ue.x.after, E.y = $.height - ue.y.before - ue.y.after, F += ue.x.before, C.x += ue.x.before, P += ue.y.before, C.y += ue.y.before;
      }
      break;
    }
    const me = Th(k.anchor);
    return Object.assign(r.value, {
      "--v-overlay-anchor-origin": `${k.anchor.side} ${k.anchor.align}`,
      transformOrigin: `${k.origin.side} ${k.origin.align}`,
      // transform: `translate(${pixelRound(x)}px, ${pixelRound(y)}px)`,
      top: Ge(zl(P)),
      left: e.isRtl.value ? void 0 : Ge(zl(F)),
      right: e.isRtl.value ? Ge(zl(-F)) : void 0,
      minWidth: Ge(me === "y" ? Math.min(l.value, b.width) : l.value),
      maxWidth: Ge(nv(Fr(E.x, l.value === 1 / 0 ? 0 : l.value, f.value))),
      maxHeight: Ge(nv(Fr(E.y, c.value === 1 / 0 ? 0 : c.value, h.value)))
    }), {
      available: E,
      contentBox: C
    };
  }
  return Re(() => [o.value, s.value, n.offset, n.minWidth, n.minHeight, n.maxWidth, n.maxHeight], () => y()), Jt(() => {
    const b = y();
    if (!b) return;
    const {
      available: C,
      contentBox: S
    } = b;
    S.height > C.y && requestAnimationFrame(() => {
      y(), requestAnimationFrame(() => {
        y();
      });
    });
  }), {
    updateLocation: y
  };
}
function zl(e) {
  return Math.round(e * devicePixelRatio) / devicePixelRatio;
}
function nv(e) {
  return Math.ceil(e * devicePixelRatio) / devicePixelRatio;
}
let bu = !0;
const Qo = [];
function Ek(e) {
  !bu || Qo.length ? (Qo.push(e), wu()) : (bu = !1, e(), wu());
}
let rv = -1;
function wu() {
  cancelAnimationFrame(rv), rv = requestAnimationFrame(() => {
    const e = Qo.shift();
    e && e(), Qo.length ? wu() : bu = !0;
  });
}
const gg = {
  none: null,
  close: kk,
  block: Tk,
  reposition: Ik
}, xk = he({
  scrollStrategy: {
    type: [String, Function],
    default: "block",
    validator: (e) => typeof e == "function" || e in gg
  }
}, "VOverlay-scroll-strategies");
function Ak(e, n) {
  if (!Pt) return;
  let r;
  Mr(async () => {
    r?.stop(), n.isActive.value && e.scrollStrategy && (r = Ru(), await new Promise((a) => setTimeout(a)), r.active && r.run(() => {
      typeof e.scrollStrategy == "function" ? e.scrollStrategy(n, e, r) : gg[e.scrollStrategy]?.(n, e, r);
    }));
  }), Zt(() => {
    r?.stop();
  });
}
function kk(e) {
  function n(r) {
    e.isActive.value = !1;
  }
  pg(e.targetEl.value ?? e.contentEl.value, n);
}
function Tk(e, n) {
  const r = e.root.value?.offsetParent, a = [.../* @__PURE__ */ new Set([...Yo(e.targetEl.value, n.contained ? r : void 0), ...Yo(e.contentEl.value, n.contained ? r : void 0)])].filter((l) => !l.classList.contains("v-overlay-scroll-blocked")), o = window.innerWidth - document.documentElement.offsetWidth, s = ((l) => ju(l) && l)(r || document.documentElement);
  s && e.root.value.classList.add("v-overlay--scroll-blocked"), a.forEach((l, c) => {
    l.style.setProperty("--v-body-scroll-x", Ge(-l.scrollLeft)), l.style.setProperty("--v-body-scroll-y", Ge(-l.scrollTop)), l !== document.documentElement && l.style.setProperty("--v-scrollbar-offset", Ge(o)), l.classList.add("v-overlay-scroll-blocked");
  }), Zt(() => {
    a.forEach((l, c) => {
      const f = parseFloat(l.style.getPropertyValue("--v-body-scroll-x")), h = parseFloat(l.style.getPropertyValue("--v-body-scroll-y")), v = l.style.scrollBehavior;
      l.style.scrollBehavior = "auto", l.style.removeProperty("--v-body-scroll-x"), l.style.removeProperty("--v-body-scroll-y"), l.style.removeProperty("--v-scrollbar-offset"), l.classList.remove("v-overlay-scroll-blocked"), l.scrollLeft = -f, l.scrollTop = -h, l.style.scrollBehavior = v;
    }), s && e.root.value.classList.remove("v-overlay--scroll-blocked");
  });
}
function Ik(e, n, r) {
  let a = !1, o = -1, s = -1;
  function l(c) {
    Ek(() => {
      const f = performance.now();
      e.updateLocation.value?.(c), a = (performance.now() - f) / (1e3 / 60) > 2;
    });
  }
  s = (typeof requestIdleCallback > "u" ? (c) => c() : requestIdleCallback)(() => {
    r.run(() => {
      pg(e.targetEl.value ?? e.contentEl.value, (c) => {
        a ? (cancelAnimationFrame(o), o = requestAnimationFrame(() => {
          o = requestAnimationFrame(() => {
            l(c);
          });
        })) : l(c);
      });
    });
  }), Zt(() => {
    typeof cancelIdleCallback < "u" && cancelIdleCallback(s), cancelAnimationFrame(o);
  });
}
function pg(e, n) {
  const r = [document, ...Yo(e)];
  r.forEach((a) => {
    a.addEventListener("scroll", n, {
      passive: !0
    });
  }), Zt(() => {
    r.forEach((a) => {
      a.removeEventListener("scroll", n);
    });
  });
}
const Cu = Symbol.for("vuetify:v-menu"), Lk = he({
  closeDelay: [Number, String],
  openDelay: [Number, String]
}, "delay");
function Ok(e, n) {
  let r = () => {
  };
  function a(l) {
    r?.();
    const c = Number(l ? e.openDelay : e.closeDelay);
    return new Promise((f) => {
      r = fx(c, () => {
        n?.(l), f(l);
      });
    });
  }
  function o() {
    return a(!0);
  }
  function s() {
    return a(!1);
  }
  return {
    clearDelay: r,
    runOpenDelay: o,
    runCloseDelay: s
  };
}
const Pk = he({
  target: [String, Object],
  activator: [String, Object],
  activatorProps: {
    type: Object,
    default: () => ({})
  },
  openOnClick: {
    type: Boolean,
    default: void 0
  },
  openOnHover: Boolean,
  openOnFocus: {
    type: Boolean,
    default: void 0
  },
  closeOnContentClick: Boolean,
  ...Lk()
}, "VOverlay-activator");
function Nk(e, n) {
  let {
    isActive: r,
    isTop: a
  } = n;
  const o = Dt("useActivator"), s = oe();
  let l = !1, c = !1, f = !0;
  const h = A(() => e.openOnFocus || e.openOnFocus == null && e.openOnHover), v = A(() => e.openOnClick || e.openOnClick == null && !e.openOnHover && !h.value), {
    runOpenDelay: m,
    runCloseDelay: p
  } = Ok(e, (E) => {
    E === (e.openOnHover && l || h.value && c) && !(e.openOnHover && r.value && !a.value) && (r.value !== E && (f = !0), r.value = E);
  }), y = oe(), b = {
    onClick: (E) => {
      E.stopPropagation(), s.value = E.currentTarget || E.target, r.value || (y.value = [E.clientX, E.clientY]), r.value = !r.value;
    },
    onMouseenter: (E) => {
      E.sourceCapabilities?.firesTouchEvents || (l = !0, s.value = E.currentTarget || E.target, m());
    },
    onMouseleave: (E) => {
      l = !1, p();
    },
    onFocus: (E) => {
      qo(E.target, ":focus-visible") !== !1 && (c = !0, E.stopPropagation(), s.value = E.currentTarget || E.target, m());
    },
    onBlur: (E) => {
      c = !1, E.stopPropagation(), p();
    }
  }, C = A(() => {
    const E = {};
    return v.value && (E.onClick = b.onClick), e.openOnHover && (E.onMouseenter = b.onMouseenter, E.onMouseleave = b.onMouseleave), h.value && (E.onFocus = b.onFocus, E.onBlur = b.onBlur), E;
  }), S = A(() => {
    const E = {};
    if (e.openOnHover && (E.onMouseenter = () => {
      l = !0, m();
    }, E.onMouseleave = () => {
      l = !1, p();
    }), h.value && (E.onFocusin = () => {
      c = !0, m();
    }, E.onFocusout = () => {
      c = !1, p();
    }), e.closeOnContentClick) {
      const V = Ze(Cu, null);
      E.onClick = () => {
        r.value = !1, V?.closeParents();
      };
    }
    return E;
  }), R = A(() => {
    const E = {};
    return e.openOnHover && (E.onMouseenter = () => {
      f && (l = !0, f = !1, m());
    }, E.onMouseleave = () => {
      l = !1, p();
    }), E;
  });
  Re(a, (E) => {
    E && (e.openOnHover && !l && (!h.value || !c) || h.value && !c && (!e.openOnHover || !l)) && (r.value = !1);
  }), Re(r, (E) => {
    E || setTimeout(() => {
      y.value = void 0;
    });
  }, {
    flush: "post"
  });
  const $ = hu();
  Mr(() => {
    $.value && Jt(() => {
      s.value = $.el;
    });
  });
  const k = hu(), L = A(() => e.target === "cursor" && y.value ? y.value : k.value ? k.el : _g(e.target, o) || s.value), F = A(() => Array.isArray(L.value) ? void 0 : L.value);
  let P;
  return Re(() => !!e.activator, (E) => {
    E && Pt ? (P = Ru(), P.run(() => {
      Rk(e, o, {
        activatorEl: s,
        activatorEvents: C
      });
    })) : P && P.stop();
  }, {
    flush: "post",
    immediate: !0
  }), Zt(() => {
    P?.stop();
  }), {
    activatorEl: s,
    activatorRef: $,
    target: L,
    targetEl: F,
    targetRef: k,
    activatorEvents: C,
    contentEvents: S,
    scrimEvents: R
  };
}
function Rk(e, n, r) {
  let {
    activatorEl: a,
    activatorEvents: o
  } = r;
  Re(() => e.activator, (f, h) => {
    if (h && f !== h) {
      const v = c(h);
      v && l(v);
    }
    f && Jt(() => s());
  }, {
    immediate: !0
  }), Re(() => e.activatorProps, () => {
    s();
  }), Zt(() => {
    l();
  });
  function s() {
    let f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : c(), h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.activatorProps;
    f && vx(f, Te(o.value, h));
  }
  function l() {
    let f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : c(), h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.activatorProps;
    f && mx(f, Te(o.value, h));
  }
  function c() {
    let f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e.activator;
    const h = _g(f, n);
    return a.value = h?.nodeType === Node.ELEMENT_NODE ? h : void 0, a.value;
  }
}
function _g(e, n) {
  if (!e) return;
  let r;
  if (e === "parent") {
    let a = n?.proxy?.$el?.parentNode;
    for (; a?.hasAttribute("data-no-activator"); )
      a = a.parentNode;
    r = a;
  } else typeof e == "string" ? r = document.querySelector(e) : "$el" in e ? r = e.$el : r = e;
  return r;
}
function Fk() {
  if (!Pt) return Ue(!1);
  const {
    ssr: e
  } = ic();
  if (e) {
    const n = Ue(!1);
    return qt(() => {
      n.value = !0;
    }), n;
  } else
    return Ue(!0);
}
const Mk = he({
  eager: Boolean
}, "lazy");
function Dk(e, n) {
  const r = Ue(!1), a = A(() => r.value || e.eager || n.value);
  Re(n, () => r.value = !0);
  function o() {
    e.eager || (r.value = !1);
  }
  return {
    isBooted: r,
    hasContent: a,
    onAfterLeave: o
  };
}
function ds() {
  const n = Dt("useScopeId").vnode.scopeId;
  return {
    scopeId: n ? {
      [n]: ""
    } : void 0
  };
}
const iv = Symbol.for("vuetify:stack"), ma = mr([]);
function $k(e, n, r) {
  const a = Dt("useStack"), o = !r, s = Ze(iv, void 0), l = mr({
    activeChildren: /* @__PURE__ */ new Set()
  });
  Et(iv, l);
  const c = Ue(+n.value);
  ri(e, () => {
    const v = ma.at(-1)?.[1];
    c.value = v ? v + 10 : +n.value, o && ma.push([a.uid, c.value]), s?.activeChildren.add(a.uid), Zt(() => {
      if (o) {
        const m = bn(ma).findIndex((p) => p[0] === a.uid);
        ma.splice(m, 1);
      }
      s?.activeChildren.delete(a.uid);
    });
  });
  const f = Ue(!0);
  o && Mr(() => {
    const v = ma.at(-1)?.[0] === a.uid;
    setTimeout(() => f.value = v);
  });
  const h = A(() => !l.activeChildren.size);
  return {
    globalTop: Nu(f),
    localTop: h,
    stackStyles: A(() => ({
      zIndex: c.value
    }))
  };
}
function Bk(e) {
  return {
    teleportTarget: A(() => {
      const r = e();
      if (r === !0 || !Pt) return;
      const a = r === !1 ? document.body : typeof r == "string" ? document.querySelector(r) : r;
      if (a == null) {
        ns(`Unable to locate target ${r}`);
        return;
      }
      let o = a.querySelector(":scope > .v-overlay-container");
      return o || (o = document.createElement("div"), o.className = "v-overlay-container", a.appendChild(o)), o;
    })
  };
}
function Vk() {
  return !0;
}
function yg(e, n, r) {
  if (!e || bg(e, r) === !1) return !1;
  const a = Cm(n);
  if (typeof ShadowRoot < "u" && a instanceof ShadowRoot && a.host === e.target) return !1;
  const o = (typeof r.value == "object" && r.value.include || (() => []))();
  return o.push(n), !o.some((s) => s?.contains(e.target));
}
function bg(e, n) {
  return (typeof n.value == "object" && n.value.closeConditional || Vk)(e);
}
function Uk(e, n, r) {
  const a = typeof r.value == "function" ? r.value : r.value.handler;
  n._clickOutside.lastMousedownWasOutside && yg(e, n, r) && setTimeout(() => {
    bg(e, r) && a && a(e);
  }, 0);
}
function av(e, n) {
  const r = Cm(e);
  n(document), typeof ShadowRoot < "u" && r instanceof ShadowRoot && n(r);
}
const Wk = {
  // [data-app] may not be found
  // if using bind, inserted makes
  // sure that the root element is
  // available, iOS does not support
  // clicks on body
  mounted(e, n) {
    const r = (o) => Uk(o, e, n), a = (o) => {
      e._clickOutside.lastMousedownWasOutside = yg(o, e, n);
    };
    av(e, (o) => {
      o.addEventListener("click", r, !0), o.addEventListener("mousedown", a, !0);
    }), e._clickOutside || (e._clickOutside = {
      lastMousedownWasOutside: !1
    }), e._clickOutside[n.instance.$.uid] = {
      onClick: r,
      onMousedown: a
    };
  },
  unmounted(e, n) {
    e._clickOutside && (av(e, (r) => {
      if (!r || !e._clickOutside?.[n.instance.$.uid]) return;
      const {
        onClick: a,
        onMousedown: o
      } = e._clickOutside[n.instance.$.uid];
      r.removeEventListener("click", a, !0), r.removeEventListener("mousedown", o, !0);
    }), delete e._clickOutside[n.instance.$.uid]);
  }
};
function Hk(e) {
  const {
    modelValue: n,
    color: r,
    ...a
  } = e;
  return T(ti, {
    name: "fade-transition",
    appear: !0
  }, {
    default: () => [e.modelValue && T("div", Te({
      class: ["v-overlay__scrim", e.color.backgroundColorClasses.value],
      style: e.color.backgroundColorStyles.value
    }, a), null)]
  });
}
const hs = he({
  absolute: Boolean,
  attach: [Boolean, String, Object],
  closeOnBack: {
    type: Boolean,
    default: !0
  },
  contained: Boolean,
  contentClass: null,
  contentProps: null,
  disabled: Boolean,
  opacity: [Number, String],
  noClickAnimation: Boolean,
  modelValue: Boolean,
  persistent: Boolean,
  scrim: {
    type: [Boolean, String],
    default: !0
  },
  zIndex: {
    type: [Number, String],
    default: 2e3
  },
  ...Pk(),
  ...ct(),
  ...li(),
  ...Mk(),
  ...yk(),
  ...xk(),
  ...un(),
  ...Pa()
}, "VOverlay"), Mi = He()({
  name: "VOverlay",
  directives: {
    ClickOutside: Wk
  },
  inheritAttrs: !1,
  props: {
    _disableGlobalStack: Boolean,
    ...hs()
  },
  emits: {
    "click:outside": (e) => !0,
    "update:modelValue": (e) => !0,
    afterEnter: () => !0,
    afterLeave: () => !0
  },
  setup(e, n) {
    let {
      slots: r,
      attrs: a,
      emit: o
    } = n;
    const s = Ot(e, "modelValue"), l = A({
      get: () => s.value,
      set: (ge) => {
        ge && e.disabled || (s.value = ge);
      }
    }), {
      themeClasses: c
    } = Dn(e), {
      rtlClasses: f,
      isRtl: h
    } = si(), {
      hasContent: v,
      onAfterLeave: m
    } = Dk(e, l), p = pr(A(() => typeof e.scrim == "string" ? e.scrim : null)), {
      globalTop: y,
      localTop: b,
      stackStyles: C
    } = $k(l, Me(e, "zIndex"), e._disableGlobalStack), {
      activatorEl: S,
      activatorRef: R,
      target: $,
      targetEl: k,
      targetRef: L,
      activatorEvents: F,
      contentEvents: P,
      scrimEvents: E
    } = Nk(e, {
      isActive: l,
      isTop: b
    }), {
      teleportTarget: V
    } = Bk(() => {
      const ge = e.attach || e.contained;
      if (ge) return ge;
      const Je = S?.value?.getRootNode();
      return Je instanceof ShadowRoot ? Je : !1;
    }), {
      dimensionStyles: W
    } = ui(e), me = Fk(), {
      scopeId: le
    } = ds();
    Re(() => e.disabled, (ge) => {
      ge && (l.value = !1);
    });
    const K = oe(), ae = oe(), ue = oe(), {
      contentStyles: Ce,
      updateLocation: Se
    } = bk(e, {
      isRtl: h,
      contentEl: ue,
      target: $,
      isActive: l
    });
    Ak(e, {
      root: K,
      contentEl: ue,
      targetEl: k,
      isActive: l,
      updateLocation: Se
    });
    function Pe(ge) {
      o("click:outside", ge), e.persistent ? fe() : l.value = !1;
    }
    function ie(ge) {
      return l.value && y.value && // If using scrim, only close if clicking on it rather than anything opened on top
      (!e.scrim || ge.target === ae.value);
    }
    Pt && Re(l, (ge) => {
      ge ? window.addEventListener("keydown", se) : window.removeEventListener("keydown", se);
    }, {
      immediate: !0
    }), _r(() => {
      Pt && window.removeEventListener("keydown", se);
    });
    function se(ge) {
      ge.key === "Escape" && y.value && (e.persistent ? fe() : (l.value = !1, ue.value?.contains(document.activeElement) && S.value?.focus()));
    }
    const j = hA();
    ri(() => e.closeOnBack, () => {
      vA(j, (ge) => {
        y.value && l.value ? (ge(!1), e.persistent ? fe() : l.value = !1) : ge();
      });
    });
    const re = oe();
    Re(() => l.value && (e.absolute || e.contained) && V.value == null, (ge) => {
      if (ge) {
        const Je = Sm(K.value);
        Je && Je !== document.scrollingElement && (re.value = Je.scrollTop);
      }
    });
    function fe() {
      e.noClickAnimation || ue.value && Li(ue.value, [{
        transformOrigin: "center"
      }, {
        transform: "scale(1.03)"
      }, {
        transformOrigin: "center"
      }], {
        duration: 150,
        easing: jo
      });
    }
    function ye() {
      o("afterEnter");
    }
    function Oe() {
      m(), o("afterLeave");
    }
    return tt(() => T(Ie, null, [r.activator?.({
      isActive: l.value,
      targetRef: L,
      props: Te({
        ref: R
      }, F.value, e.activatorProps)
    }), me.value && v.value && T(BC, {
      disabled: !V.value,
      to: V.value
    }, {
      default: () => [T("div", Te({
        class: ["v-overlay", {
          "v-overlay--absolute": e.absolute || e.contained,
          "v-overlay--active": l.value,
          "v-overlay--contained": e.contained
        }, c.value, f.value, e.class],
        style: [C.value, {
          "--v-overlay-opacity": e.opacity,
          top: Ge(re.value)
        }, e.style],
        ref: K
      }, le, a), [T(Hk, Te({
        color: p,
        modelValue: l.value && !!e.scrim,
        ref: ae
      }, E.value), null), T(Nr, {
        appear: !0,
        persisted: !0,
        transition: e.transition,
        target: $.value,
        onAfterEnter: ye,
        onAfterLeave: Oe
      }, {
        default: () => [Gn(T("div", Te({
          ref: ue,
          class: ["v-overlay__content", e.contentClass],
          style: [W.value, Ce.value]
        }, P.value, e.contentProps), [r.default?.({
          isActive: l
        })]), [[Vi, l.value], [Bi("click-outside"), {
          handler: Pe,
          closeConditional: ie,
          include: () => [S.value]
        }]])]
      })])]
    })])), {
      activatorEl: S,
      scrimEl: ae,
      target: $,
      animateClick: fe,
      contentEl: ue,
      globalTop: y,
      localTop: b,
      updateLocation: Se
    };
  }
}), ql = Symbol("Forwarded refs");
function Kl(e, n) {
  let r = e;
  for (; r; ) {
    const a = Reflect.getOwnPropertyDescriptor(r, n);
    if (a) return a;
    r = Object.getPrototypeOf(r);
  }
}
function Ra(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
    r[a - 1] = arguments[a];
  return e[ql] = r, new Proxy(e, {
    get(o, s) {
      if (Reflect.has(o, s))
        return Reflect.get(o, s);
      if (!(typeof s == "symbol" || s.startsWith("$") || s.startsWith("__"))) {
        for (const l of r)
          if (l.value && Reflect.has(l.value, s)) {
            const c = Reflect.get(l.value, s);
            return typeof c == "function" ? c.bind(l.value) : c;
          }
      }
    },
    has(o, s) {
      if (Reflect.has(o, s))
        return !0;
      if (typeof s == "symbol" || s.startsWith("$") || s.startsWith("__")) return !1;
      for (const l of r)
        if (l.value && Reflect.has(l.value, s))
          return !0;
      return !1;
    },
    set(o, s, l) {
      if (Reflect.has(o, s))
        return Reflect.set(o, s, l);
      if (typeof s == "symbol" || s.startsWith("$") || s.startsWith("__")) return !1;
      for (const c of r)
        if (c.value && Reflect.has(c.value, s))
          return Reflect.set(c.value, s, l);
      return !1;
    },
    getOwnPropertyDescriptor(o, s) {
      const l = Reflect.getOwnPropertyDescriptor(o, s);
      if (l) return l;
      if (!(typeof s == "symbol" || s.startsWith("$") || s.startsWith("__"))) {
        for (const c of r) {
          if (!c.value) continue;
          const f = Kl(c.value, s) ?? ("_" in c.value ? Kl(c.value._?.setupState, s) : void 0);
          if (f) return f;
        }
        for (const c of r) {
          const f = c.value && c.value[ql];
          if (!f) continue;
          const h = f.slice();
          for (; h.length; ) {
            const v = h.shift(), m = Kl(v.value, s);
            if (m) return m;
            const p = v.value && v.value[ql];
            p && h.push(...p);
          }
        }
      }
    }
  });
}
const Gk = he({
  // TODO
  // disableKeys: Boolean,
  id: String,
  ...oi(hs({
    closeDelay: 250,
    closeOnContentClick: !0,
    locationStrategy: "connected",
    openDelay: 300,
    scrim: !1,
    scrollStrategy: "reposition",
    transition: {
      component: Yu
    }
  }), ["absolute"])
}, "VMenu"), Fa = He()({
  name: "VMenu",
  props: Gk(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      slots: r
    } = n;
    const a = Ot(e, "modelValue"), {
      scopeId: o
    } = ds(), s = Qn(), l = A(() => e.id || `v-menu-${s}`), c = oe(), f = Ze(Cu, null), h = Ue(0);
    Et(Cu, {
      register() {
        ++h.value;
      },
      unregister() {
        --h.value;
      },
      closeParents(C) {
        setTimeout(() => {
          !h.value && !e.persistent && (C == null || c.value?.contentEl && !dx(C, c.value.contentEl)) && (a.value = !1, f?.closeParents());
        }, 40);
      }
    });
    async function v(C) {
      const S = C.relatedTarget, R = C.target;
      await Jt(), a.value && S !== R && c.value?.contentEl && // We're the topmost menu
      c.value?.globalTop && // It isn't the document or the menu body
      ![document, c.value.contentEl].includes(R) && // It isn't inside the menu body
      !c.value.contentEl.contains(R) && Sa(c.value.contentEl)[0]?.focus();
    }
    Re(a, (C) => {
      C ? (f?.register(), document.addEventListener("focusin", v, {
        once: !0
      })) : (f?.unregister(), document.removeEventListener("focusin", v));
    });
    function m(C) {
      f?.closeParents(C);
    }
    function p(C) {
      if (!e.disabled)
        if (C.key === "Tab" || C.key === "Enter" && !e.closeOnContentClick) {
          if (C.key === "Enter" && (C.target instanceof HTMLTextAreaElement || C.target instanceof HTMLInputElement && C.target.closest("form"))) return;
          C.key === "Enter" && C.preventDefault(), gm(Sa(c.value?.contentEl, !1), C.shiftKey ? "prev" : "next", (R) => R.tabIndex >= 0) || (a.value = !1, c.value?.activatorEl?.focus());
        } else ["Enter", " "].includes(C.key) && e.closeOnContentClick && (a.value = !1, f?.closeParents());
    }
    function y(C) {
      if (e.disabled) return;
      const S = c.value?.contentEl;
      S && a.value ? C.key === "ArrowDown" ? (C.preventDefault(), zo(S, "next")) : C.key === "ArrowUp" && (C.preventDefault(), zo(S, "prev")) : ["ArrowDown", "ArrowUp"].includes(C.key) && (a.value = !0, C.preventDefault(), setTimeout(() => setTimeout(() => y(C))));
    }
    const b = A(() => Te({
      "aria-haspopup": "menu",
      "aria-expanded": String(a.value),
      "aria-owns": l.value,
      onKeydown: y
    }, e.activatorProps));
    return tt(() => {
      const C = Mi.filterProps(e);
      return T(Mi, Te({
        ref: c,
        id: l.value,
        class: ["v-menu", e.class],
        style: e.style
      }, C, {
        modelValue: a.value,
        "onUpdate:modelValue": (S) => a.value = S,
        absolute: !0,
        activatorProps: b.value,
        "onClick:outside": m,
        onKeydown: p
      }, o), {
        activator: r.activator,
        default: function() {
          for (var S = arguments.length, R = new Array(S), $ = 0; $ < S; $++)
            R[$] = arguments[$];
          return T(Fn, {
            root: "VMenu"
          }, {
            default: () => [r.default?.(...R)]
          });
        }
      });
    }), Ra({
      id: l,
      ΨopenChildren: h
    }, c);
  }
}), zk = he({
  active: Boolean,
  disabled: Boolean,
  max: [Number, String],
  value: {
    type: [Number, String],
    default: 0
  },
  ...ct(),
  ...Pa({
    transition: {
      component: km
    }
  })
}, "VCounter"), qk = He()({
  name: "VCounter",
  functional: !0,
  props: zk(),
  setup(e, n) {
    let {
      slots: r
    } = n;
    const a = A(() => e.max ? `${e.value} / ${e.max}` : String(e.value));
    return tt(() => T(Nr, {
      transition: e.transition
    }, {
      default: () => [Gn(T("div", {
        class: ["v-counter", {
          "text-error": e.max && !e.disabled && parseFloat(e.value) > parseFloat(e.max)
        }, e.class],
        style: e.style
      }, [r.default ? r.default({
        counter: a.value,
        max: e.max,
        value: e.value
      }) : a.value]), [[Vi, e.active]])]
    })), {};
  }
}), Kk = he({
  floating: Boolean,
  ...ct()
}, "VFieldLabel"), Po = He()({
  name: "VFieldLabel",
  props: Kk(),
  setup(e, n) {
    let {
      slots: r
    } = n;
    return tt(() => T(zm, {
      class: ["v-field-label", {
        "v-field-label--floating": e.floating
      }, e.class],
      style: e.style,
      "aria-hidden": e.floating || void 0
    }, r)), {};
  }
}), jk = ["underlined", "outlined", "filled", "solo", "solo-inverted", "solo-filled", "plain"], wg = he({
  appendInnerIcon: _t,
  bgColor: String,
  clearable: Boolean,
  clearIcon: {
    type: _t,
    default: "$clear"
  },
  active: Boolean,
  centerAffix: {
    type: Boolean,
    default: void 0
  },
  color: String,
  baseColor: String,
  dirty: Boolean,
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  flat: Boolean,
  label: String,
  persistentClear: Boolean,
  prependInnerIcon: _t,
  reverse: Boolean,
  singleLine: Boolean,
  variant: {
    type: String,
    default: "filled",
    validator: (e) => jk.includes(e)
  },
  "onClick:clear": on(),
  "onClick:appendInner": on(),
  "onClick:prependInner": on(),
  ...ct(),
  ...uA(),
  ...fi(),
  ...un()
}, "VField"), Cg = He()({
  name: "VField",
  inheritAttrs: !1,
  props: {
    id: String,
    ...Xm(),
    ...wg()
  },
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      attrs: r,
      emit: a,
      slots: o
    } = n;
    const {
      themeClasses: s
    } = Dn(e), {
      loaderClasses: l
    } = cA(e), {
      focusClasses: c,
      isFocused: f,
      focus: h,
      blur: v
    } = Jm(e), {
      InputIcon: m
    } = Ym(e), {
      roundedClasses: p
    } = di(e), {
      rtlClasses: y
    } = si(), b = A(() => e.dirty || e.active), C = A(() => !e.singleLine && !!(e.label || o.label)), S = Qn(), R = A(() => e.id || `input-${S}`), $ = A(() => `${R.value}-messages`), k = oe(), L = oe(), F = oe(), P = A(() => ["plain", "underlined"].includes(e.variant)), {
      backgroundColorClasses: E,
      backgroundColorStyles: V
    } = pr(Me(e, "bgColor")), {
      textColorClasses: W,
      textColorStyles: me
    } = ci(A(() => e.error || e.disabled ? void 0 : b.value && f.value ? e.color : e.baseColor));
    Re(b, (ue) => {
      if (C.value) {
        const Ce = k.value.$el, Se = L.value.$el;
        requestAnimationFrame(() => {
          const Pe = qu(Ce), ie = Se.getBoundingClientRect(), se = ie.x - Pe.x, j = ie.y - Pe.y - (Pe.height / 2 - ie.height / 2), re = ie.width / 0.75, fe = Math.abs(re - Pe.width) > 1 ? {
            maxWidth: Ge(re)
          } : void 0, ye = getComputedStyle(Ce), Oe = getComputedStyle(Se), ge = parseFloat(ye.transitionDuration) * 1e3 || 150, Je = parseFloat(Oe.getPropertyValue("--v-field-label-scale")), $t = Oe.getPropertyValue("color");
          Ce.style.visibility = "visible", Se.style.visibility = "hidden", Li(Ce, {
            transform: `translate(${se}px, ${j}px) scale(${Je})`,
            color: $t,
            ...fe
          }, {
            duration: ge,
            easing: jo,
            direction: ue ? "normal" : "reverse"
          }).finished.then(() => {
            Ce.style.removeProperty("visibility"), Se.style.removeProperty("visibility");
          });
        });
      }
    }, {
      flush: "post"
    });
    const le = A(() => ({
      isActive: b,
      isFocused: f,
      controlRef: F,
      blur: v,
      focus: h
    }));
    function K(ue) {
      ue.target !== document.activeElement && ue.preventDefault();
    }
    function ae(ue) {
      ue.key !== "Enter" && ue.key !== " " || (ue.preventDefault(), ue.stopPropagation(), e["onClick:clear"]?.(new MouseEvent("click")));
    }
    return tt(() => {
      const ue = e.variant === "outlined", Ce = !!(o["prepend-inner"] || e.prependInnerIcon), Se = !!(e.clearable || o.clear), Pe = !!(o["append-inner"] || e.appendInnerIcon || Se), ie = () => o.label ? o.label({
        ...le.value,
        label: e.label,
        props: {
          for: R.value
        }
      }) : e.label;
      return T("div", Te({
        class: ["v-field", {
          "v-field--active": b.value,
          "v-field--appended": Pe,
          "v-field--center-affix": e.centerAffix ?? !P.value,
          "v-field--disabled": e.disabled,
          "v-field--dirty": e.dirty,
          "v-field--error": e.error,
          "v-field--flat": e.flat,
          "v-field--has-background": !!e.bgColor,
          "v-field--persistent-clear": e.persistentClear,
          "v-field--prepended": Ce,
          "v-field--reverse": e.reverse,
          "v-field--single-line": e.singleLine,
          "v-field--no-label": !ie(),
          [`v-field--variant-${e.variant}`]: !0
        }, s.value, E.value, c.value, l.value, p.value, y.value, e.class],
        style: [V.value, e.style],
        onClick: K
      }, r), [T("div", {
        class: "v-field__overlay"
      }, null), T(fA, {
        name: "v-field",
        active: !!e.loading,
        color: e.error ? "error" : typeof e.loading == "string" ? e.loading : e.color
      }, {
        default: o.loader
      }), Ce && T("div", {
        key: "prepend",
        class: "v-field__prepend-inner"
      }, [e.prependInnerIcon && T(m, {
        key: "prepend-icon",
        name: "prependInner"
      }, null), o["prepend-inner"]?.(le.value)]), T("div", {
        class: "v-field__field",
        "data-no-activator": ""
      }, [["filled", "solo", "solo-inverted", "solo-filled"].includes(e.variant) && C.value && T(Po, {
        key: "floating-label",
        ref: L,
        class: [W.value],
        floating: !0,
        for: R.value,
        style: me.value
      }, {
        default: () => [ie()]
      }), T(Po, {
        ref: k,
        for: R.value
      }, {
        default: () => [ie()]
      }), o.default?.({
        ...le.value,
        props: {
          id: R.value,
          class: "v-field__input",
          "aria-describedby": $.value
        },
        focus: h,
        blur: v
      })]), Se && T(Tm, {
        key: "clear"
      }, {
        default: () => [Gn(T("div", {
          class: "v-field__clearable",
          onMousedown: (se) => {
            se.preventDefault(), se.stopPropagation();
          }
        }, [T(Fn, {
          defaults: {
            VIcon: {
              icon: e.clearIcon
            }
          }
        }, {
          default: () => [o.clear ? o.clear({
            ...le.value,
            props: {
              onKeydown: ae,
              onFocus: h,
              onBlur: v,
              onClick: e["onClick:clear"]
            }
          }) : T(m, {
            name: "clear",
            onKeydown: ae,
            onFocus: h,
            onBlur: v
          }, null)]
        })]), [[Vi, e.dirty]])]
      }), Pe && T("div", {
        key: "append",
        class: "v-field__append-inner"
      }, [o["append-inner"]?.(le.value), e.appendInnerIcon && T(m, {
        key: "append-icon",
        name: "appendInner"
      }, null)]), T("div", {
        class: ["v-field__outline", W.value],
        style: me.value
      }, [ue && T(Ie, null, [T("div", {
        class: "v-field__outline__start"
      }, null), C.value && T("div", {
        class: "v-field__outline__notch"
      }, [T(Po, {
        ref: L,
        floating: !0,
        for: R.value
      }, {
        default: () => [ie()]
      })]), T("div", {
        class: "v-field__outline__end"
      }, null)]), P.value && C.value && T(Po, {
        ref: L,
        floating: !0,
        for: R.value
      }, {
        default: () => [ie()]
      })])]);
    }), {
      controlRef: F
    };
  }
});
function Yk(e) {
  const n = Object.keys(Cg.props).filter((r) => !Gu(r) && r !== "class" && r !== "style");
  return fm(e, n);
}
const Xk = ["color", "file", "time", "date", "datetime-local", "week", "month"], Sg = he({
  autofocus: Boolean,
  counter: [Boolean, Number, String],
  counterValue: [Number, Function],
  prefix: String,
  placeholder: String,
  persistentPlaceholder: Boolean,
  persistentCounter: Boolean,
  suffix: String,
  role: String,
  type: {
    type: String,
    default: "text"
  },
  modelModifiers: Object,
  ...Qm(),
  ...wg()
}, "VTextField"), ov = He()({
  name: "VTextField",
  directives: {
    Intersect: Om
  },
  inheritAttrs: !1,
  props: Sg(),
  emits: {
    "click:control": (e) => !0,
    "mousedown:control": (e) => !0,
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      attrs: r,
      emit: a,
      slots: o
    } = n;
    const s = Ot(e, "modelValue"), {
      isFocused: l,
      focus: c,
      blur: f
    } = Jm(e), h = A(() => typeof e.counterValue == "function" ? e.counterValue(s.value) : typeof e.counterValue == "number" ? e.counterValue : (s.value ?? "").toString().length), v = A(() => {
      if (r.maxlength) return r.maxlength;
      if (!(!e.counter || typeof e.counter != "number" && typeof e.counter != "string"))
        return e.counter;
    }), m = A(() => ["plain", "underlined"].includes(e.variant));
    function p(P, E) {
      !e.autofocus || !P || E[0].target?.focus?.();
    }
    const y = oe(), b = oe(), C = oe(), S = A(() => Xk.includes(e.type) || e.persistentPlaceholder || l.value || e.active);
    function R() {
      C.value !== document.activeElement && C.value?.focus(), l.value || c();
    }
    function $(P) {
      a("mousedown:control", P), P.target !== C.value && (R(), P.preventDefault());
    }
    function k(P) {
      R(), a("click:control", P);
    }
    function L(P) {
      P.stopPropagation(), R(), Jt(() => {
        s.value = null, cx(e["onClick:clear"], P);
      });
    }
    function F(P) {
      const E = P.target;
      if (s.value = E.value, e.modelModifiers?.trim && ["text", "search", "password", "tel", "url"].includes(e.type)) {
        const V = [E.selectionStart, E.selectionEnd];
        Jt(() => {
          E.selectionStart = V[0], E.selectionEnd = V[1];
        });
      }
    }
    return tt(() => {
      const P = !!(o.counter || e.counter !== !1 && e.counter != null), E = !!(P || o.details), [V, W] = hm(r), {
        modelValue: me,
        ...le
      } = Xh.filterProps(e), K = Yk(e);
      return T(Xh, Te({
        ref: y,
        modelValue: s.value,
        "onUpdate:modelValue": (ae) => s.value = ae,
        class: ["v-text-field", {
          "v-text-field--prefixed": e.prefix,
          "v-text-field--suffixed": e.suffix,
          "v-input--plain-underlined": m.value
        }, e.class],
        style: e.style
      }, V, le, {
        centerAffix: !m.value,
        focused: l.value
      }), {
        ...o,
        default: (ae) => {
          let {
            id: ue,
            isDisabled: Ce,
            isDirty: Se,
            isReadonly: Pe,
            isValid: ie
          } = ae;
          return T(Cg, Te({
            ref: b,
            onMousedown: $,
            onClick: k,
            "onClick:clear": L,
            "onClick:prependInner": e["onClick:prependInner"],
            "onClick:appendInner": e["onClick:appendInner"],
            role: e.role
          }, K, {
            id: ue.value,
            active: S.value || Se.value,
            dirty: Se.value || e.dirty,
            disabled: Ce.value,
            focused: l.value,
            error: ie.value === !1
          }), {
            ...o,
            default: (se) => {
              let {
                props: {
                  class: j,
                  ...re
                }
              } = se;
              const fe = Gn(T("input", Te({
                ref: C,
                value: s.value,
                onInput: F,
                autofocus: e.autofocus,
                readonly: Pe.value,
                disabled: Ce.value,
                name: e.name,
                placeholder: e.placeholder,
                size: 1,
                type: e.type,
                onFocus: R,
                onBlur: f
              }, re, W), null), [[Bi("intersect"), {
                handler: p
              }, null, {
                once: !0
              }]]);
              return T(Ie, null, [e.prefix && T("span", {
                class: "v-text-field__prefix"
              }, [T("span", {
                class: "v-text-field__prefix__text"
              }, [e.prefix])]), o.default ? T("div", {
                class: j,
                "data-no-activator": ""
              }, [o.default(), fe]) : tu(fe, {
                class: j
              }), e.suffix && T("span", {
                class: "v-text-field__suffix"
              }, [T("span", {
                class: "v-text-field__suffix__text"
              }, [e.suffix])])]);
            }
          });
        },
        details: E ? (ae) => T(Ie, null, [o.details?.(ae), P && T(Ie, null, [T("span", null, null), T(qk, {
          active: e.persistentCounter || l.value,
          value: h.value,
          max: v.value,
          disabled: e.disabled
        }, o.counter)])]) : void 0
      });
    }), Ra({}, y, b, C);
  }
}), Jk = he({
  renderless: Boolean,
  ...ct()
}, "VVirtualScrollItem"), Zk = He()({
  name: "VVirtualScrollItem",
  inheritAttrs: !1,
  props: Jk(),
  emits: {
    "update:height": (e) => !0
  },
  setup(e, n) {
    let {
      attrs: r,
      emit: a,
      slots: o
    } = n;
    const {
      resizeRef: s,
      contentRect: l
    } = Xo(void 0, "border");
    Re(() => l.value?.height, (c) => {
      c != null && a("update:height", c);
    }), tt(() => e.renderless ? T(Ie, null, [o.default?.({
      itemRef: s
    })]) : T("div", Te({
      ref: s,
      class: ["v-virtual-scroll__item", e.class],
      style: e.style
    }, r), [o.default?.()]));
  }
}), Qk = -1, eT = 1, jl = 100, tT = he({
  itemHeight: {
    type: [Number, String],
    default: null
  },
  height: [Number, String]
}, "virtual");
function nT(e, n) {
  const r = ic(), a = Ue(0);
  Mr(() => {
    a.value = parseFloat(e.itemHeight || 0);
  });
  const o = Ue(0), s = Ue(Math.ceil(
    // Assume 16px items filling the entire screen height if
    // not provided. This is probably incorrect but it minimises
    // the chance of ending up with empty space at the bottom.
    // The default value is set here to avoid poisoning getSize()
    (parseInt(e.height) || r.height.value) / (a.value || 16)
  ) || 1), l = Ue(0), c = Ue(0), f = oe(), h = oe();
  let v = 0;
  const {
    resizeRef: m,
    contentRect: p
  } = Xo();
  Mr(() => {
    m.value = f.value;
  });
  const y = A(() => f.value === document.documentElement ? r.height.value : p.value?.height || parseInt(e.height) || 0), b = A(() => !!(f.value && h.value && y.value && a.value));
  let C = Array.from({
    length: n.value.length
  }), S = Array.from({
    length: n.value.length
  });
  const R = Ue(0);
  let $ = -1;
  function k(se) {
    return C[se] || a.value;
  }
  const L = lx(() => {
    const se = performance.now();
    S[0] = 0;
    const j = n.value.length;
    for (let re = 1; re <= j - 1; re++)
      S[re] = (S[re - 1] || 0) + k(re - 1);
    R.value = Math.max(R.value, performance.now() - se);
  }, R), F = Re(b, (se) => {
    se && (F(), v = h.value.offsetTop, L.immediate(), Ce(), ~$ && Jt(() => {
      Pt && window.requestAnimationFrame(() => {
        Pe($), $ = -1;
      });
    }));
  });
  Zt(() => {
    L.clear();
  });
  function P(se, j) {
    const re = C[se], fe = a.value;
    a.value = fe ? Math.min(a.value, j) : j, (re !== j || fe !== a.value) && (C[se] = j, L());
  }
  function E(se) {
    return se = Fr(se, 0, n.value.length - 1), S[se] || 0;
  }
  function V(se) {
    return rT(S, se);
  }
  let W = 0, me = 0, le = 0;
  Re(y, (se, j) => {
    j && (Ce(), se < j && requestAnimationFrame(() => {
      me = 0, Ce();
    }));
  });
  function K() {
    if (!f.value || !h.value) return;
    const se = f.value.scrollTop, j = performance.now();
    j - le > 500 ? (me = Math.sign(se - W), v = h.value.offsetTop) : me = se - W, W = se, le = j, Ce();
  }
  function ae() {
    !f.value || !h.value || (me = 0, le = 0, Ce());
  }
  let ue = -1;
  function Ce() {
    cancelAnimationFrame(ue), ue = requestAnimationFrame(Se);
  }
  function Se() {
    if (!f.value || !y.value) return;
    const se = W - v, j = Math.sign(me), re = Math.max(0, se - jl), fe = Fr(V(re), 0, n.value.length), ye = se + y.value + jl, Oe = Fr(V(ye) + 1, fe + 1, n.value.length);
    if (
      // Only update the side we're scrolling towards,
      // the other side will be updated incidentally
      (j !== Qk || fe < o.value) && (j !== eT || Oe > s.value)
    ) {
      const ge = E(o.value) - E(fe), Je = E(Oe) - E(s.value);
      Math.max(ge, Je) > jl ? (o.value = fe, s.value = Oe) : (fe <= 0 && (o.value = fe), Oe >= n.value.length && (s.value = Oe));
    }
    l.value = E(o.value), c.value = E(n.value.length) - E(s.value);
  }
  function Pe(se) {
    const j = E(se);
    !f.value || se && !j ? $ = se : f.value.scrollTop = j;
  }
  const ie = A(() => n.value.slice(o.value, s.value).map((se, j) => ({
    raw: se,
    index: j + o.value
  })));
  return Re(n, () => {
    C = Array.from({
      length: n.value.length
    }), S = Array.from({
      length: n.value.length
    }), L.immediate(), Ce();
  }, {
    deep: !0
  }), {
    containerRef: f,
    markerRef: h,
    computedItems: ie,
    paddingTop: l,
    paddingBottom: c,
    scrollToIndex: Pe,
    handleScroll: K,
    handleScrollend: ae,
    handleItemResize: P
  };
}
function rT(e, n) {
  let r = e.length - 1, a = 0, o = 0, s = null, l = -1;
  if (e[r] < n)
    return r;
  for (; a <= r; )
    if (o = a + r >> 1, s = e[o], s > n)
      r = o - 1;
    else if (s < n)
      l = o, a = o + 1;
    else return s === n ? o : a;
  return l;
}
const iT = he({
  items: {
    type: Array,
    default: () => []
  },
  renderless: Boolean,
  ...tT(),
  ...ct(),
  ...li()
}, "VVirtualScroll"), aT = He()({
  name: "VVirtualScroll",
  props: iT(),
  setup(e, n) {
    let {
      slots: r
    } = n;
    const a = Dt("VVirtualScroll"), {
      dimensionStyles: o
    } = ui(e), {
      containerRef: s,
      markerRef: l,
      handleScroll: c,
      handleScrollend: f,
      handleItemResize: h,
      scrollToIndex: v,
      paddingTop: m,
      paddingBottom: p,
      computedItems: y
    } = nT(e, Me(e, "items"));
    return ri(() => e.renderless, () => {
      function b() {
        const S = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1) ? "addEventListener" : "removeEventListener";
        s.value === document.documentElement ? (document[S]("scroll", c, {
          passive: !0
        }), document[S]("scrollend", f)) : (s.value?.[S]("scroll", c, {
          passive: !0
        }), s.value?.[S]("scrollend", f));
      }
      qt(() => {
        s.value = Sm(a.vnode.el, !0), b(!0);
      }), Zt(b);
    }), tt(() => {
      const b = y.value.map((C) => T(Zk, {
        key: C.index,
        renderless: e.renderless,
        "onUpdate:height": (S) => h(C.index, S)
      }, {
        default: (S) => r.default?.({
          item: C.raw,
          index: C.index,
          ...S
        })
      }));
      return e.renderless ? T(Ie, null, [T("div", {
        ref: l,
        class: "v-virtual-scroll__spacer",
        style: {
          paddingTop: Ge(m.value)
        }
      }, null), b, T("div", {
        class: "v-virtual-scroll__spacer",
        style: {
          paddingBottom: Ge(p.value)
        }
      }, null)]) : T("div", {
        ref: s,
        class: ["v-virtual-scroll", e.class],
        onScrollPassive: c,
        onScrollend: f,
        style: [o.value, e.style]
      }, [T("div", {
        ref: l,
        class: "v-virtual-scroll__container",
        style: {
          paddingTop: Ge(m.value),
          paddingBottom: Ge(p.value)
        }
      }, [b])]);
    }), {
      scrollToIndex: v
    };
  }
});
function oT(e, n) {
  const r = Ue(!1);
  let a;
  function o(c) {
    cancelAnimationFrame(a), r.value = !0, a = requestAnimationFrame(() => {
      a = requestAnimationFrame(() => {
        r.value = !1;
      });
    });
  }
  async function s() {
    await new Promise((c) => requestAnimationFrame(c)), await new Promise((c) => requestAnimationFrame(c)), await new Promise((c) => requestAnimationFrame(c)), await new Promise((c) => {
      if (r.value) {
        const f = Re(r, () => {
          f(), c();
        });
      } else c();
    });
  }
  async function l(c) {
    if (c.key === "Tab" && n.value?.focus(), !["PageDown", "PageUp", "Home", "End"].includes(c.key)) return;
    const f = e.value?.$el;
    if (!f) return;
    (c.key === "Home" || c.key === "End") && f.scrollTo({
      top: c.key === "Home" ? 0 : f.scrollHeight,
      behavior: "smooth"
    }), await s();
    const h = f.querySelectorAll(":scope > :not(.v-virtual-scroll__spacer)");
    if (c.key === "PageDown" || c.key === "Home") {
      const v = f.getBoundingClientRect().top;
      for (const m of h)
        if (m.getBoundingClientRect().top >= v) {
          m.focus();
          break;
        }
    } else {
      const v = f.getBoundingClientRect().bottom;
      for (const m of [...h].reverse())
        if (m.getBoundingClientRect().bottom <= v) {
          m.focus();
          break;
        }
    }
  }
  return {
    onListScroll: o,
    onListKeydown: l
  };
}
const sT = he({
  chips: Boolean,
  closableChips: Boolean,
  closeText: {
    type: String,
    default: "$vuetify.close"
  },
  openText: {
    type: String,
    default: "$vuetify.open"
  },
  eager: Boolean,
  hideNoData: Boolean,
  hideSelected: Boolean,
  listProps: {
    type: Object
  },
  menu: Boolean,
  menuIcon: {
    type: _t,
    default: "$dropdown"
  },
  menuProps: {
    type: Object
  },
  multiple: Boolean,
  noDataText: {
    type: String,
    default: "$vuetify.noDataText"
  },
  openOnClear: Boolean,
  itemColor: String,
  ...dg({
    itemChildren: !1
  })
}, "Select"), lT = he({
  ...sT(),
  ...oi(Sg({
    modelValue: null,
    role: "combobox"
  }), ["validationValue", "dirty", "appendInnerIcon"]),
  ...Pa({
    transition: {
      component: Yu
    }
  })
}, "VSelect"), uT = He()({
  name: "VSelect",
  props: lT(),
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    "update:menu": (e) => !0
  },
  setup(e, n) {
    let {
      slots: r
    } = n;
    const {
      t: a
    } = ls(), o = oe(), s = oe(), l = oe(), c = Ot(e, "menu"), f = A({
      get: () => c.value,
      set: (ie) => {
        c.value && !ie && s.value?.ΨopenChildren || (c.value = ie);
      }
    }), {
      items: h,
      transformIn: v,
      transformOut: m
    } = dk(e), p = Ot(e, "modelValue", [], (ie) => v(ie === null ? [null] : Mn(ie)), (ie) => {
      const se = m(ie);
      return e.multiple ? se : se[0] ?? null;
    }), y = A(() => typeof e.counterValue == "function" ? e.counterValue(p.value) : typeof e.counterValue == "number" ? e.counterValue : p.value.length), b = Zm(), C = A(() => p.value.map((ie) => ie.value)), S = Ue(!1), R = A(() => f.value ? e.closeText : e.openText);
    let $ = "", k;
    const L = A(() => e.hideSelected ? h.value.filter((ie) => !p.value.some((se) => e.valueComparator(se, ie))) : h.value), F = A(() => e.hideNoData && !L.value.length || e.readonly || b?.isReadonly.value), P = A(() => ({
      ...e.menuProps,
      activatorProps: {
        ...e.menuProps?.activatorProps || {},
        "aria-haspopup": "listbox"
        // Set aria-haspopup to 'listbox'
      }
    })), E = oe(), {
      onListScroll: V,
      onListKeydown: W
    } = oT(E, o);
    function me(ie) {
      e.openOnClear && (f.value = !0);
    }
    function le() {
      F.value || (f.value = !f.value);
    }
    function K(ie) {
      if (!ie.key || e.readonly || b?.isReadonly.value) return;
      ["Enter", " ", "ArrowDown", "ArrowUp", "Home", "End"].includes(ie.key) && ie.preventDefault(), ["Enter", "ArrowDown", " "].includes(ie.key) && (f.value = !0), ["Escape", "Tab"].includes(ie.key) && (f.value = !1), ie.key === "Home" ? E.value?.focus("first") : ie.key === "End" && E.value?.focus("last");
      const se = 1e3;
      function j(ye) {
        const Oe = ye.key.length === 1, ge = !ye.ctrlKey && !ye.metaKey && !ye.altKey;
        return Oe && ge;
      }
      if (e.multiple || !j(ie)) return;
      const re = performance.now();
      re - k > se && ($ = ""), $ += ie.key.toLowerCase(), k = re;
      const fe = h.value.find((ye) => ye.title.toLowerCase().startsWith($));
      if (fe !== void 0) {
        p.value = [fe];
        const ye = L.value.indexOf(fe);
        Pt && window.requestAnimationFrame(() => {
          ye >= 0 && l.value?.scrollToIndex(ye);
        });
      }
    }
    function ae(ie) {
      let se = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (!ie.props.disabled)
        if (e.multiple) {
          const j = p.value.findIndex((fe) => e.valueComparator(fe.value, ie.value)), re = se ?? !~j;
          if (~j) {
            const fe = re ? [...p.value, ie] : [...p.value];
            fe.splice(j, 1), p.value = fe;
          } else re && (p.value = [...p.value, ie]);
        } else {
          const j = se !== !1;
          p.value = j ? [ie] : [], Jt(() => {
            f.value = !1;
          });
        }
    }
    function ue(ie) {
      E.value?.$el.contains(ie.relatedTarget) || (f.value = !1);
    }
    function Ce() {
      S.value && o.value?.focus();
    }
    function Se(ie) {
      S.value = !0;
    }
    function Pe(ie) {
      if (ie == null) p.value = [];
      else if (qo(o.value, ":autofill") || qo(o.value, ":-webkit-autofill")) {
        const se = h.value.find((j) => j.title === ie);
        se && ae(se);
      } else o.value && (o.value.value = "");
    }
    return Re(f, () => {
      if (!e.hideSelected && f.value && p.value.length) {
        const ie = L.value.findIndex((se) => p.value.some((j) => e.valueComparator(j.value, se.value)));
        Pt && window.requestAnimationFrame(() => {
          ie >= 0 && l.value?.scrollToIndex(ie);
        });
      }
    }), Re(() => e.items, (ie, se) => {
      f.value || S.value && !se.length && ie.length && (f.value = !0);
    }), tt(() => {
      const ie = !!(e.chips || r.chip), se = !!(!e.hideNoData || L.value.length || r["prepend-item"] || r["append-item"] || r["no-data"]), j = p.value.length > 0, re = ov.filterProps(e), fe = j || !S.value && e.label && !e.persistentPlaceholder ? void 0 : e.placeholder;
      return T(ov, Te({
        ref: o
      }, re, {
        modelValue: p.value.map((ye) => ye.props.value).join(", "),
        "onUpdate:modelValue": Pe,
        focused: S.value,
        "onUpdate:focused": (ye) => S.value = ye,
        validationValue: p.externalValue,
        counterValue: y.value,
        dirty: j,
        class: ["v-select", {
          "v-select--active-menu": f.value,
          "v-select--chips": !!e.chips,
          [`v-select--${e.multiple ? "multiple" : "single"}`]: !0,
          "v-select--selected": p.value.length,
          "v-select--selection-slot": !!r.selection
        }, e.class],
        style: e.style,
        inputmode: "none",
        placeholder: fe,
        "onClick:clear": me,
        "onMousedown:control": le,
        onBlur: ue,
        onKeydown: K,
        "aria-label": a(R.value),
        title: a(R.value)
      }), {
        ...r,
        default: () => T(Ie, null, [T(Fa, Te({
          ref: s,
          modelValue: f.value,
          "onUpdate:modelValue": (ye) => f.value = ye,
          activator: "parent",
          contentClass: "v-select__content",
          disabled: F.value,
          eager: e.eager,
          maxHeight: 310,
          openOnClick: !1,
          closeOnContentClick: !1,
          transition: e.transition,
          onAfterLeave: Ce
        }, P.value), {
          default: () => [se && T(pk, Te({
            ref: E,
            selected: C.value,
            selectStrategy: e.multiple ? "independent" : "single-independent",
            onMousedown: (ye) => ye.preventDefault(),
            onKeydown: W,
            onFocusin: Se,
            onScrollPassive: V,
            tabindex: "-1",
            "aria-live": "polite",
            color: e.itemColor ?? e.color
          }, e.listProps), {
            default: () => [r["prepend-item"]?.(), !L.value.length && !e.hideNoData && (r["no-data"]?.() ?? T(Zo, {
              title: a(e.noDataText)
            }, null)), T(aT, {
              ref: l,
              renderless: !0,
              items: L.value
            }, {
              default: (ye) => {
                let {
                  item: Oe,
                  index: ge,
                  itemRef: Je
                } = ye;
                const $t = Te(Oe.props, {
                  ref: Je,
                  key: ge,
                  onClick: () => ae(Oe, null)
                });
                return r.item?.({
                  item: Oe,
                  index: ge,
                  props: $t
                }) ?? T(Zo, Te($t, {
                  role: "option"
                }), {
                  prepend: (xt) => {
                    let {
                      isSelected: at
                    } = xt;
                    return T(Ie, null, [e.multiple && !e.hideSelected ? T(xA, {
                      key: Oe.value,
                      modelValue: at,
                      ripple: !1,
                      tabindex: "-1"
                    }, null) : void 0, Oe.props.prependAvatar && T(ka, {
                      image: Oe.props.prependAvatar
                    }, null), Oe.props.prependIcon && T(_n, {
                      icon: Oe.props.prependIcon
                    }, null)]);
                  }
                });
              }
            }), r["append-item"]?.()]
          })]
        }), p.value.map((ye, Oe) => {
          function ge(at) {
            at.stopPropagation(), at.preventDefault(), ae(ye, !1);
          }
          const Je = {
            "onClick:close": ge,
            onKeydown(at) {
              at.key !== "Enter" && at.key !== " " || (at.preventDefault(), at.stopPropagation(), ge(at));
            },
            onMousedown(at) {
              at.preventDefault(), at.stopPropagation();
            },
            modelValue: !0,
            "onUpdate:modelValue": void 0
          }, $t = ie ? !!r.chip : !!r.selection, xt = $t ? pm(ie ? r.chip({
            item: ye,
            index: Oe,
            props: Je
          }) : r.selection({
            item: ye,
            index: Oe
          })) : void 0;
          if (!($t && !xt))
            return T("div", {
              key: ye.value,
              class: "v-select__selection"
            }, [ie ? r.chip ? T(Fn, {
              key: "chip-defaults",
              defaults: {
                VChip: {
                  closable: e.closableChips,
                  size: "small",
                  text: ye.title
                }
              }
            }, {
              default: () => [xt]
            }) : T(GA, Te({
              key: "chip",
              closable: e.closableChips,
              size: "small",
              text: ye.title,
              disabled: ye.props.disabled
            }, Je), null) : xt ?? T("span", {
              class: "v-select__selection-text"
            }, [ye.title, e.multiple && Oe < p.value.length - 1 && T("span", {
              class: "v-select__selection-comma"
            }, [ni(",")])])]);
        })]),
        "append-inner": function() {
          for (var ye = arguments.length, Oe = new Array(ye), ge = 0; ge < ye; ge++)
            Oe[ge] = arguments[ge];
          return T(Ie, null, [r["append-inner"]?.(...Oe), e.menuIcon ? T(_n, {
            class: "v-select__menu-icon",
            icon: e.menuIcon
          }, null) : void 0]);
        }
      });
    }), Ra({
      isFocused: S,
      menu: f,
      select: ae
    }, o);
  }
}), cT = he({
  fullscreen: Boolean,
  retainFocus: {
    type: Boolean,
    default: !0
  },
  scrollable: Boolean,
  ...hs({
    origin: "center center",
    scrollStrategy: "block",
    transition: {
      component: Yu
    },
    zIndex: 2400
  })
}, "VDialog"), fT = He()({
  name: "VDialog",
  props: cT(),
  emits: {
    "update:modelValue": (e) => !0,
    afterLeave: () => !0
  },
  setup(e, n) {
    let {
      emit: r,
      slots: a
    } = n;
    const o = Ot(e, "modelValue"), {
      scopeId: s
    } = ds(), l = oe();
    function c(v) {
      const m = v.relatedTarget, p = v.target;
      if (m !== p && l.value?.contentEl && // We're the topmost dialog
      l.value?.globalTop && // It isn't the document or the dialog body
      ![document, l.value.contentEl].includes(p) && // It isn't inside the dialog body
      !l.value.contentEl.contains(p)) {
        const y = Sa(l.value.contentEl);
        if (!y.length) return;
        const b = y[0], C = y[y.length - 1];
        m === b ? C.focus() : b.focus();
      }
    }
    Pt && Re(() => o.value && e.retainFocus, (v) => {
      v ? document.addEventListener("focusin", c) : document.removeEventListener("focusin", c);
    }, {
      immediate: !0
    });
    function f() {
      l.value?.contentEl && !l.value.contentEl.contains(document.activeElement) && l.value.contentEl.focus({
        preventScroll: !0
      });
    }
    function h() {
      r("afterLeave");
    }
    return Re(o, async (v) => {
      v || (await Jt(), l.value.activatorEl?.focus({
        preventScroll: !0
      }));
    }), tt(() => {
      const v = Mi.filterProps(e), m = Te({
        "aria-haspopup": "dialog",
        "aria-expanded": String(o.value)
      }, e.activatorProps), p = Te({
        tabindex: -1
      }, e.contentProps);
      return T(Mi, Te({
        ref: l,
        class: ["v-dialog", {
          "v-dialog--fullscreen": e.fullscreen,
          "v-dialog--scrollable": e.scrollable
        }, e.class],
        style: e.style
      }, v, {
        modelValue: o.value,
        "onUpdate:modelValue": (y) => o.value = y,
        "aria-modal": "true",
        activatorProps: m,
        contentProps: p,
        role: "dialog",
        onAfterEnter: f,
        onAfterLeave: h
      }, s), {
        activator: a.activator,
        default: function() {
          for (var y = arguments.length, b = new Array(y), C = 0; C < y; C++)
            b[C] = arguments[C];
          return T(Fn, {
            root: "VDialog"
          }, {
            default: () => [a.default?.(...b)]
          });
        }
      });
    }), Ra({}, l);
  }
}), dT = {
  actions: "button@2",
  article: "heading, paragraph",
  avatar: "avatar",
  button: "button",
  card: "image, heading",
  "card-avatar": "image, list-item-avatar",
  chip: "chip",
  "date-picker": "list-item, heading, divider, date-picker-options, date-picker-days, actions",
  "date-picker-options": "text, avatar@2",
  "date-picker-days": "avatar@28",
  divider: "divider",
  heading: "heading",
  image: "image",
  "list-item": "text",
  "list-item-avatar": "avatar, text",
  "list-item-two-line": "sentences",
  "list-item-avatar-two-line": "avatar, sentences",
  "list-item-three-line": "paragraph",
  "list-item-avatar-three-line": "avatar, paragraph",
  ossein: "ossein",
  paragraph: "text@3",
  sentences: "text@2",
  subtitle: "text",
  table: "table-heading, table-thead, table-tbody, table-tfoot",
  "table-heading": "chip, text",
  "table-thead": "heading@6",
  "table-tbody": "table-row-divider@6",
  "table-row-divider": "table-row, divider",
  "table-row": "text@6",
  "table-tfoot": "text@2, avatar@2",
  text: "text"
};
function hT(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return T("div", {
    class: ["v-skeleton-loader__bone", `v-skeleton-loader__${e}`]
  }, [n]);
}
function sv(e) {
  const [n, r] = e.split("@");
  return Array.from({
    length: r
  }).map(() => vs(n));
}
function vs(e) {
  let n = [];
  if (!e) return n;
  const r = dT[e];
  if (e !== r) {
    if (e.includes(",")) return lv(e);
    if (e.includes("@")) return sv(e);
    r.includes(",") ? n = lv(r) : r.includes("@") ? n = sv(r) : r && n.push(vs(r));
  }
  return [hT(e, n)];
}
function lv(e) {
  return e.replace(/\s/g, "").split(",").map(vs);
}
const vT = he({
  boilerplate: Boolean,
  color: String,
  loading: Boolean,
  loadingText: {
    type: String,
    default: "$vuetify.loading"
  },
  type: {
    type: [String, Array],
    default: "ossein"
  },
  ...li(),
  ...us(),
  ...un()
}, "VSkeletonLoader"), uv = He()({
  name: "VSkeletonLoader",
  props: vT(),
  setup(e, n) {
    let {
      slots: r
    } = n;
    const {
      backgroundColorClasses: a,
      backgroundColorStyles: o
    } = pr(Me(e, "color")), {
      dimensionStyles: s
    } = ui(e), {
      elevationClasses: l
    } = cs(e), {
      themeClasses: c
    } = Dn(e), {
      t: f
    } = ls(), h = A(() => vs(Mn(e.type).join(",")));
    return tt(() => {
      const v = !r.default || e.loading, m = e.boilerplate || !v ? {} : {
        ariaLive: "polite",
        ariaLabel: f(e.loadingText),
        role: "alert"
      };
      return T("div", Te({
        class: ["v-skeleton-loader", {
          "v-skeleton-loader--boilerplate": e.boilerplate
        }, c.value, a.value, l.value],
        style: [o.value, v ? s.value : {}]
      }, m), [v ? h.value : r.default?.()]);
    }), {};
  }
}), mT = he({
  id: String,
  text: String,
  ...oi(hs({
    closeOnBack: !1,
    location: "end",
    locationStrategy: "connected",
    eager: !0,
    minWidth: 0,
    offset: 10,
    openOnClick: !1,
    openOnHover: !0,
    origin: "auto",
    scrim: !1,
    scrollStrategy: "reposition",
    transition: !1
  }), ["absolute", "persistent"])
}, "VTooltip"), gT = He()({
  name: "VTooltip",
  props: mT(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      slots: r
    } = n;
    const a = Ot(e, "modelValue"), {
      scopeId: o
    } = ds(), s = Qn(), l = A(() => e.id || `v-tooltip-${s}`), c = oe(), f = A(() => e.location.split(" ").length > 1 ? e.location : e.location + " center"), h = A(() => e.origin === "auto" || e.origin === "overlap" || e.origin.split(" ").length > 1 || e.location.split(" ").length > 1 ? e.origin : e.origin + " center"), v = A(() => e.transition ? e.transition : a.value ? "scale-transition" : "fade-transition"), m = A(() => Te({
      "aria-describedby": l.value
    }, e.activatorProps));
    return tt(() => {
      const p = Mi.filterProps(e);
      return T(Mi, Te({
        ref: c,
        class: ["v-tooltip", e.class],
        style: e.style,
        id: l.value
      }, p, {
        modelValue: a.value,
        "onUpdate:modelValue": (y) => a.value = y,
        transition: v.value,
        absolute: !0,
        location: f.value,
        origin: h.value,
        persistent: !0,
        role: "tooltip",
        activatorProps: m.value,
        _disableGlobalStack: !0
      }, o), {
        activator: r.activator,
        default: function() {
          for (var y = arguments.length, b = new Array(y), C = 0; C < y; C++)
            b[C] = arguments[C];
          return r.default?.(...b) ?? e.text;
        }
      });
    }), Ra({}, c);
  }
}), pT = {}, _T = {
  width: "111",
  height: "89",
  viewBox: "0 0 111 89",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yT = /* @__PURE__ */ VC('<g id="Group 2 Copy"><g id="Fichier 1 Copy"><g id="Group"><g id="Group_2"><g id="Group_3"><path id="Path" d="M95.9476 66.115V22.9858L86.196 28.6185V71.7476C86.196 72.8351 86.5755 73.5861 87.1661 73.8755L93.2721 77.3764L94.4886 72.4596L93.8236 70.7306C95.0323 69.741 95.9515 67.8087 95.9515 66.115H95.9476Z" fill="#D7316D"></path><path id="Path_2" d="M99.5347 74.5953L94.9542 77.2395C93.5265 78.0649 92.3687 77.1887 92.3687 75.2837V32.1545L102.12 26.5219V69.651C102.12 71.556 100.962 73.7699 99.5347 74.5953Z" fill="#FF5E98"></path></g><g id="Group_4"><g id="Group_5"><path id="Path_3" d="M101.968 27.9574L88.3591 4.91034L94.1405 1.59331C95.8576 0.63106 98.2163 0.783611 100.829 2.28957C106.071 5.31714 110.319 12.6435 110.319 18.6596C110.319 21.6793 109.247 23.7916 107.518 24.7656L101.964 27.9535L101.968 27.9574Z" fill="#FF5E98"></path><path id="Path_4" d="M104.283 22.1292C104.283 16.1131 100.035 8.78673 94.7937 5.75916C89.5522 2.73159 85.3042 5.15677 85.3042 11.1689C85.3042 17.181 89.5522 24.5113 94.7937 27.5389C100.035 30.5665 104.283 28.1413 104.283 22.1292Z" fill="#FFFBF2"></path></g><g id="Group_6"><path id="Path_5" d="M91.8442 33.8131L78.4626 10.6369L88.4294 4.88298C90.1466 3.92073 92.5092 4.07328 95.1182 5.57925C100.36 8.60682 104.608 15.9332 104.608 21.9492C104.608 24.969 103.536 27.0812 101.807 28.0552L91.8403 33.8131H91.8442Z" fill="#D7316D"></path><path id="Path_6" d="M94.1599 27.9848C94.1599 21.9688 89.912 14.6424 84.6704 11.6148C79.4289 8.58724 75.1809 11.0124 75.1809 17.0245C75.1809 23.0366 79.4289 30.3709 84.6704 33.3945C89.912 36.4221 94.1599 33.9969 94.1599 27.9848Z" fill="#FFFBF2"></path></g><path id="Path_7" d="M94.1601 27.9848C94.1601 21.9687 89.9121 14.6423 84.6706 11.6148C81.9559 10.0462 79.5112 9.95235 77.7823 11.0515V11.0437L51.1639 18.1393L22.1243 19.0703L57.4107 77.13L68.3397 58.3231L91.8444 33.8169L91.821 33.7817C93.2722 32.7061 94.1601 30.7229 94.1601 27.9887V27.9848Z" fill="#DADFFF"></path><path id="Path_8" d="M59.7107 66.3301C59.7107 50.2378 48.3436 30.629 34.3205 22.532C20.2975 14.435 8.93042 20.9165 8.93042 37.0088C8.93042 53.1011 20.2975 72.7099 34.3205 80.803C48.3436 88.8999 59.7107 82.4184 59.7107 66.3262V66.3301Z" fill="#F0F8FE"></path><path id="Path_9" d="M57.6494 65.141C57.6494 50.3552 47.2054 32.3384 34.3168 24.8986C21.432 17.4587 10.988 23.4161 10.988 38.2019C10.988 52.9877 21.432 71.0044 34.3168 78.4443C47.2015 85.8841 57.6494 79.9268 57.6494 65.141Z" fill="#DADFFF"></path><g id="Group_7"><path id="Path_10" d="M56.6989 57.044L40.3797 66.3106L25.8403 41.1317L42.7227 31.5483C49.4507 38.4092 54.6648 47.8674 56.6989 57.044Z" fill="#ABB6FD"></path><path id="Path_11" d="M42.8949 59.9777C42.8949 53.4414 38.2792 45.4774 32.58 42.1878C26.8847 38.8981 22.2651 41.5306 22.2651 48.0669C22.2651 54.6032 26.8808 62.5672 32.58 65.8568C38.2753 69.1464 42.8949 66.5139 42.8949 59.9777Z" fill="#BEC6FF"></path><path id="Path_12" d="M39.0342 59.1289C39.0342 54.2512 35.5881 48.3056 31.3362 45.8491C27.0843 43.3926 23.6382 45.3601 23.6382 50.2379C23.6382 55.1156 27.0843 61.0612 31.3362 63.5177C35.5881 65.9742 39.0342 64.0067 39.0342 59.1289Z" fill="#D7316D"></path></g></g></g></g><g id="Group_8"><path id="Path_13" d="M0.000200165 47.9534C0.0197581 46.8817 0.954628 46.0289 2.0929 46.0485L16.7692 46.3027C17.9075 46.3223 18.811 47.2063 18.7954 48.2781C18.7758 49.3499 17.841 50.2026 16.7027 50.183L2.0264 49.9288C0.888131 49.9092 -0.0154462 49.0252 0.000200165 47.9534Z" fill="#FFC23B"></path><path id="Path_14" d="M27.0879 88.7747C26.0748 88.2858 25.668 87.1201 26.1843 86.1657L32.8301 73.8442C33.3464 72.8898 34.5825 72.5104 35.5956 72.9993C36.6087 73.4883 37.0155 74.6539 36.4991 75.6083L29.8534 87.9298C29.337 88.8843 28.101 89.2637 27.0839 88.7747H27.0879Z" fill="#FFC23B"></path><path id="Path_15" d="M6.08282 73.7855C5.44132 72.9015 5.67993 71.6928 6.61871 71.0905L18.729 63.2986C19.6678 62.6962 20.9469 62.9231 21.5923 63.811C22.2338 64.695 21.9952 65.9037 21.0564 66.5061L8.94611 74.2941C8.00733 74.8964 6.72824 74.6696 6.08282 73.7816V73.7855Z" fill="#FFC23B"></path></g></g></g>', 1), bT = [
  yT
];
function wT(e, n) {
  return z(), ne("svg", _T, bT);
}
const CT = /* @__PURE__ */ Ut(pT, [["render", wT]]), ST = (e) => (Ui("data-v-d5b4b4a2"), e = e(), Wi(), e), ET = { class: "wh-bg-white wh-text-black wh-rounded-[30px] wh-p-[30px] wh-max-h-[70vh] wh-overflow-auto" }, xT = { class: "wh-text-[16px] wh-text-center wh-font-bold wh-relative" }, AT = ["title"], kT = /* @__PURE__ */ ST(() => /* @__PURE__ */ Q("i", { class: "icon-close" }, null, -1)), TT = [
  kT
], IT = { class: "wh-flex wh-flex-col wh-gap-5" }, LT = { class: "wh-flex wh-justify-center wh-my-5" }, OT = { class: "wh-text-[16px] wh-font-bold wh-flex wh-items-center wh-gap-1" }, PT = ["innerHTML"], NT = {
  key: 0,
  class: "wh-flex wh-justify-center"
}, RT = ["href", "textContent"], FT = /* @__PURE__ */ Qe({
  __name: "BannersModal",
  props: {
    banner: {}
  },
  emits: ["close"],
  setup(e, { emit: n }) {
    const r = e, { banner: a } = ht(r), o = n, s = A(() => ({
      circle_info: "icon-info-circ",
      circle_check: "icon-check-circ",
      circle_cone: "icon-construction-circ",
      circle_warning: "icon-disturbance-circ",
      circle_question: "icon-question-circ"
    })[a.value.picto] || "icon-info-circ"), l = A(() => a.value.buttonText && a.value.link);
    return (c, f) => (z(), ne("div", ET, [
      Q("header", null, [
        Q("h3", xT, [
          ni(Ve(c.$t("wh:banners:modal-title")) + " ", 1),
          Q("button", {
            class: "wh-absolute wh-top-0 wh-left-0 wh-text-2xl wh-text-gray-500",
            title: c.$t("wh:banners:close"),
            onClick: f[0] || (f[0] = (h) => o("close"))
          }, TT, 8, AT)
        ])
      ]),
      Q("main", IT, [
        Q("div", LT, [
          T(CT)
        ]),
        Q("h4", OT, [
          Q("i", {
            class: Mt([s.value, "title-icon"])
          }, null, 2),
          ni(" " + Ve(q(a).title), 1)
        ]),
        Q("p", {
          class: "wh-text-[14px]",
          innerHTML: q(a).description.replace(/\n/g, "<br/>")
        }, null, 8, PT),
        l.value ? (z(), ne("div", NT, [
          Q("a", {
            class: "wh-inline-block wh-box-border wh-bg-[var(--primary)] wh-text-white wh-font-bold wh-rounded-[16px] wh-p-[16px]",
            href: q(a).link,
            target: "_blank",
            textContent: Ve(q(a).buttonText)
          }, null, 8, RT)
        ])) : qe("", !0)
      ])
    ]));
  }
}), MT = /* @__PURE__ */ Ut(FT, [["__scopeId", "data-v-d5b4b4a2"]]), DT = ["aria-expanded", "tabindex"], $T = { class: "wh-text-[16px] wh-font-semibold wh-flex wh-items-center wh-w-full wh-gap-2 wh-text-left" }, BT = { class: "wh-text-[14px] wh-flex wh-flex-wrap wh-gap-2 wh-justify-start wh-w-full" }, VT = ["textContent"], UT = ["tabindex", "aria-expanded", "textContent"], cv = /* @__PURE__ */ Qe({
  __name: "BannerContent",
  props: {
    banner: {},
    isAllowedTab: { type: Boolean },
    isExpanded: { type: Boolean }
  },
  emits: ["banner:open-modal"],
  setup(e, { emit: n }) {
    const r = e, { banner: a } = ht(r), o = n, s = A(() => ({
      circle_info: "icon-info-circ",
      circle_check: "icon-check-circ",
      circle_cone: "icon-construction-circ",
      circle_warning: "icon-disturbance-circ",
      circle_question: "icon-question-circ"
    })[a.value.picto] || "icon-info-circ");
    return (l, c) => (z(), ne("div", {
      role: "button",
      "aria-controls": "banner-modal",
      "aria-haspopup": "dialog",
      "aria-expanded": l.isExpanded,
      class: "wh-w-full wh-flex wh-flex-col wh-items-start wh-gap-5 wh-relative",
      tabindex: l.isAllowedTab ? 0 : -1,
      onClick: c[0] || (c[0] = (f) => o("banner:open-modal", f))
    }, [
      Q("h2", $T, [
        Q("i", {
          class: Mt(s.value),
          style: { "font-size": "24px" }
        }, null, 2),
        ni(" " + Ve(q(a).title), 1)
      ]),
      Q("div", BT, [
        Q("p", {
          class: "md:wh-max-w-[80%] md:wh-w-auto wh-w-full wh-text-ellipsis wh-text-left wh-overflow-hidden wh-whitespace-nowrap",
          textContent: Ve(q(a).description)
        }, null, 8, VT),
        Q("button", {
          tabindex: l.isAllowedTab ? 0 : -1,
          "aria-controls": "banner-modal",
          "aria-haspopup": "dialog",
          "aria-expanded": l.isExpanded,
          class: "wh-font-bold",
          textContent: Ve(l.$t("wh:banners:read-more"))
        }, null, 8, UT)
      ])
    ], 8, DT));
  }
});
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var Eg = HT, fv = GT, WT = Object.prototype.toString, No = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
function HT(e, n) {
  if (typeof e != "string")
    throw new TypeError("argument str must be a string");
  for (var r = {}, a = n || {}, o = a.decode || zT, s = 0; s < e.length; ) {
    var l = e.indexOf("=", s);
    if (l === -1)
      break;
    var c = e.indexOf(";", s);
    if (c === -1)
      c = e.length;
    else if (c < l) {
      s = e.lastIndexOf(";", l - 1) + 1;
      continue;
    }
    var f = e.slice(s, l).trim();
    if (r[f] === void 0) {
      var h = e.slice(l + 1, c).trim();
      h.charCodeAt(0) === 34 && (h = h.slice(1, -1)), r[f] = jT(h, o);
    }
    s = c + 1;
  }
  return r;
}
function GT(e, n, r) {
  var a = r || {}, o = a.encode || qT;
  if (typeof o != "function")
    throw new TypeError("option encode is invalid");
  if (!No.test(e))
    throw new TypeError("argument name is invalid");
  var s = o(n);
  if (s && !No.test(s))
    throw new TypeError("argument val is invalid");
  var l = e + "=" + s;
  if (a.maxAge != null) {
    var c = a.maxAge - 0;
    if (isNaN(c) || !isFinite(c))
      throw new TypeError("option maxAge is invalid");
    l += "; Max-Age=" + Math.floor(c);
  }
  if (a.domain) {
    if (!No.test(a.domain))
      throw new TypeError("option domain is invalid");
    l += "; Domain=" + a.domain;
  }
  if (a.path) {
    if (!No.test(a.path))
      throw new TypeError("option path is invalid");
    l += "; Path=" + a.path;
  }
  if (a.expires) {
    var f = a.expires;
    if (!KT(f) || isNaN(f.valueOf()))
      throw new TypeError("option expires is invalid");
    l += "; Expires=" + f.toUTCString();
  }
  if (a.httpOnly && (l += "; HttpOnly"), a.secure && (l += "; Secure"), a.partitioned && (l += "; Partitioned"), a.priority) {
    var h = typeof a.priority == "string" ? a.priority.toLowerCase() : a.priority;
    switch (h) {
      case "low":
        l += "; Priority=Low";
        break;
      case "medium":
        l += "; Priority=Medium";
        break;
      case "high":
        l += "; Priority=High";
        break;
      default:
        throw new TypeError("option priority is invalid");
    }
  }
  if (a.sameSite) {
    var v = typeof a.sameSite == "string" ? a.sameSite.toLowerCase() : a.sameSite;
    switch (v) {
      case !0:
        l += "; SameSite=Strict";
        break;
      case "lax":
        l += "; SameSite=Lax";
        break;
      case "strict":
        l += "; SameSite=Strict";
        break;
      case "none":
        l += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return l;
}
function zT(e) {
  return e.indexOf("%") !== -1 ? decodeURIComponent(e) : e;
}
function qT(e) {
  return encodeURIComponent(e);
}
function KT(e) {
  return WT.call(e) === "[object Date]" || e instanceof Date;
}
function jT(e, n) {
  try {
    return n(e);
  } catch {
    return e;
  }
}
function YT() {
  const e = typeof global > "u" ? void 0 : global.TEST_HAS_DOCUMENT_COOKIE;
  return typeof e == "boolean" ? e : typeof document == "object" && typeof document.cookie == "string";
}
function XT(e) {
  return typeof e == "string" ? Eg(e) : typeof e == "object" && e !== null ? e : {};
}
function Yl(e, n = {}) {
  const r = JT(e);
  if (!n.doNotParse)
    try {
      return JSON.parse(r);
    } catch {
    }
  return e;
}
function JT(e) {
  return e && e[0] === "j" && e[1] === ":" ? e.substr(2) : e;
}
class xg {
  constructor(n, r = {}) {
    this.changeListeners = [], this.HAS_DOCUMENT_COOKIE = !1, this.update = () => {
      if (!this.HAS_DOCUMENT_COOKIE)
        return;
      const o = this.cookies;
      this.cookies = Eg(document.cookie), this._checkChanges(o);
    };
    const a = typeof document > "u" ? "" : document.cookie;
    this.cookies = XT(n || a), this.defaultSetOptions = r, this.HAS_DOCUMENT_COOKIE = YT();
  }
  _emitChange(n) {
    for (let r = 0; r < this.changeListeners.length; ++r)
      this.changeListeners[r](n);
  }
  _checkChanges(n) {
    new Set(Object.keys(n).concat(Object.keys(this.cookies))).forEach((a) => {
      n[a] !== this.cookies[a] && this._emitChange({
        name: a,
        value: Yl(this.cookies[a])
      });
    });
  }
  _startPolling() {
    this.pollingInterval = setInterval(this.update, 300);
  }
  _stopPolling() {
    this.pollingInterval && clearInterval(this.pollingInterval);
  }
  get(n, r = {}) {
    return r.doNotUpdate || this.update(), Yl(this.cookies[n], r);
  }
  getAll(n = {}) {
    n.doNotUpdate || this.update();
    const r = {};
    for (let a in this.cookies)
      r[a] = Yl(this.cookies[a], n);
    return r;
  }
  set(n, r, a) {
    a ? a = Object.assign(Object.assign({}, this.defaultSetOptions), a) : a = this.defaultSetOptions;
    const o = typeof r == "string" ? r : JSON.stringify(r);
    this.cookies = Object.assign(Object.assign({}, this.cookies), { [n]: o }), this.HAS_DOCUMENT_COOKIE && (document.cookie = fv(n, o, a)), this._emitChange({ name: n, value: r, options: a });
  }
  remove(n, r) {
    const a = r = Object.assign(Object.assign(Object.assign({}, this.defaultSetOptions), r), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 });
    this.cookies = Object.assign({}, this.cookies), delete this.cookies[n], this.HAS_DOCUMENT_COOKIE && (document.cookie = fv(n, "", a)), this._emitChange({ name: n, value: void 0, options: r });
  }
  addChangeListener(n) {
    this.changeListeners.push(n), this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 1 && (typeof window == "object" && "cookieStore" in window ? window.cookieStore.addEventListener("change", this.update) : this._startPolling());
  }
  removeChangeListener(n) {
    const r = this.changeListeners.indexOf(n);
    r >= 0 && this.changeListeners.splice(r, 1), this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 0 && (typeof window == "object" && "cookieStore" in window ? window.cookieStore.removeEventListener("change", this.update) : this._stopPolling());
  }
}
function Ag(e, { doNotParse: n = !1, autoUpdateDependencies: r = !1 } = {}, a = new xg()) {
  const o = r ? [...e || []] : e;
  let s = a.getAll({ doNotParse: !0 });
  const l = oe(0), c = () => {
    const f = a.getAll({ doNotParse: !0 });
    ZT(
      o || null,
      f,
      s
    ) && l.value++, s = f;
  };
  return a.addChangeListener(c), Nv(() => {
    a.removeChangeListener(c);
  }), {
    /**
     * Reactive get cookie by name. If **autoUpdateDependencies = true** then it will update watching dependencies
     */
    get: (...f) => (r && o && !o.includes(f[0]) && o.push(f[0]), l.value, a.get(f[0], { doNotParse: n, ...f[1] })),
    /**
     * Reactive get all cookies
     */
    getAll: (...f) => (l.value, a.getAll({ doNotParse: n, ...f[0] })),
    set: (...f) => a.set(...f),
    remove: (...f) => a.remove(...f),
    addChangeListener: (...f) => a.addChangeListener(...f),
    removeChangeListener: (...f) => a.removeChangeListener(...f)
  };
}
function ZT(e, n, r) {
  if (!e)
    return !0;
  for (const a of e)
    if (n[a] !== r[a])
      return !0;
  return !1;
}
const QT = (e) => {
  const n = oe([]), r = Ag(
    ["banners:already-close"],
    {
      autoUpdateDependencies: !0
    },
    new xg(null, {
      domain: e.banners?.cookieDomain,
      path: "/"
    })
  ), a = A(
    () => n.value.filter((c) => !o(c.id))
  ), o = (c) => {
    if (typeof window > "u")
      return !1;
    const f = r.get("banners:already-closed");
    return f ? f.includes(c) : !1;
  };
  return {
    fetchedBanners: n,
    filteredBanners: a,
    isAlreadyClosed: o,
    saveClosedBanner: (c) => {
      if (typeof window > "u")
        return;
      const f = r.get("banners:already-closed");
      if (f) {
        r.set("banners:already-closed", [...f, c]);
        return;
      }
      r.set("banners:already-closed", [c]);
    },
    loadBanners: async () => {
      try {
        const c = await fetch(`${e.apiUrl}/core/v1/banners`, {
          headers: {
            "X-Api-Key": e.apiKey
          }
        }).then((f) => f.json());
        n.value = c.banners ?? [];
      } catch (c) {
        console.log("Failed to load banners", c);
      }
    }
  };
}, lc = (e) => (Ui("data-v-af367140"), e = e(), Wi(), e), eI = {
  key: 0,
  class: "wh-mt-5 wh-flex wh-justify-between wh-items-center"
}, tI = ["title"], nI = /* @__PURE__ */ lc(() => /* @__PURE__ */ Q("i", { class: "icon-chevron-left" }, null, -1)), rI = [
  nI
], iI = { class: "wh-flex wh-gap-1" }, aI = ["title", "onClick"], oI = ["title"], sI = /* @__PURE__ */ lc(() => /* @__PURE__ */ Q("i", { class: "icon-chevron-right" }, null, -1)), lI = [
  sI
], uI = ["aria-label", "title"], cI = /* @__PURE__ */ lc(() => /* @__PURE__ */ Q("i", { class: "icon-close" }, null, -1)), fI = [
  cI
], dI = /* @__PURE__ */ Qe({
  __name: "BannersCarousel",
  props: {
    configuration: {}
  },
  setup(e) {
    const n = e, { configuration: r } = ht(n), a = oe(null), o = oe(), s = oe(), l = oe(), c = oe(!1), f = r.value.banners.cookieDomain, { loadBanners: h, saveClosedBanner: v, filteredBanners: m } = QT({
      ...r.value,
      banners: {
        ...r.value.banners,
        enabled: !0,
        cookieDomain: f
      }
    }), { colorVars: p } = rs(r), y = A(() => m.value.length === 1 ? m.value[0] : m.value[
      // @ts-ignore
      o.value?.data?.currentSlide.value || 0
    ]);
    qt(async () => {
      await h();
    });
    const b = () => {
      o.value?.next();
    }, C = () => {
      o.value?.prev();
    }, S = (L) => {
      o.value?.slideTo(L);
    }, R = (L) => {
      c.value = !0, a.value = L.target;
    };
    Re(c, () => {
      if (c.value === !1) {
        document.body.classList.remove("wh-banners-modal-open"), window.setTimeout(() => {
          a.value?.focus();
        });
        return;
      }
      document.body.classList.add("wh-banners-modal-open");
    });
    const $ = (L) => L === o.value?.data?.currentSlide.value, k = () => {
      v(y.value.id);
    };
    return (L, F) => q(m).length > 0 ? (z(), ne("div", {
      key: 0,
      ref_key: "containerRef",
      ref: l,
      class: "wh-top-[65px] wh-bg-[var(--secondary)] wh-text-white md:wh-ml-[80px] wh-p-3 wh-fixed md:wh-w-[calc(100%-80px)] wh-w-full wh-z-40",
      style: Di(q(p))
    }, [
      q(m).length > 1 ? (z(), wt(q(rx), {
        key: 0,
        ref_key: "carouselElementRef",
        ref: o,
        "wrap-around": "",
        "aria-label": L.$t("wh:banners:accessibility-label")
      }, {
        addons: bt(({ slidesCount: P, currentSlide: E }) => [
          P > 1 ? (z(), ne("div", eI, [
            Q("button", {
              title: L.$t("wh:banners:slide-previous"),
              onClick: C
            }, rI, 8, tI),
            Q("nav", null, [
              Q("ul", iI, [
                (z(!0), ne(Ie, null, pt(q(m), (V, W) => (z(), ne("li", { key: W }, [
                  Q("button", {
                    title: L.$t("wh:banners:slide-to", {
                      index: W + 1
                    }),
                    onClick: (me) => S(W)
                  }, [
                    Q("i", {
                      class: Mt({
                        "icon-dot-fill": W === E,
                        "icon-dot-outline": W !== E
                      }),
                      style: { "font-size": "12px" }
                    }, null, 2)
                  ], 8, aI)
                ]))), 128))
              ])
            ]),
            Q("button", {
              title: L.$t("wh:banners:slide-next"),
              onClick: b
            }, lI, 8, oI)
          ])) : qe("", !0)
        ]),
        default: bt(() => [
          (z(!0), ne(Ie, null, pt(q(m), (P, E) => (z(), wt(q(ix), {
            key: P.id
          }, {
            default: bt(() => [
              T(cv, {
                banner: P,
                "is-allowed-tab": $(E),
                "is-expanded": c.value,
                "onBanner:openModal": R
              }, null, 8, ["banner", "is-allowed-tab", "is-expanded"])
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 1
      }, 8, ["aria-label"])) : (z(), wt(cv, {
        key: 1,
        banner: q(m)[0],
        "is-allowed-tab": !0,
        "is-expanded": c.value,
        "onBanner:openModal": R
      }, null, 8, ["banner", "is-expanded"])),
      Q("button", {
        ref_key: "closeButtonRef",
        ref: s,
        class: "wh-absolute wh-top-2 wh-z-50 wh-right-2 wh-flex wh-items-center",
        "aria-label": L.$t("wh:banners:add-to-closed"),
        title: L.$t("wh:banners:add-to-closed"),
        onClick: k
      }, fI, 8, uI),
      T(q(fT), {
        id: "banner-modal",
        modelValue: c.value,
        "onUpdate:modelValue": F[1] || (F[1] = (P) => c.value = P),
        "max-width": "600",
        attach: l.value,
        "aria-label": L.$t("wh:banners:modal-title")
      }, {
        default: bt(() => [
          T(MT, {
            banner: y.value,
            onClose: F[0] || (F[0] = (P) => c.value = !1)
          }, null, 8, ["banner"])
        ]),
        _: 1
      }, 8, ["modelValue", "attach", "aria-label"])
    ], 4)) : qe("", !0);
  }
}), hI = /* @__PURE__ */ Ut(dI, [["__scopeId", "data-v-af367140"]]), Ki = () => {
  const e = A(() => {
    const c = s().get("userToken");
    if (c)
      return c.accessToken;
  }), n = A(() => {
    const c = s().get("userInfos");
    if (c)
      return c;
  }), r = A(() => {
    if (n.value) {
      const l = o();
      return `${l.firstName} ${l.lastName}`;
    }
    return "";
  }), a = A(() => s().get("userToken") !== void 0);
  function o() {
    const c = s().get("userInfos");
    if (c)
      return c.attributes;
  }
  function s() {
    return Ag(["userToken"], {
      doNotParse: !1,
      autoUpdateDependencies: !0
    });
  }
  return {
    isAuthenticated: a,
    userLabel: r,
    userToken: e
  };
}, $r = (e) => {
  const { getConfiguration: n } = Mu(e), r = Ze(NN, yr().t), a = Ze(Ma, "LIB"), o = (l) => !s(l).startsWith("http"), s = (l, c) => r(l, {
    storeURL: a === "VAD" ? "" : n("storeURL"),
    simURL: a === "SIM" ? "" : n("simURL"),
    cmsURL: n("cmsURL"),
    ...c
  });
  return {
    translateLink: s,
    shouldUseRouterLink: o
  };
}, Ma = Symbol(
  "INJECT_MAIN_APPLICATION_CONTEXT"
), vI = { class: "AccountMenu" }, mI = ["aria-label"], gI = /* @__PURE__ */ Q("i", { class: "AccountMenu-icon icon-account-fill wh-text-[25px]" }, null, -1), pI = ["textContent"], _I = { class: "AccountMenu-content md:wh-w-auto wh-bg-white wh-px-5 wh-pt-5 wh-rounded-[8px] wh-shadow-[0_0_8px_rgba(0,0,0,0.5)]" }, yI = ["textContent"], bI = { class: "wh-flex wh-flex-col wh-gap-5" }, wI = ["textContent"], CI = ["textContent"], SI = ["href"], EI = ["textContent"], xI = ["onClick"], AI = ["textContent"], kI = /* @__PURE__ */ Q("i", { class: "AccountMenu-icon icon-account-outline wh-text-[25px]" }, null, -1), TI = ["textContent"], II = /* @__PURE__ */ Qe({
  __name: "AccountMenu",
  props: {
    configuration: {},
    accountConfiguration: {},
    customAccountConfiguration: { default: void 0 },
    accountMenu: { default: () => [] }
  },
  setup(e) {
    const n = e, r = oe(!1), {
      configuration: a,
      accountConfiguration: o,
      accountMenu: s,
      customAccountConfiguration: l
    } = ht(n), c = A(() => ({
      ...o.value,
      ...l.value
    })), f = c.value["cookies-domain"], h = A(() => ({
      ...c.value,
      "cookies-domain": f,
      "is-signed-in-loader-displayed": !1
    })), { translateLink: v, shouldUseRouterLink: m } = $r(a), { isAuthenticated: p, userLabel: y } = Ki(), b = oe(!1), C = Ze(Ma), S = () => {
      document.body.dispatchEvent(
        new CustomEvent("kas-login", {
          detail: { redirectTo: window.location.href }
        })
      );
    };
    qt(async () => {
      const { load: $ } = Uo(
        `https://storage.googleapis.com/is-cdn-${c.value.environment}/widgets/${c.value["network-id"]}/login/dist/js/app.js?context=${C}`,
        () => {
          b.value = !0;
        },
        {
          manual: !0,
          type: "module"
        }
      );
      await $(), setTimeout(() => {
        document.body.dispatchEvent(new CustomEvent("login-widget-ready"));
      }, 0);
    });
    const R = ($) => {
      $ === "logout" && document.body.dispatchEvent(new CustomEvent("kas-logout"));
    };
    return ($, k) => {
      const L = UC("router-link");
      return z(), ne("div", vI, [
        q(p) ? (z(), wt(q(Fa), {
          key: 0,
          modelValue: r.value,
          "onUpdate:modelValue": k[0] || (k[0] = (F) => r.value = F),
          location: "bottom start",
          attach: "#web-harmony-header-nav"
        }, {
          activator: bt(({ props: F }) => [
            Q("button", Te(F, {
              "aria-label": $.$t("wh:account:menu"),
              class: [{ "AccountMenu-headerButton--active": r.value }, "AccountMenu-headerButton"]
            }), [
              gI,
              Q("span", {
                class: "wh-hidden md:wh-block",
                textContent: Ve(q(y))
              }, null, 8, pI)
            ], 16, mI)
          ]),
          default: bt(() => [
            Q("div", _I, [
              Q("h3", {
                class: "md:wh-hidden wh-text-xl wh-font-bold wh-text-center wh-mb-2",
                textContent: Ve($.$t("wh:account:menu"))
              }, null, 8, yI),
              Q("nav", bI, [
                (z(!0), ne(Ie, null, pt(q(s), (F, P) => (z(), ne("ul", {
                  key: P,
                  class: Mt(["wh-border-neutral-200 wh-pb-3 wh-flex wh-flex-col wh-gap-2", {
                    "wh-border-b": P !== q(s).length - 1
                  }])
                }, [
                  F.title ? (z(), ne("li", {
                    key: 0,
                    class: "wh-text-neutral-400",
                    textContent: Ve($.$t(F.title))
                  }, null, 8, wI)) : qe("", !0),
                  (z(!0), ne(Ie, null, pt(F.items, (E, V) => (z(), ne("li", {
                    key: V,
                    class: "AccountMenu-item"
                  }, [
                    E.link && q(m)(E.link) ? (z(), ne(Ie, { key: 0 }, [
                      E.link ? (z(), wt(L, {
                        key: 0,
                        to: q(v)(E.link),
                        class: "wh-flex wh-items-center wh-gap-3 AccountMenu-itemLink"
                      }, {
                        default: bt(() => [
                          Q("i", {
                            class: Mt(`icon-${E.icon} AccountMenu-itemIcon`)
                          }, null, 2),
                          Q("span", {
                            textContent: Ve($.$t(E.label))
                          }, null, 8, CI)
                        ]),
                        _: 2
                      }, 1032, ["to"])) : qe("", !0)
                    ], 64)) : E.link ? (z(), ne(Ie, { key: 1 }, [
                      E.link ? (z(), ne("a", {
                        key: 0,
                        href: q(v)(E.link),
                        class: "wh-flex wh-items-center wh-gap-3 AccountMenu-itemLink"
                      }, [
                        Q("i", {
                          class: Mt(`icon-${E.icon} AccountMenu-itemIcon`)
                        }, null, 2),
                        Q("span", {
                          textContent: Ve($.$t(E.label))
                        }, null, 8, EI)
                      ], 8, SI)) : qe("", !0)
                    ], 64)) : (z(), ne(Ie, { key: 2 }, [
                      E.specific ? (z(), ne("button", {
                        key: 0,
                        class: "wh-flex wh-items-center wh-gap-3 AccountMenu-itemLink",
                        onClick: (W) => R(E.specific)
                      }, [
                        Q("i", {
                          class: Mt(`icon-${E.icon} AccountMenu-itemIcon`)
                        }, null, 2),
                        Q("span", {
                          textContent: Ve($.$t(E.label))
                        }, null, 8, AI)
                      ], 8, xI)) : qe("", !0)
                    ], 64))
                  ]))), 128))
                ], 2))), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])) : (z(), ne("button", {
          key: 1,
          class: "AccountMenu-headerButton",
          onClick: S
        }, [
          kI,
          Q("span", {
            class: "wh-hidden sm:wh-block",
            textContent: Ve($.$t("wh:account:login"))
          }, null, 8, TI)
        ])),
        b.value ? (z(), ne("login-component", WC(Te({ key: 2 }, h.value)), null, 16)) : qe("", !0)
      ]);
    };
  }
}), LI = {
  key: 0,
  class: "wh-flex wh-items-center wh-gap-2"
}, OI = ["href", "title"], PI = ["src", "alt"], NI = /* @__PURE__ */ Qe({
  __name: "AdditionnalLogos",
  props: {
    items: {}
  },
  setup(e) {
    const n = e, { items: r } = ht(n);
    return (a, o) => q(r) ? (z(), ne("div", LI, [
      (z(!0), ne(Ie, null, pt(q(r), (s, l) => (z(), ne("a", {
        key: l,
        href: s.link ?? "/",
        target: "_blank",
        title: a.$t(s.alt)
      }, [
        Q("img", {
          class: "wh-h-[50px]",
          src: s.url,
          alt: a.$t(s.alt ?? "")
        }, null, 8, PI)
      ], 8, OI))), 128))
    ])) : qe("", !0);
  }
});
function kg(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: RI } = Object.prototype, { getPrototypeOf: uc } = Object, ms = /* @__PURE__ */ ((e) => (n) => {
  const r = RI.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Kn = (e) => (e = e.toLowerCase(), (n) => ms(n) === e), gs = (e) => (n) => typeof n === e, { isArray: ji } = Array, La = gs("undefined");
function FI(e) {
  return e !== null && !La(e) && e.constructor !== null && !La(e.constructor) && yn(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Tg = Kn("ArrayBuffer");
function MI(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && Tg(e.buffer), n;
}
const DI = gs("string"), yn = gs("function"), Ig = gs("number"), ps = (e) => e !== null && typeof e == "object", $I = (e) => e === !0 || e === !1, $o = (e) => {
  if (ms(e) !== "object")
    return !1;
  const n = uc(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, BI = Kn("Date"), VI = Kn("File"), UI = Kn("Blob"), WI = Kn("FileList"), HI = (e) => ps(e) && yn(e.pipe), GI = (e) => {
  let n;
  return e && (typeof FormData == "function" && e instanceof FormData || yn(e.append) && ((n = ms(e)) === "formdata" || // detect form-data instance
  n === "object" && yn(e.toString) && e.toString() === "[object FormData]"));
}, zI = Kn("URLSearchParams"), [qI, KI, jI, YI] = ["ReadableStream", "Request", "Response", "Headers"].map(Kn), XI = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Da(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let a, o;
  if (typeof e != "object" && (e = [e]), ji(e))
    for (a = 0, o = e.length; a < o; a++)
      n.call(null, e[a], a, e);
  else {
    const s = r ? Object.getOwnPropertyNames(e) : Object.keys(e), l = s.length;
    let c;
    for (a = 0; a < l; a++)
      c = s[a], n.call(null, e[c], c, e);
  }
}
function Lg(e, n) {
  n = n.toLowerCase();
  const r = Object.keys(e);
  let a = r.length, o;
  for (; a-- > 0; )
    if (o = r[a], n === o.toLowerCase())
      return o;
  return null;
}
const Xr = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Og = (e) => !La(e) && e !== Xr;
function Su() {
  const { caseless: e } = Og(this) && this || {}, n = {}, r = (a, o) => {
    const s = e && Lg(n, o) || o;
    $o(n[s]) && $o(a) ? n[s] = Su(n[s], a) : $o(a) ? n[s] = Su({}, a) : ji(a) ? n[s] = a.slice() : n[s] = a;
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && Da(arguments[a], r);
  return n;
}
const JI = (e, n, r, { allOwnKeys: a } = {}) => (Da(n, (o, s) => {
  r && yn(o) ? e[s] = kg(o, r) : e[s] = o;
}, { allOwnKeys: a }), e), ZI = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), QI = (e, n, r, a) => {
  e.prototype = Object.create(n.prototype, a), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, eL = (e, n, r, a) => {
  let o, s, l;
  const c = {};
  if (n = n || {}, e == null) return n;
  do {
    for (o = Object.getOwnPropertyNames(e), s = o.length; s-- > 0; )
      l = o[s], (!a || a(l, e, n)) && !c[l] && (n[l] = e[l], c[l] = !0);
    e = r !== !1 && uc(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, tL = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const a = e.indexOf(n, r);
  return a !== -1 && a === r;
}, nL = (e) => {
  if (!e) return null;
  if (ji(e)) return e;
  let n = e.length;
  if (!Ig(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, rL = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && uc(Uint8Array)), iL = (e, n) => {
  const a = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = a.next()) && !o.done; ) {
    const s = o.value;
    n.call(e, s[0], s[1]);
  }
}, aL = (e, n) => {
  let r;
  const a = [];
  for (; (r = e.exec(n)) !== null; )
    a.push(r);
  return a;
}, oL = Kn("HTMLFormElement"), sL = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, a, o) {
    return a.toUpperCase() + o;
  }
), dv = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), lL = Kn("RegExp"), Pg = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), a = {};
  Da(r, (o, s) => {
    let l;
    (l = n(o, s, e)) !== !1 && (a[s] = l || o);
  }), Object.defineProperties(e, a);
}, uL = (e) => {
  Pg(e, (n, r) => {
    if (yn(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const a = e[r];
    if (yn(a)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, cL = (e, n) => {
  const r = {}, a = (o) => {
    o.forEach((s) => {
      r[s] = !0;
    });
  };
  return ji(e) ? a(e) : a(String(e).split(n)), r;
}, fL = () => {
}, dL = (e, n) => e != null && Number.isFinite(e = +e) ? e : n, Xl = "abcdefghijklmnopqrstuvwxyz", hv = "0123456789", Ng = {
  DIGIT: hv,
  ALPHA: Xl,
  ALPHA_DIGIT: Xl + Xl.toUpperCase() + hv
}, hL = (e = 16, n = Ng.ALPHA_DIGIT) => {
  let r = "";
  const { length: a } = n;
  for (; e--; )
    r += n[Math.random() * a | 0];
  return r;
};
function vL(e) {
  return !!(e && yn(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const mL = (e) => {
  const n = new Array(10), r = (a, o) => {
    if (ps(a)) {
      if (n.indexOf(a) >= 0)
        return;
      if (!("toJSON" in a)) {
        n[o] = a;
        const s = ji(a) ? [] : {};
        return Da(a, (l, c) => {
          const f = r(l, o + 1);
          !La(f) && (s[c] = f);
        }), n[o] = void 0, s;
      }
    }
    return a;
  };
  return r(e, 0);
}, gL = Kn("AsyncFunction"), pL = (e) => e && (ps(e) || yn(e)) && yn(e.then) && yn(e.catch), Rg = ((e, n) => e ? setImmediate : n ? ((r, a) => (Xr.addEventListener("message", ({ source: o, data: s }) => {
  o === Xr && s === r && a.length && a.shift()();
}, !1), (o) => {
  a.push(o), Xr.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  yn(Xr.postMessage)
), _L = typeof queueMicrotask < "u" ? queueMicrotask.bind(Xr) : typeof process < "u" && process.nextTick || Rg, U = {
  isArray: ji,
  isArrayBuffer: Tg,
  isBuffer: FI,
  isFormData: GI,
  isArrayBufferView: MI,
  isString: DI,
  isNumber: Ig,
  isBoolean: $I,
  isObject: ps,
  isPlainObject: $o,
  isReadableStream: qI,
  isRequest: KI,
  isResponse: jI,
  isHeaders: YI,
  isUndefined: La,
  isDate: BI,
  isFile: VI,
  isBlob: UI,
  isRegExp: lL,
  isFunction: yn,
  isStream: HI,
  isURLSearchParams: zI,
  isTypedArray: rL,
  isFileList: WI,
  forEach: Da,
  merge: Su,
  extend: JI,
  trim: XI,
  stripBOM: ZI,
  inherits: QI,
  toFlatObject: eL,
  kindOf: ms,
  kindOfTest: Kn,
  endsWith: tL,
  toArray: nL,
  forEachEntry: iL,
  matchAll: aL,
  isHTMLForm: oL,
  hasOwnProperty: dv,
  hasOwnProp: dv,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Pg,
  freezeMethods: uL,
  toObjectSet: cL,
  toCamelCase: sL,
  noop: fL,
  toFiniteNumber: dL,
  findKey: Lg,
  global: Xr,
  isContextDefined: Og,
  ALPHABET: Ng,
  generateString: hL,
  isSpecCompliantForm: vL,
  toJSONObject: mL,
  isAsyncFn: gL,
  isThenable: pL,
  setImmediate: Rg,
  asap: _L
};
function De(e, n, r, a, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), r && (this.config = r), a && (this.request = a), o && (this.response = o, this.status = o.status ? o.status : null);
}
U.inherits(De, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: U.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Fg = De.prototype, Mg = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Mg[e] = { value: e };
});
Object.defineProperties(De, Mg);
Object.defineProperty(Fg, "isAxiosError", { value: !0 });
De.from = (e, n, r, a, o, s) => {
  const l = Object.create(Fg);
  return U.toFlatObject(e, l, function(f) {
    return f !== Error.prototype;
  }, (c) => c !== "isAxiosError"), De.call(l, e.message, n, r, a, o), l.cause = e, l.name = e.name, s && Object.assign(l, s), l;
};
const yL = null;
function Eu(e) {
  return U.isPlainObject(e) || U.isArray(e);
}
function Dg(e) {
  return U.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function vv(e, n, r) {
  return e ? e.concat(n).map(function(o, s) {
    return o = Dg(o), !r && s ? "[" + o + "]" : o;
  }).join(r ? "." : "") : n;
}
function bL(e) {
  return U.isArray(e) && !e.some(Eu);
}
const wL = U.toFlatObject(U, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function _s(e, n, r) {
  if (!U.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = U.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(C, S) {
    return !U.isUndefined(S[C]);
  });
  const a = r.metaTokens, o = r.visitor || v, s = r.dots, l = r.indexes, f = (r.Blob || typeof Blob < "u" && Blob) && U.isSpecCompliantForm(n);
  if (!U.isFunction(o))
    throw new TypeError("visitor must be a function");
  function h(b) {
    if (b === null) return "";
    if (U.isDate(b))
      return b.toISOString();
    if (!f && U.isBlob(b))
      throw new De("Blob is not supported. Use a Buffer instead.");
    return U.isArrayBuffer(b) || U.isTypedArray(b) ? f && typeof Blob == "function" ? new Blob([b]) : Buffer.from(b) : b;
  }
  function v(b, C, S) {
    let R = b;
    if (b && !S && typeof b == "object") {
      if (U.endsWith(C, "{}"))
        C = a ? C : C.slice(0, -2), b = JSON.stringify(b);
      else if (U.isArray(b) && bL(b) || (U.isFileList(b) || U.endsWith(C, "[]")) && (R = U.toArray(b)))
        return C = Dg(C), R.forEach(function(k, L) {
          !(U.isUndefined(k) || k === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            l === !0 ? vv([C], L, s) : l === null ? C : C + "[]",
            h(k)
          );
        }), !1;
    }
    return Eu(b) ? !0 : (n.append(vv(S, C, s), h(b)), !1);
  }
  const m = [], p = Object.assign(wL, {
    defaultVisitor: v,
    convertValue: h,
    isVisitable: Eu
  });
  function y(b, C) {
    if (!U.isUndefined(b)) {
      if (m.indexOf(b) !== -1)
        throw Error("Circular reference detected in " + C.join("."));
      m.push(b), U.forEach(b, function(R, $) {
        (!(U.isUndefined(R) || R === null) && o.call(
          n,
          R,
          U.isString($) ? $.trim() : $,
          C,
          p
        )) === !0 && y(R, C ? C.concat($) : [$]);
      }), m.pop();
    }
  }
  if (!U.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), n;
}
function mv(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(a) {
    return n[a];
  });
}
function cc(e, n) {
  this._pairs = [], e && _s(e, this, n);
}
const $g = cc.prototype;
$g.append = function(n, r) {
  this._pairs.push([n, r]);
};
$g.toString = function(n) {
  const r = n ? function(a) {
    return n.call(this, a, mv);
  } : mv;
  return this._pairs.map(function(o) {
    return r(o[0]) + "=" + r(o[1]);
  }, "").join("&");
};
function CL(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Bg(e, n, r) {
  if (!n)
    return e;
  const a = r && r.encode || CL, o = r && r.serialize;
  let s;
  if (o ? s = o(n, r) : s = U.isURLSearchParams(n) ? n.toString() : new cc(n, r).toString(a), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class gv {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, a) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: a ? a.synchronous : !1,
      runWhen: a ? a.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    U.forEach(this.handlers, function(a) {
      a !== null && n(a);
    });
  }
}
const Vg = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, SL = typeof URLSearchParams < "u" ? URLSearchParams : cc, EL = typeof FormData < "u" ? FormData : null, xL = typeof Blob < "u" ? Blob : null, AL = {
  isBrowser: !0,
  classes: {
    URLSearchParams: SL,
    FormData: EL,
    Blob: xL
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, fc = typeof window < "u" && typeof document < "u", xu = typeof navigator == "object" && navigator || void 0, kL = fc && (!xu || ["ReactNative", "NativeScript", "NS"].indexOf(xu.product) < 0), TL = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", IL = fc && window.location.href || "http://localhost", LL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: fc,
  hasStandardBrowserEnv: kL,
  hasStandardBrowserWebWorkerEnv: TL,
  navigator: xu,
  origin: IL
}, Symbol.toStringTag, { value: "Module" })), sn = {
  ...LL,
  ...AL
};
function OL(e, n) {
  return _s(e, new sn.classes.URLSearchParams(), Object.assign({
    visitor: function(r, a, o, s) {
      return sn.isNode && U.isBuffer(r) ? (this.append(a, r.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    }
  }, n));
}
function PL(e) {
  return U.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function NL(e) {
  const n = {}, r = Object.keys(e);
  let a;
  const o = r.length;
  let s;
  for (a = 0; a < o; a++)
    s = r[a], n[s] = e[s];
  return n;
}
function Ug(e) {
  function n(r, a, o, s) {
    let l = r[s++];
    if (l === "__proto__") return !0;
    const c = Number.isFinite(+l), f = s >= r.length;
    return l = !l && U.isArray(o) ? o.length : l, f ? (U.hasOwnProp(o, l) ? o[l] = [o[l], a] : o[l] = a, !c) : ((!o[l] || !U.isObject(o[l])) && (o[l] = []), n(r, a, o[l], s) && U.isArray(o[l]) && (o[l] = NL(o[l])), !c);
  }
  if (U.isFormData(e) && U.isFunction(e.entries)) {
    const r = {};
    return U.forEachEntry(e, (a, o) => {
      n(PL(a), o, r, 0);
    }), r;
  }
  return null;
}
function RL(e, n, r) {
  if (U.isString(e))
    try {
      return (n || JSON.parse)(e), U.trim(e);
    } catch (a) {
      if (a.name !== "SyntaxError")
        throw a;
    }
  return (r || JSON.stringify)(e);
}
const $a = {
  transitional: Vg,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(n, r) {
    const a = r.getContentType() || "", o = a.indexOf("application/json") > -1, s = U.isObject(n);
    if (s && U.isHTMLForm(n) && (n = new FormData(n)), U.isFormData(n))
      return o ? JSON.stringify(Ug(n)) : n;
    if (U.isArrayBuffer(n) || U.isBuffer(n) || U.isStream(n) || U.isFile(n) || U.isBlob(n) || U.isReadableStream(n))
      return n;
    if (U.isArrayBufferView(n))
      return n.buffer;
    if (U.isURLSearchParams(n))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let c;
    if (s) {
      if (a.indexOf("application/x-www-form-urlencoded") > -1)
        return OL(n, this.formSerializer).toString();
      if ((c = U.isFileList(n)) || a.indexOf("multipart/form-data") > -1) {
        const f = this.env && this.env.FormData;
        return _s(
          c ? { "files[]": n } : n,
          f && new f(),
          this.formSerializer
        );
      }
    }
    return s || o ? (r.setContentType("application/json", !1), RL(n)) : n;
  }],
  transformResponse: [function(n) {
    const r = this.transitional || $a.transitional, a = r && r.forcedJSONParsing, o = this.responseType === "json";
    if (U.isResponse(n) || U.isReadableStream(n))
      return n;
    if (n && U.isString(n) && (a && !this.responseType || o)) {
      const l = !(r && r.silentJSONParsing) && o;
      try {
        return JSON.parse(n);
      } catch (c) {
        if (l)
          throw c.name === "SyntaxError" ? De.from(c, De.ERR_BAD_RESPONSE, this, null, this.response) : c;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: sn.classes.FormData,
    Blob: sn.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
U.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  $a.headers[e] = {};
});
const FL = U.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), ML = (e) => {
  const n = {};
  let r, a, o;
  return e && e.split(`
`).forEach(function(l) {
    o = l.indexOf(":"), r = l.substring(0, o).trim().toLowerCase(), a = l.substring(o + 1).trim(), !(!r || n[r] && FL[r]) && (r === "set-cookie" ? n[r] ? n[r].push(a) : n[r] = [a] : n[r] = n[r] ? n[r] + ", " + a : a);
  }), n;
}, pv = Symbol("internals");
function ga(e) {
  return e && String(e).trim().toLowerCase();
}
function Bo(e) {
  return e === !1 || e == null ? e : U.isArray(e) ? e.map(Bo) : String(e);
}
function DL(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let a;
  for (; a = r.exec(e); )
    n[a[1]] = a[2];
  return n;
}
const $L = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Jl(e, n, r, a, o) {
  if (U.isFunction(a))
    return a.call(this, n, r);
  if (o && (n = r), !!U.isString(n)) {
    if (U.isString(a))
      return n.indexOf(a) !== -1;
    if (U.isRegExp(a))
      return a.test(n);
  }
}
function BL(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, a) => r.toUpperCase() + a);
}
function VL(e, n) {
  const r = U.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((a) => {
    Object.defineProperty(e, a + r, {
      value: function(o, s, l) {
        return this[a].call(this, n, o, s, l);
      },
      configurable: !0
    });
  });
}
class ln {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, a) {
    const o = this;
    function s(c, f, h) {
      const v = ga(f);
      if (!v)
        throw new Error("header name must be a non-empty string");
      const m = U.findKey(o, v);
      (!m || o[m] === void 0 || h === !0 || h === void 0 && o[m] !== !1) && (o[m || f] = Bo(c));
    }
    const l = (c, f) => U.forEach(c, (h, v) => s(h, v, f));
    if (U.isPlainObject(n) || n instanceof this.constructor)
      l(n, r);
    else if (U.isString(n) && (n = n.trim()) && !$L(n))
      l(ML(n), r);
    else if (U.isHeaders(n))
      for (const [c, f] of n.entries())
        s(f, c, a);
    else
      n != null && s(r, n, a);
    return this;
  }
  get(n, r) {
    if (n = ga(n), n) {
      const a = U.findKey(this, n);
      if (a) {
        const o = this[a];
        if (!r)
          return o;
        if (r === !0)
          return DL(o);
        if (U.isFunction(r))
          return r.call(this, o, a);
        if (U.isRegExp(r))
          return r.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = ga(n), n) {
      const a = U.findKey(this, n);
      return !!(a && this[a] !== void 0 && (!r || Jl(this, this[a], a, r)));
    }
    return !1;
  }
  delete(n, r) {
    const a = this;
    let o = !1;
    function s(l) {
      if (l = ga(l), l) {
        const c = U.findKey(a, l);
        c && (!r || Jl(a, a[c], c, r)) && (delete a[c], o = !0);
      }
    }
    return U.isArray(n) ? n.forEach(s) : s(n), o;
  }
  clear(n) {
    const r = Object.keys(this);
    let a = r.length, o = !1;
    for (; a--; ) {
      const s = r[a];
      (!n || Jl(this, this[s], s, n, !0)) && (delete this[s], o = !0);
    }
    return o;
  }
  normalize(n) {
    const r = this, a = {};
    return U.forEach(this, (o, s) => {
      const l = U.findKey(a, s);
      if (l) {
        r[l] = Bo(o), delete r[s];
        return;
      }
      const c = n ? BL(s) : String(s).trim();
      c !== s && delete r[s], r[c] = Bo(o), a[c] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return U.forEach(this, (a, o) => {
      a != null && a !== !1 && (r[o] = n && U.isArray(a) ? a.join(", ") : a);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const a = new this(n);
    return r.forEach((o) => a.set(o)), a;
  }
  static accessor(n) {
    const a = (this[pv] = this[pv] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function s(l) {
      const c = ga(l);
      a[c] || (VL(o, l), a[c] = !0);
    }
    return U.isArray(n) ? n.forEach(s) : s(n), this;
  }
}
ln.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
U.reduceDescriptors(ln.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(a) {
      this[r] = a;
    }
  };
});
U.freezeMethods(ln);
function Zl(e, n) {
  const r = this || $a, a = n || r, o = ln.from(a.headers);
  let s = a.data;
  return U.forEach(e, function(c) {
    s = c.call(r, s, o.normalize(), n ? n.status : void 0);
  }), o.normalize(), s;
}
function Wg(e) {
  return !!(e && e.__CANCEL__);
}
function Yi(e, n, r) {
  De.call(this, e ?? "canceled", De.ERR_CANCELED, n, r), this.name = "CanceledError";
}
U.inherits(Yi, De, {
  __CANCEL__: !0
});
function Hg(e, n, r) {
  const a = r.config.validateStatus;
  !r.status || !a || a(r.status) ? e(r) : n(new De(
    "Request failed with status code " + r.status,
    [De.ERR_BAD_REQUEST, De.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function UL(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function WL(e, n) {
  e = e || 10;
  const r = new Array(e), a = new Array(e);
  let o = 0, s = 0, l;
  return n = n !== void 0 ? n : 1e3, function(f) {
    const h = Date.now(), v = a[s];
    l || (l = h), r[o] = f, a[o] = h;
    let m = s, p = 0;
    for (; m !== o; )
      p += r[m++], m = m % e;
    if (o = (o + 1) % e, o === s && (s = (s + 1) % e), h - l < n)
      return;
    const y = v && h - v;
    return y ? Math.round(p * 1e3 / y) : void 0;
  };
}
function HL(e, n) {
  let r = 0, a = 1e3 / n, o, s;
  const l = (h, v = Date.now()) => {
    r = v, o = null, s && (clearTimeout(s), s = null), e.apply(null, h);
  };
  return [(...h) => {
    const v = Date.now(), m = v - r;
    m >= a ? l(h, v) : (o = h, s || (s = setTimeout(() => {
      s = null, l(o);
    }, a - m)));
  }, () => o && l(o)];
}
const es = (e, n, r = 3) => {
  let a = 0;
  const o = WL(50, 250);
  return HL((s) => {
    const l = s.loaded, c = s.lengthComputable ? s.total : void 0, f = l - a, h = o(f), v = l <= c;
    a = l;
    const m = {
      loaded: l,
      total: c,
      progress: c ? l / c : void 0,
      bytes: f,
      rate: h || void 0,
      estimated: h && c && v ? (c - l) / h : void 0,
      event: s,
      lengthComputable: c != null,
      [n ? "download" : "upload"]: !0
    };
    e(m);
  }, r);
}, _v = (e, n) => {
  const r = e != null;
  return [(a) => n[0]({
    lengthComputable: r,
    total: e,
    loaded: a
  }), n[1]];
}, yv = (e) => (...n) => U.asap(() => e(...n)), GL = sn.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const n = sn.navigator && /(msie|trident)/i.test(sn.navigator.userAgent), r = document.createElement("a");
    let a;
    function o(s) {
      let l = s;
      return n && (r.setAttribute("href", l), l = r.href), r.setAttribute("href", l), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return a = o(window.location.href), function(l) {
      const c = U.isString(l) ? o(l) : l;
      return c.protocol === a.protocol && c.host === a.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), zL = sn.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, a, o, s) {
      const l = [e + "=" + encodeURIComponent(n)];
      U.isNumber(r) && l.push("expires=" + new Date(r).toGMTString()), U.isString(a) && l.push("path=" + a), U.isString(o) && l.push("domain=" + o), s === !0 && l.push("secure"), document.cookie = l.join("; ");
    },
    read(e) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function qL(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function KL(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function Gg(e, n) {
  return e && !qL(n) ? KL(e, n) : n;
}
const bv = (e) => e instanceof ln ? { ...e } : e;
function ii(e, n) {
  n = n || {};
  const r = {};
  function a(h, v, m) {
    return U.isPlainObject(h) && U.isPlainObject(v) ? U.merge.call({ caseless: m }, h, v) : U.isPlainObject(v) ? U.merge({}, v) : U.isArray(v) ? v.slice() : v;
  }
  function o(h, v, m) {
    if (U.isUndefined(v)) {
      if (!U.isUndefined(h))
        return a(void 0, h, m);
    } else return a(h, v, m);
  }
  function s(h, v) {
    if (!U.isUndefined(v))
      return a(void 0, v);
  }
  function l(h, v) {
    if (U.isUndefined(v)) {
      if (!U.isUndefined(h))
        return a(void 0, h);
    } else return a(void 0, v);
  }
  function c(h, v, m) {
    if (m in n)
      return a(h, v);
    if (m in e)
      return a(void 0, h);
  }
  const f = {
    url: s,
    method: s,
    data: s,
    baseURL: l,
    transformRequest: l,
    transformResponse: l,
    paramsSerializer: l,
    timeout: l,
    timeoutMessage: l,
    withCredentials: l,
    withXSRFToken: l,
    adapter: l,
    responseType: l,
    xsrfCookieName: l,
    xsrfHeaderName: l,
    onUploadProgress: l,
    onDownloadProgress: l,
    decompress: l,
    maxContentLength: l,
    maxBodyLength: l,
    beforeRedirect: l,
    transport: l,
    httpAgent: l,
    httpsAgent: l,
    cancelToken: l,
    socketPath: l,
    responseEncoding: l,
    validateStatus: c,
    headers: (h, v) => o(bv(h), bv(v), !0)
  };
  return U.forEach(Object.keys(Object.assign({}, e, n)), function(v) {
    const m = f[v] || o, p = m(e[v], n[v], v);
    U.isUndefined(p) && m !== c || (r[v] = p);
  }), r;
}
const zg = (e) => {
  const n = ii({}, e);
  let { data: r, withXSRFToken: a, xsrfHeaderName: o, xsrfCookieName: s, headers: l, auth: c } = n;
  n.headers = l = ln.from(l), n.url = Bg(Gg(n.baseURL, n.url), e.params, e.paramsSerializer), c && l.set(
    "Authorization",
    "Basic " + btoa((c.username || "") + ":" + (c.password ? unescape(encodeURIComponent(c.password)) : ""))
  );
  let f;
  if (U.isFormData(r)) {
    if (sn.hasStandardBrowserEnv || sn.hasStandardBrowserWebWorkerEnv)
      l.setContentType(void 0);
    else if ((f = l.getContentType()) !== !1) {
      const [h, ...v] = f ? f.split(";").map((m) => m.trim()).filter(Boolean) : [];
      l.setContentType([h || "multipart/form-data", ...v].join("; "));
    }
  }
  if (sn.hasStandardBrowserEnv && (a && U.isFunction(a) && (a = a(n)), a || a !== !1 && GL(n.url))) {
    const h = o && s && zL.read(s);
    h && l.set(o, h);
  }
  return n;
}, jL = typeof XMLHttpRequest < "u", YL = jL && function(e) {
  return new Promise(function(r, a) {
    const o = zg(e);
    let s = o.data;
    const l = ln.from(o.headers).normalize();
    let { responseType: c, onUploadProgress: f, onDownloadProgress: h } = o, v, m, p, y, b;
    function C() {
      y && y(), b && b(), o.cancelToken && o.cancelToken.unsubscribe(v), o.signal && o.signal.removeEventListener("abort", v);
    }
    let S = new XMLHttpRequest();
    S.open(o.method.toUpperCase(), o.url, !0), S.timeout = o.timeout;
    function R() {
      if (!S)
        return;
      const k = ln.from(
        "getAllResponseHeaders" in S && S.getAllResponseHeaders()
      ), F = {
        data: !c || c === "text" || c === "json" ? S.responseText : S.response,
        status: S.status,
        statusText: S.statusText,
        headers: k,
        config: e,
        request: S
      };
      Hg(function(E) {
        r(E), C();
      }, function(E) {
        a(E), C();
      }, F), S = null;
    }
    "onloadend" in S ? S.onloadend = R : S.onreadystatechange = function() {
      !S || S.readyState !== 4 || S.status === 0 && !(S.responseURL && S.responseURL.indexOf("file:") === 0) || setTimeout(R);
    }, S.onabort = function() {
      S && (a(new De("Request aborted", De.ECONNABORTED, e, S)), S = null);
    }, S.onerror = function() {
      a(new De("Network Error", De.ERR_NETWORK, e, S)), S = null;
    }, S.ontimeout = function() {
      let L = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const F = o.transitional || Vg;
      o.timeoutErrorMessage && (L = o.timeoutErrorMessage), a(new De(
        L,
        F.clarifyTimeoutError ? De.ETIMEDOUT : De.ECONNABORTED,
        e,
        S
      )), S = null;
    }, s === void 0 && l.setContentType(null), "setRequestHeader" in S && U.forEach(l.toJSON(), function(L, F) {
      S.setRequestHeader(F, L);
    }), U.isUndefined(o.withCredentials) || (S.withCredentials = !!o.withCredentials), c && c !== "json" && (S.responseType = o.responseType), h && ([p, b] = es(h, !0), S.addEventListener("progress", p)), f && S.upload && ([m, y] = es(f), S.upload.addEventListener("progress", m), S.upload.addEventListener("loadend", y)), (o.cancelToken || o.signal) && (v = (k) => {
      S && (a(!k || k.type ? new Yi(null, e, S) : k), S.abort(), S = null);
    }, o.cancelToken && o.cancelToken.subscribe(v), o.signal && (o.signal.aborted ? v() : o.signal.addEventListener("abort", v)));
    const $ = UL(o.url);
    if ($ && sn.protocols.indexOf($) === -1) {
      a(new De("Unsupported protocol " + $ + ":", De.ERR_BAD_REQUEST, e));
      return;
    }
    S.send(s || null);
  });
}, XL = (e, n) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (n || r) {
    let a = new AbortController(), o;
    const s = function(h) {
      if (!o) {
        o = !0, c();
        const v = h instanceof Error ? h : this.reason;
        a.abort(v instanceof De ? v : new Yi(v instanceof Error ? v.message : v));
      }
    };
    let l = n && setTimeout(() => {
      l = null, s(new De(`timeout ${n} of ms exceeded`, De.ETIMEDOUT));
    }, n);
    const c = () => {
      e && (l && clearTimeout(l), l = null, e.forEach((h) => {
        h.unsubscribe ? h.unsubscribe(s) : h.removeEventListener("abort", s);
      }), e = null);
    };
    e.forEach((h) => h.addEventListener("abort", s));
    const { signal: f } = a;
    return f.unsubscribe = () => U.asap(c), f;
  }
}, JL = function* (e, n) {
  let r = e.byteLength;
  if (!n || r < n) {
    yield e;
    return;
  }
  let a = 0, o;
  for (; a < r; )
    o = a + n, yield e.slice(a, o), a = o;
}, ZL = async function* (e, n) {
  for await (const r of QL(e))
    yield* JL(r, n);
}, QL = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: a } = await n.read();
      if (r)
        break;
      yield a;
    }
  } finally {
    await n.cancel();
  }
}, wv = (e, n, r, a) => {
  const o = ZL(e, n);
  let s = 0, l, c = (f) => {
    l || (l = !0, a && a(f));
  };
  return new ReadableStream({
    async pull(f) {
      try {
        const { done: h, value: v } = await o.next();
        if (h) {
          c(), f.close();
          return;
        }
        let m = v.byteLength;
        if (r) {
          let p = s += m;
          r(p);
        }
        f.enqueue(new Uint8Array(v));
      } catch (h) {
        throw c(h), h;
      }
    },
    cancel(f) {
      return c(f), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, ys = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", qg = ys && typeof ReadableStream == "function", eO = ys && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (n) => e.encode(n))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Kg = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, tO = qg && Kg(() => {
  let e = !1;
  const n = new Request(sn.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !n;
}), Cv = 64 * 1024, Au = qg && Kg(() => U.isReadableStream(new Response("").body)), ts = {
  stream: Au && ((e) => e.body)
};
ys && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((n) => {
    !ts[n] && (ts[n] = U.isFunction(e[n]) ? (r) => r[n]() : (r, a) => {
      throw new De(`Response type '${n}' is not supported`, De.ERR_NOT_SUPPORT, a);
    });
  });
})(new Response());
const nO = async (e) => {
  if (e == null)
    return 0;
  if (U.isBlob(e))
    return e.size;
  if (U.isSpecCompliantForm(e))
    return (await new Request(sn.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (U.isArrayBufferView(e) || U.isArrayBuffer(e))
    return e.byteLength;
  if (U.isURLSearchParams(e) && (e = e + ""), U.isString(e))
    return (await eO(e)).byteLength;
}, rO = async (e, n) => {
  const r = U.toFiniteNumber(e.getContentLength());
  return r ?? nO(n);
}, iO = ys && (async (e) => {
  let {
    url: n,
    method: r,
    data: a,
    signal: o,
    cancelToken: s,
    timeout: l,
    onDownloadProgress: c,
    onUploadProgress: f,
    responseType: h,
    headers: v,
    withCredentials: m = "same-origin",
    fetchOptions: p
  } = zg(e);
  h = h ? (h + "").toLowerCase() : "text";
  let y = XL([o, s && s.toAbortSignal()], l), b;
  const C = y && y.unsubscribe && (() => {
    y.unsubscribe();
  });
  let S;
  try {
    if (f && tO && r !== "get" && r !== "head" && (S = await rO(v, a)) !== 0) {
      let F = new Request(n, {
        method: "POST",
        body: a,
        duplex: "half"
      }), P;
      if (U.isFormData(a) && (P = F.headers.get("content-type")) && v.setContentType(P), F.body) {
        const [E, V] = _v(
          S,
          es(yv(f))
        );
        a = wv(F.body, Cv, E, V);
      }
    }
    U.isString(m) || (m = m ? "include" : "omit");
    const R = "credentials" in Request.prototype;
    b = new Request(n, {
      ...p,
      signal: y,
      method: r.toUpperCase(),
      headers: v.normalize().toJSON(),
      body: a,
      duplex: "half",
      credentials: R ? m : void 0
    });
    let $ = await fetch(b);
    const k = Au && (h === "stream" || h === "response");
    if (Au && (c || k && C)) {
      const F = {};
      ["status", "statusText", "headers"].forEach((W) => {
        F[W] = $[W];
      });
      const P = U.toFiniteNumber($.headers.get("content-length")), [E, V] = c && _v(
        P,
        es(yv(c), !0)
      ) || [];
      $ = new Response(
        wv($.body, Cv, E, () => {
          V && V(), C && C();
        }),
        F
      );
    }
    h = h || "text";
    let L = await ts[U.findKey(ts, h) || "text"]($, e);
    return !k && C && C(), await new Promise((F, P) => {
      Hg(F, P, {
        data: L,
        headers: ln.from($.headers),
        status: $.status,
        statusText: $.statusText,
        config: e,
        request: b
      });
    });
  } catch (R) {
    throw C && C(), R && R.name === "TypeError" && /fetch/i.test(R.message) ? Object.assign(
      new De("Network Error", De.ERR_NETWORK, e, b),
      {
        cause: R.cause || R
      }
    ) : De.from(R, R && R.code, e, b);
  }
}), ku = {
  http: yL,
  xhr: YL,
  fetch: iO
};
U.forEach(ku, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const Sv = (e) => `- ${e}`, aO = (e) => U.isFunction(e) || e === null || e === !1, jg = {
  getAdapter: (e) => {
    e = U.isArray(e) ? e : [e];
    const { length: n } = e;
    let r, a;
    const o = {};
    for (let s = 0; s < n; s++) {
      r = e[s];
      let l;
      if (a = r, !aO(r) && (a = ku[(l = String(r)).toLowerCase()], a === void 0))
        throw new De(`Unknown adapter '${l}'`);
      if (a)
        break;
      o[l || "#" + s] = a;
    }
    if (!a) {
      const s = Object.entries(o).map(
        ([c, f]) => `adapter ${c} ` + (f === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let l = n ? s.length > 1 ? `since :
` + s.map(Sv).join(`
`) : " " + Sv(s[0]) : "as no adapter specified";
      throw new De(
        "There is no suitable adapter to dispatch the request " + l,
        "ERR_NOT_SUPPORT"
      );
    }
    return a;
  },
  adapters: ku
};
function Ql(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Yi(null, e);
}
function Ev(e) {
  return Ql(e), e.headers = ln.from(e.headers), e.data = Zl.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), jg.getAdapter(e.adapter || $a.adapter)(e).then(function(a) {
    return Ql(e), a.data = Zl.call(
      e,
      e.transformResponse,
      a
    ), a.headers = ln.from(a.headers), a;
  }, function(a) {
    return Wg(a) || (Ql(e), a && a.response && (a.response.data = Zl.call(
      e,
      e.transformResponse,
      a.response
    ), a.response.headers = ln.from(a.response.headers))), Promise.reject(a);
  });
}
const Yg = "1.7.7", dc = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  dc[e] = function(a) {
    return typeof a === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const xv = {};
dc.transitional = function(n, r, a) {
  function o(s, l) {
    return "[Axios v" + Yg + "] Transitional option '" + s + "'" + l + (a ? ". " + a : "");
  }
  return (s, l, c) => {
    if (n === !1)
      throw new De(
        o(l, " has been removed" + (r ? " in " + r : "")),
        De.ERR_DEPRECATED
      );
    return r && !xv[l] && (xv[l] = !0, console.warn(
      o(
        l,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(s, l, c) : !0;
  };
};
function oO(e, n, r) {
  if (typeof e != "object")
    throw new De("options must be an object", De.ERR_BAD_OPTION_VALUE);
  const a = Object.keys(e);
  let o = a.length;
  for (; o-- > 0; ) {
    const s = a[o], l = n[s];
    if (l) {
      const c = e[s], f = c === void 0 || l(c, s, e);
      if (f !== !0)
        throw new De("option " + s + " must be " + f, De.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new De("Unknown option " + s, De.ERR_BAD_OPTION);
  }
}
const Tu = {
  assertOptions: oO,
  validators: dc
}, Pr = Tu.validators;
class ei {
  constructor(n) {
    this.defaults = n, this.interceptors = {
      request: new gv(),
      response: new gv()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (a) {
      if (a instanceof Error) {
        let o;
        Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
        const s = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          a.stack ? s && !String(a.stack).endsWith(s.replace(/^.+\n.+\n/, "")) && (a.stack += `
` + s) : a.stack = s;
        } catch {
        }
      }
      throw a;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = ii(this.defaults, r);
    const { transitional: a, paramsSerializer: o, headers: s } = r;
    a !== void 0 && Tu.assertOptions(a, {
      silentJSONParsing: Pr.transitional(Pr.boolean),
      forcedJSONParsing: Pr.transitional(Pr.boolean),
      clarifyTimeoutError: Pr.transitional(Pr.boolean)
    }, !1), o != null && (U.isFunction(o) ? r.paramsSerializer = {
      serialize: o
    } : Tu.assertOptions(o, {
      encode: Pr.function,
      serialize: Pr.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let l = s && U.merge(
      s.common,
      s[r.method]
    );
    s && U.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (b) => {
        delete s[b];
      }
    ), r.headers = ln.concat(l, s);
    const c = [];
    let f = !0;
    this.interceptors.request.forEach(function(C) {
      typeof C.runWhen == "function" && C.runWhen(r) === !1 || (f = f && C.synchronous, c.unshift(C.fulfilled, C.rejected));
    });
    const h = [];
    this.interceptors.response.forEach(function(C) {
      h.push(C.fulfilled, C.rejected);
    });
    let v, m = 0, p;
    if (!f) {
      const b = [Ev.bind(this), void 0];
      for (b.unshift.apply(b, c), b.push.apply(b, h), p = b.length, v = Promise.resolve(r); m < p; )
        v = v.then(b[m++], b[m++]);
      return v;
    }
    p = c.length;
    let y = r;
    for (m = 0; m < p; ) {
      const b = c[m++], C = c[m++];
      try {
        y = b(y);
      } catch (S) {
        C.call(this, S);
        break;
      }
    }
    try {
      v = Ev.call(this, y);
    } catch (b) {
      return Promise.reject(b);
    }
    for (m = 0, p = h.length; m < p; )
      v = v.then(h[m++], h[m++]);
    return v;
  }
  getUri(n) {
    n = ii(this.defaults, n);
    const r = Gg(n.baseURL, n.url);
    return Bg(r, n.params, n.paramsSerializer);
  }
}
U.forEach(["delete", "get", "head", "options"], function(n) {
  ei.prototype[n] = function(r, a) {
    return this.request(ii(a || {}, {
      method: n,
      url: r,
      data: (a || {}).data
    }));
  };
});
U.forEach(["post", "put", "patch"], function(n) {
  function r(a) {
    return function(s, l, c) {
      return this.request(ii(c || {}, {
        method: n,
        headers: a ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: l
      }));
    };
  }
  ei.prototype[n] = r(), ei.prototype[n + "Form"] = r(!0);
});
class hc {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(s) {
      r = s;
    });
    const a = this;
    this.promise.then((o) => {
      if (!a._listeners) return;
      let s = a._listeners.length;
      for (; s-- > 0; )
        a._listeners[s](o);
      a._listeners = null;
    }), this.promise.then = (o) => {
      let s;
      const l = new Promise((c) => {
        a.subscribe(c), s = c;
      }).then(o);
      return l.cancel = function() {
        a.unsubscribe(s);
      }, l;
    }, n(function(s, l, c) {
      a.reason || (a.reason = new Yi(s, l, c), r(a.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (a) => {
      n.abort(a);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new hc(function(o) {
        n = o;
      }),
      cancel: n
    };
  }
}
function sO(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function lO(e) {
  return U.isObject(e) && e.isAxiosError === !0;
}
const Iu = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Iu).forEach(([e, n]) => {
  Iu[n] = e;
});
function Xg(e) {
  const n = new ei(e), r = kg(ei.prototype.request, n);
  return U.extend(r, ei.prototype, n, { allOwnKeys: !0 }), U.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(o) {
    return Xg(ii(e, o));
  }, r;
}
const Tt = Xg($a);
Tt.Axios = ei;
Tt.CanceledError = Yi;
Tt.CancelToken = hc;
Tt.isCancel = Wg;
Tt.VERSION = Yg;
Tt.toFormData = _s;
Tt.AxiosError = De;
Tt.Cancel = Tt.CanceledError;
Tt.all = function(n) {
  return Promise.all(n);
};
Tt.spread = sO;
Tt.isAxiosError = lO;
Tt.mergeConfig = ii;
Tt.AxiosHeaders = ln;
Tt.formToJSON = (e) => Ug(U.isHTMLForm(e) ? new FormData(e) : e);
Tt.getAdapter = jg.getAdapter;
Tt.HttpStatusCode = Iu;
Tt.default = Tt;
/*! js-cookie v3.0.5 | MIT */
function Ro(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n];
    for (var a in r)
      e[a] = r[a];
  }
  return e;
}
var uO = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Lu(e, n) {
  function r(o, s, l) {
    if (!(typeof document > "u")) {
      l = Ro({}, n, l), typeof l.expires == "number" && (l.expires = new Date(Date.now() + l.expires * 864e5)), l.expires && (l.expires = l.expires.toUTCString()), o = encodeURIComponent(o).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var c = "";
      for (var f in l)
        l[f] && (c += "; " + f, l[f] !== !0 && (c += "=" + l[f].split(";")[0]));
      return document.cookie = o + "=" + e.write(s, o) + c;
    }
  }
  function a(o) {
    if (!(typeof document > "u" || arguments.length && !o)) {
      for (var s = document.cookie ? document.cookie.split("; ") : [], l = {}, c = 0; c < s.length; c++) {
        var f = s[c].split("="), h = f.slice(1).join("=");
        try {
          var v = decodeURIComponent(f[0]);
          if (l[v] = e.read(h, v), o === v)
            break;
        } catch {
        }
      }
      return o ? l[o] : l;
    }
  }
  return Object.create(
    {
      set: r,
      get: a,
      remove: function(o, s) {
        r(
          o,
          "",
          Ro({}, s, {
            expires: -1
          })
        );
      },
      withAttributes: function(o) {
        return Lu(this.converter, Ro({}, this.attributes, o));
      },
      withConverter: function(o) {
        return Lu(Ro({}, this.converter, o), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(n) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var cO = Lu(uO, { path: "/" });
class fO {
  accountId;
  basketInfo;
  basketType;
  deliveryMode;
  deviceId;
  deviceLabel;
  fareMediaId;
  fareMediaLabel;
  line;
  ownerFirstName;
  ownerLastName;
  products;
  productsNormalized;
  providerId;
  providerUserEmail;
  providerUserId;
  providerUserExternalId;
  providerUserFirstName;
  providerUserLastName;
  recipientUser;
  constructor(n) {
    this.accountId = n.accountId ?? "", this.basketInfo = n.basketInfo ?? "", this.basketType = n.basketType ?? "", this.deliveryMode = n.deliveryMode ?? "", this.deviceId = n.deviceId ?? "", this.deviceLabel = n.deviceLabel ?? "", this.fareMediaId = n.fareMediaId ?? "", this.fareMediaLabel = n.fareMediaLabel ?? "", this.line = n.line ?? 0, this.ownerFirstName = n.ownerFirstName ?? "", this.ownerLastName = n.ownerLastName ?? "", this.products = n.products ?? [], this.productsNormalized = [], this.providerId = n.providerId ?? "", this.providerUserEmail = n.providerUserEmail ?? "", this.providerUserId = n.providerUserId ?? "", this.providerUserExternalId = n.providerUserExternalId ?? "", this.providerUserFirstName = n.providerUserFirstName ?? "", this.providerUserLastName = n.providerUserLastName ?? "", this.recipientUser = n.recipientUser ?? null;
  }
  getObjectFull() {
    return {
      accountId: this.accountId,
      basketInfo: this.basketInfo,
      basketType: this.basketType,
      deliveryMode: this.deliveryMode,
      deviceId: this.deviceId,
      deviceLabel: this.deviceLabel,
      fareMediaId: this.fareMediaId,
      fareMediaLabel: this.fareMediaLabel,
      line: this.line,
      ownerFirstName: this.ownerFirstName,
      ownerLastName: this.ownerLastName,
      products: this.products,
      productsNormalized: this.productsNormalized,
      providerId: this.providerId,
      providerUserEmail: this.providerUserEmail,
      providerUserId: this.providerUserId,
      providerUserExternalId: this.providerUserExternalId,
      providerUserFirstName: this.providerUserFirstName,
      providerUserLastName: this.providerUserLastName,
      recipientUser: this.recipientUser
    };
  }
}
var Jg = /* @__PURE__ */ ((e) => (e.UNIT = "UNIT", e.MONETARY = "MONETARY", e.NONE = "NONE", e))(Jg || {});
class dO {
  actions;
  baskets;
  currency;
  empty;
  id;
  immediateAmountExcludingTaxes;
  immediateAmountIncludingTaxes;
  immediateVatAmount;
  packages;
  packagesNormalized;
  paymentModes;
  plans;
  plansNormalized;
  status;
  totalAmountExcludingTaxes;
  totalAmountIncludingTaxes;
  totalVatAmount;
  userId;
  constructor(n) {
    this.actions = n.actions ?? [], this.baskets = [], this.currency = n.currency ?? "EUR", this.empty = n.empty ?? !0, this.id = n.id ?? null, this.immediateAmountExcludingTaxes = n.immediateAmountExcludingTaxes ?? null, this.immediateAmountIncludingTaxes = n.immediateAmountIncludingTaxes ?? null, this.immediateVatAmount = n.immediateVatAmount ?? null, this.packages = [], this.packagesNormalized = [], this.paymentModes = n.paymentModes ?? [], this.plans = [], this.plansNormalized = [], this.status = n.status ?? null, this.totalAmountExcludingTaxes = n.totalAmountExcludingTaxes ?? 0, this.totalAmountIncludingTaxes = n.totalAmountIncludingTaxes ?? 0, this.totalVatAmount = n.totalVatAmount ?? 0, this.userId = n.userId ?? null;
  }
  getObjectFull() {
    return {
      actions: this.actions,
      baskets: this.baskets,
      currency: this.currency,
      empty: this.empty,
      id: this.id,
      immediateAmountExcludingTaxes: this.immediateAmountExcludingTaxes,
      immediateAmountIncludingTaxes: this.immediateAmountIncludingTaxes,
      immediateVatAmount: this.immediateVatAmount,
      packages: this.packages,
      packagesNormalized: this.packagesNormalized,
      paymentModes: this.paymentModes,
      plans: this.plans,
      plansNormalized: this.plansNormalized,
      status: this.status,
      totalAmountExcludingTaxes: this.totalAmountExcludingTaxes,
      totalAmountIncludingTaxes: this.totalAmountIncludingTaxes,
      totalVatAmount: this.totalVatAmount,
      userId: this.userId
    };
  }
}
class eu {
  actions;
  address;
  basketLine;
  currency;
  deliveryMode;
  fareExcludingTaxes;
  fareIncludingTaxes;
  id;
  line;
  name;
  providerItemDescription;
  providerNetworkLabel;
  quantity;
  saleableUnit;
  totalFareExcludingTaxes;
  totalFareIncludingTaxes;
  totalVatAmount;
  unit;
  vatAmount;
  vatRate;
  version;
  constructor(n) {
    this.actions = "actions" in n ? n.actions : [], this.address = "address" in n ? n.address : void 0, this.basketLine = "basketLine" in n ? n.basketLine : 0, this.currency = "currency" in n && n.currency ? n.currency : "EUR", this.deliveryMode = "deliveryMode" in n ? n.deliveryMode : null, this.fareExcludingTaxes = n.fareExcludingTaxes ?? 0, this.fareIncludingTaxes = n.fareIncludingTaxes ?? 0, this.id = null, this.line = n.line ?? 0, this.name = "", this.providerItemDescription = "providerItemDescription" in n && n.providerItemDescription ? n.providerItemDescription : "", this.providerNetworkLabel = "providerNetworkLabel" in n && n.providerNetworkLabel ? n.providerNetworkLabel : "", this.quantity = "quantity" in n ? n.quantity : 1, this.saleableUnit = "saleableUnit" in n ? n.saleableUnit : Jg.UNIT, this.totalFareExcludingTaxes = "totalFareExcludingTaxes" in n ? n.totalFareExcludingTaxes : 0, this.totalFareIncludingTaxes = "totalFareIncludingTaxes" in n ? n.totalFareIncludingTaxes : 0, this.totalVatAmount = "totalVatAmount" in n ? n.totalVatAmount : 0, this.unit = "unit" in n ? n.unit : "", this.vatAmount = n.vatAmount ?? 0, this.vatRate = n.vatRate ?? 0, this.version = 1;
  }
  getObjectFull() {
    return {
      actions: this.actions,
      address: this.address,
      basketLine: this.basketLine,
      currency: this.currency,
      deliveryMode: this.deliveryMode,
      fareExcludingTaxes: this.fareExcludingTaxes,
      fareIncludingTaxes: this.fareIncludingTaxes,
      id: this.id,
      line: this.line,
      name: this.name,
      providerItemDescription: this.providerItemDescription,
      providerNetworkLabel: this.providerNetworkLabel,
      quantity: this.quantity,
      saleableUnit: this.saleableUnit,
      totalFareExcludingTaxes: this.totalFareExcludingTaxes,
      totalFareIncludingTaxes: this.totalFareIncludingTaxes,
      totalVatAmount: this.totalVatAmount,
      unit: this.unit,
      vatAmount: this.vatAmount,
      vatRate: this.vatRate,
      version: this.version
    };
  }
}
class hO {
  associationId;
  associationType;
  email;
  firstName;
  lastName;
  userId;
  constructor(n) {
    this.associationId = n.associationId ?? null, this.associationType = n.associationType ?? null, this.email = n.email ?? "", this.firstName = n.firstName ?? null, this.lastName = n.lastName ?? null, this.userId = n.userId ?? "";
  }
  getObjectFull() {
    return {
      associationId: this.associationId,
      associationType: this.associationType,
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      userId: this.userId
    };
  }
}
const bs = () => ({
  isEmpty: (r) => r == null ? !0 : typeof r == "number" || typeof r == "boolean" ? !1 : Array.isArray(r) || typeof r == "string" ? r.length === 0 : typeof r == "object" ? Object.keys(r).length === 0 : !1,
  ucFirst: (r) => r ? r.charAt(0).toUpperCase() + r.slice(1) : ""
}), { isEmpty: pa } = bs();
function vO(e) {
  const { userToken: n } = Ki();
  function r() {
    if (n.value)
      return a(`${e.value.apiUrl}/store/cart`, {
        Authorization: n.value,
        "X-Api-Key": e.value.apiKey
      });
    {
      const v = cO.get("cartEmail");
      return pa(v) ? null : a(
        `${e.value.apiUrl}/store/cart?email=${v}`,
        {
          "X-Api-Key": e.value.apiKey
        }
      );
    }
  }
  async function a(v, m) {
    try {
      const p = await Tt.get(v, { headers: m });
      return o(p.data);
    } catch (p) {
      return console.log(p), null;
    }
  }
  function o(v) {
    const m = new dO(v).getObjectFull();
    return pa(v) || (pa(v.baskets) || v.baskets.forEach((p) => {
      m.baskets.push(s(p));
    }), v.packages && !pa(v.packages) && v.packages.forEach((p) => {
      m.packagesNormalized && m.packagesNormalized.push(f(p));
    }), v.plans && !pa(v.plans) && v.plans.forEach((p) => {
      m.plansNormalized && m.plansNormalized.push(c(p));
    })), m;
  }
  function s(v) {
    const m = new fO(v).getObjectFull();
    return typeof v.products < "u" && v.products.forEach((p) => {
      m.productsNormalized.push(l(p));
    }), v.recipientUser && typeof v.recipientUser < "u" && (m.recipientUser = h(v.recipientUser)), m;
  }
  function l(v) {
    const m = new eu(v).getObjectFull();
    return m.id = v.modalProductId, m.name = v.modalProductName, m.version = v.modalProductVersion, m;
  }
  function c(v) {
    const m = new eu(v).getObjectFull();
    return m.id = v.modalPlanId, m.name = v.modalPlanName, m.version = v.modalPlanVersion, m;
  }
  const f = (v) => {
    const m = new eu(v).getObjectFull();
    return m.id = v.modalPackageId, m.name = v.modalPackageName, m.version = v.modalPackageVersion, m;
  }, h = (v) => new hO(v).getObjectFull();
  return {
    getCart: r,
    normalizeCart: o
  };
}
const mO = { class: "FormattedFare-units" }, gO = { class: "FormattedFare-decimals" }, pO = { class: "FormattedFare-currency" }, _O = /* @__PURE__ */ Qe({
  __name: "FormattedFare",
  props: {
    currency: {
      type: String,
      default: "EUR"
    },
    fare: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: "Medium",
      validator: (e) => [
        "XLarge",
        "Large",
        "Medium",
        "SMedium",
        "Small",
        "XSmall",
        "XXSmall"
      ].includes(e)
    },
    tag: {
      type: String,
      default: "p"
    }
  },
  setup(e) {
    const n = e, { ucFirst: r } = bs(), a = A(() => r(n.size));
    function o() {
      switch (n.currency) {
        case "EUR":
          return "€";
        case "USD":
          return "$";
        case "GBP":
          return "£";
        case "XPF":
          return "XPF";
        default:
          return "€";
      }
    }
    function s() {
      if (n.fare < 0)
        return "00";
      const c = Math.round((n.fare - l()) * 100);
      return c === 0 ? "00" : c < 10 ? "0" + c : c;
    }
    function l() {
      return n.fare < 0 ? 0 : Math.floor(n.fare);
    }
    return (c, f) => (z(), wt(zn(e.tag), {
      class: Mt([["FormattedFare--size" + a.value], "FormattedFare"])
    }, {
      default: bt(() => [
        Q("span", mO, Ve(l()), 1),
        ni(","),
        Q("span", gO, Ve(s()), 1),
        Q("span", pO, Ve(o()), 1)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Zg = /* @__PURE__ */ Ut(_O, [["__scopeId", "data-v-c5403deb"]]), yO = /* @__PURE__ */ Qe({
  __name: "TranslatedLink",
  props: {
    label: {},
    link: {},
    suffix: {},
    configuration: {}
  },
  setup(e) {
    const n = e, { label: r, link: a, configuration: o, suffix: s } = ht(n), { translateLink: l, shouldUseRouterLink: c } = $r(o), f = A(() => l(a.value) + (s.value ? `/${s.value}` : "")), h = A(() => c(f.value) ? "router-link" : "a");
    return (v, m) => (z(), wt(zn(h.value), {
      href: f.value,
      to: f.value
    }, {
      default: bt(() => [
        ni(Ve(v.$t(q(r))), 1)
      ]),
      _: 1
    }, 8, ["href", "to"]));
  }
}), bO = /* @__PURE__ */ Qe({
  __name: "IcomoonIcon",
  props: {
    color: {},
    layersCount: {},
    name: {}
  },
  setup(e) {
    function n(r) {
      return {
        "--icon-color": r
      };
    }
    return (r, a) => (z(), ne("span", {
      class: Mt(["icon-" + r.name, "IcomoonIcon"])
    }, [
      (z(!0), ne(Ie, null, pt(r.layersCount, (o) => (z(), ne("span", {
        key: o,
        class: Mt(["path" + o, "IcomoonIcon-path"]),
        style: Di(n(r.color))
      }, null, 6))), 128))
    ], 2));
  }
}), Qg = /* @__PURE__ */ Ut(bO, [["__scopeId", "data-v-1f264342"]]), wO = { class: "HeaderCartItem-container" }, CO = { class: "HeaderCartItem-content" }, SO = { class: "HeaderCartItem-label" }, EO = { class: "HeaderCartItem-quantity" }, xO = {
  key: 0,
  class: "HeaderCartItem-providerNetworkLabel"
}, AO = ["innerHTML"], kO = /* @__PURE__ */ Qe({
  __name: "HeaderCartItem",
  props: {
    item: {},
    configuration: {}
  },
  setup(e) {
    const n = e, { configuration: r } = ht(n), a = A(
      () => n.item.providerItemDescription !== ""
    );
    function o(l) {
      const c = l?.route?.params;
      return c ? `${c.providerId}/${c.providerUserId}/${c.providerUserExternalId}/${c.fareMediaId}` : "";
    }
    function s(l, c) {
      return l !== c ? l.replace(/\n/g, "<br>") : "";
    }
    return (l, c) => l.item ? (z(), wt(zn("li"), {
      key: 0,
      class: "HeaderCartItem"
    }, {
      default: bt(() => [
        Q("div", wO, [
          Q("div", CO, [
            Q("div", SO, [
              Q("span", EO, Ve(l.item.quantity) + "x ", 1),
              ni(" " + Ve(l.item.name) + " ", 1),
              l.item.deliveryMode === "CARDREADER_MANDATORY" ? (z(), wt(q(gT), {
                key: 0,
                location: "bottom"
              }, {
                activator: bt(({ props: f }) => [
                  T(Qg, Te(f, {
                    "layers-count": 3,
                    color: "secondary",
                    name: "card-reader",
                    "aria-hidden": "",
                    class: "HeaderCartItem-cardReaderMandatoryIcon"
                  }), null, 16)
                ]),
                default: bt(() => [
                  Q("span", null, Ve(l.$t("wh:card_reader_mandatory")), 1)
                ]),
                _: 1
              })) : qe("", !0)
            ]),
            l.item.providerNetworkLabel ? (z(), ne("p", xO, Ve(l.item.providerNetworkLabel), 1)) : qe("", !0),
            a.value ? (z(), ne("div", {
              key: 1,
              class: "HeaderCartItem-providerDescription",
              innerHTML: s(l.item.providerItemDescription, l.item.name)
            }, null, 8, AO)) : qe("", !0)
          ]),
          T(Zg, {
            currency: l.item?.currency,
            fare: l.item?.totalFareIncludingTaxes,
            size: "XSmall",
            class: "HeaderCartItem-fare"
          }, null, 8, ["currency", "fare"])
        ]),
        l.item.actions?.length > 0 ? (z(!0), ne(Ie, { key: 0 }, pt(l.item.actions, (f, h) => (z(), wt(yO, {
          key: `cart_item_action_${h}`,
          configuration: q(r),
          label: f.label,
          link: "wh:link:cart-add-item",
          suffix: o(f),
          class: "HeaderCartItem-action HeaderCartItem-action--button-reversed"
        }, null, 8, ["configuration", "label", "suffix"]))), 128)) : qe("", !0)
      ]),
      _: 1
    })) : qe("", !0);
  }
}), ep = /* @__PURE__ */ Ut(kO, [["__scopeId", "data-v-d9a756a8"]]), TO = (e) => (Ui("data-v-bf40fee2"), e = e(), Wi(), e), IO = {
  key: 0,
  class: "HeaderCartBasket"
}, LO = {
  key: 0,
  class: "HeaderCartBasket-number"
}, OO = /* @__PURE__ */ TO(() => /* @__PURE__ */ Q("i", { icon: "HeaderCartBasket-icon icon-phone wh-text-[25px]" }, null, -1)), PO = { key: 0 }, NO = {
  key: 1,
  class: "HeaderCartBasket-header"
}, RO = {
  key: 1,
  class: "HeaderCartBasket-labelWrapper"
}, FO = {
  key: 0,
  class: "HeaderCartBasket-label"
}, MO = {
  key: 1,
  class: "HeaderCartBasket-subLabel"
}, DO = { class: "HeaderCartBasket-list" }, $O = /* @__PURE__ */ Qe({
  __name: "HeaderCartBasket",
  props: {
    basket: {},
    configuration: {}
  },
  setup(e) {
    const n = e, { configuration: r } = ht(n), { isEmpty: a } = bs(), { t: o } = yr(), s = A(() => {
      const v = n.basket?.productsNormalized || [];
      return n.basket?.basketType === "FAREMEDIA" && n.basket.providerId && n.basket.providerUserId && n.basket.providerUserExternalId && n.basket.fareMediaId && v.forEach((m) => {
        m.actions.filter((p) => p.type === "ADD_NEW_PRODUCT_TO_BASKET").forEach((p) => {
          p.route = {
            name: "catalog",
            params: {
              isTemporary: !0,
              providerId: n.basket.recipientUser?.associationId !== 0 ? n.basket.recipientUser?.userId : n.basket.providerId,
              providerUserId: n.basket.recipientUser?.associationId !== 0 ? n.basket.recipientUser?.userId : n.basket.providerId,
              providerUserExternalId: n.basket.recipientUser?.associationId !== 0 ? n.basket.recipientUser?.userId : n.basket.providerId,
              fareMediaId: n.basket.fareMediaId
            }
          };
        });
      }), v;
    }), l = A(() => n.basket?.ownerFirstName || n.basket?.ownerLastName ? `${n.basket?.ownerFirstName ? n.basket.ownerFirstName + " " : ""}${n.basket?.ownerLastName ?? ""}` : n.basket?.providerUserFirstName || n.basket?.providerUserLastName ? `${n.basket?.providerUserFirstName ? n.basket.providerUserFirstName + " " : ""}${n.basket?.providerUserLastName ?? ""}` : n.basket?.recipientUser?.firstName || n.basket?.recipientUser?.lastName ? `${n.basket?.recipientUser?.firstName ? n.basket.recipientUser.firstName + " " : ""}${n.basket?.recipientUser?.lastName ?? ""}` : ""), c = A(() => [
      "PROVIDERFAREMEDIA",
      "PROVIDERACCOUNTANDFAREMEDIA",
      "PROVIDERACCOUNTANDDEVICE"
    ].includes(n.basket.basketInfo) ? l.value && l.value !== "anonymous anonymous" ? o("wh:fare_media:card_of").replace("%cardOwner%", l.value) : o("wh:fare_media:default") : ""), f = A(() => {
      const { basketType: v, basketInfo: m, fareMediaId: p } = n.basket;
      return v !== "SALE" ? "" : ["PROVIDERACCOUNTANDFAREMEDIA", "PROVIDERFAREMEDIA"].includes(
        m
      ) && !a(p) || l.value !== "anonymous anonymous" ? `n° ${p}` : "";
    }), h = A(() => n.basket.basketInfo === "PROVIDERACCOUNTANDFAREMEDIA" || n.basket.basketInfo === "PROVIDERFAREMEDIA");
    return (v, m) => v.basket?.products?.length > 0 ? (z(), ne("div", IO, [
      v.basket.basketInfo === "PROVIDERACCOUNTANDDEVICE" ? (z(), ne("p", LO, [
        OO,
        v.basket.deviceLabel ? (z(), ne("span", PO, Ve(v.basket.deviceLabel), 1)) : qe("", !0)
      ])) : qe("", !0),
      c.value !== "" || f.value !== "" ? (z(), ne("p", NO, [
        h.value ? (z(), wt(Qg, {
          key: 0,
          color: "secondary",
          "layers-count": 0,
          name: "Card",
          class: "HeaderCartBasket-headerIcon"
        })) : qe("", !0),
        c.value || f.value ? (z(), ne("span", RO, [
          c.value ? (z(), ne("span", FO, Ve(c.value), 1)) : qe("", !0),
          f.value ? (z(), ne("span", MO, Ve(f.value), 1)) : qe("", !0)
        ])) : qe("", !0)
      ])) : qe("", !0),
      Q("ul", DO, [
        (z(!0), ne(Ie, null, pt(s.value, (p) => (z(), wt(ep, {
          key: p.id,
          configuration: q(r),
          item: p
        }, null, 8, ["configuration", "item"]))), 128))
      ])
    ])) : qe("", !0);
  }
}), BO = /* @__PURE__ */ Ut($O, [["__scopeId", "data-v-bf40fee2"]]), VO = ["textContent"], UO = /* @__PURE__ */ Qe({
  __name: "ContextualLink",
  props: {
    configuration: {},
    isButton: { type: Boolean },
    label: {},
    icon: {},
    link: {},
    linkParameters: {},
    useRouterLink: { type: Boolean },
    routingContext: {},
    type: {}
  },
  setup(e) {
    const n = e, { label: r, icon: a, link: o, useRouterLink: s, routingContext: l, configuration: c } = ht(n), f = Ze(Ma), { translateLink: h } = $r(c), v = A(() => {
      const b = n.linkParameters ? `${h(o.value)}/${n.linkParameters}` : h(o.value);
      return y.value && b.startsWith("http") ? new URL(b).pathname : b;
    }), m = A(() => ({
      to: v.value
    })), p = A(() => ({
      href: v.value
    })), y = A(() => s.value && l ? l.value === f : s.value && !l.value);
    return (b, C) => (z(), wt(zn(y.value ? "router-link" : "a"), Te(y.value ? m.value : p.value, {
      class: [`ContextualLink--${b.type}`, "ContextualLink"]
    }), {
      default: bt(() => [
        q(a) ? (z(), ne("i", {
          key: 0,
          class: Mt(["icon-" + q(a), "wh-text-[25px]"])
        }, null, 2)) : qe("", !0),
        q(r) ? (z(), ne("span", {
          key: 1,
          class: "wh-hidden sm:wh-block",
          textContent: Ve(b.$t(q(r)))
        }, null, 8, VO)) : qe("", !0)
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), tp = /* @__PURE__ */ Ut(UO, [["__scopeId", "data-v-8ece9fa8"]]), WO = (e) => (Ui("data-v-ed17fce4"), e = e(), Wi(), e), HO = ["aria-label"], GO = { class: "CartSummary-content" }, zO = { class: "CartSummary-sections" }, qO = {
  key: 0,
  class: "CartSummary-separator"
}, KO = {
  key: 0,
  class: "CartSummary-list"
}, jO = {
  key: 1,
  class: "mb-5"
}, YO = { class: "cartSummary-empty" }, XO = /* @__PURE__ */ WO(() => /* @__PURE__ */ Q("div", { class: "CartSummary-separator" }, null, -1)), JO = { class: "CartSummary-total" }, ZO = { class: "CartSummary-totalPrice" }, QO = { class: "CartSummary-totalLabel" }, eP = /* @__PURE__ */ Qe({
  __name: "CartSummary",
  props: {
    configuration: {},
    propsCart: {}
  },
  setup(e) {
    const n = e, { configuration: r, propsCart: a } = ht(n), { getCart: o, normalizeCart: s } = vO(r), { isEmpty: l } = bs(), c = oe(
      a.value ? s(a.value) : {
        actions: [],
        currency: "EUR",
        baskets: [],
        empty: !0,
        id: null,
        immediateAmountExcludingTaxes: null,
        immediateAmountIncludingTaxes: null,
        immediateVatAmount: null,
        packages: [],
        packagesNormalized: [],
        paymentModes: [],
        plans: [],
        plansNormalized: [],
        status: null,
        totalAmountExcludingTaxes: 0,
        totalAmountIncludingTaxes: 0,
        totalVatAmount: 0,
        userId: null
      }
    ), f = oe(!1), h = A(
      () => c.value?.packagesNormalized?.length && c.value?.plansNormalized?.length
    ), v = A(
      () => l(c.value) || l(c.value?.baskets) || c.value?.baskets?.length === 0 && !h.value
    ), m = A(
      () => c.value ? [
        ...c.value.packagesNormalized || [],
        ...c.value.plansNormalized || []
      ] : []
    ), p = A(
      () => !v.value && c.value?.baskets ? "wh:link:cart-url" : "wh:sidebar:shop-link"
    ), y = A(
      () => !v.value && c.value?.baskets ? "wh:cart:go_to_cart" : "wh:cart:shop"
    );
    return Re(
      () => a.value,
      (b) => {
        b && JSON.stringify(c.value) !== JSON.stringify(s(b)) && (c.value = s(b));
      },
      { deep: !0 }
    ), qt(async () => {
      a.value || (c.value = await o()), document.body.addEventListener("cartUpdated", async (b) => {
        const C = b, S = C.detail?.status, R = C.detail?.cart;
        R && JSON.stringify(c.value) !== JSON.stringify(s(R)) ? c.value = R : R || (c.value = await o()), S === "add" && (f.value = !0);
      });
    }), (b, C) => (z(), wt(q(Fa), {
      modelValue: f.value,
      "onUpdate:modelValue": C[0] || (C[0] = (S) => f.value = S),
      attach: "#web-harmony-header-nav",
      location: "bottom start",
      class: "CartSummary"
    }, {
      activator: bt(({ props: S }) => [
        Q("button", Te(S, {
          "aria-label": b.$t("wh:cart:cart-menu"),
          class: [{ "CartSummary-headerButton--active": f.value }, "CartSummary-headerButton"]
        }), [
          Q("i", {
            class: Mt([v.value ? "icon-cart-outline" : "icon-cart-fill", "wh-text-[25px]"])
          }, null, 2)
        ], 16, HO)
      ]),
      default: bt(() => [
        Q("div", GO, [
          Q("div", zO, [
            !v.value && c.value?.baskets ? (z(), ne(Ie, { key: 0 }, [
              (z(!0), ne(Ie, null, pt(c.value.baskets, (S, R) => (z(), ne("section", {
                key: S.fareMediaId
              }, [
                T(BO, {
                  basket: S,
                  configuration: q(r)
                }, null, 8, ["basket", "configuration"]),
                R < c.value.baskets.length - 1 ? (z(), ne("div", qO)) : qe("", !0)
              ]))), 128)),
              h.value ? (z(), ne("section", KO, [
                (z(!0), ne(Ie, null, pt(m.value, (S) => (z(), wt(ep, {
                  key: S.id,
                  configuration: q(r),
                  item: S
                }, null, 8, ["configuration", "item"]))), 128))
              ])) : qe("", !0)
            ], 64)) : (z(), ne("div", jO, [
              Q("p", YO, Ve(b.$t("wh:cart:empty")), 1)
            ]))
          ]),
          !v.value && c.value?.baskets ? (z(), ne(Ie, { key: 0 }, [
            XO,
            Q("div", JO, [
              Q("div", ZO, [
                Q("span", QO, Ve(b.$t("wh:cart:total_to_settle")), 1),
                T(Zg, {
                  currency: c.value?.currency ?? "EUR",
                  fare: c.value?.totalAmountIncludingTaxes,
                  size: "Small",
                  class: "CartSummary-totalFare"
                }, null, 8, ["currency", "fare"])
              ])
            ])
          ], 64)) : qe("", !0),
          T(tp, {
            class: "CartSummary-button",
            link: p.value,
            label: y.value,
            "use-router-link": !0,
            "routing-context": "VAD",
            configuration: q(r)
          }, null, 8, ["link", "label", "configuration"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), tP = /* @__PURE__ */ Ut(eP, [["__scopeId", "data-v-ed17fce4"]]), nP = { class: "cms-menu wh-flex wh-items-center wh-gap-5" }, rP = ["aria-label"], iP = {
  key: 0,
  class: "icon-close wh-text-[20px]"
}, aP = {
  key: 1,
  class: "icon-menu wh-text-[20px]"
}, oP = ["textContent"], sP = { class: "menu" }, lP = {
  class: "wh-flex wh-px-[60px] sm:wh-px-[100px] lg:wh-px-0 wh-justify-between wh-flex-wrap wh-max-w-[1080px] wh-mx-auto",
  style: { "row-gap": "40px" }
}, uP = { class: "menu-col-item" }, cP = ["href", "innerHTML"], fP = ["href", "innerHTML"], dP = ["href", "innerHTML"], hP = { class: "wh-w-full sm:wh-w-[50%] md:wh-w-auto wh-flex wh-flex-col wh-gap-[1em]" }, vP = /* @__PURE__ */ Qe({
  __name: "CmsMenu",
  props: {
    configuration: {},
    menuItems: {}
  },
  setup(e) {
    const n = e, { configuration: r, menuItems: a } = ht(n), o = oe(!1), { isAuthenticated: s } = Ki(), { getRealComponent: l, componentsForSlotAndPosition: c } = mc(
      r,
      s
    ), f = c("inner-menu");
    return (h, v) => (z(), ne("div", nP, [
      T(q(Fa), {
        modelValue: o.value,
        "onUpdate:modelValue": v[0] || (v[0] = (m) => o.value = m),
        transition: "slide-y-transition",
        "close-on-content-click": !1,
        attach: "#web-harmony-header-nav",
        class: "cms-menu"
      }, {
        activator: bt(({ props: m }) => [
          Q("button", Te(m, {
            class: "wh-flex wh-bg-[var(--primary-container)] wh-items-center wh-text-[var(--on-primary)] wh-py-[12px] wh-px-[13px] wh-rounded-[16px] wh-font-bold wh-gap-1",
            "aria-label": h.$t("wh:menu:title")
          }), [
            o.value ? (z(), ne("i", iP)) : (z(), ne("i", aP)),
            Q("span", {
              class: "wh-hidden md:wh-flex",
              textContent: Ve(h.$t("wh:menu:title"))
            }, null, 8, oP)
          ], 16, rP)
        ]),
        default: bt(() => [
          Q("div", sP, [
            Q("div", lP, [
              (z(!0), ne(Ie, null, pt(q(a), (m, p) => (z(), ne("div", {
                key: p,
                class: "wh-w-full sm:wh-w-[50%] md:wh-w-auto"
              }, [
                Q("div", uP, [
                  Q("a", {
                    href: m.url,
                    class: "wh-block wh-font-bold wh-text-xl wh-mb-[30px] wh-text-white",
                    innerHTML: m.title
                  }, null, 8, cP),
                  (z(!0), ne(Ie, null, pt(m.child_items, (y, b) => (z(), ne("div", {
                    key: b,
                    class: "wh-mb-[20px]"
                  }, [
                    Q("a", {
                      class: "menu-link wh-text-white",
                      href: y.url,
                      innerHTML: y.title
                    }, null, 8, fP),
                    (z(!0), ne(Ie, null, pt(y.child_items, (C, S) => (z(), ne("div", {
                      key: S,
                      class: "wh-my-[20px] wh-ml-[20px]"
                    }, [
                      Q("a", {
                        class: "menu-link wh-text-white",
                        href: C.url,
                        innerHTML: C.title
                      }, null, 8, dP)
                    ]))), 128))
                  ]))), 128))
                ])
              ]))), 128)),
              Q("div", hP, [
                (z(!0), ne(Ie, null, pt(q(f), (m, p) => (z(), wt(zn(q(l)(m)), Te({
                  key: p,
                  configuration: q(r),
                  ref_for: !0
                }, m.props), null, 16, ["configuration"]))), 128))
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]));
  }
}), mP = /* @__PURE__ */ Ut(vP, [["__scopeId", "data-v-d0500464"]]), gP = (e) => (Ui("data-v-be9ba461"), e = e(), Wi(), e), pP = { class: "language-selector wh-flex wh-items-center" }, _P = ["textContent"], yP = { class: "wh-flex wh-items-center wh-gap-3 wh-pl-3 wh-cursor-pointer" }, bP = ["src", "alt"], wP = ["textContent"], CP = /* @__PURE__ */ gP(() => /* @__PURE__ */ Q("i", { class: "icon-chevron-down" }, null, -1)), SP = ["data-cy", "onClick", "onKeydown"], EP = ["src", "alt"], xP = ["textContent"], AP = /* @__PURE__ */ Qe({
  __name: "LanguageSelector",
  props: {
    configuration: {},
    availableLocales: {},
    defaultLocale: { default: "fr" },
    title: { default: "" },
    responsive: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, { configuration: r, availableLocales: a, title: o, responsive: s } = ht(n), { getConfiguration: l } = Mu(r), c = `${l("globalCdn")}/webapp/img/`, { locale: f } = yr(), h = (v) => {
      const m = f.value;
      f.value = v, tarteaucitronForceLanguage = v;
      const p = document.querySelector(
        "#tarteaucitronRoot[lang='" + m + "']"
      );
      p && p.remove(), r.value.tarteaucitron && Uo(
        `https://tarteaucitron.io/load.js?domain=${r.value.tarteaucitron.domain}&uuid=${r.value.tarteaucitron.uuid}&locale=${f.value}`,
        //
        (y) => {
          tarteaucitron.initEvents.loadEvent(!1), y.remove();
        }
      ), document.body.dispatchEvent(
        new CustomEvent("wh:locale:change", { detail: v })
      );
    };
    return (v, m) => (z(), ne("div", pP, [
      Q("div", null, [
        q(o) ? (z(), ne("p", {
          key: 0,
          class: "wh-mb-[10px] wh-font-bold wh-block",
          textContent: Ve(v.$t(q(o)))
        }, null, 8, _P)) : qe("", !0),
        T(q(uT), {
          items: q(a),
          "model-value": q(f),
          "menu-props": {
            closeOnContentClick: !0
          },
          "data-cy": "locale-selector"
        }, {
          selection: bt(({ item: p }) => [
            Q("div", yP, [
              Q("img", {
                class: "wh-inline-flex wh-h-[20px]",
                src: c + p.value + ".svg",
                alt: "Drapeau " + p.value
              }, null, 8, bP),
              Q("span", {
                class: Mt(q(s) ? "wh-hidden sm:wh-block" : ""),
                textContent: Ve(v.$t("wh:header:language:" + p.value))
              }, null, 10, wP),
              CP
            ])
          ]),
          item: bt(({ item: p }) => [
            Q("div", {
              class: "wh-flex wh-items-center wh-gap-3 wh-pl-3 wh-py-2 wh-cursor-pointer",
              "data-cy": "locale-" + p.value,
              onClick: (y) => h(p.value),
              onKeydown: HC((y) => h(p.value), ["enter"])
            }, [
              Q("img", {
                class: "wh-inline-flex wh-h-[20px]",
                src: c + p.value + ".svg",
                alt: "Drapeau " + p.value
              }, null, 8, EP),
              Q("span", {
                class: Mt(q(s) ? "wh-hidden sm:wh-block" : ""),
                textContent: Ve(v.$t("wh:header:language:" + p.value))
              }, null, 10, xP)
            ], 40, SP)
          ]),
          _: 1
        }, 8, ["items", "model-value"])
      ])
    ]));
  }
}), kP = /* @__PURE__ */ Ut(AP, [["__scopeId", "data-v-be9ba461"]]), TP = ["innerHTML"], IP = { class: "wh-flex wh-gap-[10px]" }, LP = ["href", "title"], OP = ["src", "alt"], PP = /* @__PURE__ */ Qe({
  __name: "MobileApps",
  props: {
    title: {},
    items: {}
  },
  setup(e) {
    const n = e, { title: r, items: a } = ht(n), { locale: o } = yr(), s = () => o.value === "fr" || o.value === "en" || o.value === "it" || o.value === "de" || o.value === "es" ? `imageUrl_${o.value}` : "imageUrl_fr";
    return (l, c) => (z(), ne("div", null, [
      q(r) ? (z(), ne("p", {
        key: 0,
        class: "wh-block wh-mb-[10px] wh-font-bold",
        innerHTML: l.$t(q(r))
      }, null, 8, TP)) : qe("", !0),
      Q("div", IP, [
        (z(!0), ne(Ie, null, pt(q(a), (f, h) => (z(), ne("a", {
          key: h,
          href: f.url,
          target: "_blank",
          title: l.$t(f.alt)
        }, [
          Q("img", {
            src: f[s()],
            alt: l.$t(f.alt),
            class: "wh-max-h-[40px]"
          }, null, 8, OP)
        ], 8, LP))), 128))
      ])
    ]));
  }
}), NP = (e) => {
  const n = oe([]), r = oe(!1), a = oe(!1), { locale: o } = yr(), { userToken: s } = Ki();
  return {
    notifications: n,
    isLoading: r,
    hasError: a,
    fetchNotifications: async () => {
      if (s.value) {
        r.value = !0;
        try {
          n.value = await fetch(
            `${e.value.apiUrl}/store/notifications`,
            {
              headers: {
                "X-Api-Key": e.value.apiKey,
                Authorization: `Bearer ${s.value}`,
                "Accept-Language": o.value || "fr"
              }
            }
          ).then((c) => c.json()).then((c) => c.notifications ? c.notifications : []).then((c) => (a.value = !1, c));
        } catch (c) {
          console.error(c), a.value = !0;
        }
        r.value = !1;
      }
    }
  };
}, RP = (e) => (Ui("data-v-c9b2c749"), e = e(), Wi(), e), FP = {
  id: "notifications-menu",
  class: "NotificationsMenu"
}, MP = ["aria-label", "aria-details"], DP = /* @__PURE__ */ RP(() => /* @__PURE__ */ Q("i", {
  id: "notifications-menu-icon",
  class: "NotificationsMenu-iconNotifications icon-notifications-outline wh-text-[25px]"
}, null, -1)), $P = {
  key: 0,
  class: "wh-absolute wh-top-[5px] wh-right-[5px]"
}, BP = {
  height: "10",
  width: "10",
  xmlns: "http://www.w3.org/2000/svg"
}, VP = { class: "NotificationsMenu-content" }, UP = {
  key: 0,
  class: "NotificationsMenu-list"
}, WP = ["href", "to"], HP = { key: 1 }, GP = ["textContent"], zP = ["textContent"], qP = /* @__PURE__ */ Qe({
  __name: "NotificationsMenu",
  props: {
    configuration: {}
  },
  setup(e) {
    const n = e, { configuration: r } = ht(n), { translateLink: a } = $r(r), { notifications: o, isLoading: s, hasError: l, fetchNotifications: c } = NP(r), f = oe(!1), h = (m) => {
      const p = m.actions[0];
      return a(
        `wh:notifications:link:${p.type}`,
        p.parameters
      );
    }, v = A(() => o.value.length ? "wh:notifications:not-empty" : "wh:notifications:empty");
    return qt(() => {
      c();
    }), (m, p) => (z(), ne("div", FP, [
      T(q(Fa), {
        modelValue: f.value,
        "onUpdate:modelValue": p[0] || (p[0] = (y) => f.value = y),
        attach: "#web-harmony-header-nav",
        width: "400",
        location: "bottom start"
      }, {
        activator: bt(({ props: y }) => [
          Q("button", Te({ id: "notifications-menu-button" }, y, {
            "aria-label": m.$t("wh:notifications:menu"),
            "aria-details": m.$t(v.value),
            class: [{ "NotificationsMenu-headerButton--active": f.value }, "NotificationsMenu-headerButton"]
          }), [
            DP,
            q(o).length ? (z(), ne("span", $P, [
              (z(), ne("svg", BP, [
                Q("circle", {
                  style: Di({ fill: f.value ? "white" : "var(--secondary)" }),
                  r: "3",
                  cx: "5",
                  cy: "5"
                }, null, 4)
              ]))
            ])) : qe("", !0)
          ], 16, MP)
        ]),
        default: bt(() => [
          Q("div", VP, [
            q(o).length && !q(s) ? (z(), ne("ul", UP, [
              (z(!0), ne(Ie, null, pt(q(o), (y, b) => (z(), ne("li", {
                key: b,
                class: "NotificationsMenu-item"
              }, [
                Q("a", {
                  class: "wh-block wh-p-2 wh-px-5",
                  href: h(y),
                  to: h(y)
                }, Ve(y.label), 9, WP)
              ]))), 128))
            ])) : q(s) ? (z(), ne("div", HP, [
              T(q(uv), { type: "list-item-three-line" }),
              T(q(uv), { type: "list-item-three-line" })
            ])) : q(l) ? (z(), ne("p", {
              key: 2,
              class: "NotificationsMenu-emptyOrError wh-text-[var(--red-darken-4)]",
              textContent: Ve(m.$t("wh:notifications:error"))
            }, null, 8, GP)) : q(o).length === 0 ? (z(), ne("p", {
              key: 3,
              class: "NotificationsMenu-emptyOrError",
              textContent: Ve(m.$t("wh:notifications:empty"))
            }, null, 8, zP)) : qe("", !0)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]));
  }
}), KP = /* @__PURE__ */ Ut(qP, [["__scopeId", "data-v-c9b2c749"]]), vc = () => {
  const e = oe(""), n = oe(!1), r = () => {
    let o = document.location.pathname;
    e.value = o, new MutationObserver((l) => {
      o !== document.location.pathname && (o = document.location.pathname, e.value = o);
    }).observe(document.body, { childList: !0, subtree: !0 }), n.value = !0;
  };
  return {
    initializeUrlObserver: () => {
      if (!n.value) {
        if (typeof document > "u")
          throw new TypeError(
            "useUrlObserver().initializeUrlObserver() should be used only in the browser !"
          );
        r();
      }
    },
    actualRoutePath: e
  };
}, jP = { class: "nav-icon wh-flex wh-items-center wh-justify-center" }, YP = ["textContent"], XP = /* @__PURE__ */ Qe({
  __name: "SidebarLink",
  props: {
    configuration: {},
    label: {},
    icon: {},
    activeIcon: {},
    mdiIcon: {},
    mdiActiveIcon: {},
    link: {},
    useRouterLink: { type: Boolean },
    exactOrPrefix: {},
    routingContext: {},
    mainApplicationContext: {}
  },
  setup(e) {
    const n = e, {
      label: r,
      icon: a,
      activeIcon: o,
      mdiIcon: s,
      mdiActiveIcon: l,
      link: c,
      exactOrPrefix: f,
      configuration: h,
      useRouterLink: v,
      routingContext: m,
      mainApplicationContext: p
    } = ht(n), { actualRoutePath: y, initializeUrlObserver: b } = vc(), { translateLink: C } = $r(h), S = A(() => {
      const P = C(c.value);
      return F.value && P.startsWith("http") ? new URL(P).pathname : P;
    }), R = A(() => ({
      to: S.value
    })), $ = A(() => ({
      href: S.value
    })), k = A(() => s.value || l.value ? l.value && L.value ? l.value : s.value : o.value ? L.value ? `icon-${o.value}` : `icon-${a.value}` : `icon-${a.value}`);
    qt(() => {
      b();
    });
    const L = A(() => {
      if (f.value) {
        const P = `${S.value}${f.value}`;
        return !!(y.value.startsWith(P) || y.value === S.value);
      }
      return !!y.value.startsWith(S.value);
    }), F = A(() => v.value && m ? m.value === p.value : v.value && !m.value);
    return (P, E) => (z(), wt(zn(F.value ? "router-link" : "a"), Te(F.value ? R.value : $.value, {
      class: ["wh-flex wh-flex-col wh-items-center wh-gap-2", { "active-link": L.value }],
      "aria-current": L.value ? "page" : null,
      "active-class": "active-link"
    }), {
      default: bt(() => [
        Q("span", jP, [
          Q("i", {
            class: Mt(k.value)
          }, null, 2)
        ]),
        Q("span", {
          class: "nav-label",
          textContent: Ve(P.$t(q(r)))
        }, null, 8, YP)
      ]),
      _: 1
    }, 16, ["class", "aria-current"]));
  }
}), JP = /* @__PURE__ */ Ut(XP, [["__scopeId", "data-v-91370f17"]]), ZP = ["href", "to"], QP = {
  key: 0,
  class: "wh-text-[25px] wh-flex wh-items-center"
}, eN = ["textContent"], tN = /* @__PURE__ */ Qe({
  __name: "SimpleLink",
  props: {
    label: {},
    url: {},
    icon: {},
    responsive: { type: Boolean },
    configuration: {}
  },
  setup(e) {
    const n = e, { label: r, url: a, icon: o, responsive: s, configuration: l } = ht(n), { translateLink: c } = $r(l);
    return (f, h) => (z(), ne("a", {
      href: q(c)(q(a)),
      to: q(c)(q(a)),
      class: "wh-flex wh-items-center wh-font-bold wh-gap-3 wh-text-center SimpleLink"
    }, [
      q(o) ? (z(), ne("span", QP, [
        Q("i", {
          class: Mt(`icon-${q(o)}`)
        }, null, 2)
      ])) : qe("", !0),
      q(r) ? (z(), ne("span", {
        key: 1,
        class: Mt(["md:wh-block", { "wh-hidden": q(s) }]),
        textContent: Ve(f.$t(q(r)))
      }, null, 10, eN)) : qe("", !0)
    ], 8, ZP));
  }
}), nN = /* @__PURE__ */ Ut(tN, [["__scopeId", "data-v-68ebc10c"]]), rN = ["innerHTML"], iN = { class: "wh-flex wh-gap-[10px]" }, aN = ["href", "title"], oN = ["src", "alt"], sN = /* @__PURE__ */ Qe({
  __name: "SocialNetworks",
  props: {
    title: {},
    items: {}
  },
  setup(e) {
    const n = e, { title: r, items: a } = ht(n);
    return (o, s) => (z(), ne("div", null, [
      q(r) ? (z(), ne("span", {
        key: 0,
        class: "wh-block wh-mb-[10px] wh-font-bold",
        innerHTML: o.$t(q(r))
      }, null, 8, rN)) : qe("", !0),
      Q("div", iN, [
        (z(!0), ne(Ie, null, pt(q(a), (l, c) => (z(), ne("a", {
          key: c,
          href: l.url,
          target: "_blank",
          title: o.$t(l.alt)
        }, [
          Q("img", {
            src: l.imageUrl,
            alt: o.$t(l.alt),
            class: "wh-h-[30px]"
          }, null, 8, oN)
        ], 8, aN))), 128))
      ])
    ]));
  }
}), lN = ["innerHTML"], uN = { class: "wh-flex wh-gap-3" }, cN = ["href", "title"], fN = ["src", "alt"], dN = ["src", "alt"], hN = /* @__PURE__ */ Qe({
  __name: "SponsorsLogos",
  props: {
    title: {},
    items: {}
  },
  setup(e) {
    const n = e, { items: r, title: a } = ht(n);
    return (o, s) => (z(), ne("div", null, [
      q(a) ? (z(), ne("p", {
        key: 0,
        class: "wh-block wh-mb-[10px] wh-font-bold",
        innerHTML: o.$t(q(a))
      }, null, 8, lN)) : qe("", !0),
      Q("div", uN, [
        (z(!0), ne(Ie, null, pt(q(r), (l, c) => (z(), ne("div", { key: c }, [
          l.link ? (z(), ne("a", {
            key: 0,
            href: l.link,
            target: "_blank",
            title: o.$t(l.alt)
          }, [
            Q("img", {
              src: l.imageUrl,
              alt: o.$t(l.alt),
              class: "wh-w-[200px]"
            }, null, 8, fN)
          ], 8, cN)) : (z(), ne("img", {
            key: 1,
            src: l.imageUrl,
            alt: o.$t(l.alt),
            class: "wh-w-[200px]"
          }, null, 8, dN))
        ]))), 128))
      ])
    ]));
  }
}), vN = ["href", "title"], mN = ["src", "alt"], gN = /* @__PURE__ */ Qe({
  __name: "TopLogo",
  props: {
    alt: {},
    link: {},
    url: {},
    configuration: {}
  },
  setup(e) {
    const n = e, { alt: r, link: a, url: o, configuration: s } = ht(n), { translateLink: l } = $r(s), c = A(() => a.value ? l(a.value) : "/");
    return (f, h) => (z(), ne("a", {
      href: c.value,
      title: f.$t(q(r) ?? ""),
      class: "wh-me-[10px] sm:wh-me-0"
    }, [
      Q("img", {
        src: q(o),
        alt: f.$t(q(r) ?? ""),
        class: "wh-h-[65px]"
      }, null, 8, mN)
    ], 8, vN));
  }
}), pN = {}, _N = { class: "wh-w-[0px] wh-border-r wh-border-[var(--grey-lighten-2)] wh-my-[-5px] md:wh-mx-[10px]" };
function yN(e, n) {
  return z(), ne("div", _N);
}
const bN = /* @__PURE__ */ Ut(pN, [["render", yN]]);
/*!
  * vue-router v4.4.0
  * (c) 2024 Eduardo San Martin Morote
  * @license MIT
  */
var Av;
(function(e) {
  e.pop = "pop", e.push = "push";
})(Av || (Av = {}));
var kv;
(function(e) {
  e.back = "back", e.forward = "forward", e.unknown = "";
})(kv || (kv = {}));
var Tv;
(function(e) {
  e[e.aborted = 4] = "aborted", e[e.cancelled = 8] = "cancelled", e[e.duplicated = 16] = "duplicated";
})(Tv || (Tv = {}));
const wN = Symbol("");
function CN() {
  return Ze(wN);
}
const SN = ["textContent"], EN = /* @__PURE__ */ Qe({
  __name: "HeaderLink",
  props: {
    configuration: {},
    label: {},
    icon: {},
    link: {},
    useRouterLink: { type: Boolean },
    routingContext: {},
    mainApplicationContext: {}
  },
  setup(e) {
    const n = CN(), r = e, {
      label: a,
      icon: o,
      link: s,
      configuration: l,
      useRouterLink: c,
      routingContext: f,
      mainApplicationContext: h
    } = ht(r), { initializeUrlObserver: v } = vc(), { translateLink: m } = $r(l), p = A(() => {
      const $ = m(s.value);
      return S.value && $.startsWith("http") ? new URL($).pathname : $;
    }), y = A(() => ({
      to: p.value
    })), b = A(() => ({
      href: p.value
    })), C = A(() => `icon-${o.value}`);
    qt(() => {
      v();
    });
    const S = A(() => c.value && f ? f.value === h.value : c.value && !f.value);
    function R() {
      S.value ? n.push(y.value.to) : window.location.href = b.value.href;
    }
    return ($, k) => (z(), ne("button", {
      class: "AccountMenu-headerButton wh-gap-2",
      onClick: R
    }, [
      Q("i", {
        class: Mt([C.value, "AccountMenu-icon wh-text-[25px]"])
      }, null, 2),
      Q("span", {
        class: "wh-hidden sm:wh-block",
        textContent: Ve($.$t(q(a)))
      }, null, 8, SN)
    ]));
  }
}), Iv = {
  AccountMenu: II,
  AdditionnalLogos: NI,
  CartSummary: tP,
  CmsMenu: mP,
  ContextualLink: tp,
  LanguageSelector: kP,
  MobileApps: PP,
  NotificationsMenu: KP,
  SidebarLink: JP,
  SimpleLink: nN,
  SocialNetworks: sN,
  SponsorsLogos: hN,
  TopLogo: gN,
  VerticalDivider: bN,
  HeaderLink: EN
}, mc = (e, n) => {
  const r = oS(aS), a = A(() => e.value.components);
  return {
    getRealComponent: (l) => {
      if (!Iv[l.name]) {
        console.error(
          `Component ${l.name} found in configuration but not in codebase. Please check the configuration file.`
        );
        return;
      }
      return Iv[l.name];
    },
    componentsForSlotAndPosition: (l, c = "start") => A(() => {
      const f = r.lg.value ? "desktop" : r.md.value ? "tablet" : "mobile";
      return a.value ? a.value.filter((h) => h[f]).filter((h) => {
        const v = h[f].position || "start";
        return h[f].slot === l && v === c;
      }).filter((h) => !(h.needsAuthentication && !n.value)).sort((h, v) => {
        const m = h[f].order || 0, p = v[f].order || 0;
        return m - p;
      }) : [];
    })
  };
}, xN = { class: "wh-px-5 md:wh-py-0 md:wh-px-6 md:wh-pl-[24px] wh-bg-white wh-shadow-md wh-flex wh-items-center wh-justify-between wh-min-h-[65px] web-harmony-header-nav" }, AN = { class: "wh-flex wh-gap-3" }, kN = { class: "wh-flex wh-gap-3 wh-ml-auto" }, TN = /* @__PURE__ */ Qe({
  __name: "TheHeader",
  props: {
    menuItems: {},
    configuration: {},
    customAccountConfiguration: {},
    propsCart: {}
  },
  setup(e) {
    const n = e, r = Ze(Ma), { configuration: a, menuItems: o, propsCart: s } = ht(n), { colorVars: l } = rs(a), { locale: c } = yr(), { isAuthenticated: f } = Ki(), { getRealComponent: h, componentsForSlotAndPosition: v } = mc(
      a,
      f
    ), m = v("header", "start"), p = v("header", "end");
    if (a.value.tarteaucitron && Uo(
      `https://tarteaucitron.io/load.js?domain=${a.value.tarteaucitron.domain}&uuid=${a.value.tarteaucitron.uuid}&locale=${c.value}`,
      //
      (y) => {
        tarteaucitron.initEvents.loadEvent(!1), y.remove();
      }
    ), a.value.matomo && typeof window < "u") {
      const y = window._paq = window._paq || [];
      a.value.matomo.excludedQueryParams && y.push([
        "setExcludedQueryParams",
        a.value.matomo.excludedQueryParams
      ]), y.push(["trackPageView"]), a.value.matomo.disableCookies && y.push(["disableCookies"]), y.push(["enableLinkTracking"]), function() {
        const b = a.value.matomo.trackerUrl;
        y.push(["setTrackerUrl", b + "matomo.php"]), y.push(["setSiteId", a.value.matomo.siteId]), Uo(
          `${a.value.matomo.trackerUrl}matomo.js`,
          () => {
          },
          { async: !0 }
        );
      }();
    }
    return (y, b) => (z(), ne("div", null, [
      Q("header", {
        id: "web-harmony-header-nav",
        class: "TheHeader wh-header wh-fixed wh-top-0 wh-left-0 wh-w-full wh-z-50",
        style: Di(q(l))
      }, [
        Q("nav", xN, [
          Q("div", AN, [
            (z(!0), ne(Ie, null, pt(q(m), (C, S) => (z(), wt(zn(q(h)(C)), Te({
              key: `${S}-${C.name}`,
              ref_for: !0
            }, C.props, {
              configuration: q(a),
              "main-application-context": q(r),
              "menu-items": q(o),
              "props-cart": q(s),
              "custom-account-configuration": y.customAccountConfiguration
            }), null, 16, ["configuration", "main-application-context", "menu-items", "props-cart", "custom-account-configuration"]))), 128))
          ]),
          Q("div", kN, [
            (z(!0), ne(Ie, null, pt(q(p), (C, S) => (z(), wt(zn(q(h)(C)), Te({
              key: `${S}-${C.name}`,
              ref_for: !0
            }, C.props, {
              configuration: q(a),
              "menu-items": q(o),
              "props-cart": q(s),
              "custom-account-configuration": y.customAccountConfiguration
            }), null, 16, ["configuration", "menu-items", "props-cart", "custom-account-configuration"]))), 128))
          ])
        ])
      ], 4),
      q(a).banners?.enabled ? (z(), wt(hI, {
        key: 0,
        configuration: q(a)
      }, null, 8, ["configuration"])) : qe("", !0)
    ]));
  }
}), IN = { class: "wh-flex md:wh-flex-col wh-gap-5 wh-justify-around wh-w-full" }, LN = { class: "wh-hidden md:wh-flex md:wh-flex-col wh-gap-5" }, ON = /* @__PURE__ */ Qe({
  __name: "TheSidebar",
  props: {
    configuration: {},
    useRouterLink: { type: Boolean }
  },
  setup(e) {
    const n = e, r = Ze(Ma), { configuration: a, useRouterLink: o } = ht(n), { isAuthenticated: s } = Ki(), { colorVars: l } = rs(a), { getRealComponent: c, componentsForSlotAndPosition: f } = mc(
      a,
      s
    ), h = f("sidebar", "start"), v = f("sidebar", "end");
    return qt(() => {
      vc().initializeUrlObserver();
    }), (m, p) => (z(), ne("aside", {
      class: "TheSidebar wh-sidebar wh-shadow-[0px_0px_15px_0px_rgba(0,0,0,0.2)] md:wh-shadow wh-flex md:wh-flex-col wh-bg-white md:wh-min-h-[100vh] wh-justify-around md:wh-justify-between md:wh-pt-[80px] wh-py-5 wh-fixed wh-bottom-0 wh-w-full wh-left-0 wh-gap-5 md:wh-w-[80px] wh-z-40",
      style: Di(q(l))
    }, [
      Q("div", IN, [
        (z(!0), ne(Ie, null, pt(q(h), (y, b) => (z(), wt(zn(q(c)(y)), Te({
          key: `${b}-start`,
          ref_for: !0
        }, y.props, {
          "use-router-link": q(o),
          "main-application-context": q(r),
          configuration: q(a)
        }), null, 16, ["use-router-link", "main-application-context", "configuration"]))), 128))
      ]),
      Q("div", LN, [
        (z(!0), ne(Ie, null, pt(q(v), (y, b) => (z(), wt(zn(q(c)(y)), Te({
          key: `${b}-end`,
          ref_for: !0
        }, y.props, {
          "use-router-link": q(o),
          configuration: q(a)
        }), null, 16, ["use-router-link", "configuration"]))), 128))
      ])
    ], 4));
  }
}), PN = /* @__PURE__ */ Ut(ON, [["__scopeId", "data-v-2fc438ae"]]), DN = (e, n) => {
  const { portalUrl: r } = n;
  return {
    loadFooterMenuItems: async (s = "fr", l) => {
      if (!r && !l)
        return [];
      let c = `${l || r}/wp-json/menus/v1/menus/menu-secondaire-footer`;
      s !== "fr" && (c += `-${s}`);
      try {
        return await e(c).then((f) => f.items || []);
      } catch {
        return [];
      }
    },
    loadHeaderMenuItems: async (s = "fr", l) => {
      if (!r && !l)
        return [];
      let c = `${l || r}/wp-json/menus/v1/menus/menu-primaire-header`;
      s !== "fr" && (c += `-${s}`);
      try {
        return await e(c).then((f) => f.items || []).then(
          (f) => f.filter((h) => h.type_label !== "Shortcode")
        );
      } catch {
        return [];
      }
    }
  };
}, NN = Symbol(
  "INJECT_WH_TRANSLATION_FN"
), RN = (e) => {
  e.component("WebHarmonyHeader", TN), e.component("WebHarmonyFooter", JC), e.component("WebHarmonySidebar", PN);
}, $N = {
  install: RN
};
export {
  Ma as INJECT_MAIN_APPLICATION_CONTEXT,
  NN as INJECT_WH_TRANSLATION_FN,
  JC as TheFooter,
  TN as TheHeader,
  PN as TheSidebar,
  $N as default,
  DN as useCmsMenuApi,
  MN as whDefaultConfiguration
};
